import { a as G, j as R, c as wt } from "../../utils-BdNIfrGQ.js";
import * as x from "react";
import Dn, { isValidElement as vt, Children as hi, forwardRef as gt, useContext as Gr, createContext as er, PureComponent as Yr, useState as ct, useCallback as oe, useEffect as ae, useMemo as na, cloneElement as kt, useRef as it, createElement as $h, useImperativeHandle as Db, Component as Rh } from "react";
import { createPortal as Lh } from "react-dom";
import { g as It } from "../../_commonjsHelpers-DaMA6jEr.js";
import { r as Bh } from "../../index-DXQlDdB3.js";
var Wa = {}, Ua = {}, yl;
function Nb() {
  return yl || (yl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      return r === "__proto__";
    }
    e.isUnsafeProperty = t;
  })(Ua)), Ua;
}
var Va = {}, gl;
function zh() {
  return gl || (gl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      switch (typeof r) {
        case "number":
        case "symbol":
          return !1;
        case "string":
          return r.includes(".") || r.includes("[") || r.includes("]");
      }
    }
    e.isDeepKey = t;
  })(Va)), Va;
}
var Ha = {}, bl;
function qh() {
  return bl || (bl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      return typeof r == "string" || typeof r == "symbol" ? r : Object.is(r?.valueOf?.(), -0) ? "-0" : String(r);
    }
    e.toKey = t;
  })(Ha)), Ha;
}
var Ga = {}, wl;
function Mc() {
  return wl || (wl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      const n = [], i = r.length;
      if (i === 0)
        return n;
      let a = 0, o = "", u = "", c = !1;
      for (r.charCodeAt(0) === 46 && (n.push(""), a++); a < i; ) {
        const s = r[a];
        u ? s === "\\" && a + 1 < i ? (a++, o += r[a]) : s === u ? u = "" : o += s : c ? s === '"' || s === "'" ? u = s : s === "]" ? (c = !1, n.push(o), o = "") : o += s : s === "[" ? (c = !0, o && (n.push(o), o = "")) : s === "." ? o && (n.push(o), o = "") : o += s, a++;
      }
      return o && n.push(o), n;
    }
    e.toPath = t;
  })(Ga)), Ga;
}
var xl;
function Cc() {
  return xl || (xl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ Nb(), r = /* @__PURE__ */ zh(), n = /* @__PURE__ */ qh(), i = /* @__PURE__ */ Mc();
    function a(u, c, s) {
      if (u == null)
        return s;
      switch (typeof c) {
        case "string": {
          if (t.isUnsafeProperty(c))
            return s;
          const l = u[c];
          return l === void 0 ? r.isDeepKey(c) ? a(u, i.toPath(c), s) : s : l;
        }
        case "number":
        case "symbol": {
          typeof c == "number" && (c = n.toKey(c));
          const l = u[c];
          return l === void 0 ? s : l;
        }
        default: {
          if (Array.isArray(c))
            return o(u, c, s);
          if (Object.is(c?.valueOf(), -0) ? c = "-0" : c = String(c), t.isUnsafeProperty(c))
            return s;
          const l = u[c];
          return l === void 0 ? s : l;
        }
      }
    }
    function o(u, c, s) {
      if (c.length === 0)
        return s;
      let l = u;
      for (let f = 0; f < c.length; f++) {
        if (l == null || t.isUnsafeProperty(c[f]))
          return s;
        l = l[c[f]];
      }
      return l === void 0 ? s : l;
    }
    e.get = a;
  })(Wa)), Wa;
}
var Ya, Ol;
function $b() {
  return Ol || (Ol = 1, Ya = Cc().get), Ya;
}
var Rb = /* @__PURE__ */ $b();
const gr = /* @__PURE__ */ It(Rb);
var Jn = { exports: {} }, U = {};
var Pl;
function Lb() {
  if (Pl) return U;
  Pl = 1;
  var e = /* @__PURE__ */ Symbol.for("react.element"), t = /* @__PURE__ */ Symbol.for("react.portal"), r = /* @__PURE__ */ Symbol.for("react.fragment"), n = /* @__PURE__ */ Symbol.for("react.strict_mode"), i = /* @__PURE__ */ Symbol.for("react.profiler"), a = /* @__PURE__ */ Symbol.for("react.provider"), o = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.server_context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), s = /* @__PURE__ */ Symbol.for("react.suspense"), l = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), d = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), h;
  h = /* @__PURE__ */ Symbol.for("react.module.reference");
  function p(m) {
    if (typeof m == "object" && m !== null) {
      var y = m.$$typeof;
      switch (y) {
        case e:
          switch (m = m.type, m) {
            case r:
            case i:
            case n:
            case s:
            case l:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case u:
                case o:
                case c:
                case d:
                case f:
                case a:
                  return m;
                default:
                  return y;
              }
          }
        case t:
          return y;
      }
    }
  }
  return U.ContextConsumer = o, U.ContextProvider = a, U.Element = e, U.ForwardRef = c, U.Fragment = r, U.Lazy = d, U.Memo = f, U.Portal = t, U.Profiler = i, U.StrictMode = n, U.Suspense = s, U.SuspenseList = l, U.isAsyncMode = function() {
    return !1;
  }, U.isConcurrentMode = function() {
    return !1;
  }, U.isContextConsumer = function(m) {
    return p(m) === o;
  }, U.isContextProvider = function(m) {
    return p(m) === a;
  }, U.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === e;
  }, U.isForwardRef = function(m) {
    return p(m) === c;
  }, U.isFragment = function(m) {
    return p(m) === r;
  }, U.isLazy = function(m) {
    return p(m) === d;
  }, U.isMemo = function(m) {
    return p(m) === f;
  }, U.isPortal = function(m) {
    return p(m) === t;
  }, U.isProfiler = function(m) {
    return p(m) === i;
  }, U.isStrictMode = function(m) {
    return p(m) === n;
  }, U.isSuspense = function(m) {
    return p(m) === s;
  }, U.isSuspenseList = function(m) {
    return p(m) === l;
  }, U.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === r || m === i || m === n || m === s || m === l || m === v || typeof m == "object" && m !== null && (m.$$typeof === d || m.$$typeof === f || m.$$typeof === a || m.$$typeof === o || m.$$typeof === c || m.$$typeof === h || m.getModuleId !== void 0);
  }, U.typeOf = p, U;
}
var V = {};
var Al;
function Bb() {
  return Al || (Al = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = /* @__PURE__ */ Symbol.for("react.element"), t = /* @__PURE__ */ Symbol.for("react.portal"), r = /* @__PURE__ */ Symbol.for("react.fragment"), n = /* @__PURE__ */ Symbol.for("react.strict_mode"), i = /* @__PURE__ */ Symbol.for("react.profiler"), a = /* @__PURE__ */ Symbol.for("react.provider"), o = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.server_context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), s = /* @__PURE__ */ Symbol.for("react.suspense"), l = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), d = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), h = !1, p = !1, m = !1, y = !1, g = !1, b;
    b = /* @__PURE__ */ Symbol.for("react.module.reference");
    function O(M) {
      return !!(typeof M == "string" || typeof M == "function" || M === r || M === i || g || M === n || M === s || M === l || y || M === v || h || p || m || typeof M == "object" && M !== null && (M.$$typeof === d || M.$$typeof === f || M.$$typeof === a || M.$$typeof === o || M.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      M.$$typeof === b || M.getModuleId !== void 0));
    }
    function w(M) {
      if (typeof M == "object" && M !== null) {
        var xe = M.$$typeof;
        switch (xe) {
          case e:
            var pe = M.type;
            switch (pe) {
              case r:
              case i:
              case n:
              case s:
              case l:
                return pe;
              default:
                var ft = pe && pe.$$typeof;
                switch (ft) {
                  case u:
                  case o:
                  case c:
                  case d:
                  case f:
                  case a:
                    return ft;
                  default:
                    return xe;
                }
            }
          case t:
            return xe;
        }
      }
    }
    var P = o, A = a, _ = e, T = c, N = r, j = d, C = f, z = t, K = i, J = n, se = s, ne = l, Ce = !1, he = !1;
    function zt(M) {
      return Ce || (Ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function qt(M) {
      return he || (he = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function L(M) {
      return w(M) === o;
    }
    function on(M) {
      return w(M) === a;
    }
    function un(M) {
      return typeof M == "object" && M !== null && M.$$typeof === e;
    }
    function De(M) {
      return w(M) === c;
    }
    function qa(M) {
      return w(M) === r;
    }
    function Ka(M) {
      return w(M) === d;
    }
    function Fa(M) {
      return w(M) === f;
    }
    function D(M) {
      return w(M) === t;
    }
    function B(M) {
      return w(M) === i;
    }
    function q(M) {
      return w(M) === n;
    }
    function E(M) {
      return w(M) === s;
    }
    function Ee(M) {
      return w(M) === l;
    }
    V.ContextConsumer = P, V.ContextProvider = A, V.Element = _, V.ForwardRef = T, V.Fragment = N, V.Lazy = j, V.Memo = C, V.Portal = z, V.Profiler = K, V.StrictMode = J, V.Suspense = se, V.SuspenseList = ne, V.isAsyncMode = zt, V.isConcurrentMode = qt, V.isContextConsumer = L, V.isContextProvider = on, V.isElement = un, V.isForwardRef = De, V.isFragment = qa, V.isLazy = Ka, V.isMemo = Fa, V.isPortal = D, V.isProfiler = B, V.isStrictMode = q, V.isSuspense = E, V.isSuspenseList = Ee, V.isValidElementType = O, V.typeOf = w;
  })()), V;
}
var Sl;
function zb() {
  return Sl || (Sl = 1, process.env.NODE_ENV === "production" ? Jn.exports = Lb() : Jn.exports = Bb()), Jn.exports;
}
var qb = zb(), Re = (e) => e === 0 ? 0 : e > 0 ? 1 : -1, Be = (e) => typeof e == "number" && e != +e, sr = (e) => typeof e == "string" && e.indexOf("%") === e.length - 1, k = (e) => (typeof e == "number" || e instanceof Number) && !Be(e), mt = (e) => k(e) || typeof e == "string", Kb = 0, wn = (e) => {
  var t = ++Kb;
  return "".concat(e || "").concat(t);
}, st = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!k(t) && typeof t != "string")
    return n;
  var a;
  if (sr(t)) {
    if (r == null)
      return n;
    var o = t.indexOf("%");
    a = r * parseFloat(t.slice(0, o)) / 100;
  } else
    a = +t;
  return Be(a) && (a = n), i && r != null && a > r && (a = r), a;
}, Kh = (e) => {
  if (!Array.isArray(e))
    return !1;
  for (var t = e.length, r = {}, n = 0; n < t; n++)
    if (!r[e[n]])
      r[e[n]] = !0;
    else
      return !0;
  return !1;
};
function tt(e, t, r) {
  return k(e) && k(t) ? e + r * (t - e) : t;
}
function Fh(e, t, r) {
  if (!(!e || !e.length))
    return e.find((n) => n && (typeof t == "function" ? t(n) : gr(n, t)) === r);
}
var te = (e) => e === null || typeof e > "u", Nn = (e) => te(e) ? e : "".concat(e.charAt(0).toUpperCase()).concat(e.slice(1)), Fb = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"];
function kc(e) {
  if (typeof e != "string")
    return !1;
  var t = Fb;
  return t.includes(e);
}
var Wb = ["viewBox", "children"], El = ["points", "pathLength"], Xa = {
  svg: Wb,
  polygon: El,
  polyline: El
}, Ic = (e, t) => {
  if (!e || typeof e == "function" || typeof e == "boolean")
    return null;
  var r = e;
  if (/* @__PURE__ */ vt(e) && (r = e.props), typeof r != "object" && typeof r != "function")
    return null;
  var n = {};
  return Object.keys(r).forEach((i) => {
    kc(i) && (n[i] = ((a) => r[i](r, a)));
  }), n;
}, Ub = (e, t, r) => (n) => (e(t, r, n), null), ia = (e, t, r) => {
  if (e === null || typeof e != "object" && typeof e != "function")
    return null;
  var n = null;
  return Object.keys(e).forEach((i) => {
    var a = e[i];
    kc(i) && typeof a == "function" && (n || (n = {}), n[i] = Ub(a, t, r));
  }), n;
}, Vb = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it, and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
];
function Wh(e) {
  if (typeof e != "string")
    return !1;
  var t = Vb;
  return t.includes(e);
}
function tr(e) {
  var t = Object.entries(e).filter((r) => {
    var [n] = r;
    return Wh(n);
  });
  return Object.fromEntries(t);
}
var _l = (e) => typeof e == "string" ? e : e ? e.displayName || e.name || "Component" : "", jl = null, Za = null, Uh = (e) => {
  if (e === jl && Array.isArray(Za))
    return Za;
  var t = [];
  return hi.forEach(e, (r) => {
    te(r) || (qb.isFragment(r) ? t = t.concat(Uh(r.props.children)) : t.push(r));
  }), Za = t, jl = e, t;
};
function Dc(e, t) {
  var r = [], n = [];
  return Array.isArray(t) ? n = t.map((i) => _l(i)) : n = [_l(t)], Uh(e).forEach((i) => {
    var a = gr(i, "type.displayName") || gr(i, "type.name");
    n.indexOf(a) !== -1 && r.push(i);
  }), r;
}
var Vh = (e) => e && typeof e == "object" && "clipDot" in e ? !!e.clipDot : !0, Hb = (e, t, r, n) => {
  var i;
  if (typeof t == "symbol" || typeof t == "number")
    return !0;
  var a = (i = n && Xa?.[n]) !== null && i !== void 0 ? i : [], o = t.startsWith("data-"), u = typeof e != "function" && (!!n && a.includes(t) || Wh(t)), c = !!r && kc(t);
  return o || u || c;
}, ie = (e, t, r) => {
  if (!e || typeof e == "function" || typeof e == "boolean")
    return null;
  var n = e;
  if (/* @__PURE__ */ vt(e) && (n = e.props), typeof n != "object" && typeof n != "function")
    return null;
  var i = {};
  return Object.keys(n).forEach((a) => {
    var o;
    Hb((o = n) === null || o === void 0 ? void 0 : o[a], a, t, r) && (i[a] = n[a]);
  }), i;
}, Gb = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function ku() {
  return ku = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ku.apply(null, arguments);
}
function Yb(e, t) {
  if (e == null) return {};
  var r, n, i = Xb(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function Xb(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var Nc = /* @__PURE__ */ gt((e, t) => {
  var {
    children: r,
    width: n,
    height: i,
    viewBox: a,
    className: o,
    style: u,
    title: c,
    desc: s
  } = e, l = Yb(e, Gb), f = a || {
    width: n,
    height: i,
    x: 0,
    y: 0
  }, d = G("recharts-surface", o);
  return /* @__PURE__ */ x.createElement("svg", ku({}, ie(l, !0, "svg"), {
    className: d,
    width: n,
    height: i,
    style: u,
    viewBox: "".concat(f.x, " ").concat(f.y, " ").concat(f.width, " ").concat(f.height),
    ref: t
  }), /* @__PURE__ */ x.createElement("title", null, c), /* @__PURE__ */ x.createElement("desc", null, s), r);
}), Zb = ["children", "className"];
function Iu() {
  return Iu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Iu.apply(null, arguments);
}
function Jb(e, t) {
  if (e == null) return {};
  var r, n, i = Qb(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function Qb(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var ze = /* @__PURE__ */ x.forwardRef((e, t) => {
  var {
    children: r,
    className: n
  } = e, i = Jb(e, Zb), a = G("recharts-layer", n);
  return /* @__PURE__ */ x.createElement("g", Iu({
    className: a
  }, ie(i, !0), {
    ref: t
  }), r);
}), Hh = /* @__PURE__ */ er(null), e0 = () => Gr(Hh);
function X(e) {
  return function() {
    return e;
  };
}
const Gh = Math.cos, yi = Math.sin, lt = Math.sqrt, gi = Math.PI, aa = 2 * gi, Du = Math.PI, Nu = 2 * Du, ar = 1e-6, t0 = Nu - ar;
function Yh(e) {
  this._ += e[0];
  for (let t = 1, r = e.length; t < r; ++t)
    this._ += arguments[t] + e[t];
}
function r0(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return Yh;
  const r = 10 ** t;
  return function(n) {
    this._ += n[0];
    for (let i = 1, a = n.length; i < a; ++i)
      this._ += Math.round(arguments[i] * r) / r + n[i];
  };
}
class n0 {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? Yh : r0(t);
  }
  moveTo(t, r) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, r) {
    this._append`L${this._x1 = +t},${this._y1 = +r}`;
  }
  quadraticCurveTo(t, r, n, i) {
    this._append`Q${+t},${+r},${this._x1 = +n},${this._y1 = +i}`;
  }
  bezierCurveTo(t, r, n, i, a, o) {
    this._append`C${+t},${+r},${+n},${+i},${this._x1 = +a},${this._y1 = +o}`;
  }
  arcTo(t, r, n, i, a) {
    if (t = +t, r = +r, n = +n, i = +i, a = +a, a < 0) throw new Error(`negative radius: ${a}`);
    let o = this._x1, u = this._y1, c = n - t, s = i - r, l = o - t, f = u - r, d = l * l + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = r}`;
    else if (d > ar) if (!(Math.abs(f * c - s * l) > ar) || !a)
      this._append`L${this._x1 = t},${this._y1 = r}`;
    else {
      let v = n - o, h = i - u, p = c * c + s * s, m = v * v + h * h, y = Math.sqrt(p), g = Math.sqrt(d), b = a * Math.tan((Du - Math.acos((p + d - m) / (2 * y * g))) / 2), O = b / g, w = b / y;
      Math.abs(O - 1) > ar && this._append`L${t + O * l},${r + O * f}`, this._append`A${a},${a},0,0,${+(f * v > l * h)},${this._x1 = t + w * c},${this._y1 = r + w * s}`;
    }
  }
  arc(t, r, n, i, a, o) {
    if (t = +t, r = +r, n = +n, o = !!o, n < 0) throw new Error(`negative radius: ${n}`);
    let u = n * Math.cos(i), c = n * Math.sin(i), s = t + u, l = r + c, f = 1 ^ o, d = o ? i - a : a - i;
    this._x1 === null ? this._append`M${s},${l}` : (Math.abs(this._x1 - s) > ar || Math.abs(this._y1 - l) > ar) && this._append`L${s},${l}`, n && (d < 0 && (d = d % Nu + Nu), d > t0 ? this._append`A${n},${n},0,1,${f},${t - u},${r - c}A${n},${n},0,1,${f},${this._x1 = s},${this._y1 = l}` : d > ar && this._append`A${n},${n},0,${+(d >= Du)},${f},${this._x1 = t + n * Math.cos(a)},${this._y1 = r + n * Math.sin(a)}`);
  }
  rect(t, r, n, i) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}h${n = +n}v${+i}h${-n}Z`;
  }
  toString() {
    return this._;
  }
}
function $c(e) {
  let t = 3;
  return e.digits = function(r) {
    if (!arguments.length) return t;
    if (r == null)
      t = null;
    else {
      const n = Math.floor(r);
      if (!(n >= 0)) throw new RangeError(`invalid digits: ${r}`);
      t = n;
    }
    return e;
  }, () => new n0(t);
}
function Rc(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function Xh(e) {
  this._context = e;
}
Xh.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function oa(e) {
  return new Xh(e);
}
function Zh(e) {
  return e[0];
}
function Jh(e) {
  return e[1];
}
function Qh(e, t) {
  var r = X(!0), n = null, i = oa, a = null, o = $c(u);
  e = typeof e == "function" ? e : e === void 0 ? Zh : X(e), t = typeof t == "function" ? t : t === void 0 ? Jh : X(t);
  function u(c) {
    var s, l = (c = Rc(c)).length, f, d = !1, v;
    for (n == null && (a = i(v = o())), s = 0; s <= l; ++s)
      !(s < l && r(f = c[s], s, c)) === d && ((d = !d) ? a.lineStart() : a.lineEnd()), d && a.point(+e(f, s, c), +t(f, s, c));
    if (v) return a = null, v + "" || null;
  }
  return u.x = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : X(+c), u) : e;
  }, u.y = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : X(+c), u) : t;
  }, u.defined = function(c) {
    return arguments.length ? (r = typeof c == "function" ? c : X(!!c), u) : r;
  }, u.curve = function(c) {
    return arguments.length ? (i = c, n != null && (a = i(n)), u) : i;
  }, u.context = function(c) {
    return arguments.length ? (c == null ? n = a = null : a = i(n = c), u) : n;
  }, u;
}
function Qn(e, t, r) {
  var n = null, i = X(!0), a = null, o = oa, u = null, c = $c(s);
  e = typeof e == "function" ? e : e === void 0 ? Zh : X(+e), t = typeof t == "function" ? t : X(t === void 0 ? 0 : +t), r = typeof r == "function" ? r : r === void 0 ? Jh : X(+r);
  function s(f) {
    var d, v, h, p = (f = Rc(f)).length, m, y = !1, g, b = new Array(p), O = new Array(p);
    for (a == null && (u = o(g = c())), d = 0; d <= p; ++d) {
      if (!(d < p && i(m = f[d], d, f)) === y)
        if (y = !y)
          v = d, u.areaStart(), u.lineStart();
        else {
          for (u.lineEnd(), u.lineStart(), h = d - 1; h >= v; --h)
            u.point(b[h], O[h]);
          u.lineEnd(), u.areaEnd();
        }
      y && (b[d] = +e(m, d, f), O[d] = +t(m, d, f), u.point(n ? +n(m, d, f) : b[d], r ? +r(m, d, f) : O[d]));
    }
    if (g) return u = null, g + "" || null;
  }
  function l() {
    return Qh().defined(i).curve(o).context(a);
  }
  return s.x = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : X(+f), n = null, s) : e;
  }, s.x0 = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : X(+f), s) : e;
  }, s.x1 = function(f) {
    return arguments.length ? (n = f == null ? null : typeof f == "function" ? f : X(+f), s) : n;
  }, s.y = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : X(+f), r = null, s) : t;
  }, s.y0 = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : X(+f), s) : t;
  }, s.y1 = function(f) {
    return arguments.length ? (r = f == null ? null : typeof f == "function" ? f : X(+f), s) : r;
  }, s.lineX0 = s.lineY0 = function() {
    return l().x(e).y(t);
  }, s.lineY1 = function() {
    return l().x(e).y(r);
  }, s.lineX1 = function() {
    return l().x(n).y(t);
  }, s.defined = function(f) {
    return arguments.length ? (i = typeof f == "function" ? f : X(!!f), s) : i;
  }, s.curve = function(f) {
    return arguments.length ? (o = f, a != null && (u = o(a)), s) : o;
  }, s.context = function(f) {
    return arguments.length ? (f == null ? a = u = null : u = o(a = f), s) : a;
  }, s;
}
class ep {
  constructor(t, r) {
    this._context = t, this._x = r;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, r) {
    switch (t = +t, r = +r, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, r, t, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, t, this._y0, t, r);
        break;
      }
    }
    this._x0 = t, this._y0 = r;
  }
}
function i0(e) {
  return new ep(e, !0);
}
function a0(e) {
  return new ep(e, !1);
}
const Lc = {
  draw(e, t) {
    const r = lt(t / gi);
    e.moveTo(r, 0), e.arc(0, 0, r, 0, aa);
  }
}, o0 = {
  draw(e, t) {
    const r = lt(t / 5) / 2;
    e.moveTo(-3 * r, -r), e.lineTo(-r, -r), e.lineTo(-r, -3 * r), e.lineTo(r, -3 * r), e.lineTo(r, -r), e.lineTo(3 * r, -r), e.lineTo(3 * r, r), e.lineTo(r, r), e.lineTo(r, 3 * r), e.lineTo(-r, 3 * r), e.lineTo(-r, r), e.lineTo(-3 * r, r), e.closePath();
  }
}, tp = lt(1 / 3), u0 = tp * 2, c0 = {
  draw(e, t) {
    const r = lt(t / u0), n = r * tp;
    e.moveTo(0, -r), e.lineTo(n, 0), e.lineTo(0, r), e.lineTo(-n, 0), e.closePath();
  }
}, s0 = {
  draw(e, t) {
    const r = lt(t), n = -r / 2;
    e.rect(n, n, r, r);
  }
}, l0 = 0.8908130915292852, rp = yi(gi / 10) / yi(7 * gi / 10), f0 = yi(aa / 10) * rp, d0 = -Gh(aa / 10) * rp, v0 = {
  draw(e, t) {
    const r = lt(t * l0), n = f0 * r, i = d0 * r;
    e.moveTo(0, -r), e.lineTo(n, i);
    for (let a = 1; a < 5; ++a) {
      const o = aa * a / 5, u = Gh(o), c = yi(o);
      e.lineTo(c * r, -u * r), e.lineTo(u * n - c * i, c * n + u * i);
    }
    e.closePath();
  }
}, Ja = lt(3), h0 = {
  draw(e, t) {
    const r = -lt(t / (Ja * 3));
    e.moveTo(0, r * 2), e.lineTo(-Ja * r, -r), e.lineTo(Ja * r, -r), e.closePath();
  }
}, Ze = -0.5, Je = lt(3) / 2, $u = 1 / lt(12), p0 = ($u / 2 + 1) * 3, m0 = {
  draw(e, t) {
    const r = lt(t / p0), n = r / 2, i = r * $u, a = n, o = r * $u + r, u = -a, c = o;
    e.moveTo(n, i), e.lineTo(a, o), e.lineTo(u, c), e.lineTo(Ze * n - Je * i, Je * n + Ze * i), e.lineTo(Ze * a - Je * o, Je * a + Ze * o), e.lineTo(Ze * u - Je * c, Je * u + Ze * c), e.lineTo(Ze * n + Je * i, Ze * i - Je * n), e.lineTo(Ze * a + Je * o, Ze * o - Je * a), e.lineTo(Ze * u + Je * c, Ze * c - Je * u), e.closePath();
  }
};
function y0(e, t) {
  let r = null, n = $c(i);
  e = typeof e == "function" ? e : X(e || Lc), t = typeof t == "function" ? t : X(t === void 0 ? 64 : +t);
  function i() {
    let a;
    if (r || (r = a = n()), e.apply(this, arguments).draw(r, +t.apply(this, arguments)), a) return r = null, a + "" || null;
  }
  return i.type = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : X(a), i) : e;
  }, i.size = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : X(+a), i) : t;
  }, i.context = function(a) {
    return arguments.length ? (r = a ?? null, i) : r;
  }, i;
}
function bi() {
}
function wi(e, t, r) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + r) / 6
  );
}
function np(e) {
  this._context = e;
}
np.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        wi(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        wi(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function g0(e) {
  return new np(e);
}
function ip(e) {
  this._context = e;
}
ip.prototype = {
  areaStart: bi,
  areaEnd: bi,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        wi(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function b0(e) {
  return new ip(e);
}
function ap(e) {
  this._context = e;
}
ap.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + e) / 6, n = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        wi(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function w0(e) {
  return new ap(e);
}
function op(e) {
  this._context = e;
}
op.prototype = {
  areaStart: bi,
  areaEnd: bi,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function x0(e) {
  return new op(e);
}
function Tl(e) {
  return e < 0 ? -1 : 1;
}
function Ml(e, t, r) {
  var n = e._x1 - e._x0, i = t - e._x1, a = (e._y1 - e._y0) / (n || i < 0 && -0), o = (r - e._y1) / (i || n < 0 && -0), u = (a * i + o * n) / (n + i);
  return (Tl(a) + Tl(o)) * Math.min(Math.abs(a), Math.abs(o), 0.5 * Math.abs(u)) || 0;
}
function Cl(e, t) {
  var r = e._x1 - e._x0;
  return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
}
function Qa(e, t, r) {
  var n = e._x0, i = e._y0, a = e._x1, o = e._y1, u = (a - n) / 3;
  e._context.bezierCurveTo(n + u, i + u * t, a - u, o - u * r, a, o);
}
function xi(e) {
  this._context = e;
}
xi.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        Qa(this, this._t0, Cl(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var r = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, Qa(this, Cl(this, r = Ml(this, e, t)), r);
          break;
        default:
          Qa(this, this._t0, r = Ml(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
    }
  }
};
function up(e) {
  this._context = new cp(e);
}
(up.prototype = Object.create(xi.prototype)).point = function(e, t) {
  xi.prototype.point.call(this, t, e);
};
function cp(e) {
  this._context = e;
}
cp.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, r, n, i, a) {
    this._context.bezierCurveTo(t, e, n, r, a, i);
  }
};
function O0(e) {
  return new xi(e);
}
function P0(e) {
  return new up(e);
}
function sp(e) {
  this._context = e;
}
sp.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, r = e.length;
    if (r)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), r === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var n = kl(e), i = kl(t), a = 0, o = 1; o < r; ++a, ++o)
          this._context.bezierCurveTo(n[0][a], i[0][a], n[1][a], i[1][a], e[o], t[o]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function kl(e) {
  var t, r = e.length - 1, n, i = new Array(r), a = new Array(r), o = new Array(r);
  for (i[0] = 0, a[0] = 2, o[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t) i[t] = 1, a[t] = 4, o[t] = 4 * e[t] + 2 * e[t + 1];
  for (i[r - 1] = 2, a[r - 1] = 7, o[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t) n = i[t] / a[t - 1], a[t] -= n, o[t] -= n * o[t - 1];
  for (i[r - 1] = o[r - 1] / a[r - 1], t = r - 2; t >= 0; --t) i[t] = (o[t] - i[t + 1]) / a[t];
  for (a[r - 1] = (e[r] + i[r - 1]) / 2, t = 0; t < r - 1; ++t) a[t] = 2 * e[t + 1] - i[t + 1];
  return [i, a];
}
function A0(e) {
  return new sp(e);
}
function ua(e, t) {
  this._context = e, this._t = t;
}
ua.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var r = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function S0(e) {
  return new ua(e, 0.5);
}
function E0(e) {
  return new ua(e, 0);
}
function _0(e) {
  return new ua(e, 1);
}
function Lr(e, t) {
  if ((o = e.length) > 1)
    for (var r = 1, n, i, a = e[t[0]], o, u = a.length; r < o; ++r)
      for (i = a, a = e[t[r]], n = 0; n < u; ++n)
        a[n][1] += a[n][0] = isNaN(i[n][1]) ? i[n][0] : i[n][1];
}
function Ru(e) {
  for (var t = e.length, r = new Array(t); --t >= 0; ) r[t] = t;
  return r;
}
function j0(e, t) {
  return e[t];
}
function T0(e) {
  const t = [];
  return t.key = e, t;
}
function M0() {
  var e = X([]), t = Ru, r = Lr, n = j0;
  function i(a) {
    var o = Array.from(e.apply(this, arguments), T0), u, c = o.length, s = -1, l;
    for (const f of a)
      for (u = 0, ++s; u < c; ++u)
        (o[u][s] = [0, +n(f, o[u].key, s, a)]).data = f;
    for (u = 0, l = Rc(t(o)); u < c; ++u)
      o[l[u]].index = u;
    return r(o, l), o;
  }
  return i.keys = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : X(Array.from(a)), i) : e;
  }, i.value = function(a) {
    return arguments.length ? (n = typeof a == "function" ? a : X(+a), i) : n;
  }, i.order = function(a) {
    return arguments.length ? (t = a == null ? Ru : typeof a == "function" ? a : X(Array.from(a)), i) : t;
  }, i.offset = function(a) {
    return arguments.length ? (r = a ?? Lr, i) : r;
  }, i;
}
function C0(e, t) {
  if ((n = e.length) > 0) {
    for (var r, n, i = 0, a = e[0].length, o; i < a; ++i) {
      for (o = r = 0; r < n; ++r) o += e[r][i][1] || 0;
      if (o) for (r = 0; r < n; ++r) e[r][i][1] /= o;
    }
    Lr(e, t);
  }
}
function k0(e, t) {
  if ((i = e.length) > 0) {
    for (var r = 0, n = e[t[0]], i, a = n.length; r < a; ++r) {
      for (var o = 0, u = 0; o < i; ++o) u += e[o][r][1] || 0;
      n[r][1] += n[r][0] = -u / 2;
    }
    Lr(e, t);
  }
}
function I0(e, t) {
  if (!(!((o = e.length) > 0) || !((a = (i = e[t[0]]).length) > 0))) {
    for (var r = 0, n = 1, i, a, o; n < a; ++n) {
      for (var u = 0, c = 0, s = 0; u < o; ++u) {
        for (var l = e[t[u]], f = l[n][1] || 0, d = l[n - 1][1] || 0, v = (f - d) / 2, h = 0; h < u; ++h) {
          var p = e[t[h]], m = p[n][1] || 0, y = p[n - 1][1] || 0;
          v += m - y;
        }
        c += f, s += v * f;
      }
      i[n - 1][1] += i[n - 1][0] = r, c && (r -= s / c);
    }
    i[n - 1][1] += i[n - 1][0] = r, Lr(e, t);
  }
}
var D0 = ["type", "size", "sizeType"];
function Lu() {
  return Lu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lu.apply(null, arguments);
}
function Il(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Dl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Il(Object(r), !0).forEach(function(n) {
      N0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Il(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function N0(e, t, r) {
  return (t = $0(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function $0(e) {
  var t = R0(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function R0(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function L0(e, t) {
  if (e == null) return {};
  var r, n, i = B0(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function B0(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var lp = {
  symbolCircle: Lc,
  symbolCross: o0,
  symbolDiamond: c0,
  symbolSquare: s0,
  symbolStar: v0,
  symbolTriangle: h0,
  symbolWye: m0
}, z0 = Math.PI / 180, q0 = (e) => {
  var t = "symbol".concat(Nn(e));
  return lp[t] || Lc;
}, K0 = (e, t, r) => {
  if (t === "area")
    return e;
  switch (r) {
    case "cross":
      return 5 * e * e / 9;
    case "diamond":
      return 0.5 * e * e / Math.sqrt(3);
    case "square":
      return e * e;
    case "star": {
      var n = 18 * z0;
      return 1.25 * e * e * (Math.tan(n) - Math.tan(n * 2) * Math.tan(n) ** 2);
    }
    case "triangle":
      return Math.sqrt(3) * e * e / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * e * e / 8;
    default:
      return Math.PI * e * e / 4;
  }
}, F0 = (e, t) => {
  lp["symbol".concat(Nn(e))] = t;
}, Bc = (e) => {
  var {
    type: t = "circle",
    size: r = 64,
    sizeType: n = "area"
  } = e, i = L0(e, D0), a = Dl(Dl({}, i), {}, {
    type: t,
    size: r,
    sizeType: n
  }), o = () => {
    var f = q0(t), d = y0().type(f).size(K0(r, n, t));
    return d();
  }, {
    className: u,
    cx: c,
    cy: s
  } = a, l = ie(a, !0);
  return c === +c && s === +s && r === +r ? /* @__PURE__ */ x.createElement("path", Lu({}, l, {
    className: G("recharts-symbols", u),
    transform: "translate(".concat(c, ", ").concat(s, ")"),
    d: o()
  })) : null;
};
Bc.registerSymbol = F0;
function Bu() {
  return Bu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bu.apply(null, arguments);
}
function Nl(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function W0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Nl(Object(r), !0).forEach(function(n) {
      zc(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Nl(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function zc(e, t, r) {
  return (t = U0(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function U0(e) {
  var t = V0(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function V0(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Qe = 32;
class qc extends Yr {
  /**
   * Render the path of icon
   * @param data Data of each legend item
   * @param iconType if defined, it will always render this icon. If undefined then it uses icon from data.type
   * @return Path element
   */
  renderIcon(t, r) {
    var {
      inactiveColor: n
    } = this.props, i = Qe / 2, a = Qe / 6, o = Qe / 3, u = t.inactive ? n : t.color, c = r ?? t.type;
    if (c === "none")
      return null;
    if (c === "plainline")
      return /* @__PURE__ */ x.createElement("line", {
        strokeWidth: 4,
        fill: "none",
        stroke: u,
        strokeDasharray: t.payload.strokeDasharray,
        x1: 0,
        y1: i,
        x2: Qe,
        y2: i,
        className: "recharts-legend-icon"
      });
    if (c === "line")
      return /* @__PURE__ */ x.createElement("path", {
        strokeWidth: 4,
        fill: "none",
        stroke: u,
        d: "M0,".concat(i, "h").concat(o, `
            A`).concat(a, ",").concat(a, ",0,1,1,").concat(2 * o, ",").concat(i, `
            H`).concat(Qe, "M").concat(2 * o, ",").concat(i, `
            A`).concat(a, ",").concat(a, ",0,1,1,").concat(o, ",").concat(i),
        className: "recharts-legend-icon"
      });
    if (c === "rect")
      return /* @__PURE__ */ x.createElement("path", {
        stroke: "none",
        fill: u,
        d: "M0,".concat(Qe / 8, "h").concat(Qe, "v").concat(Qe * 3 / 4, "h").concat(-Qe, "z"),
        className: "recharts-legend-icon"
      });
    if (/* @__PURE__ */ x.isValidElement(t.legendIcon)) {
      var s = W0({}, t);
      return delete s.legendIcon, /* @__PURE__ */ x.cloneElement(t.legendIcon, s);
    }
    return /* @__PURE__ */ x.createElement(Bc, {
      fill: u,
      cx: i,
      cy: i,
      size: Qe,
      sizeType: "diameter",
      type: c
    });
  }
  /**
   * Draw items of legend
   * @return Items
   */
  renderItems() {
    var {
      payload: t,
      iconSize: r,
      layout: n,
      formatter: i,
      inactiveColor: a,
      iconType: o
    } = this.props, u = {
      x: 0,
      y: 0,
      width: Qe,
      height: Qe
    }, c = {
      display: n === "horizontal" ? "inline-block" : "block",
      marginRight: 10
    }, s = {
      display: "inline-block",
      verticalAlign: "middle",
      marginRight: 4
    };
    return t.map((l, f) => {
      var d = l.formatter || i, v = G({
        "recharts-legend-item": !0,
        ["legend-item-".concat(f)]: !0,
        inactive: l.inactive
      });
      if (l.type === "none")
        return null;
      var h = l.inactive ? a : l.color, p = d ? d(l.value, l, f) : l.value;
      return /* @__PURE__ */ x.createElement("li", Bu({
        className: v,
        style: c,
        key: "legend-item-".concat(f)
      }, ia(this.props, l, f)), /* @__PURE__ */ x.createElement(Nc, {
        width: r,
        height: r,
        viewBox: u,
        style: s,
        "aria-label": "".concat(p, " legend icon")
      }, this.renderIcon(l, o)), /* @__PURE__ */ x.createElement("span", {
        className: "recharts-legend-item-text",
        style: {
          color: h
        }
      }, p));
    });
  }
  render() {
    var {
      payload: t,
      layout: r,
      align: n
    } = this.props;
    if (!t || !t.length)
      return null;
    var i = {
      padding: 0,
      margin: 0,
      textAlign: r === "horizontal" ? n : "left"
    };
    return /* @__PURE__ */ x.createElement("ul", {
      className: "recharts-default-legend",
      style: i
    }, this.renderItems());
  }
}
zc(qc, "displayName", "Legend");
zc(qc, "defaultProps", {
  align: "center",
  iconSize: 14,
  inactiveColor: "#ccc",
  layout: "horizontal",
  verticalAlign: "middle"
});
var eo = {}, to = {}, $l;
function H0() {
  return $l || ($l = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r, n) {
      const i = /* @__PURE__ */ new Map();
      for (let a = 0; a < r.length; a++) {
        const o = r[a], u = n(o);
        i.has(u) || i.set(u, o);
      }
      return Array.from(i.values());
    }
    e.uniqBy = t;
  })(to)), to;
}
var ro = {}, Rl;
function fp() {
  return Rl || (Rl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      return r;
    }
    e.identity = t;
  })(ro)), ro;
}
var no = {}, io = {}, ao = {}, Ll;
function G0() {
  return Ll || (Ll = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      return Number.isSafeInteger(r) && r >= 0;
    }
    e.isLength = t;
  })(ao)), ao;
}
var Bl;
function Kc() {
  return Bl || (Bl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ G0();
    function r(n) {
      return n != null && typeof n != "function" && t.isLength(n.length);
    }
    e.isArrayLike = r;
  })(io)), io;
}
var oo = {}, zl;
function Y0() {
  return zl || (zl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      return typeof r == "object" && r !== null;
    }
    e.isObjectLike = t;
  })(oo)), oo;
}
var ql;
function X0() {
  return ql || (ql = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ Kc(), r = /* @__PURE__ */ Y0();
    function n(i) {
      return r.isObjectLike(i) && t.isArrayLike(i);
    }
    e.isArrayLikeObject = n;
  })(no)), no;
}
var uo = {}, co = {}, Kl;
function Z0() {
  return Kl || (Kl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ Cc();
    function r(n) {
      return function(i) {
        return t.get(i, n);
      };
    }
    e.property = r;
  })(co)), co;
}
var so = {}, lo = {}, fo = {}, vo = {}, Fl;
function dp() {
  return Fl || (Fl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      return r !== null && (typeof r == "object" || typeof r == "function");
    }
    e.isObject = t;
  })(vo)), vo;
}
var ho = {}, Wl;
function vp() {
  return Wl || (Wl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      return r == null || typeof r != "object" && typeof r != "function";
    }
    e.isPrimitive = t;
  })(ho)), ho;
}
var po = {}, Ul;
function Fc() {
  return Ul || (Ul = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r, n) {
      return r === n || Number.isNaN(r) && Number.isNaN(n);
    }
    e.eq = t;
  })(po)), po;
}
var Vl;
function J0() {
  return Vl || (Vl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ Wc(), r = /* @__PURE__ */ dp(), n = /* @__PURE__ */ vp(), i = /* @__PURE__ */ Fc();
    function a(f, d, v) {
      return typeof v != "function" ? t.isMatch(f, d) : o(f, d, function h(p, m, y, g, b, O) {
        const w = v(p, m, y, g, b, O);
        return w !== void 0 ? !!w : o(p, m, h, O);
      }, /* @__PURE__ */ new Map());
    }
    function o(f, d, v, h) {
      if (d === f)
        return !0;
      switch (typeof d) {
        case "object":
          return u(f, d, v, h);
        case "function":
          return Object.keys(d).length > 0 ? o(f, { ...d }, v, h) : i.eq(f, d);
        default:
          return r.isObject(f) ? typeof d == "string" ? d === "" : !0 : i.eq(f, d);
      }
    }
    function u(f, d, v, h) {
      if (d == null)
        return !0;
      if (Array.isArray(d))
        return s(f, d, v, h);
      if (d instanceof Map)
        return c(f, d, v, h);
      if (d instanceof Set)
        return l(f, d, v, h);
      const p = Object.keys(d);
      if (f == null)
        return p.length === 0;
      if (p.length === 0)
        return !0;
      if (h && h.has(d))
        return h.get(d) === f;
      h && h.set(d, f);
      try {
        for (let m = 0; m < p.length; m++) {
          const y = p[m];
          if (!n.isPrimitive(f) && !(y in f) || d[y] === void 0 && f[y] !== void 0 || d[y] === null && f[y] !== null || !v(f[y], d[y], y, f, d, h))
            return !1;
        }
        return !0;
      } finally {
        h && h.delete(d);
      }
    }
    function c(f, d, v, h) {
      if (d.size === 0)
        return !0;
      if (!(f instanceof Map))
        return !1;
      for (const [p, m] of d.entries()) {
        const y = f.get(p);
        if (v(y, m, p, f, d, h) === !1)
          return !1;
      }
      return !0;
    }
    function s(f, d, v, h) {
      if (d.length === 0)
        return !0;
      if (!Array.isArray(f))
        return !1;
      const p = /* @__PURE__ */ new Set();
      for (let m = 0; m < d.length; m++) {
        const y = d[m];
        let g = !1;
        for (let b = 0; b < f.length; b++) {
          if (p.has(b))
            continue;
          const O = f[b];
          let w = !1;
          if (v(O, y, m, f, d, h) && (w = !0), w) {
            p.add(b), g = !0;
            break;
          }
        }
        if (!g)
          return !1;
      }
      return !0;
    }
    function l(f, d, v, h) {
      return d.size === 0 ? !0 : f instanceof Set ? s([...f], [...d], v, h) : !1;
    }
    e.isMatchWith = a, e.isSetMatch = l;
  })(fo)), fo;
}
var Hl;
function Wc() {
  return Hl || (Hl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ J0();
    function r(n, i) {
      return t.isMatchWith(n, i, () => {
      });
    }
    e.isMatch = r;
  })(lo)), lo;
}
var mo = {}, yo = {}, go = {}, Gl;
function hp() {
  return Gl || (Gl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      return Object.getOwnPropertySymbols(r).filter((n) => Object.prototype.propertyIsEnumerable.call(r, n));
    }
    e.getSymbols = t;
  })(go)), go;
}
var bo = {}, Yl;
function Uc() {
  return Yl || (Yl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      return r == null ? r === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(r);
    }
    e.getTag = t;
  })(bo)), bo;
}
var wo = {}, Xl;
function Vc() {
  return Xl || (Xl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = "[object RegExp]", r = "[object String]", n = "[object Number]", i = "[object Boolean]", a = "[object Arguments]", o = "[object Symbol]", u = "[object Date]", c = "[object Map]", s = "[object Set]", l = "[object Array]", f = "[object Function]", d = "[object ArrayBuffer]", v = "[object Object]", h = "[object Error]", p = "[object DataView]", m = "[object Uint8Array]", y = "[object Uint8ClampedArray]", g = "[object Uint16Array]", b = "[object Uint32Array]", O = "[object BigUint64Array]", w = "[object Int8Array]", P = "[object Int16Array]", A = "[object Int32Array]", _ = "[object BigInt64Array]", T = "[object Float32Array]", N = "[object Float64Array]";
    e.argumentsTag = a, e.arrayBufferTag = d, e.arrayTag = l, e.bigInt64ArrayTag = _, e.bigUint64ArrayTag = O, e.booleanTag = i, e.dataViewTag = p, e.dateTag = u, e.errorTag = h, e.float32ArrayTag = T, e.float64ArrayTag = N, e.functionTag = f, e.int16ArrayTag = P, e.int32ArrayTag = A, e.int8ArrayTag = w, e.mapTag = c, e.numberTag = n, e.objectTag = v, e.regexpTag = t, e.setTag = s, e.stringTag = r, e.symbolTag = o, e.uint16ArrayTag = g, e.uint32ArrayTag = b, e.uint8ArrayTag = m, e.uint8ClampedArrayTag = y;
  })(wo)), wo;
}
var xo = {}, Zl;
function Q0() {
  return Zl || (Zl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      return ArrayBuffer.isView(r) && !(r instanceof DataView);
    }
    e.isTypedArray = t;
  })(xo)), xo;
}
var Jl;
function pp() {
  return Jl || (Jl = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ hp(), r = /* @__PURE__ */ Uc(), n = /* @__PURE__ */ Vc(), i = /* @__PURE__ */ vp(), a = /* @__PURE__ */ Q0();
    function o(l, f) {
      return u(l, void 0, l, /* @__PURE__ */ new Map(), f);
    }
    function u(l, f, d, v = /* @__PURE__ */ new Map(), h = void 0) {
      const p = h?.(l, f, d, v);
      if (p !== void 0)
        return p;
      if (i.isPrimitive(l))
        return l;
      if (v.has(l))
        return v.get(l);
      if (Array.isArray(l)) {
        const m = new Array(l.length);
        v.set(l, m);
        for (let y = 0; y < l.length; y++)
          m[y] = u(l[y], y, d, v, h);
        return Object.hasOwn(l, "index") && (m.index = l.index), Object.hasOwn(l, "input") && (m.input = l.input), m;
      }
      if (l instanceof Date)
        return new Date(l.getTime());
      if (l instanceof RegExp) {
        const m = new RegExp(l.source, l.flags);
        return m.lastIndex = l.lastIndex, m;
      }
      if (l instanceof Map) {
        const m = /* @__PURE__ */ new Map();
        v.set(l, m);
        for (const [y, g] of l)
          m.set(y, u(g, y, d, v, h));
        return m;
      }
      if (l instanceof Set) {
        const m = /* @__PURE__ */ new Set();
        v.set(l, m);
        for (const y of l)
          m.add(u(y, void 0, d, v, h));
        return m;
      }
      if (typeof Buffer < "u" && Buffer.isBuffer(l))
        return l.subarray();
      if (a.isTypedArray(l)) {
        const m = new (Object.getPrototypeOf(l)).constructor(l.length);
        v.set(l, m);
        for (let y = 0; y < l.length; y++)
          m[y] = u(l[y], y, d, v, h);
        return m;
      }
      if (l instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && l instanceof SharedArrayBuffer)
        return l.slice(0);
      if (l instanceof DataView) {
        const m = new DataView(l.buffer.slice(0), l.byteOffset, l.byteLength);
        return v.set(l, m), c(m, l, d, v, h), m;
      }
      if (typeof File < "u" && l instanceof File) {
        const m = new File([l], l.name, {
          type: l.type
        });
        return v.set(l, m), c(m, l, d, v, h), m;
      }
      if (l instanceof Blob) {
        const m = new Blob([l], { type: l.type });
        return v.set(l, m), c(m, l, d, v, h), m;
      }
      if (l instanceof Error) {
        const m = new l.constructor();
        return v.set(l, m), m.message = l.message, m.name = l.name, m.stack = l.stack, m.cause = l.cause, c(m, l, d, v, h), m;
      }
      if (typeof l == "object" && s(l)) {
        const m = Object.create(Object.getPrototypeOf(l));
        return v.set(l, m), c(m, l, d, v, h), m;
      }
      return l;
    }
    function c(l, f, d = l, v, h) {
      const p = [...Object.keys(f), ...t.getSymbols(f)];
      for (let m = 0; m < p.length; m++) {
        const y = p[m], g = Object.getOwnPropertyDescriptor(l, y);
        (g == null || g.writable) && (l[y] = u(f[y], y, d, v, h));
      }
    }
    function s(l) {
      switch (r.getTag(l)) {
        case n.argumentsTag:
        case n.arrayTag:
        case n.arrayBufferTag:
        case n.dataViewTag:
        case n.booleanTag:
        case n.dateTag:
        case n.float32ArrayTag:
        case n.float64ArrayTag:
        case n.int8ArrayTag:
        case n.int16ArrayTag:
        case n.int32ArrayTag:
        case n.mapTag:
        case n.numberTag:
        case n.objectTag:
        case n.regexpTag:
        case n.setTag:
        case n.stringTag:
        case n.symbolTag:
        case n.uint8ArrayTag:
        case n.uint8ClampedArrayTag:
        case n.uint16ArrayTag:
        case n.uint32ArrayTag:
          return !0;
        default:
          return !1;
      }
    }
    e.cloneDeepWith = o, e.cloneDeepWithImpl = u, e.copyProperties = c;
  })(yo)), yo;
}
var Ql;
function ew() {
  return Ql || (Ql = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ pp();
    function r(n) {
      return t.cloneDeepWithImpl(n, void 0, n, /* @__PURE__ */ new Map(), void 0);
    }
    e.cloneDeep = r;
  })(mo)), mo;
}
var ef;
function tw() {
  return ef || (ef = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ Wc(), r = /* @__PURE__ */ ew();
    function n(i) {
      return i = r.cloneDeep(i), (a) => t.isMatch(a, i);
    }
    e.matches = n;
  })(so)), so;
}
var Oo = {}, Po = {}, Ao = {}, tf;
function rw() {
  return tf || (tf = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ pp(), r = /* @__PURE__ */ Vc();
    function n(i, a) {
      return t.cloneDeepWith(i, (o, u, c, s) => {
        const l = a?.(o, u, c, s);
        if (l !== void 0)
          return l;
        if (typeof i == "object")
          switch (Object.prototype.toString.call(i)) {
            case r.numberTag:
            case r.stringTag:
            case r.booleanTag: {
              const f = new i.constructor(i?.valueOf());
              return t.copyProperties(f, i), f;
            }
            case r.argumentsTag: {
              const f = {};
              return t.copyProperties(f, i), f.length = i.length, f[Symbol.iterator] = i[Symbol.iterator], f;
            }
            default:
              return;
          }
      });
    }
    e.cloneDeepWith = n;
  })(Ao)), Ao;
}
var rf;
function nw() {
  return rf || (rf = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ rw();
    function r(n) {
      return t.cloneDeepWith(n);
    }
    e.cloneDeep = r;
  })(Po)), Po;
}
var So = {}, Eo = {}, nf;
function mp() {
  return nf || (nf = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /^(?:0|[1-9]\d*)$/;
    function r(n, i = Number.MAX_SAFE_INTEGER) {
      switch (typeof n) {
        case "number":
          return Number.isInteger(n) && n >= 0 && n < i;
        case "symbol":
          return !1;
        case "string":
          return t.test(n);
      }
    }
    e.isIndex = r;
  })(Eo)), Eo;
}
var _o = {}, af;
function iw() {
  return af || (af = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ Uc();
    function r(n) {
      return n !== null && typeof n == "object" && t.getTag(n) === "[object Arguments]";
    }
    e.isArguments = r;
  })(_o)), _o;
}
var of;
function aw() {
  return of || (of = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ zh(), r = /* @__PURE__ */ mp(), n = /* @__PURE__ */ iw(), i = /* @__PURE__ */ Mc();
    function a(o, u) {
      let c;
      if (Array.isArray(u) ? c = u : typeof u == "string" && t.isDeepKey(u) && o?.[u] == null ? c = i.toPath(u) : c = [u], c.length === 0)
        return !1;
      let s = o;
      for (let l = 0; l < c.length; l++) {
        const f = c[l];
        if ((s == null || !Object.hasOwn(s, f)) && !((Array.isArray(s) || n.isArguments(s)) && r.isIndex(f) && f < s.length))
          return !1;
        s = s[f];
      }
      return !0;
    }
    e.has = a;
  })(So)), So;
}
var uf;
function ow() {
  return uf || (uf = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ Wc(), r = /* @__PURE__ */ qh(), n = /* @__PURE__ */ nw(), i = /* @__PURE__ */ Cc(), a = /* @__PURE__ */ aw();
    function o(u, c) {
      switch (typeof u) {
        case "object": {
          Object.is(u?.valueOf(), -0) && (u = "-0");
          break;
        }
        case "number": {
          u = r.toKey(u);
          break;
        }
      }
      return c = n.cloneDeep(c), function(s) {
        const l = i.get(s, u);
        return l === void 0 ? a.has(s, u) : c === void 0 ? l === void 0 : t.isMatch(l, c);
      };
    }
    e.matchesProperty = o;
  })(Oo)), Oo;
}
var cf;
function uw() {
  return cf || (cf = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ fp(), r = /* @__PURE__ */ Z0(), n = /* @__PURE__ */ tw(), i = /* @__PURE__ */ ow();
    function a(o) {
      if (o == null)
        return t.identity;
      switch (typeof o) {
        case "function":
          return o;
        case "object":
          return Array.isArray(o) && o.length === 2 ? i.matchesProperty(o[0], o[1]) : n.matches(o);
        case "string":
        case "symbol":
        case "number":
          return r.property(o);
      }
    }
    e.iteratee = a;
  })(uo)), uo;
}
var sf;
function cw() {
  return sf || (sf = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ H0(), r = /* @__PURE__ */ fp(), n = /* @__PURE__ */ X0(), i = /* @__PURE__ */ uw();
    function a(o, u = r.identity) {
      return n.isArrayLikeObject(o) ? t.uniqBy(Array.from(o), i.iteratee(u)) : [];
    }
    e.uniqBy = a;
  })(eo)), eo;
}
var jo, lf;
function sw() {
  return lf || (lf = 1, jo = cw().uniqBy), jo;
}
var lw = /* @__PURE__ */ sw();
const ff = /* @__PURE__ */ It(lw);
function yp(e, t, r) {
  return t === !0 ? ff(e, r) : typeof t == "function" ? ff(e, t) : e;
}
var ei = { exports: {} }, To = {};
var df;
function fw() {
  if (df) return To;
  df = 1;
  var e = Dn, t = Bh();
  function r(s, l) {
    return s === l && (s !== 0 || 1 / s === 1 / l) || s !== s && l !== l;
  }
  var n = typeof Object.is == "function" ? Object.is : r, i = t.useSyncExternalStore, a = e.useRef, o = e.useEffect, u = e.useMemo, c = e.useDebugValue;
  return To.useSyncExternalStoreWithSelector = function(s, l, f, d, v) {
    var h = a(null);
    if (h.current === null) {
      var p = { hasValue: !1, value: null };
      h.current = p;
    } else p = h.current;
    h = u(
      function() {
        function y(P) {
          if (!g) {
            if (g = !0, b = P, P = d(P), v !== void 0 && p.hasValue) {
              var A = p.value;
              if (v(A, P))
                return O = A;
            }
            return O = P;
          }
          if (A = O, n(b, P)) return A;
          var _ = d(P);
          return v !== void 0 && v(A, _) ? (b = P, A) : (b = P, O = _);
        }
        var g = !1, b, O, w = f === void 0 ? null : f;
        return [
          function() {
            return y(l());
          },
          w === null ? void 0 : function() {
            return y(w());
          }
        ];
      },
      [l, f, d, v]
    );
    var m = i(s, h[0], h[1]);
    return o(
      function() {
        p.hasValue = !0, p.value = m;
      },
      [m]
    ), c(m), m;
  }, To;
}
var Mo = {};
var vf;
function dw() {
  return vf || (vf = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(s, l) {
      return s === l && (s !== 0 || 1 / s === 1 / l) || s !== s && l !== l;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = Dn, r = Bh(), n = typeof Object.is == "function" ? Object.is : e, i = r.useSyncExternalStore, a = t.useRef, o = t.useEffect, u = t.useMemo, c = t.useDebugValue;
    Mo.useSyncExternalStoreWithSelector = function(s, l, f, d, v) {
      var h = a(null);
      if (h.current === null) {
        var p = { hasValue: !1, value: null };
        h.current = p;
      } else p = h.current;
      h = u(
        function() {
          function y(P) {
            if (!g) {
              if (g = !0, b = P, P = d(P), v !== void 0 && p.hasValue) {
                var A = p.value;
                if (v(A, P))
                  return O = A;
              }
              return O = P;
            }
            if (A = O, n(b, P))
              return A;
            var _ = d(P);
            return v !== void 0 && v(A, _) ? (b = P, A) : (b = P, O = _);
          }
          var g = !1, b, O, w = f === void 0 ? null : f;
          return [
            function() {
              return y(l());
            },
            w === null ? void 0 : function() {
              return y(w());
            }
          ];
        },
        [l, f, d, v]
      );
      var m = i(s, h[0], h[1]);
      return o(
        function() {
          p.hasValue = !0, p.value = m;
        },
        [m]
      ), c(m), m;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), Mo;
}
var hf;
function vw() {
  return hf || (hf = 1, process.env.NODE_ENV === "production" ? ei.exports = fw() : ei.exports = dw()), ei.exports;
}
var hw = vw(), Hc = /* @__PURE__ */ er(null), pw = (e) => e, be = () => {
  var e = Gr(Hc);
  return e ? e.store.dispatch : pw;
}, pi = () => {
}, mw = () => pi, yw = (e, t) => e === t;
function $(e) {
  var t = Gr(Hc);
  return hw.useSyncExternalStoreWithSelector(t ? t.subscription.addNestedSub : mw, t ? t.store.getState : pi, t ? t.store.getState : pi, t ? e : pi, yw);
}
var gw = (e, t, r) => {
  if (t.length === 1 && t[0] === r) {
    let n = !1;
    try {
      const i = {};
      e(i) === i && (n = !0);
    } catch {
    }
    if (n) {
      let i;
      try {
        throw new Error();
      } catch (a) {
        ({ stack: i } = a);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: i }
      );
    }
  }
}, bw = (e, t, r) => {
  const { memoize: n, memoizeOptions: i } = t, { inputSelectorResults: a, inputSelectorResultsCopy: o } = e, u = n(() => ({}), ...i);
  if (!(u.apply(null, a) === u.apply(null, o))) {
    let s;
    try {
      throw new Error();
    } catch (l) {
      ({ stack: s } = l);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: r,
        firstInputs: a,
        secondInputs: o,
        stack: s
      }
    );
  }
}, ww = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
function xw(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function Ow(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function Pw(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((r) => typeof r == "function")) {
    const r = e.map(
      (n) => typeof n == "function" ? `function ${n.name || "unnamed"}()` : typeof n
    ).join(", ");
    throw new TypeError(`${t}[${r}]`);
  }
}
var pf = (e) => Array.isArray(e) ? e : [e];
function Aw(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return Pw(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function mf(e, t) {
  const r = [], { length: n } = e;
  for (let i = 0; i < n; i++)
    r.push(e[i].apply(null, t));
  return r;
}
var Sw = (e, t) => {
  const { identityFunctionCheck: r, inputStabilityCheck: n } = {
    ...ww,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: r === "always" || r === "once" && e,
      run: gw
    },
    inputStabilityCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: bw
    }
  };
}, Ew = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, _w = typeof WeakRef < "u" ? WeakRef : Ew, jw = 0, yf = 1;
function ti() {
  return {
    s: jw,
    v: void 0,
    o: null,
    p: null
  };
}
function gp(e, t = {}) {
  let r = ti();
  const { resultEqualityCheck: n } = t;
  let i, a = 0;
  function o() {
    let u = r;
    const { length: c } = arguments;
    for (let f = 0, d = c; f < d; f++) {
      const v = arguments[f];
      if (typeof v == "function" || typeof v == "object" && v !== null) {
        let h = u.o;
        h === null && (u.o = h = /* @__PURE__ */ new WeakMap());
        const p = h.get(v);
        p === void 0 ? (u = ti(), h.set(v, u)) : u = p;
      } else {
        let h = u.p;
        h === null && (u.p = h = /* @__PURE__ */ new Map());
        const p = h.get(v);
        p === void 0 ? (u = ti(), h.set(v, u)) : u = p;
      }
    }
    const s = u;
    let l;
    if (u.s === yf)
      l = u.v;
    else if (l = e.apply(null, arguments), a++, n) {
      const f = i?.deref?.() ?? i;
      f != null && n(f, l) && (l = f, a !== 0 && a--), i = typeof l == "object" && l !== null || typeof l == "function" ? new _w(l) : l;
    }
    return s.s = yf, s.v = l, l;
  }
  return o.clearCache = () => {
    r = ti(), o.resetResultsCount();
  }, o.resultsCount = () => a, o.resetResultsCount = () => {
    a = 0;
  }, o;
}
function Tw(e, ...t) {
  const r = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, n = (...i) => {
    let a = 0, o = 0, u, c = {}, s = i.pop();
    typeof s == "object" && (c = s, s = i.pop()), xw(
      s,
      `createSelector expects an output function after the inputs, but received: [${typeof s}]`
    );
    const l = {
      ...r,
      ...c
    }, {
      memoize: f,
      memoizeOptions: d = [],
      argsMemoize: v = gp,
      argsMemoizeOptions: h = [],
      devModeChecks: p = {}
    } = l, m = pf(d), y = pf(h), g = Aw(i), b = f(function() {
      return a++, s.apply(
        null,
        arguments
      );
    }, ...m);
    let O = !0;
    const w = v(function() {
      o++;
      const A = mf(
        g,
        arguments
      );
      if (u = b.apply(null, A), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: _, inputStabilityCheck: T } = Sw(O, p);
        if (_.shouldRun && _.run(
          s,
          A,
          u
        ), T.shouldRun) {
          const N = mf(
            g,
            arguments
          );
          T.run(
            { inputSelectorResults: A, inputSelectorResultsCopy: N },
            { memoize: f, memoizeOptions: m },
            arguments
          );
        }
        O && (O = !1);
      }
      return u;
    }, ...y);
    return Object.assign(w, {
      resultFunc: s,
      memoizedResultFunc: b,
      dependencies: g,
      dependencyRecomputations: () => o,
      resetDependencyRecomputations: () => {
        o = 0;
      },
      lastResult: () => u,
      recomputations: () => a,
      resetRecomputations: () => {
        a = 0;
      },
      memoize: f,
      argsMemoize: v
    });
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var S = /* @__PURE__ */ Tw(gp), Mw = Object.assign(
  (e, t = S) => {
    Ow(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const r = Object.keys(e), n = r.map(
      (a) => e[a]
    );
    return t(
      n,
      (...a) => a.reduce((o, u, c) => (o[r[c]] = u, o), {})
    );
  },
  { withTypes: () => Mw }
), Co = {}, ko = {}, Io = {}, gf;
function Cw() {
  return gf || (gf = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(n) {
      return typeof n == "symbol" ? 1 : n === null ? 2 : n === void 0 ? 3 : n !== n ? 4 : 0;
    }
    const r = (n, i, a) => {
      if (n !== i) {
        const o = t(n), u = t(i);
        if (o === u && o === 0) {
          if (n < i)
            return a === "desc" ? 1 : -1;
          if (n > i)
            return a === "desc" ? -1 : 1;
        }
        return a === "desc" ? u - o : o - u;
      }
      return 0;
    };
    e.compareValues = r;
  })(Io)), Io;
}
var Do = {}, No = {}, bf;
function bp() {
  return bf || (bf = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      return typeof r == "symbol" || r instanceof Symbol;
    }
    e.isSymbol = t;
  })(No)), No;
}
var wf;
function kw() {
  return wf || (wf = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ bp(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
    function i(a, o) {
      return Array.isArray(a) ? !1 : typeof a == "number" || typeof a == "boolean" || a == null || t.isSymbol(a) ? !0 : typeof a == "string" && (n.test(a) || !r.test(a)) || o != null && Object.hasOwn(o, a);
    }
    e.isKey = i;
  })(Do)), Do;
}
var xf;
function Iw() {
  return xf || (xf = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ Cw(), r = /* @__PURE__ */ kw(), n = /* @__PURE__ */ Mc();
    function i(a, o, u, c) {
      if (a == null)
        return [];
      u = c ? void 0 : u, Array.isArray(a) || (a = Object.values(a)), Array.isArray(o) || (o = o == null ? [null] : [o]), o.length === 0 && (o = [null]), Array.isArray(u) || (u = u == null ? [] : [u]), u = u.map((v) => String(v));
      const s = (v, h) => {
        let p = v;
        for (let m = 0; m < h.length && p != null; ++m)
          p = p[h[m]];
        return p;
      }, l = (v, h) => h == null || v == null ? h : typeof v == "object" && "key" in v ? Object.hasOwn(h, v.key) ? h[v.key] : s(h, v.path) : typeof v == "function" ? v(h) : Array.isArray(v) ? s(h, v) : typeof h == "object" ? h[v] : h, f = o.map((v) => (Array.isArray(v) && v.length === 1 && (v = v[0]), v == null || typeof v == "function" || Array.isArray(v) || r.isKey(v) ? v : { key: v, path: n.toPath(v) }));
      return a.map((v) => ({
        original: v,
        criteria: f.map((h) => l(h, v))
      })).slice().sort((v, h) => {
        for (let p = 0; p < f.length; p++) {
          const m = t.compareValues(v.criteria[p], h.criteria[p], u[p]);
          if (m !== 0)
            return m;
        }
        return 0;
      }).map((v) => v.original);
    }
    e.orderBy = i;
  })(ko)), ko;
}
var $o = {}, Of;
function Dw() {
  return Of || (Of = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r, n = 1) {
      const i = [], a = Math.floor(n), o = (u, c) => {
        for (let s = 0; s < u.length; s++) {
          const l = u[s];
          Array.isArray(l) && c < a ? o(l, c + 1) : i.push(l);
        }
      };
      return o(r, 0), i;
    }
    e.flatten = t;
  })($o)), $o;
}
var Ro = {}, Pf;
function wp() {
  return Pf || (Pf = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ mp(), r = /* @__PURE__ */ Kc(), n = /* @__PURE__ */ dp(), i = /* @__PURE__ */ Fc();
    function a(o, u, c) {
      return n.isObject(c) && (typeof u == "number" && r.isArrayLike(c) && t.isIndex(u) && u < c.length || typeof u == "string" && u in c) ? i.eq(c[u], o) : !1;
    }
    e.isIterateeCall = a;
  })(Ro)), Ro;
}
var Af;
function Nw() {
  return Af || (Af = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ Iw(), r = /* @__PURE__ */ Dw(), n = /* @__PURE__ */ wp();
    function i(a, ...o) {
      const u = o.length;
      return u > 1 && n.isIterateeCall(a, o[0], o[1]) ? o = [] : u > 2 && n.isIterateeCall(o[0], o[1], o[2]) && (o = [o[0]]), t.orderBy(a, r.flatten(o), ["asc"]);
    }
    e.sortBy = i;
  })(Co)), Co;
}
var Lo, Sf;
function $w() {
  return Sf || (Sf = 1, Lo = Nw().sortBy), Lo;
}
var Rw = /* @__PURE__ */ $w();
const ca = /* @__PURE__ */ It(Rw);
var xp = (e) => e.legend.settings, Lw = (e) => e.legend.size, Bw = (e) => e.legend.payload, zw = S([Bw, xp], (e, t) => {
  var {
    itemSorter: r
  } = t, n = e.flat(1);
  return r ? ca(n, r) : n;
});
function qw() {
  return $(zw);
}
var ri = 1;
function Op() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], [t, r] = ct({
    height: 0,
    left: 0,
    top: 0,
    width: 0
  }), n = oe((i) => {
    if (i != null) {
      var a = i.getBoundingClientRect(), o = {
        height: a.height,
        left: a.left,
        top: a.top,
        width: a.width
      };
      (Math.abs(o.height - t.height) > ri || Math.abs(o.left - t.left) > ri || Math.abs(o.top - t.top) > ri || Math.abs(o.width - t.width) > ri) && r({
        height: o.height,
        left: o.left,
        top: o.top,
        width: o.width
      });
    }
  }, [t.width, t.height, t.top, t.left, ...e]);
  return [t, n];
}
function ye(e) {
  for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
  if (process.env.NODE_ENV !== "production") {
    var i = Yw[e], a = i ? typeof i == "function" ? i.apply(null, r) : i : "unknown error nr: " + e;
    throw Error("[Immer] " + a);
  }
  throw Error("[Immer] minified error nr: " + e + (r.length ? " " + r.map((function(o) {
    return "'" + o + "'";
  })).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function Zt(e) {
  return !!e && !!e[Q];
}
function jt(e) {
  var t;
  return !!e && ((function(r) {
    if (!r || typeof r != "object") return !1;
    var n = Object.getPrototypeOf(r);
    if (n === null) return !0;
    var i = Object.hasOwnProperty.call(n, "constructor") && n.constructor;
    return i === Object || typeof i == "function" && Function.toString.call(i) === Xw;
  })(e) || Array.isArray(e) || !!e[kf] || !!(!((t = e.constructor) === null || t === void 0) && t[kf]) || Gc(e) || Yc(e));
}
function br(e, t, r) {
  r === void 0 && (r = !1), Xr(e) === 0 ? (r ? Object.keys : Dr)(e).forEach((function(n) {
    r && typeof n == "symbol" || t(n, e[n], e);
  })) : e.forEach((function(n, i) {
    return t(i, n, e);
  }));
}
function Xr(e) {
  var t = e[Q];
  return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : Gc(e) ? 2 : Yc(e) ? 3 : 0;
}
function Ir(e, t) {
  return Xr(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Kw(e, t) {
  return Xr(e) === 2 ? e.get(t) : e[t];
}
function Pp(e, t, r) {
  var n = Xr(e);
  n === 2 ? e.set(t, r) : n === 3 ? e.add(r) : e[t] = r;
}
function Ap(e, t) {
  return e === t ? e !== 0 || 1 / e == 1 / t : e != e && t != t;
}
function Gc(e) {
  return Hw && e instanceof Map;
}
function Yc(e) {
  return Gw && e instanceof Set;
}
function Wt(e) {
  return e.o || e.t;
}
function Xc(e) {
  if (Array.isArray(e)) return Array.prototype.slice.call(e);
  var t = Ep(e);
  delete t[Q];
  for (var r = Dr(t), n = 0; n < r.length; n++) {
    var i = r[n], a = t[i];
    a.writable === !1 && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (t[i] = { configurable: !0, writable: !0, enumerable: a.enumerable, value: e[i] });
  }
  return Object.create(Object.getPrototypeOf(e), t);
}
function Zc(e, t) {
  return t === void 0 && (t = !1), Jc(e) || Zt(e) || !jt(e) || (Xr(e) > 1 && (e.set = e.add = e.clear = e.delete = Fw), Object.freeze(e), t && br(e, (function(r, n) {
    return Zc(n, !0);
  }), !0)), e;
}
function Fw() {
  ye(2);
}
function Jc(e) {
  return e == null || typeof e != "object" || Object.isFrozen(e);
}
function ht(e) {
  var t = Fu[e];
  return t || ye(18, e), t;
}
function Ww(e, t) {
  Fu[e] || (Fu[e] = t);
}
function zu() {
  return process.env.NODE_ENV === "production" || Br || ye(0), Br;
}
function Bo(e, t) {
  t && (ht("Patches"), e.u = [], e.s = [], e.v = t);
}
function Oi(e) {
  qu(e), e.p.forEach(Uw), e.p = null;
}
function qu(e) {
  e === Br && (Br = e.l);
}
function Ef(e) {
  return Br = { p: [], l: Br, h: e, m: !0, _: 0 };
}
function Uw(e) {
  var t = e[Q];
  t.i === 0 || t.i === 1 ? t.j() : t.g = !0;
}
function zo(e, t) {
  t._ = t.p.length;
  var r = t.p[0], n = e !== void 0 && e !== r;
  return t.h.O || ht("ES5").S(t, e, n), n ? (r[Q].P && (Oi(t), ye(4)), jt(e) && (e = Pi(t, e), t.l || Ai(t, e)), t.u && ht("Patches").M(r[Q].t, e, t.u, t.s)) : e = Pi(t, r, []), Oi(t), t.u && t.v(t.u, t.s), e !== Sp ? e : void 0;
}
function Pi(e, t, r) {
  if (Jc(t)) return t;
  var n = t[Q];
  if (!n) return br(t, (function(u, c) {
    return _f(e, n, t, u, c, r);
  }), !0), t;
  if (n.A !== e) return t;
  if (!n.P) return Ai(e, n.t, !0), n.t;
  if (!n.I) {
    n.I = !0, n.A._--;
    var i = n.i === 4 || n.i === 5 ? n.o = Xc(n.k) : n.o, a = i, o = !1;
    n.i === 3 && (a = new Set(i), i.clear(), o = !0), br(a, (function(u, c) {
      return _f(e, n, i, u, c, r, o);
    })), Ai(e, i, !1), r && e.u && ht("Patches").N(n, r, e.u, e.s);
  }
  return n.o;
}
function _f(e, t, r, n, i, a, o) {
  if (process.env.NODE_ENV !== "production" && i === r && ye(5), Zt(i)) {
    var u = Pi(e, i, a && t && t.i !== 3 && !Ir(t.R, n) ? a.concat(n) : void 0);
    if (Pp(r, n, u), !Zt(u)) return;
    e.m = !1;
  } else o && r.add(i);
  if (jt(i) && !Jc(i)) {
    if (!e.h.D && e._ < 1) return;
    Pi(e, i), t && t.A.l || Ai(e, i);
  }
}
function Ai(e, t, r) {
  r === void 0 && (r = !1), !e.l && e.h.D && e.m && Zc(t, r);
}
function qo(e, t) {
  var r = e[Q];
  return (r ? Wt(r) : e)[t];
}
function jf(e, t) {
  if (t in e) for (var r = Object.getPrototypeOf(e); r; ) {
    var n = Object.getOwnPropertyDescriptor(r, t);
    if (n) return n;
    r = Object.getPrototypeOf(r);
  }
}
function Vt(e) {
  e.P || (e.P = !0, e.l && Vt(e.l));
}
function Ko(e) {
  e.o || (e.o = Xc(e.t));
}
function Ku(e, t, r) {
  var n = Gc(t) ? ht("MapSet").F(t, r) : Yc(t) ? ht("MapSet").T(t, r) : e.O ? (function(i, a) {
    var o = Array.isArray(i), u = { i: o ? 1 : 0, A: a ? a.A : zu(), P: !1, I: !1, R: {}, l: a, t: i, k: null, o: null, j: null, C: !1 }, c = u, s = xn;
    o && (c = [u], s = mn);
    var l = Proxy.revocable(c, s), f = l.revoke, d = l.proxy;
    return u.k = d, u.j = f, d;
  })(t, r) : ht("ES5").J(t, r);
  return (r ? r.A : zu()).p.push(n), n;
}
function St(e) {
  return Zt(e) || ye(22, e), (function t(r) {
    if (!jt(r)) return r;
    var n, i = r[Q], a = Xr(r);
    if (i) {
      if (!i.P && (i.i < 4 || !ht("ES5").K(i))) return i.t;
      i.I = !0, n = Tf(r, a), i.I = !1;
    } else n = Tf(r, a);
    return br(n, (function(o, u) {
      i && Kw(i.t, o) === u || Pp(n, o, t(u));
    })), a === 3 ? new Set(n) : n;
  })(e);
}
function Tf(e, t) {
  switch (t) {
    case 2:
      return new Map(e);
    case 3:
      return Array.from(e);
  }
  return Xc(e);
}
function Vw() {
  function e(o, u) {
    var c = a[o];
    return c ? c.enumerable = u : a[o] = c = { configurable: !0, enumerable: u, get: function() {
      var s = this[Q];
      return process.env.NODE_ENV !== "production" && i(s), xn.get(s, o);
    }, set: function(s) {
      var l = this[Q];
      process.env.NODE_ENV !== "production" && i(l), xn.set(l, o, s);
    } }, c;
  }
  function t(o) {
    for (var u = o.length - 1; u >= 0; u--) {
      var c = o[u][Q];
      if (!c.P) switch (c.i) {
        case 5:
          n(c) && Vt(c);
          break;
        case 4:
          r(c) && Vt(c);
      }
    }
  }
  function r(o) {
    for (var u = o.t, c = o.k, s = Dr(c), l = s.length - 1; l >= 0; l--) {
      var f = s[l];
      if (f !== Q) {
        var d = u[f];
        if (d === void 0 && !Ir(u, f)) return !0;
        var v = c[f], h = v && v[Q];
        if (h ? h.t !== d : !Ap(v, d)) return !0;
      }
    }
    var p = !!u[Q];
    return s.length !== Dr(u).length + (p ? 0 : 1);
  }
  function n(o) {
    var u = o.k;
    if (u.length !== o.t.length) return !0;
    var c = Object.getOwnPropertyDescriptor(u, u.length - 1);
    if (c && !c.get) return !0;
    for (var s = 0; s < u.length; s++) if (!u.hasOwnProperty(s)) return !0;
    return !1;
  }
  function i(o) {
    o.g && ye(3, JSON.stringify(Wt(o)));
  }
  var a = {};
  Ww("ES5", { J: function(o, u) {
    var c = Array.isArray(o), s = (function(f, d) {
      if (f) {
        for (var v = Array(d.length), h = 0; h < d.length; h++) Object.defineProperty(v, "" + h, e(h, !0));
        return v;
      }
      var p = Ep(d);
      delete p[Q];
      for (var m = Dr(p), y = 0; y < m.length; y++) {
        var g = m[y];
        p[g] = e(g, f || !!p[g].enumerable);
      }
      return Object.create(Object.getPrototypeOf(d), p);
    })(c, o), l = { i: c ? 5 : 4, A: u ? u.A : zu(), P: !1, I: !1, R: {}, l: u, t: o, k: s, o: null, g: !1, C: !1 };
    return Object.defineProperty(s, Q, { value: l, writable: !0 }), s;
  }, S: function(o, u, c) {
    c ? Zt(u) && u[Q].A === o && t(o.p) : (o.u && (function s(l) {
      if (l && typeof l == "object") {
        var f = l[Q];
        if (f) {
          var d = f.t, v = f.k, h = f.R, p = f.i;
          if (p === 4) br(v, (function(O) {
            O !== Q && (d[O] !== void 0 || Ir(d, O) ? h[O] || s(v[O]) : (h[O] = !0, Vt(f)));
          })), br(d, (function(O) {
            v[O] !== void 0 || Ir(v, O) || (h[O] = !1, Vt(f));
          }));
          else if (p === 5) {
            if (n(f) && (Vt(f), h.length = !0), v.length < d.length) for (var m = v.length; m < d.length; m++) h[m] = !1;
            else for (var y = d.length; y < v.length; y++) h[y] = !0;
            for (var g = Math.min(v.length, d.length), b = 0; b < g; b++) v.hasOwnProperty(b) || (h[b] = !0), h[b] === void 0 && s(v[b]);
          }
        }
      }
    })(o.p[0]), t(o.p));
  }, K: function(o) {
    return o.i === 4 ? r(o) : n(o);
  } });
}
var Mf, Br, Qc = typeof Symbol < "u" && typeof /* @__PURE__ */ Symbol("x") == "symbol", Hw = typeof Map < "u", Gw = typeof Set < "u", Cf = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", Sp = Qc ? /* @__PURE__ */ Symbol.for("immer-nothing") : ((Mf = {})["immer-nothing"] = !0, Mf), kf = Qc ? /* @__PURE__ */ Symbol.for("immer-draftable") : "__$immer_draftable", Q = Qc ? /* @__PURE__ */ Symbol.for("immer-state") : "__$immer_state", Yw = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(e) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(e) {
  return "Cannot apply patch, path doesn't resolve: " + e;
}, 16: 'Sets cannot have "replace" patches.', 17: function(e) {
  return "Unsupported patch operation: " + e;
}, 18: function(e) {
  return "The plugin for '" + e + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + e + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(e) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + e + "'";
}, 22: function(e) {
  return "'current' expects a draft, got: " + e;
}, 23: function(e) {
  return "'original' expects a draft, got: " + e;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, Xw = "" + Object.prototype.constructor, Dr = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Object.getOwnPropertyNames, Ep = Object.getOwnPropertyDescriptors || function(e) {
  var t = {};
  return Dr(e).forEach((function(r) {
    t[r] = Object.getOwnPropertyDescriptor(e, r);
  })), t;
}, Fu = {}, xn = { get: function(e, t) {
  if (t === Q) return e;
  var r = Wt(e);
  if (!Ir(r, t)) return (function(i, a, o) {
    var u, c = jf(a, o);
    return c ? "value" in c ? c.value : (u = c.get) === null || u === void 0 ? void 0 : u.call(i.k) : void 0;
  })(e, r, t);
  var n = r[t];
  return e.I || !jt(n) ? n : n === qo(e.t, t) ? (Ko(e), e.o[t] = Ku(e.A.h, n, e)) : n;
}, has: function(e, t) {
  return t in Wt(e);
}, ownKeys: function(e) {
  return Reflect.ownKeys(Wt(e));
}, set: function(e, t, r) {
  var n = jf(Wt(e), t);
  if (n?.set) return n.set.call(e.k, r), !0;
  if (!e.P) {
    var i = qo(Wt(e), t), a = i?.[Q];
    if (a && a.t === r) return e.o[t] = r, e.R[t] = !1, !0;
    if (Ap(r, i) && (r !== void 0 || Ir(e.t, t))) return !0;
    Ko(e), Vt(e);
  }
  return e.o[t] === r && (r !== void 0 || t in e.o) || Number.isNaN(r) && Number.isNaN(e.o[t]) || (e.o[t] = r, e.R[t] = !0), !0;
}, deleteProperty: function(e, t) {
  return qo(e.t, t) !== void 0 || t in e.t ? (e.R[t] = !1, Ko(e), Vt(e)) : delete e.R[t], e.o && delete e.o[t], !0;
}, getOwnPropertyDescriptor: function(e, t) {
  var r = Wt(e), n = Reflect.getOwnPropertyDescriptor(r, t);
  return n && { writable: !0, configurable: e.i !== 1 || t !== "length", enumerable: n.enumerable, value: r[t] };
}, defineProperty: function() {
  ye(11);
}, getPrototypeOf: function(e) {
  return Object.getPrototypeOf(e.t);
}, setPrototypeOf: function() {
  ye(12);
} }, mn = {};
br(xn, (function(e, t) {
  mn[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
})), mn.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && ye(13), mn.set.call(this, e, t, void 0);
}, mn.set = function(e, t, r) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && ye(14), xn.set.call(this, e[0], t, r, e[0]);
};
var Zw = (function() {
  function e(r) {
    var n = this;
    this.O = Cf, this.D = !0, this.produce = function(i, a, o) {
      if (typeof i == "function" && typeof a != "function") {
        var u = a;
        a = i;
        var c = n;
        return function(p) {
          var m = this;
          p === void 0 && (p = u);
          for (var y = arguments.length, g = Array(y > 1 ? y - 1 : 0), b = 1; b < y; b++) g[b - 1] = arguments[b];
          return c.produce(p, (function(O) {
            var w;
            return (w = a).call.apply(w, [m, O].concat(g));
          }));
        };
      }
      var s;
      if (typeof a != "function" && ye(6), o !== void 0 && typeof o != "function" && ye(7), jt(i)) {
        var l = Ef(n), f = Ku(n, i, void 0), d = !0;
        try {
          s = a(f), d = !1;
        } finally {
          d ? Oi(l) : qu(l);
        }
        return typeof Promise < "u" && s instanceof Promise ? s.then((function(p) {
          return Bo(l, o), zo(p, l);
        }), (function(p) {
          throw Oi(l), p;
        })) : (Bo(l, o), zo(s, l));
      }
      if (!i || typeof i != "object") {
        if ((s = a(i)) === void 0 && (s = i), s === Sp && (s = void 0), n.D && Zc(s, !0), o) {
          var v = [], h = [];
          ht("Patches").M(i, s, v, h), o(v, h);
        }
        return s;
      }
      ye(21, i);
    }, this.produceWithPatches = function(i, a) {
      if (typeof i == "function") return function(s) {
        for (var l = arguments.length, f = Array(l > 1 ? l - 1 : 0), d = 1; d < l; d++) f[d - 1] = arguments[d];
        return n.produceWithPatches(s, (function(v) {
          return i.apply(void 0, [v].concat(f));
        }));
      };
      var o, u, c = n.produce(i, a, (function(s, l) {
        o = s, u = l;
      }));
      return typeof Promise < "u" && c instanceof Promise ? c.then((function(s) {
        return [s, o, u];
      })) : [c, o, u];
    }, typeof r?.useProxies == "boolean" && this.setUseProxies(r.useProxies), typeof r?.autoFreeze == "boolean" && this.setAutoFreeze(r.autoFreeze);
  }
  var t = e.prototype;
  return t.createDraft = function(r) {
    jt(r) || ye(8), Zt(r) && (r = St(r));
    var n = Ef(this), i = Ku(this, r, void 0);
    return i[Q].C = !0, qu(n), i;
  }, t.finishDraft = function(r, n) {
    var i = r && r[Q];
    process.env.NODE_ENV !== "production" && (i && i.C || ye(9), i.I && ye(10));
    var a = i.A;
    return Bo(a, n), zo(void 0, a);
  }, t.setAutoFreeze = function(r) {
    this.D = r;
  }, t.setUseProxies = function(r) {
    r && !Cf && ye(20), this.O = r;
  }, t.applyPatches = function(r, n) {
    var i;
    for (i = n.length - 1; i >= 0; i--) {
      var a = n[i];
      if (a.path.length === 0 && a.op === "replace") {
        r = a.value;
        break;
      }
    }
    i > -1 && (n = n.slice(i + 1));
    var o = ht("Patches").$;
    return Zt(r) ? o(r, n) : this.produce(r, (function(u) {
      return o(u, n);
    }));
  }, e;
})(), Ve = new Zw(), _p = Ve.produce;
Ve.produceWithPatches.bind(Ve);
Ve.setAutoFreeze.bind(Ve);
Ve.setUseProxies.bind(Ve);
Ve.applyPatches.bind(Ve);
Ve.createDraft.bind(Ve);
Ve.finishDraft.bind(Ve);
function On(e) {
  "@babel/helpers - typeof";
  return On = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, On(e);
}
function Jw(e, t) {
  if (On(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (On(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Qw(e) {
  var t = Jw(e, "string");
  return On(t) == "symbol" ? t : t + "";
}
function ex(e, t, r) {
  return (t = Qw(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function If(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Df(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? If(Object(r), !0).forEach(function(n) {
      ex(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : If(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function _e(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var Nf = (function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
})(), Fo = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, pr = {
  INIT: "@@redux/INIT" + Fo(),
  REPLACE: "@@redux/REPLACE" + Fo(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + Fo();
  }
};
function jp(e) {
  if (typeof e != "object" || e === null) return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function tx(e) {
  if (e === void 0) return "undefined";
  if (e === null) return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e)) return "array";
  if (ix(e)) return "date";
  if (nx(e)) return "error";
  var r = rx(e);
  switch (r) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return r;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function rx(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function nx(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function ix(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function or(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = tx(e)), t;
}
function Tp(e, t, r) {
  var n;
  if (typeof t == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? _e(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof r > "u" && (r = t, t = void 0), typeof r < "u") {
    if (typeof r != "function")
      throw new Error(process.env.NODE_ENV === "production" ? _e(1) : "Expected the enhancer to be a function. Instead, received: '" + or(r) + "'");
    return r(Tp)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? _e(2) : "Expected the root reducer to be a function. Instead, received: '" + or(e) + "'");
  var i = e, a = t, o = [], u = o, c = !1;
  function s() {
    u === o && (u = o.slice());
  }
  function l() {
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? _e(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return a;
  }
  function f(p) {
    if (typeof p != "function")
      throw new Error(process.env.NODE_ENV === "production" ? _e(4) : "Expected the listener to be a function. Instead, received: '" + or(p) + "'");
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? _e(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var m = !0;
    return s(), u.push(p), function() {
      if (m) {
        if (c)
          throw new Error(process.env.NODE_ENV === "production" ? _e(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        m = !1, s();
        var g = u.indexOf(p);
        u.splice(g, 1), o = null;
      }
    };
  }
  function d(p) {
    if (!jp(p))
      throw new Error(process.env.NODE_ENV === "production" ? _e(7) : "Actions must be plain objects. Instead, the actual type was: '" + or(p) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof p.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? _e(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? _e(9) : "Reducers may not dispatch actions.");
    try {
      c = !0, a = i(a, p);
    } finally {
      c = !1;
    }
    for (var m = o = u, y = 0; y < m.length; y++) {
      var g = m[y];
      g();
    }
    return p;
  }
  function v(p) {
    if (typeof p != "function")
      throw new Error(process.env.NODE_ENV === "production" ? _e(10) : "Expected the nextReducer to be a function. Instead, received: '" + or(p));
    i = p, d({
      type: pr.REPLACE
    });
  }
  function h() {
    var p, m = f;
    return p = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(g) {
        if (typeof g != "object" || g === null)
          throw new Error(process.env.NODE_ENV === "production" ? _e(11) : "Expected the observer to be an object. Instead, received: '" + or(g) + "'");
        function b() {
          g.next && g.next(l());
        }
        b();
        var O = m(b);
        return {
          unsubscribe: O
        };
      }
    }, p[Nf] = function() {
      return this;
    }, p;
  }
  return d({
    type: pr.INIT
  }), n = {
    dispatch: d,
    subscribe: f,
    getState: l,
    replaceReducer: v
  }, n[Nf] = h, n;
}
function $f(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function ax(e, t, r, n) {
  var i = Object.keys(t), a = r && r.type === pr.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (i.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!jp(e))
    return "The " + a + ' has unexpected type of "' + or(e) + '". Expected argument to be an object with the following ' + ('keys: "' + i.join('", "') + '"');
  var o = Object.keys(e).filter(function(u) {
    return !t.hasOwnProperty(u) && !n[u];
  });
  if (o.forEach(function(u) {
    n[u] = !0;
  }), !(r && r.type === pr.REPLACE) && o.length > 0)
    return "Unexpected " + (o.length > 1 ? "keys" : "key") + " " + ('"' + o.join('", "') + '" found in ' + a + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + i.join('", "') + '". Unexpected keys will be ignored.');
}
function ox(e) {
  Object.keys(e).forEach(function(t) {
    var r = e[t], n = r(void 0, {
      type: pr.INIT
    });
    if (typeof n > "u")
      throw new Error(process.env.NODE_ENV === "production" ? _e(12) : 'The slice reducer for key "' + t + `" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof r(void 0, {
      type: pr.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? _e(13) : 'The slice reducer for key "' + t + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + pr.INIT + `' or other actions in "redux/*" `) + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.");
  });
}
function Mp(e) {
  for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++) {
    var i = t[n];
    process.env.NODE_ENV !== "production" && typeof e[i] > "u" && $f('No reducer provided for key "' + i + '"'), typeof e[i] == "function" && (r[i] = e[i]);
  }
  var a = Object.keys(r), o;
  process.env.NODE_ENV !== "production" && (o = {});
  var u;
  try {
    ox(r);
  } catch (c) {
    u = c;
  }
  return function(s, l) {
    if (s === void 0 && (s = {}), u)
      throw u;
    if (process.env.NODE_ENV !== "production") {
      var f = ax(s, r, l, o);
      f && $f(f);
    }
    for (var d = !1, v = {}, h = 0; h < a.length; h++) {
      var p = a[h], m = r[p], y = s[p], g = m(y, l);
      if (typeof g > "u") {
        var b = l && l.type;
        throw new Error(process.env.NODE_ENV === "production" ? _e(14) : "When called with an action of type " + (b ? '"' + String(b) + '"' : "(unknown type)") + ', the slice reducer for key "' + p + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.');
      }
      v[p] = g, d = d || g !== y;
    }
    return d = d || a.length !== Object.keys(s).length, d ? v : s;
  };
}
function Si() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return t.length === 0 ? function(n) {
    return n;
  } : t.length === 1 ? t[0] : t.reduce(function(n, i) {
    return function() {
      return n(i.apply(void 0, arguments));
    };
  });
}
function ux() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(n) {
    return function() {
      var i = n.apply(void 0, arguments), a = function() {
        throw new Error(process.env.NODE_ENV === "production" ? _e(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, o = {
        getState: i.getState,
        dispatch: function() {
          return a.apply(void 0, arguments);
        }
      }, u = t.map(function(c) {
        return c(o);
      });
      return a = Si.apply(void 0, u)(i.dispatch), Df(Df({}, i), {}, {
        dispatch: a
      });
    };
  };
}
function Cp(e) {
  var t = function(n) {
    var i = n.dispatch, a = n.getState;
    return function(o) {
      return function(u) {
        return typeof u == "function" ? u(i, a, e) : o(u);
      };
    };
  };
  return t;
}
var Wu = Cp();
Wu.withExtraArgument = Cp;
var kp = /* @__PURE__ */ (function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (n[a] = i[a]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
})(), $n = function(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, o;
  return o = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (a = s[0] & 2 ? i.return : s[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, s[1])).done) return a;
      switch (i = 0, a && (s = [s[0] & 2, a.value]), s[0]) {
        case 0:
        case 1:
          a = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!a || s[1] > a[0] && s[1] < a[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < a[1]) {
            r.label = a[1], a = s;
            break;
          }
          if (a && r.label < a[2]) {
            r.label = a[2], r.ops.push(s);
            break;
          }
          a[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = a = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, wr = function(e, t) {
  for (var r = 0, n = t.length, i = e.length; r < n; r++, i++)
    e[i] = t[r];
  return e;
}, cx = Object.defineProperty, sx = Object.defineProperties, lx = Object.getOwnPropertyDescriptors, Rf = Object.getOwnPropertySymbols, fx = Object.prototype.hasOwnProperty, dx = Object.prototype.propertyIsEnumerable, Lf = function(e, t, r) {
  return t in e ? cx(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
}, Gt = function(e, t) {
  for (var r in t || (t = {}))
    fx.call(t, r) && Lf(e, r, t[r]);
  if (Rf)
    for (var n = 0, i = Rf(t); n < i.length; n++) {
      var r = i[n];
      dx.call(t, r) && Lf(e, r, t[r]);
    }
  return e;
}, Wo = function(e, t) {
  return sx(e, lx(t));
}, Rn = function(e, t, r) {
  return new Promise(function(n, i) {
    var a = function(c) {
      try {
        u(r.next(c));
      } catch (s) {
        i(s);
      }
    }, o = function(c) {
      try {
        u(r.throw(c));
      } catch (s) {
        i(s);
      }
    }, u = function(c) {
      return c.done ? n(c.value) : Promise.resolve(c.value).then(a, o);
    };
    u((r = r.apply(e, t)).next());
  });
}, vx = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? Si : Si.apply(null, arguments);
};
function es(e) {
  if (typeof e != "object" || e === null)
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var r = t; Object.getPrototypeOf(r) !== null; )
    r = Object.getPrototypeOf(r);
  return t === r;
}
var hx = function(e) {
  return e && typeof e.match == "function";
};
function Ie(e, t) {
  function r() {
    for (var n = [], i = 0; i < arguments.length; i++)
      n[i] = arguments[i];
    if (t) {
      var a = t.apply(void 0, n);
      if (!a)
        throw new Error("prepareAction did not return an object");
      return Gt(Gt({
        type: e,
        payload: a.payload
      }, "meta" in a && { meta: a.meta }), "error" in a && { error: a.error });
    }
    return { type: e, payload: n[0] };
  }
  return r.toString = function() {
    return "" + e;
  }, r.type = e, r.match = function(n) {
    return n.type === e;
  }, r;
}
function px(e) {
  return es(e) && "type" in e;
}
function mx(e) {
  return typeof e == "function" && "type" in e && hx(e);
}
function yx(e) {
  var t = e ? ("" + e).split("/") : [], r = t[t.length - 1] || "actionCreator";
  return 'Detected an action creator with type "' + (e || "unknown") + `" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(` + r + "())` instead of `dispatch(" + r + ")`. This is necessary even if the action has no payload.";
}
function gx(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(n) {
        return function(i) {
          return n(i);
        };
      };
    };
  var t = e.isActionCreator, r = t === void 0 ? mx : t;
  return function() {
    return function(n) {
      return function(i) {
        return r(i) && console.warn(yx(i.type)), n(i);
      };
    };
  };
}
function Ip(e, t) {
  var r = 0;
  return {
    measureTime: function(n) {
      var i = Date.now();
      try {
        return n();
      } finally {
        var a = Date.now();
        r += a - i;
      }
    },
    warnIfExceeded: function() {
      r > e && console.warn(t + " took " + r + "ms, which is more than the warning threshold of " + e + `ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var bx = (
  /** @class */
  (function(e) {
    kp(t, e);
    function t() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      var i = e.apply(this, r) || this;
      return Object.setPrototypeOf(i, t.prototype), i;
    }
    return Object.defineProperty(t, Symbol.species, {
      get: function() {
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.concat = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return e.prototype.concat.apply(this, r);
    }, t.prototype.prepend = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return r.length === 1 && Array.isArray(r[0]) ? new (t.bind.apply(t, wr([void 0], r[0].concat(this))))() : new (t.bind.apply(t, wr([void 0], r.concat(this))))();
    }, t;
  })(Array)
), wx = (
  /** @class */
  (function(e) {
    kp(t, e);
    function t() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      var i = e.apply(this, r) || this;
      return Object.setPrototypeOf(i, t.prototype), i;
    }
    return Object.defineProperty(t, Symbol.species, {
      get: function() {
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.concat = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return e.prototype.concat.apply(this, r);
    }, t.prototype.prepend = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return r.length === 1 && Array.isArray(r[0]) ? new (t.bind.apply(t, wr([void 0], r[0].concat(this))))() : new (t.bind.apply(t, wr([void 0], r.concat(this))))();
    }, t;
  })(Array)
);
function Uu(e) {
  return jt(e) ? _p(e, function() {
  }) : e;
}
var xx = process.env.NODE_ENV === "production", Bf = "Invariant failed";
function zf(e, t) {
  if (!e)
    throw xx ? new Error(Bf) : new Error(Bf + ": " + (t || ""));
}
function Ox(e, t, r, n) {
  return JSON.stringify(e, Px(t, n), r);
}
function Px(e, t) {
  var r = [], n = [];
  return t || (t = function(i, a) {
    return r[0] === a ? "[Circular ~]" : "[Circular ~." + n.slice(0, r.indexOf(a)).join(".") + "]";
  }), function(i, a) {
    if (r.length > 0) {
      var o = r.indexOf(this);
      ~o ? r.splice(o + 1) : r.push(this), ~o ? n.splice(o, 1 / 0, i) : n.push(i), ~r.indexOf(a) && (a = t.call(this, i, a));
    } else
      r.push(a);
    return e == null ? a : e.call(this, i, a);
  };
}
function Ax(e) {
  return typeof e != "object" || e == null || Object.isFrozen(e);
}
function Sx(e, t, r) {
  var n = Dp(e, t, r);
  return {
    detectMutations: function() {
      return Np(e, t, n, r);
    }
  };
}
function Dp(e, t, r, n, i) {
  t === void 0 && (t = []), n === void 0 && (n = ""), i === void 0 && (i = /* @__PURE__ */ new Set());
  var a = { value: r };
  if (!e(r) && !i.has(r)) {
    i.add(r), a.children = {};
    for (var o in r) {
      var u = n ? n + "." + o : o;
      t.length && t.indexOf(u) !== -1 || (a.children[o] = Dp(e, t, r[o], u));
    }
  }
  return a;
}
function Np(e, t, r, n, i, a) {
  t === void 0 && (t = []), i === void 0 && (i = !1), a === void 0 && (a = "");
  var o = r ? r.value : void 0, u = o === n;
  if (i && !u && !Number.isNaN(n))
    return { wasMutated: !0, path: a };
  if (e(o) || e(n))
    return { wasMutated: !1 };
  var c = {};
  for (var s in r.children)
    c[s] = !0;
  for (var s in n)
    c[s] = !0;
  var l = t.length > 0, f = function(v) {
    var h = a ? a + "." + v : v;
    if (l) {
      var p = t.some(function(y) {
        return y instanceof RegExp ? y.test(h) : h === y;
      });
      if (p)
        return "continue";
    }
    var m = Np(e, t, r.children[v], n[v], u, h);
    if (m.wasMutated)
      return { value: m };
  };
  for (var s in c) {
    var d = f(s);
    if (typeof d == "object")
      return d.value;
  }
  return { wasMutated: !1 };
}
function Ex(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(c) {
        return function(s) {
          return c(s);
        };
      };
    };
  var t = e.isImmutable, r = t === void 0 ? Ax : t, n = e.ignoredPaths, i = e.warnAfter, a = i === void 0 ? 32 : i, o = e.ignore;
  n = n || o;
  var u = Sx.bind(null, r, n);
  return function(c) {
    var s = c.getState, l = s(), f = u(l), d;
    return function(v) {
      return function(h) {
        var p = Ip(a, "ImmutableStateInvariantMiddleware");
        p.measureTime(function() {
          l = s(), d = f.detectMutations(), f = u(l), zf(!d.wasMutated, "A state mutation was detected between dispatches, in the path '" + (d.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        });
        var m = v(h);
        return p.measureTime(function() {
          l = s(), d = f.detectMutations(), f = u(l), d.wasMutated && zf(!d.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (d.path || "") + ". Take a look at the reducer(s) handling the action " + Ox(h) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        }), p.warnIfExceeded(), m;
      };
    };
  };
}
function $p(e) {
  var t = typeof e;
  return e == null || t === "string" || t === "boolean" || t === "number" || Array.isArray(e) || es(e);
}
function Vu(e, t, r, n, i, a) {
  t === void 0 && (t = ""), r === void 0 && (r = $p), i === void 0 && (i = []);
  var o;
  if (!r(e))
    return {
      keyPath: t || "<root>",
      value: e
    };
  if (typeof e != "object" || e === null || a?.has(e))
    return !1;
  for (var u = n != null ? n(e) : Object.entries(e), c = i.length > 0, s = function(m, y) {
    var g = t ? t + "." + m : m;
    if (c) {
      var b = i.some(function(O) {
        return O instanceof RegExp ? O.test(g) : g === O;
      });
      if (b)
        return "continue";
    }
    if (!r(y))
      return { value: {
        keyPath: g,
        value: y
      } };
    if (typeof y == "object" && (o = Vu(y, g, r, n, i, a), o))
      return { value: o };
  }, l = 0, f = u; l < f.length; l++) {
    var d = f[l], v = d[0], h = d[1], p = s(v, h);
    if (typeof p == "object")
      return p.value;
  }
  return a && Rp(e) && a.add(e), !1;
}
function Rp(e) {
  if (!Object.isFrozen(e))
    return !1;
  for (var t = 0, r = Object.values(e); t < r.length; t++) {
    var n = r[t];
    if (!(typeof n != "object" || n === null) && !Rp(n))
      return !1;
  }
  return !0;
}
function _x(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(b) {
        return function(O) {
          return b(O);
        };
      };
    };
  var t = e.isSerializable, r = t === void 0 ? $p : t, n = e.getEntries, i = e.ignoredActions, a = i === void 0 ? [] : i, o = e.ignoredActionPaths, u = o === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : o, c = e.ignoredPaths, s = c === void 0 ? [] : c, l = e.warnAfter, f = l === void 0 ? 32 : l, d = e.ignoreState, v = d === void 0 ? !1 : d, h = e.ignoreActions, p = h === void 0 ? !1 : h, m = e.disableCache, y = m === void 0 ? !1 : m, g = !y && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
  return function(b) {
    return function(O) {
      return function(w) {
        var P = O(w), A = Ip(f, "SerializableStateInvariantMiddleware");
        return !p && !(a.length && a.indexOf(w.type) !== -1) && A.measureTime(function() {
          var _ = Vu(w, "", r, n, u, g);
          if (_) {
            var T = _.keyPath, N = _.value;
            console.error("A non-serializable value was detected in an action, in the path: `" + T + "`. Value:", N, `
Take a look at the logic that dispatched this action: `, w, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
          }
        }), v || (A.measureTime(function() {
          var _ = b.getState(), T = Vu(_, "", r, n, s, g);
          if (T) {
            var N = T.keyPath, j = T.value;
            console.error("A non-serializable value was detected in the state, in the path: `" + N + "`. Value:", j, `
Take a look at the reducer(s) handling this action type: ` + w.type + `.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
          }
        }), A.warnIfExceeded()), P;
      };
    };
  };
}
function ni(e) {
  return typeof e == "boolean";
}
function jx() {
  return function(t) {
    return Tx(t);
  };
}
function Tx(e) {
  e === void 0 && (e = {});
  var t = e.thunk, r = t === void 0 ? !0 : t, n = e.immutableCheck, i = n === void 0 ? !0 : n, a = e.serializableCheck, o = a === void 0 ? !0 : a, u = e.actionCreatorCheck, c = u === void 0 ? !0 : u, s = new bx();
  if (r && (ni(r) ? s.push(Wu) : s.push(Wu.withExtraArgument(r.extraArgument))), process.env.NODE_ENV !== "production") {
    if (i) {
      var l = {};
      ni(i) || (l = i), s.unshift(Ex(l));
    }
    if (o) {
      var f = {};
      ni(o) || (f = o), s.push(_x(f));
    }
    if (c) {
      var d = {};
      ni(c) || (d = c), s.unshift(gx(d));
    }
  }
  return s;
}
var Uo = process.env.NODE_ENV === "production";
function Mx(e) {
  var t = jx(), r = e || {}, n = r.reducer, i = n === void 0 ? void 0 : n, a = r.middleware, o = a === void 0 ? t() : a, u = r.devTools, c = u === void 0 ? !0 : u, s = r.preloadedState, l = s === void 0 ? void 0 : s, f = r.enhancers, d = f === void 0 ? void 0 : f, v;
  if (typeof i == "function")
    v = i;
  else if (es(i))
    v = Mp(i);
  else
    throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
  var h = o;
  if (typeof h == "function" && (h = h(t), !Uo && !Array.isArray(h)))
    throw new Error("when using a middleware builder function, an array of middleware must be returned");
  if (!Uo && h.some(function(O) {
    return typeof O != "function";
  }))
    throw new Error("each middleware provided to configureStore must be a function");
  var p = ux.apply(void 0, h), m = Si;
  c && (m = vx(Gt({
    trace: !Uo
  }, typeof c == "object" && c)));
  var y = new wx(p), g = y;
  Array.isArray(d) ? g = wr([p], d) : typeof d == "function" && (g = d(y));
  var b = m.apply(void 0, g);
  return Tp(v, l, b);
}
function Lp(e) {
  var t = {}, r = [], n, i = {
    addCase: function(a, o) {
      if (process.env.NODE_ENV !== "production") {
        if (r.length > 0)
          throw new Error("`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (n)
          throw new Error("`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      var u = typeof a == "string" ? a : a.type;
      if (!u)
        throw new Error("`builder.addCase` cannot be called with an empty action type");
      if (u in t)
        throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
      return t[u] = o, i;
    },
    addMatcher: function(a, o) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error("`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return r.push({ matcher: a, reducer: o }), i;
    },
    addDefaultCase: function(a) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error("`builder.addDefaultCase` can only be called once");
      return n = a, i;
    }
  };
  return e(i), [t, r, n];
}
function Cx(e) {
  return typeof e == "function";
}
var qf = !1;
function kx(e, t, r, n) {
  r === void 0 && (r = []), process.env.NODE_ENV !== "production" && typeof t == "object" && (qf || (qf = !0, console.warn("The object notation for `createReducer` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer")));
  var i = typeof t == "function" ? Lp(t) : [t, r, n], a = i[0], o = i[1], u = i[2], c;
  if (Cx(e))
    c = function() {
      return Uu(e());
    };
  else {
    var s = Uu(e);
    c = function() {
      return s;
    };
  }
  function l(f, d) {
    f === void 0 && (f = c());
    var v = wr([
      a[d.type]
    ], o.filter(function(h) {
      var p = h.matcher;
      return p(d);
    }).map(function(h) {
      var p = h.reducer;
      return p;
    }));
    return v.filter(function(h) {
      return !!h;
    }).length === 0 && (v = [u]), v.reduce(function(h, p) {
      if (p)
        if (Zt(h)) {
          var m = h, y = p(m, d);
          return y === void 0 ? h : y;
        } else {
          if (jt(h))
            return _p(h, function(g) {
              return p(g, d);
            });
          var y = p(h, d);
          if (y === void 0) {
            if (h === null)
              return h;
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return y;
        }
      return h;
    }, f);
  }
  return l.getInitialState = c, l;
}
var Kf = !1;
function Ix(e, t) {
  return e + "/" + t;
}
function Ye(e) {
  var t = e.name;
  if (!t)
    throw new Error("`name` is a required option for createSlice");
  typeof process < "u" && process.env.NODE_ENV === "development" && e.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
  var r = typeof e.initialState == "function" ? e.initialState : Uu(e.initialState), n = e.reducers || {}, i = Object.keys(n), a = {}, o = {}, u = {};
  i.forEach(function(l) {
    var f = n[l], d = Ix(t, l), v, h;
    "reducer" in f ? (v = f.reducer, h = f.prepare) : v = f, a[l] = v, o[d] = v, u[l] = h ? Ie(d, h) : Ie(d);
  });
  function c() {
    process.env.NODE_ENV !== "production" && typeof e.extraReducers == "object" && (Kf || (Kf = !0, console.warn("The object notation for `createSlice.extraReducers` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice")));
    var l = typeof e.extraReducers == "function" ? Lp(e.extraReducers) : [e.extraReducers], f = l[0], d = f === void 0 ? {} : f, v = l[1], h = v === void 0 ? [] : v, p = l[2], m = p === void 0 ? void 0 : p, y = Gt(Gt({}, d), o);
    return kx(r, function(g) {
      for (var b in y)
        g.addCase(b, y[b]);
      for (var O = 0, w = h; O < w.length; O++) {
        var P = w[O];
        g.addMatcher(P.matcher, P.reducer);
      }
      m && g.addDefaultCase(m);
    });
  }
  var s;
  return {
    name: t,
    reducer: function(l, f) {
      return s || (s = c()), s(l, f);
    },
    actions: u,
    caseReducers: a,
    getInitialState: function() {
      return s || (s = c()), s.getInitialState();
    }
  };
}
var Dx = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", Bp = function(e) {
  e === void 0 && (e = 21);
  for (var t = "", r = e; r--; )
    t += Dx[Math.random() * 64 | 0];
  return t;
}, Nx = [
  "name",
  "message",
  "stack",
  "code"
], Vo = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(t, r) {
      this.payload = t, this.meta = r;
    }
    return e;
  })()
), Ff = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(t, r) {
      this.payload = t, this.meta = r;
    }
    return e;
  })()
), $x = function(e) {
  if (typeof e == "object" && e !== null) {
    for (var t = {}, r = 0, n = Nx; r < n.length; r++) {
      var i = n[r];
      typeof e[i] == "string" && (t[i] = e[i]);
    }
    return t;
  }
  return { message: String(e) };
};
(function() {
  function e(t, r, n) {
    var i = Ie(t + "/fulfilled", function(l, f, d, v) {
      return {
        payload: l,
        meta: Wo(Gt({}, v || {}), {
          arg: d,
          requestId: f,
          requestStatus: "fulfilled"
        })
      };
    }), a = Ie(t + "/pending", function(l, f, d) {
      return {
        payload: void 0,
        meta: Wo(Gt({}, d || {}), {
          arg: f,
          requestId: l,
          requestStatus: "pending"
        })
      };
    }), o = Ie(t + "/rejected", function(l, f, d, v, h) {
      return {
        payload: v,
        error: (n && n.serializeError || $x)(l || "Rejected"),
        meta: Wo(Gt({}, h || {}), {
          arg: d,
          requestId: f,
          rejectedWithValue: !!v,
          requestStatus: "rejected",
          aborted: l?.name === "AbortError",
          condition: l?.name === "ConditionError"
        })
      };
    }), u = !1, c = typeof AbortController < "u" ? AbortController : (
      /** @class */
      (function() {
        function l() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return l.prototype.abort = function() {
          process.env.NODE_ENV !== "production" && (u || (u = !0, console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.")));
        }, l;
      })()
    );
    function s(l) {
      return function(f, d, v) {
        var h = n?.idGenerator ? n.idGenerator(l) : Bp(), p = new c(), m;
        function y(b) {
          m = b, p.abort();
        }
        var g = (function() {
          return Rn(this, null, function() {
            var b, O, w, P, A, _, T;
            return $n(this, function(N) {
              switch (N.label) {
                case 0:
                  return N.trys.push([0, 4, , 5]), P = (b = n?.condition) == null ? void 0 : b.call(n, l, { getState: d, extra: v }), Lx(P) ? [4, P] : [3, 2];
                case 1:
                  P = N.sent(), N.label = 2;
                case 2:
                  if (P === !1 || p.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return A = new Promise(function(j, C) {
                    return p.signal.addEventListener("abort", function() {
                      return C({
                        name: "AbortError",
                        message: m || "Aborted"
                      });
                    });
                  }), f(a(h, l, (O = n?.getPendingMeta) == null ? void 0 : O.call(n, { requestId: h, arg: l }, { getState: d, extra: v }))), [4, Promise.race([
                    A,
                    Promise.resolve(r(l, {
                      dispatch: f,
                      getState: d,
                      extra: v,
                      requestId: h,
                      signal: p.signal,
                      abort: y,
                      rejectWithValue: function(j, C) {
                        return new Vo(j, C);
                      },
                      fulfillWithValue: function(j, C) {
                        return new Ff(j, C);
                      }
                    })).then(function(j) {
                      if (j instanceof Vo)
                        throw j;
                      return j instanceof Ff ? i(j.payload, h, l, j.meta) : i(j, h, l);
                    })
                  ])];
                case 3:
                  return w = N.sent(), [3, 5];
                case 4:
                  return _ = N.sent(), w = _ instanceof Vo ? o(null, h, l, _.payload, _.meta) : o(_, h, l), [3, 5];
                case 5:
                  return T = n && !n.dispatchConditionRejection && o.match(w) && w.meta.condition, T || f(w), [2, w];
              }
            });
          });
        })();
        return Object.assign(g, {
          abort: y,
          requestId: h,
          arg: l,
          unwrap: function() {
            return g.then(Rx);
          }
        });
      };
    }
    return Object.assign(s, {
      pending: a,
      rejected: o,
      fulfilled: i,
      typePrefix: t
    });
  }
  return e.withTypes = function() {
    return e;
  }, e;
})();
function Rx(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function Lx(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var ts = function(e, t) {
  if (typeof e != "function")
    throw new TypeError(t + " is not a function");
}, Hu = function() {
}, zp = function(e, t) {
  return t === void 0 && (t = Hu), e.catch(t), e;
}, qp = function(e, t) {
  return e.addEventListener("abort", t, { once: !0 }), function() {
    return e.removeEventListener("abort", t);
  };
}, Nr = function(e, t) {
  var r = e.signal;
  r.aborted || ("reason" in r || Object.defineProperty(r, "reason", {
    enumerable: !0,
    value: t,
    configurable: !0,
    writable: !0
  }), e.abort(t));
}, Bx = "task", Kp = "listener", Fp = "completed", rs = "cancelled", zx = "task-" + rs, qx = "task-" + Fp, Wp = Kp + "-" + rs, Kx = Kp + "-" + Fp, sa = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(t) {
      this.code = t, this.name = "TaskAbortError", this.message = Bx + " " + rs + " (reason: " + t + ")";
    }
    return e;
  })()
), $r = function(e) {
  if (e.aborted)
    throw new sa(e.reason);
};
function Up(e, t) {
  var r = Hu;
  return new Promise(function(n, i) {
    var a = function() {
      return i(new sa(e.reason));
    };
    if (e.aborted) {
      a();
      return;
    }
    r = qp(e, a), t.finally(function() {
      return r();
    }).then(n, i);
  }).finally(function() {
    r = Hu;
  });
}
var Fx = function(e, t) {
  return Rn(void 0, null, function() {
    var r, n;
    return $n(this, function(i) {
      switch (i.label) {
        case 0:
          return i.trys.push([0, 3, 4, 5]), [4, Promise.resolve()];
        case 1:
          return i.sent(), [4, e()];
        case 2:
          return r = i.sent(), [2, {
            status: "ok",
            value: r
          }];
        case 3:
          return n = i.sent(), [2, {
            status: n instanceof sa ? "cancelled" : "rejected",
            error: n
          }];
        case 4:
          return t?.(), [
            7
            /*endfinally*/
          ];
        case 5:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}, Ei = function(e) {
  return function(t) {
    return zp(Up(e, t).then(function(r) {
      return $r(e), r;
    }));
  };
}, Vp = function(e) {
  var t = Ei(e);
  return function(r) {
    return t(new Promise(function(n) {
      return setTimeout(n, r);
    }));
  };
}, Wx = Object.assign, Wf = {}, Ln = "listenerMiddleware", Ux = function(e, t) {
  var r = function(n) {
    return qp(e, function() {
      return Nr(n, e.reason);
    });
  };
  return function(n, i) {
    ts(n, "taskExecutor");
    var a = new AbortController();
    r(a);
    var o = Fx(function() {
      return Rn(void 0, null, function() {
        var u;
        return $n(this, function(c) {
          switch (c.label) {
            case 0:
              return $r(e), $r(a.signal), [4, n({
                pause: Ei(a.signal),
                delay: Vp(a.signal),
                signal: a.signal
              })];
            case 1:
              return u = c.sent(), $r(a.signal), [2, u];
          }
        });
      });
    }, function() {
      return Nr(a, qx);
    });
    return i?.autoJoin && t.push(o), {
      result: Ei(e)(o),
      cancel: function() {
        Nr(a, zx);
      }
    };
  };
}, Vx = function(e, t) {
  var r = function(n, i) {
    return Rn(void 0, null, function() {
      var a, o, u, c;
      return $n(this, function(s) {
        switch (s.label) {
          case 0:
            $r(t), a = function() {
            }, o = new Promise(function(l, f) {
              var d = e({
                predicate: n,
                effect: function(v, h) {
                  h.unsubscribe(), l([
                    v,
                    h.getState(),
                    h.getOriginalState()
                  ]);
                }
              });
              a = function() {
                d(), f();
              };
            }), u = [
              o
            ], i != null && u.push(new Promise(function(l) {
              return setTimeout(l, i, null);
            })), s.label = 1;
          case 1:
            return s.trys.push([1, , 3, 4]), [4, Up(t, Promise.race(u))];
          case 2:
            return c = s.sent(), $r(t), [2, c];
          case 3:
            return a(), [
              7
              /*endfinally*/
            ];
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  };
  return function(n, i) {
    return zp(r(n, i));
  };
}, Hp = function(e) {
  var t = e.type, r = e.actionCreator, n = e.matcher, i = e.predicate, a = e.effect;
  if (t)
    i = Ie(t).match;
  else if (r)
    t = r.type, i = r.match;
  else if (n)
    i = n;
  else if (!i) throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
  return ts(a, "options.listener"), { predicate: i, type: t, effect: a };
}, Hx = function(e) {
  var t = Hp(e), r = t.type, n = t.predicate, i = t.effect, a = Bp(), o = {
    id: a,
    effect: i,
    type: r,
    predicate: n,
    pending: /* @__PURE__ */ new Set(),
    unsubscribe: function() {
      throw new Error("Unsubscribe not initialized");
    }
  };
  return o;
}, Gu = function(e) {
  e.pending.forEach(function(t) {
    Nr(t, Wp);
  });
}, Gx = function(e) {
  return function() {
    e.forEach(Gu), e.clear();
  };
}, Uf = function(e, t, r) {
  try {
    e(t, r);
  } catch (n) {
    setTimeout(function() {
      throw n;
    }, 0);
  }
}, Yx = Ie(Ln + "/add"), Xx = Ie(Ln + "/removeAll"), Zx = Ie(Ln + "/remove"), Jx = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  console.error.apply(console, wr([Ln + "/error"], e));
};
function Bn(e) {
  var t = this;
  e === void 0 && (e = {});
  var r = /* @__PURE__ */ new Map(), n = e.extra, i = e.onError, a = i === void 0 ? Jx : i;
  ts(a, "onError");
  var o = function(v) {
    return v.unsubscribe = function() {
      return r.delete(v.id);
    }, r.set(v.id, v), function(h) {
      v.unsubscribe(), h?.cancelActive && Gu(v);
    };
  }, u = function(v) {
    for (var h = 0, p = Array.from(r.values()); h < p.length; h++) {
      var m = p[h];
      if (v(m))
        return m;
    }
  }, c = function(v) {
    var h = u(function(p) {
      return p.effect === v.effect;
    });
    return h || (h = Hx(v)), o(h);
  }, s = function(v) {
    var h = Hp(v), p = h.type, m = h.effect, y = h.predicate, g = u(function(b) {
      var O = typeof p == "string" ? b.type === p : b.predicate === y;
      return O && b.effect === m;
    });
    return g && (g.unsubscribe(), v.cancelActive && Gu(g)), !!g;
  }, l = function(v, h, p, m) {
    return Rn(t, null, function() {
      var y, g, b, O;
      return $n(this, function(w) {
        switch (w.label) {
          case 0:
            y = new AbortController(), g = Vx(c, y.signal), b = [], w.label = 1;
          case 1:
            return w.trys.push([1, 3, 4, 6]), v.pending.add(y), [4, Promise.resolve(v.effect(h, Wx({}, p, {
              getOriginalState: m,
              condition: function(P, A) {
                return g(P, A).then(Boolean);
              },
              take: g,
              delay: Vp(y.signal),
              pause: Ei(y.signal),
              extra: n,
              signal: y.signal,
              fork: Ux(y.signal, b),
              unsubscribe: v.unsubscribe,
              subscribe: function() {
                r.set(v.id, v);
              },
              cancelActiveListeners: function() {
                v.pending.forEach(function(P, A, _) {
                  P !== y && (Nr(P, Wp), _.delete(P));
                });
              }
            })))];
          case 2:
            return w.sent(), [3, 6];
          case 3:
            return O = w.sent(), O instanceof sa || Uf(a, O, {
              raisedBy: "effect"
            }), [3, 6];
          case 4:
            return [4, Promise.allSettled(b)];
          case 5:
            return w.sent(), Nr(y, Kx), v.pending.delete(y), [
              7
              /*endfinally*/
            ];
          case 6:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, f = Gx(r), d = function(v) {
    return function(h) {
      return function(p) {
        if (!px(p))
          return h(p);
        if (Yx.match(p))
          return c(p.payload);
        if (Xx.match(p)) {
          f();
          return;
        }
        if (Zx.match(p))
          return s(p.payload);
        var m = v.getState(), y = function() {
          if (m === Wf)
            throw new Error(Ln + ": getOriginalState can only be called synchronously");
          return m;
        }, g;
        try {
          if (g = h(p), r.size > 0)
            for (var b = v.getState(), O = Array.from(r.values()), w = 0, P = O; w < P.length; w++) {
              var A = P[w], _ = !1;
              try {
                _ = A.predicate(p, b, m);
              } catch (T) {
                _ = !1, Uf(a, T, {
                  raisedBy: "predicate"
                });
              }
              _ && l(A, p, v, y);
            }
        } finally {
          m = Wf;
        }
        return g;
      };
    };
  };
  return {
    middleware: d,
    startListening: c,
    stopListening: s,
    clearListeners: f
  };
}
var Vf;
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window < "u" ? window : typeof global < "u" ? global : globalThis);
Vw();
var Qx = {
  layoutType: "horizontal",
  width: 0,
  height: 0,
  margin: {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
  },
  scale: 1
}, Gp = Ye({
  name: "chartLayout",
  initialState: Qx,
  reducers: {
    setLayout(e, t) {
      e.layoutType = t.payload;
    },
    setChartSize(e, t) {
      e.width = t.payload.width, e.height = t.payload.height;
    },
    setMargin(e, t) {
      e.margin.top = t.payload.top, e.margin.right = t.payload.right, e.margin.bottom = t.payload.bottom, e.margin.left = t.payload.left;
    },
    setScale(e, t) {
      e.scale = t.payload;
    }
  }
}), {
  setMargin: eO,
  setLayout: tO,
  setChartSize: rO,
  setScale: nO
} = Gp.actions, iO = Gp.reducer;
function Hf(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hf(Object(r), !0).forEach(function(n) {
      aO(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Hf(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function aO(e, t, r) {
  return (t = oO(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function oO(e) {
  var t = uO(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function uO(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var _i = Math.PI / 180, cO = (e) => e * 180 / Math.PI, Pe = (e, t, r, n) => ({
  x: e + Math.cos(-_i * n) * r,
  y: t + Math.sin(-_i * n) * r
}), sO = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (n.left || 0) - (n.right || 0)), Math.abs(r - (n.top || 0) - (n.bottom || 0))) / 2;
}, lO = (e, t) => {
  var {
    x: r,
    y: n
  } = e, {
    x: i,
    y: a
  } = t;
  return Math.sqrt((r - i) ** 2 + (n - a) ** 2);
}, fO = (e, t) => {
  var {
    x: r,
    y: n
  } = e, {
    cx: i,
    cy: a
  } = t, o = lO({
    x: r,
    y: n
  }, {
    x: i,
    y: a
  });
  if (o <= 0)
    return {
      radius: o,
      angle: 0
    };
  var u = (r - i) / o, c = Math.acos(u);
  return n > a && (c = 2 * Math.PI - c), {
    radius: o,
    angle: cO(c),
    angleInRadian: c
  };
}, dO = (e) => {
  var {
    startAngle: t,
    endAngle: r
  } = e, n = Math.floor(t / 360), i = Math.floor(r / 360), a = Math.min(n, i);
  return {
    startAngle: t - a * 360,
    endAngle: r - a * 360
  };
}, vO = (e, t) => {
  var {
    startAngle: r,
    endAngle: n
  } = t, i = Math.floor(r / 360), a = Math.floor(n / 360), o = Math.min(i, a);
  return e + o * 360;
}, hO = (e, t) => {
  var {
    x: r,
    y: n
  } = e, {
    radius: i,
    angle: a
  } = fO({
    x: r,
    y: n
  }, t), {
    innerRadius: o,
    outerRadius: u
  } = t;
  if (i < o || i > u || i === 0)
    return null;
  var {
    startAngle: c,
    endAngle: s
  } = dO(t), l = a, f;
  if (c <= s) {
    for (; l > s; )
      l -= 360;
    for (; l < c; )
      l += 360;
    f = l >= c && l <= s;
  } else {
    for (; l > c; )
      l -= 360;
    for (; l < s; )
      l += 360;
    f = l >= s && l <= c;
  }
  return f ? Gf(Gf({}, t), {}, {
    radius: i,
    angle: vO(l, t)
  }) : null;
};
function Yp(e, t, r) {
  return Array.isArray(e) && e && t + r !== 0 ? e.slice(t, r + 1) : e;
}
function Yf(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function rt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Yf(Object(r), !0).forEach(function(n) {
      pO(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Yf(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function pO(e, t, r) {
  return (t = mO(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function mO(e) {
  var t = yO(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function yO(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ge(e, t, r) {
  return te(e) || te(t) ? r : mt(t) ? gr(e, t, r) : typeof t == "function" ? t(e) : r;
}
var gO = (e, t, r, n, i) => {
  var a, o = -1, u = (a = t?.length) !== null && a !== void 0 ? a : 0;
  if (u <= 1 || e == null)
    return 0;
  if (n === "angleAxis" && i != null && Math.abs(Math.abs(i[1] - i[0]) - 360) <= 1e-6)
    for (var c = 0; c < u; c++) {
      var s = c > 0 ? r[c - 1].coordinate : r[u - 1].coordinate, l = r[c].coordinate, f = c >= u - 1 ? r[0].coordinate : r[c + 1].coordinate, d = void 0;
      if (Re(l - s) !== Re(f - l)) {
        var v = [];
        if (Re(f - l) === Re(i[1] - i[0])) {
          d = f;
          var h = l + i[1] - i[0];
          v[0] = Math.min(h, (h + s) / 2), v[1] = Math.max(h, (h + s) / 2);
        } else {
          d = s;
          var p = f + i[1] - i[0];
          v[0] = Math.min(l, (p + l) / 2), v[1] = Math.max(l, (p + l) / 2);
        }
        var m = [Math.min(l, (d + l) / 2), Math.max(l, (d + l) / 2)];
        if (e > m[0] && e <= m[1] || e >= v[0] && e <= v[1]) {
          ({
            index: o
          } = r[c]);
          break;
        }
      } else {
        var y = Math.min(s, f), g = Math.max(s, f);
        if (e > (y + l) / 2 && e <= (g + l) / 2) {
          ({
            index: o
          } = r[c]);
          break;
        }
      }
    }
  else if (t) {
    for (var b = 0; b < u; b++)
      if (b === 0 && e <= (t[b].coordinate + t[b + 1].coordinate) / 2 || b > 0 && b < u - 1 && e > (t[b].coordinate + t[b - 1].coordinate) / 2 && e <= (t[b].coordinate + t[b + 1].coordinate) / 2 || b === u - 1 && e > (t[b].coordinate + t[b - 1].coordinate) / 2) {
        ({
          index: o
        } = t[b]);
        break;
      }
  }
  return o;
}, bO = (e, t, r) => {
  if (t && r) {
    var {
      width: n,
      height: i
    } = r, {
      align: a,
      verticalAlign: o,
      layout: u
    } = t;
    if ((u === "vertical" || u === "horizontal" && o === "middle") && a !== "center" && k(e[a]))
      return rt(rt({}, e), {}, {
        [a]: e[a] + (n || 0)
      });
    if ((u === "horizontal" || u === "vertical" && a === "center") && o !== "middle" && k(e[o]))
      return rt(rt({}, e), {}, {
        [o]: e[o] + (i || 0)
      });
  }
  return e;
}, Dt = (e, t) => e === "horizontal" && t === "xAxis" || e === "vertical" && t === "yAxis" || e === "centric" && t === "angleAxis" || e === "radial" && t === "radiusAxis", Xp = (e, t, r, n) => {
  if (n)
    return e.map((u) => u.coordinate);
  var i, a, o = e.map((u) => (u.coordinate === t && (i = !0), u.coordinate === r && (a = !0), u.coordinate));
  return i || o.push(t), a || o.push(r), o;
}, Zp = (e, t, r) => {
  if (!e)
    return null;
  var {
    duplicateDomain: n,
    type: i,
    range: a,
    scale: o,
    realScaleType: u,
    isCategorical: c,
    categoricalDomain: s,
    tickCount: l,
    ticks: f,
    niceTicks: d,
    axisType: v
  } = e;
  if (!o)
    return null;
  var h = u === "scaleBand" && o.bandwidth ? o.bandwidth() / 2 : 2, p = i === "category" && o.bandwidth ? o.bandwidth() / h : 0;
  if (p = v === "angleAxis" && a && a.length >= 2 ? Re(a[0] - a[1]) * 2 * p : p, f || d) {
    var m = (f || d || []).map((y, g) => {
      var b = n ? n.indexOf(y) : y;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: o(b) + p,
        value: y,
        offset: p,
        index: g
      };
    });
    return m.filter((y) => !Be(y.coordinate));
  }
  return c && s ? s.map((y, g) => ({
    coordinate: o(y) + p,
    value: y,
    index: g,
    offset: p
  })) : o.ticks && l != null ? o.ticks(l).map((y, g) => ({
    coordinate: o(y) + p,
    value: y,
    offset: p,
    index: g
  })) : o.domain().map((y, g) => ({
    coordinate: o(y) + p,
    value: n ? n[y] : y,
    index: g,
    offset: p
  }));
}, Xf = 1e-4, wO = (e) => {
  var t = e.domain();
  if (!(!t || t.length <= 2)) {
    var r = t.length, n = e.range(), i = Math.min(n[0], n[1]) - Xf, a = Math.max(n[0], n[1]) + Xf, o = e(t[0]), u = e(t[r - 1]);
    (o < i || o > a || u < i || u > a) && e.domain([t[0], t[r - 1]]);
  }
}, xO = (e, t) => {
  if (!t || t.length !== 2 || !k(t[0]) || !k(t[1]))
    return e;
  var r = Math.min(t[0], t[1]), n = Math.max(t[0], t[1]), i = [e[0], e[1]];
  return (!k(e[0]) || e[0] < r) && (i[0] = r), (!k(e[1]) || e[1] > n) && (i[1] = n), i[0] > n && (i[0] = n), i[1] < r && (i[1] = r), i;
}, OO = (e) => {
  var t = e.length;
  if (!(t <= 0))
    for (var r = 0, n = e[0].length; r < n; ++r)
      for (var i = 0, a = 0, o = 0; o < t; ++o) {
        var u = Be(e[o][r][1]) ? e[o][r][0] : e[o][r][1];
        u >= 0 ? (e[o][r][0] = i, e[o][r][1] = i + u, i = e[o][r][1]) : (e[o][r][0] = a, e[o][r][1] = a + u, a = e[o][r][1]);
      }
}, PO = (e) => {
  var t = e.length;
  if (!(t <= 0))
    for (var r = 0, n = e[0].length; r < n; ++r)
      for (var i = 0, a = 0; a < t; ++a) {
        var o = Be(e[a][r][1]) ? e[a][r][0] : e[a][r][1];
        o >= 0 ? (e[a][r][0] = i, e[a][r][1] = i + o, i = e[a][r][1]) : (e[a][r][0] = 0, e[a][r][1] = 0);
      }
}, AO = {
  sign: OO,
  // @ts-expect-error definitelytyped types are incorrect
  expand: C0,
  // @ts-expect-error definitelytyped types are incorrect
  none: Lr,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: k0,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: I0,
  positive: PO
}, SO = (e, t, r) => {
  var n = AO[r], i = M0().keys(t).value((a, o) => +ge(a, o, 0)).order(Ru).offset(n);
  return i(e);
};
function Jp(e) {
  return e == null ? void 0 : String(e);
}
function Zf(e) {
  var {
    axis: t,
    ticks: r,
    bandSize: n,
    entry: i,
    index: a,
    dataKey: o
  } = e;
  if (t.type === "category") {
    if (!t.allowDuplicatedCategory && t.dataKey && !te(i[t.dataKey])) {
      var u = Fh(r, "value", i[t.dataKey]);
      if (u)
        return u.coordinate + n / 2;
    }
    return r[a] ? r[a].coordinate + n / 2 : null;
  }
  var c = ge(i, te(o) ? t.dataKey : o);
  return te(c) ? null : t.scale(c);
}
var Jf = (e) => {
  var {
    axis: t,
    ticks: r,
    offset: n,
    bandSize: i,
    entry: a,
    index: o
  } = e;
  if (t.type === "category")
    return r[o] ? r[o].coordinate + n : null;
  var u = ge(a, t.dataKey, t.scale.domain()[o]);
  return te(u) ? null : t.scale(u) - i / 2 + n;
}, EO = (e) => {
  var {
    numericAxis: t
  } = e, r = t.scale.domain();
  if (t.type === "number") {
    var n = Math.min(r[0], r[1]), i = Math.max(r[0], r[1]);
    return n <= 0 && i >= 0 ? 0 : i < 0 ? i : n;
  }
  return r[0];
}, _O = (e) => {
  var t = e.flat(2).filter(k);
  return [Math.min(...t), Math.max(...t)];
}, jO = (e) => [e[0] === 1 / 0 ? 0 : e[0], e[1] === -1 / 0 ? 0 : e[1]], TO = (e, t, r) => {
  if (e != null)
    return jO(Object.keys(e).reduce((n, i) => {
      var a = e[i], {
        stackedData: o
      } = a, u = o.reduce((c, s) => {
        var l = Yp(s, t, r), f = _O(l);
        return [Math.min(c[0], f[0]), Math.max(c[1], f[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(u[0], n[0]), Math.max(u[1], n[1])];
    }, [1 / 0, -1 / 0]));
}, Qf = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, ed = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, Pn = (e, t, r) => {
  if (e && e.scale && e.scale.bandwidth) {
    var n = e.scale.bandwidth();
    if (!r || n > 0)
      return n;
  }
  if (e && t && t.length >= 2) {
    for (var i = ca(t, (l) => l.coordinate), a = 1 / 0, o = 1, u = i.length; o < u; o++) {
      var c = i[o], s = i[o - 1];
      a = Math.min((c.coordinate || 0) - (s.coordinate || 0), a);
    }
    return a === 1 / 0 ? 0 : a;
  }
  return r ? void 0 : 0;
};
function td(e) {
  var {
    tooltipEntrySettings: t,
    dataKey: r,
    payload: n,
    value: i,
    name: a
  } = e;
  return rt(rt({}, t), {}, {
    dataKey: r,
    payload: n,
    value: i,
    name: a
  });
}
function la(e, t) {
  if (e)
    return String(e);
  if (typeof t == "string")
    return t;
}
function MO(e, t, r, n, i) {
  if (r === "horizontal" || r === "vertical") {
    var a = e >= i.left && e <= i.left + i.width && t >= i.top && t <= i.top + i.height;
    return a ? {
      x: e,
      y: t
    } : null;
  }
  return n ? hO({
    x: e,
    y: t
  }, n) : null;
}
var CO = (e, t, r, n) => {
  var i = t.find((s) => s && s.index === r);
  if (i) {
    if (e === "horizontal")
      return {
        x: i.coordinate,
        y: n.y
      };
    if (e === "vertical")
      return {
        x: n.x,
        y: i.coordinate
      };
    if (e === "centric") {
      var a = i.coordinate, {
        radius: o
      } = n;
      return rt(rt(rt({}, n), Pe(n.cx, n.cy, o, a)), {}, {
        angle: a,
        radius: o
      });
    }
    var u = i.coordinate, {
      angle: c
    } = n;
    return rt(rt(rt({}, n), Pe(n.cx, n.cy, u, c)), {}, {
      angle: c,
      radius: u
    });
  }
  return {
    x: 0,
    y: 0
  };
}, kO = (e, t) => t === "horizontal" ? e.x : t === "vertical" ? e.y : t === "centric" ? e.angle : e.radius, Nt = (e) => e.layout.width, $t = (e) => e.layout.height, IO = (e) => e.layout.scale, Qp = (e) => e.layout.margin, ns = S((e) => e.cartesianAxis.xAxis, (e) => Object.values(e)), is = S((e) => e.cartesianAxis.yAxis, (e) => Object.values(e)), DO = "data-recharts-item-index", NO = "data-recharts-item-data-key", fa = 60;
function rd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Kt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rd(Object(r), !0).forEach(function(n) {
      $O(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : rd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function $O(e, t, r) {
  return (t = RO(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function RO(e) {
  var t = LO(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function LO(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var BO = (e) => e.brush.height, Se = S([Nt, $t, Qp, BO, ns, is, xp, Lw], (e, t, r, n, i, a, o, u) => {
  var c = a.reduce((h, p) => {
    var {
      orientation: m
    } = p;
    if (!p.mirror && !p.hide) {
      var y = typeof p.width == "number" ? p.width : fa;
      return Kt(Kt({}, h), {}, {
        [m]: h[m] + y
      });
    }
    return h;
  }, {
    left: r.left || 0,
    right: r.right || 0
  }), s = i.reduce((h, p) => {
    var {
      orientation: m
    } = p;
    return !p.mirror && !p.hide ? Kt(Kt({}, h), {}, {
      [m]: gr(h, "".concat(m)) + p.height
    }) : h;
  }, {
    top: r.top || 0,
    bottom: r.bottom || 0
  }), l = Kt(Kt({}, s), c), f = l.bottom;
  l.bottom += n, l = bO(l, o, u);
  var d = e - l.left - l.right, v = t - l.top - l.bottom;
  return Kt(Kt({
    brushBottom: f
  }, l), {}, {
    // never return negative values for height and width
    width: Math.max(d, 0),
    height: Math.max(v, 0)
  });
}), zO = S(Se, (e) => ({
  x: e.left,
  y: e.top,
  width: e.width,
  height: e.height
})), qO = S(Nt, $t, (e, t) => ({
  x: 0,
  y: 0,
  width: e,
  height: t
})), KO = /* @__PURE__ */ er(null), Xe = () => Gr(KO) != null, da = (e) => e.brush, va = S([da, Se, Qp], (e, t, r) => ({
  height: e.height,
  x: k(e.x) ? e.x : t.left,
  y: k(e.y) ? e.y : t.top + t.height + t.brushBottom - (r?.bottom || 0),
  width: k(e.width) ? e.width : t.width
})), as = () => {
  var e, t = Xe(), r = $(zO), n = $(va), i = (e = $(da)) === null || e === void 0 ? void 0 : e.padding;
  return !t || !n || !i ? r : {
    width: n.width - i.left - i.right,
    height: n.height - i.top - i.bottom,
    x: i.left,
    y: i.top
  };
}, FO = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  width: 0,
  height: 0,
  brushBottom: 0
}, em = () => {
  var e;
  return (e = $(Se)) !== null && e !== void 0 ? e : FO;
}, os = () => $(Nt), us = () => $($t), WO = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, UO = () => {
  var e;
  return (e = $((t) => t.layout.margin)) !== null && e !== void 0 ? e : WO;
}, W = (e) => e.layout.layoutType, ha = () => $(W), tm = /* @__PURE__ */ Symbol.for("immer-nothing"), nd = /* @__PURE__ */ Symbol.for("immer-draftable"), He = /* @__PURE__ */ Symbol.for("immer-state"), VO = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function $e(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const r = VO[e], n = typeof r == "function" ? r.apply(null, t) : r;
    throw new Error(`[Immer] ${n}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var zr = Object.getPrototypeOf;
function qr(e) {
  return !!e && !!e[He];
}
function xr(e) {
  return e ? rm(e) || Array.isArray(e) || !!e[nd] || !!e.constructor?.[nd] || ma(e) || ya(e) : !1;
}
var HO = Object.prototype.constructor.toString();
function rm(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = zr(e);
  if (t === null)
    return !0;
  const r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return r === Object ? !0 : typeof r == "function" && Function.toString.call(r) === HO;
}
function ji(e, t) {
  pa(e) === 0 ? Reflect.ownKeys(e).forEach((r) => {
    t(r, e[r], e);
  }) : e.forEach((r, n) => t(n, r, e));
}
function pa(e) {
  const t = e[He];
  return t ? t.type_ : Array.isArray(e) ? 1 : ma(e) ? 2 : ya(e) ? 3 : 0;
}
function Yu(e, t) {
  return pa(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function nm(e, t, r) {
  const n = pa(e);
  n === 2 ? e.set(t, r) : n === 3 ? e.add(r) : e[t] = r;
}
function GO(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function ma(e) {
  return e instanceof Map;
}
function ya(e) {
  return e instanceof Set;
}
function ur(e) {
  return e.copy_ || e.base_;
}
function Xu(e, t) {
  if (ma(e))
    return new Map(e);
  if (ya(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const r = rm(e);
  if (t === !0 || t === "class_only" && !r) {
    const n = Object.getOwnPropertyDescriptors(e);
    delete n[He];
    let i = Reflect.ownKeys(n);
    for (let a = 0; a < i.length; a++) {
      const o = i[a], u = n[o];
      u.writable === !1 && (u.writable = !0, u.configurable = !0), (u.get || u.set) && (n[o] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: u.enumerable,
        value: e[o]
      });
    }
    return Object.create(zr(e), n);
  } else {
    const n = zr(e);
    if (n !== null && r)
      return { ...e };
    const i = Object.create(n);
    return Object.assign(i, e);
  }
}
function cs(e, t = !1) {
  return ga(e) || qr(e) || !xr(e) || (pa(e) > 1 && (e.set = e.add = e.clear = e.delete = YO), Object.freeze(e), t && Object.entries(e).forEach(([r, n]) => cs(n, !0))), e;
}
function YO() {
  $e(2);
}
function ga(e) {
  return Object.isFrozen(e);
}
var XO = {};
function Or(e) {
  const t = XO[e];
  return t || $e(0, e), t;
}
var An;
function im() {
  return An;
}
function ZO(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function id(e, t) {
  t && (Or("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function Zu(e) {
  Ju(e), e.drafts_.forEach(JO), e.drafts_ = null;
}
function Ju(e) {
  e === An && (An = e.parent_);
}
function ad(e) {
  return An = ZO(An, e);
}
function JO(e) {
  const t = e[He];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function od(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const r = t.drafts_[0];
  return e !== void 0 && e !== r ? (r[He].modified_ && (Zu(t), $e(4)), xr(e) && (e = Ti(t, e), t.parent_ || Mi(t, e)), t.patches_ && Or("Patches").generateReplacementPatches_(
    r[He].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = Ti(t, r, []), Zu(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== tm ? e : void 0;
}
function Ti(e, t, r) {
  if (ga(t))
    return t;
  const n = t[He];
  if (!n)
    return ji(
      t,
      (i, a) => ud(e, n, t, i, a, r)
    ), t;
  if (n.scope_ !== e)
    return t;
  if (!n.modified_)
    return Mi(e, n.base_, !0), n.base_;
  if (!n.finalized_) {
    n.finalized_ = !0, n.scope_.unfinalizedDrafts_--;
    const i = n.copy_;
    let a = i, o = !1;
    n.type_ === 3 && (a = new Set(i), i.clear(), o = !0), ji(
      a,
      (u, c) => ud(e, n, i, u, c, r, o)
    ), Mi(e, i, !1), r && e.patches_ && Or("Patches").generatePatches_(
      n,
      r,
      e.patches_,
      e.inversePatches_
    );
  }
  return n.copy_;
}
function ud(e, t, r, n, i, a, o) {
  if (process.env.NODE_ENV !== "production" && i === r && $e(5), qr(i)) {
    const u = a && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !Yu(t.assigned_, n) ? a.concat(n) : void 0, c = Ti(e, i, u);
    if (nm(r, n, c), qr(c))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else o && r.add(i);
  if (xr(i) && !ga(i)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    Ti(e, i), (!t || !t.scope_.parent_) && typeof n != "symbol" && Object.prototype.propertyIsEnumerable.call(r, n) && Mi(e, i);
  }
}
function Mi(e, t, r = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && cs(t, r);
}
function QO(e, t) {
  const r = Array.isArray(e), n = {
    type_: r ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : im(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let i = n, a = ss;
  r && (i = [n], a = Sn);
  const { revoke: o, proxy: u } = Proxy.revocable(i, a);
  return n.draft_ = u, n.revoke_ = o, u;
}
var ss = {
  get(e, t) {
    if (t === He)
      return e;
    const r = ur(e);
    if (!Yu(r, t))
      return e1(e, r, t);
    const n = r[t];
    return e.finalized_ || !xr(n) ? n : n === Ho(e.base_, t) ? (Go(e), e.copy_[t] = ec(n, e)) : n;
  },
  has(e, t) {
    return t in ur(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(ur(e));
  },
  set(e, t, r) {
    const n = am(ur(e), t);
    if (n?.set)
      return n.set.call(e.draft_, r), !0;
    if (!e.modified_) {
      const i = Ho(ur(e), t), a = i?.[He];
      if (a && a.base_ === r)
        return e.copy_[t] = r, e.assigned_[t] = !1, !0;
      if (GO(r, i) && (r !== void 0 || Yu(e.base_, t)))
        return !0;
      Go(e), Qu(e);
    }
    return e.copy_[t] === r && // special case: handle new props with value 'undefined'
    (r !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(r) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = r, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return Ho(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, Go(e), Qu(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const r = ur(e), n = Reflect.getOwnPropertyDescriptor(r, t);
    return n && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: n.enumerable,
      value: r[t]
    };
  },
  defineProperty() {
    $e(11);
  },
  getPrototypeOf(e) {
    return zr(e.base_);
  },
  setPrototypeOf() {
    $e(12);
  }
}, Sn = {};
ji(ss, (e, t) => {
  Sn[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
Sn.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && $e(13), Sn.set.call(this, e, t, void 0);
};
Sn.set = function(e, t, r) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && $e(14), ss.set.call(this, e[0], t, r, e[0]);
};
function Ho(e, t) {
  const r = e[He];
  return (r ? ur(r) : e)[t];
}
function e1(e, t, r) {
  const n = am(t, r);
  return n ? "value" in n ? n.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    n.get?.call(e.draft_)
  ) : void 0;
}
function am(e, t) {
  if (!(t in e))
    return;
  let r = zr(e);
  for (; r; ) {
    const n = Object.getOwnPropertyDescriptor(r, t);
    if (n)
      return n;
    r = zr(r);
  }
}
function Qu(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && Qu(e.parent_));
}
function Go(e) {
  e.copy_ || (e.copy_ = Xu(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var t1 = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, r, n) => {
      if (typeof t == "function" && typeof r != "function") {
        const a = r;
        r = t;
        const o = this;
        return function(c = a, ...s) {
          return o.produce(c, (l) => r.call(this, l, ...s));
        };
      }
      typeof r != "function" && $e(6), n !== void 0 && typeof n != "function" && $e(7);
      let i;
      if (xr(t)) {
        const a = ad(this), o = ec(t, void 0);
        let u = !0;
        try {
          i = r(o), u = !1;
        } finally {
          u ? Zu(a) : Ju(a);
        }
        return id(a, n), od(i, a);
      } else if (!t || typeof t != "object") {
        if (i = r(t), i === void 0 && (i = t), i === tm && (i = void 0), this.autoFreeze_ && cs(i, !0), n) {
          const a = [], o = [];
          Or("Patches").generateReplacementPatches_(t, i, a, o), n(a, o);
        }
        return i;
      } else
        $e(1, t);
    }, this.produceWithPatches = (t, r) => {
      if (typeof t == "function")
        return (o, ...u) => this.produceWithPatches(o, (c) => t(c, ...u));
      let n, i;
      return [this.produce(t, r, (o, u) => {
        n = o, i = u;
      }), n, i];
    }, typeof e?.autoFreeze == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof e?.useStrictShallowCopy == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    xr(e) || $e(8), qr(e) && (e = r1(e));
    const t = ad(this), r = ec(e, void 0);
    return r[He].isManual_ = !0, Ju(t), r;
  }
  finishDraft(e, t) {
    const r = e && e[He];
    (!r || !r.isManual_) && $e(9);
    const { scope_: n } = r;
    return id(n, t), od(void 0, n);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let r;
    for (r = t.length - 1; r >= 0; r--) {
      const i = t[r];
      if (i.path.length === 0 && i.op === "replace") {
        e = i.value;
        break;
      }
    }
    r > -1 && (t = t.slice(r + 1));
    const n = Or("Patches").applyPatches_;
    return qr(e) ? n(e, t) : this.produce(
      e,
      (i) => n(i, t)
    );
  }
};
function ec(e, t) {
  const r = ma(e) ? Or("MapSet").proxyMap_(e, t) : ya(e) ? Or("MapSet").proxySet_(e, t) : QO(e, t);
  return (t ? t.scope_ : im()).drafts_.push(r), r;
}
function r1(e) {
  return qr(e) || $e(10, e), om(e);
}
function om(e) {
  if (!xr(e) || ga(e))
    return e;
  const t = e[He];
  let r;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, r = Xu(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    r = Xu(e, !0);
  return ji(r, (n, i) => {
    nm(r, n, om(i));
  }), t && (t.finalized_ = !1), r;
}
var Ge = new t1();
Ge.produce;
Ge.produceWithPatches.bind(
  Ge
);
Ge.setAutoFreeze.bind(Ge);
Ge.setUseStrictShallowCopy.bind(Ge);
Ge.applyPatches.bind(Ge);
Ge.createDraft.bind(Ge);
Ge.finishDraft.bind(Ge);
var n1 = {
  settings: {
    layout: "horizontal",
    align: "center",
    verticalAlign: "middle",
    itemSorter: "value"
  },
  size: {
    width: 0,
    height: 0
  },
  payload: []
}, um = Ye({
  name: "legend",
  initialState: n1,
  reducers: {
    setLegendSize(e, t) {
      e.size.width = t.payload.width, e.size.height = t.payload.height;
    },
    setLegendSettings(e, t) {
      e.settings.align = t.payload.align, e.settings.layout = t.payload.layout, e.settings.verticalAlign = t.payload.verticalAlign, e.settings.itemSorter = t.payload.itemSorter;
    },
    addLegendPayload(e, t) {
      e.payload.push(t.payload);
    },
    removeLegendPayload(e, t) {
      var r = St(e).payload.indexOf(t.payload);
      r > -1 && e.payload.splice(r, 1);
    }
  }
}), {
  setLegendSize: cd,
  setLegendSettings: i1,
  addLegendPayload: a1,
  removeLegendPayload: o1
} = um.actions, u1 = um.reducer, c1 = ["contextPayload"];
function tc() {
  return tc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, tc.apply(null, arguments);
}
function sd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Kr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? sd(Object(r), !0).forEach(function(n) {
      ls(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : sd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ls(e, t, r) {
  return (t = s1(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function s1(e) {
  var t = l1(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function l1(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function f1(e, t) {
  if (e == null) return {};
  var r, n, i = d1(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function d1(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function v1(e) {
  return e.value;
}
function h1(e) {
  var {
    contextPayload: t
  } = e, r = f1(e, c1), n = yp(t, e.payloadUniqBy, v1), i = Kr(Kr({}, r), {}, {
    payload: n
  });
  return /* @__PURE__ */ x.isValidElement(e.content) ? /* @__PURE__ */ x.cloneElement(e.content, i) : typeof e.content == "function" ? /* @__PURE__ */ x.createElement(e.content, i) : /* @__PURE__ */ x.createElement(qc, i);
}
function p1(e, t, r, n, i, a) {
  var {
    layout: o,
    align: u,
    verticalAlign: c
  } = t, s, l;
  return (!e || (e.left === void 0 || e.left === null) && (e.right === void 0 || e.right === null)) && (u === "center" && o === "vertical" ? s = {
    left: ((n || 0) - a.width) / 2
  } : s = u === "right" ? {
    right: r && r.right || 0
  } : {
    left: r && r.left || 0
  }), (!e || (e.top === void 0 || e.top === null) && (e.bottom === void 0 || e.bottom === null)) && (c === "middle" ? l = {
    top: ((i || 0) - a.height) / 2
  } : l = c === "bottom" ? {
    bottom: r && r.bottom || 0
  } : {
    top: r && r.top || 0
  }), Kr(Kr({}, s), l);
}
function m1(e) {
  var t = be();
  return ae(() => {
    t(i1(e));
  }, [t, e]), null;
}
function y1(e) {
  var t = be();
  return ae(() => (t(cd(e)), () => {
    t(cd({
      width: 0,
      height: 0
    }));
  }), [t, e]), null;
}
function g1(e) {
  var t = qw(), r = e0(), n = UO(), {
    width: i,
    height: a,
    wrapperStyle: o,
    portal: u
  } = e, [c, s] = Op([t]), l = os(), f = us(), d = l - (n.left || 0) - (n.right || 0), v = ba.getWidthOrHeight(e.layout, a, i, d), h = u ? o : Kr(Kr({
    position: "absolute",
    width: v?.width || i || "auto",
    height: v?.height || a || "auto"
  }, p1(o, e, n, l, f, c)), o), p = u ?? r;
  if (p == null)
    return null;
  var m = /* @__PURE__ */ x.createElement("div", {
    className: "recharts-legend-wrapper",
    style: h,
    ref: s
  }, /* @__PURE__ */ x.createElement(m1, {
    layout: e.layout,
    align: e.align,
    verticalAlign: e.verticalAlign,
    itemSorter: e.itemSorter
  }), /* @__PURE__ */ x.createElement(y1, {
    width: c.width,
    height: c.height
  }), /* @__PURE__ */ x.createElement(h1, tc({}, e, v, {
    margin: n,
    chartWidth: l,
    chartHeight: f,
    contextPayload: t
  })));
  return /* @__PURE__ */ Lh(m, p);
}
class ba extends Yr {
  static getWidthOrHeight(t, r, n, i) {
    return t === "vertical" && k(r) ? {
      height: r
    } : t === "horizontal" ? {
      width: n || i
    } : null;
  }
  render() {
    return /* @__PURE__ */ x.createElement(g1, this.props);
  }
}
ls(ba, "displayName", "Legend");
ls(ba, "defaultProps", {
  align: "center",
  iconSize: 14,
  itemSorter: "value",
  layout: "horizontal",
  verticalAlign: "bottom"
});
function rc() {
  return rc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rc.apply(null, arguments);
}
function ld(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Yo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ld(Object(r), !0).forEach(function(n) {
      b1(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ld(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function b1(e, t, r) {
  return (t = w1(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function w1(e) {
  var t = x1(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function x1(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function O1(e) {
  return Array.isArray(e) && mt(e[0]) && mt(e[1]) ? e.join(" ~ ") : e;
}
var P1 = (e) => {
  var {
    separator: t = " : ",
    contentStyle: r = {},
    itemStyle: n = {},
    labelStyle: i = {},
    payload: a,
    formatter: o,
    itemSorter: u,
    wrapperClassName: c,
    labelClassName: s,
    label: l,
    labelFormatter: f,
    accessibilityLayer: d = !1
  } = e, v = () => {
    if (a && a.length) {
      var w = {
        padding: 0,
        margin: 0
      }, P = (u ? ca(a, u) : a).map((A, _) => {
        if (A.type === "none")
          return null;
        var T = A.formatter || o || O1, {
          value: N,
          name: j
        } = A, C = N, z = j;
        if (T) {
          var K = T(N, j, A, _, a);
          if (Array.isArray(K))
            [C, z] = K;
          else if (K != null)
            C = K;
          else
            return null;
        }
        var J = Yo({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: A.color || "#000"
        }, n);
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ x.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(_),
            style: J
          }, mt(z) ? /* @__PURE__ */ x.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, z) : null, mt(z) ? /* @__PURE__ */ x.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, t) : null, /* @__PURE__ */ x.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, C), /* @__PURE__ */ x.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, A.unit || ""))
        );
      });
      return /* @__PURE__ */ x.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: w
      }, P);
    }
    return null;
  }, h = Yo({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, r), p = Yo({
    margin: 0
  }, i), m = !te(l), y = m ? l : "", g = G("recharts-default-tooltip", c), b = G("recharts-tooltip-label", s);
  m && f && a !== void 0 && a !== null && (y = f(l, a));
  var O = d ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ x.createElement("div", rc({
    className: g,
    style: h
  }, O), /* @__PURE__ */ x.createElement("p", {
    className: b,
    style: p
  }, /* @__PURE__ */ x.isValidElement(y) ? y : "".concat(y)), v());
}, cn = "recharts-tooltip-wrapper", A1 = {
  visibility: "hidden"
};
function S1(e) {
  var {
    coordinate: t,
    translateX: r,
    translateY: n
  } = e;
  return G(cn, {
    ["".concat(cn, "-right")]: k(r) && t && k(t.x) && r >= t.x,
    ["".concat(cn, "-left")]: k(r) && t && k(t.x) && r < t.x,
    ["".concat(cn, "-bottom")]: k(n) && t && k(t.y) && n >= t.y,
    ["".concat(cn, "-top")]: k(n) && t && k(t.y) && n < t.y
  });
}
function fd(e) {
  var {
    allowEscapeViewBox: t,
    coordinate: r,
    key: n,
    offsetTopLeft: i,
    position: a,
    reverseDirection: o,
    tooltipDimension: u,
    viewBox: c,
    viewBoxDimension: s
  } = e;
  if (a && k(a[n]))
    return a[n];
  var l = r[n] - u - (i > 0 ? i : 0), f = r[n] + i;
  if (t[n])
    return o[n] ? l : f;
  var d = c[n];
  if (d == null)
    return 0;
  if (o[n]) {
    var v = l, h = d;
    return v < h ? Math.max(f, d) : Math.max(l, d);
  }
  if (s == null)
    return 0;
  var p = f + u, m = d + s;
  return p > m ? Math.max(l, d) : Math.max(f, d);
}
function E1(e) {
  var {
    translateX: t,
    translateY: r,
    useTranslate3d: n
  } = e;
  return {
    transform: n ? "translate3d(".concat(t, "px, ").concat(r, "px, 0)") : "translate(".concat(t, "px, ").concat(r, "px)")
  };
}
function _1(e) {
  var {
    allowEscapeViewBox: t,
    coordinate: r,
    offsetTopLeft: n,
    position: i,
    reverseDirection: a,
    tooltipBox: o,
    useTranslate3d: u,
    viewBox: c
  } = e, s, l, f;
  return o.height > 0 && o.width > 0 && r ? (l = fd({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "x",
    offsetTopLeft: n,
    position: i,
    reverseDirection: a,
    tooltipDimension: o.width,
    viewBox: c,
    viewBoxDimension: c.width
  }), f = fd({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "y",
    offsetTopLeft: n,
    position: i,
    reverseDirection: a,
    tooltipDimension: o.height,
    viewBox: c,
    viewBoxDimension: c.height
  }), s = E1({
    translateX: l,
    translateY: f,
    useTranslate3d: u
  })) : s = A1, {
    cssProperties: s,
    cssClasses: S1({
      translateX: l,
      translateY: f,
      coordinate: r
    })
  };
}
function dd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ii(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dd(Object(r), !0).forEach(function(n) {
      nc(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : dd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function nc(e, t, r) {
  return (t = j1(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function j1(e) {
  var t = T1(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function T1(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class M1 extends Yr {
  constructor() {
    super(...arguments), nc(this, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      }
    }), nc(this, "handleKeyDown", (t) => {
      if (t.key === "Escape") {
        var r, n, i, a;
        this.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (r = (n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== null && r !== void 0 ? r : 0,
            y: (i = (a = this.props.coordinate) === null || a === void 0 ? void 0 : a.y) !== null && i !== void 0 ? i : 0
          }
        });
      }
    });
  }
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }
  componentDidUpdate() {
    var t, r;
    this.state.dismissed && (((t = this.props.coordinate) === null || t === void 0 ? void 0 : t.x) !== this.state.dismissedAtCoordinate.x || ((r = this.props.coordinate) === null || r === void 0 ? void 0 : r.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
  }
  render() {
    var {
      active: t,
      allowEscapeViewBox: r,
      animationDuration: n,
      animationEasing: i,
      children: a,
      coordinate: o,
      hasPayload: u,
      isAnimationActive: c,
      offset: s,
      position: l,
      reverseDirection: f,
      useTranslate3d: d,
      viewBox: v,
      wrapperStyle: h,
      lastBoundingBox: p,
      innerRef: m,
      hasPortalFromProps: y
    } = this.props, {
      cssClasses: g,
      cssProperties: b
    } = _1({
      allowEscapeViewBox: r,
      coordinate: o,
      offsetTopLeft: s,
      position: l,
      reverseDirection: f,
      tooltipBox: {
        height: p.height,
        width: p.width
      },
      useTranslate3d: d,
      viewBox: v
    }), O = y ? {} : ii(ii({
      transition: c && t ? "transform ".concat(n, "ms ").concat(i) : void 0
    }, b), {}, {
      pointerEvents: "none",
      visibility: !this.state.dismissed && t && u ? "visible" : "hidden",
      position: "absolute",
      top: 0,
      left: 0
    }), w = ii(ii({}, O), {}, {
      visibility: !this.state.dismissed && t && u ? "visible" : "hidden"
    }, h);
    return (
      // This element allow listening to the `Escape` key. See https://github.com/recharts/recharts/pull/2925
      /* @__PURE__ */ x.createElement("div", {
        // @ts-expect-error typescript library does not recognize xmlns attribute, but it's required for an HTML chunk inside SVG.
        xmlns: "http://www.w3.org/1999/xhtml",
        tabIndex: -1,
        className: g,
        style: w,
        ref: m
      }, a)
    );
  }
}
var C1 = () => !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout), Zr = {
  isSsr: C1()
}, cm = () => $((e) => e.rootProps.accessibilityLayer);
function Ae(e) {
  return Number.isFinite(e);
}
function Ci(e) {
  return typeof e == "number" && e > 0 && Number.isFinite(e);
}
function ic() {
  return ic = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ic.apply(null, arguments);
}
function vd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vd(Object(r), !0).forEach(function(n) {
      k1(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function k1(e, t, r) {
  return (t = I1(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function I1(e) {
  var t = D1(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function D1(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var pd = {
  curveBasisClosed: b0,
  curveBasisOpen: w0,
  curveBasis: g0,
  curveBumpX: i0,
  curveBumpY: a0,
  curveLinearClosed: x0,
  curveLinear: oa,
  curveMonotoneX: O0,
  curveMonotoneY: P0,
  curveNatural: A0,
  curveStep: S0,
  curveStepAfter: _0,
  curveStepBefore: E0
}, ai = (e) => Ae(e.x) && Ae(e.y), sn = (e) => e.x, ln = (e) => e.y, N1 = (e, t) => {
  if (typeof e == "function")
    return e;
  var r = "curve".concat(Nn(e));
  return (r === "curveMonotone" || r === "curveBump") && t ? pd["".concat(r).concat(t === "vertical" ? "Y" : "X")] : pd[r] || oa;
}, $1 = (e) => {
  var {
    type: t = "linear",
    points: r = [],
    baseLine: n,
    layout: i,
    connectNulls: a = !1
  } = e, o = N1(t, i), u = a ? r.filter(ai) : r, c;
  if (Array.isArray(n)) {
    var s = a ? n.filter((f) => ai(f)) : n, l = u.map((f, d) => hd(hd({}, f), {}, {
      base: s[d]
    }));
    return i === "vertical" ? c = Qn().y(ln).x1(sn).x0((f) => f.base.x) : c = Qn().x(sn).y1(ln).y0((f) => f.base.y), c.defined(ai).curve(o), c(l);
  }
  return i === "vertical" && k(n) ? c = Qn().y(ln).x1(sn).x0(n) : k(n) ? c = Qn().x(sn).y1(ln).y0(n) : c = Qh().x(sn).y(ln), c.defined(ai).curve(o), c(u);
}, mi = (e) => {
  var {
    className: t,
    points: r,
    path: n,
    pathRef: i
  } = e;
  if ((!r || !r.length) && !n)
    return null;
  var a = r && r.length ? $1(e) : n;
  return /* @__PURE__ */ x.createElement("path", ic({}, tr(e), Ic(e), {
    className: G("recharts-curve", t),
    d: a === null ? void 0 : a,
    ref: i
  }));
}, R1 = ["x", "y", "top", "left", "width", "height", "className"];
function ac() {
  return ac = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ac.apply(null, arguments);
}
function md(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function L1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? md(Object(r), !0).forEach(function(n) {
      B1(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : md(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function B1(e, t, r) {
  return (t = z1(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function z1(e) {
  var t = q1(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function q1(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function K1(e, t) {
  if (e == null) return {};
  var r, n, i = F1(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function F1(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var W1 = (e, t, r, n, i, a) => "M".concat(e, ",").concat(i, "v").concat(n, "M").concat(a, ",").concat(t, "h").concat(r), U1 = (e) => {
  var {
    x: t = 0,
    y: r = 0,
    top: n = 0,
    left: i = 0,
    width: a = 0,
    height: o = 0,
    className: u
  } = e, c = K1(e, R1), s = L1({
    x: t,
    y: r,
    top: n,
    left: i,
    width: a,
    height: o
  }, c);
  return !k(t) || !k(r) || !k(a) || !k(o) || !k(n) || !k(i) ? null : /* @__PURE__ */ x.createElement("path", ac({}, ie(s, !0), {
    className: G("recharts-cross", u),
    d: W1(t, r, a, o, n, i)
  }));
};
function V1(e, t, r, n) {
  var i = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - i : r.left + 0.5,
    y: e === "horizontal" ? r.top + 0.5 : t.y - i,
    width: e === "horizontal" ? n : r.width - 1,
    height: e === "horizontal" ? r.height - 1 : n
  };
}
function yd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function H1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yd(Object(r), !0).forEach(function(n) {
      G1(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function G1(e, t, r) {
  return (t = Y1(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Y1(e) {
  var t = X1(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function X1(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function bt(e, t) {
  var r = H1({}, e), n = t, i = Object.keys(t), a = i.reduce((o, u) => (o[u] === void 0 && n[u] !== void 0 && (o[u] = n[u]), o), r);
  return a;
}
var Xo = {}, Zo = {}, Jo = {}, gd;
function Z1() {
  return gd || (gd = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      if (!r || typeof r != "object")
        return !1;
      const n = Object.getPrototypeOf(r);
      return n === null || n === Object.prototype || Object.getPrototypeOf(n) === null ? Object.prototype.toString.call(r) === "[object Object]" : !1;
    }
    e.isPlainObject = t;
  })(Jo)), Jo;
}
var bd;
function J1() {
  return bd || (bd = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ Z1(), r = /* @__PURE__ */ hp(), n = /* @__PURE__ */ Uc(), i = /* @__PURE__ */ Vc(), a = /* @__PURE__ */ Fc();
    function o(s, l, f) {
      return u(s, l, void 0, void 0, void 0, void 0, f);
    }
    function u(s, l, f, d, v, h, p) {
      const m = p(s, l, f, d, v, h);
      if (m !== void 0)
        return m;
      if (typeof s == typeof l)
        switch (typeof s) {
          case "bigint":
          case "string":
          case "boolean":
          case "symbol":
          case "undefined":
            return s === l;
          case "number":
            return s === l || Object.is(s, l);
          case "function":
            return s === l;
          case "object":
            return c(s, l, h, p);
        }
      return c(s, l, h, p);
    }
    function c(s, l, f, d) {
      if (Object.is(s, l))
        return !0;
      let v = n.getTag(s), h = n.getTag(l);
      if (v === i.argumentsTag && (v = i.objectTag), h === i.argumentsTag && (h = i.objectTag), v !== h)
        return !1;
      switch (v) {
        case i.stringTag:
          return s.toString() === l.toString();
        case i.numberTag: {
          const y = s.valueOf(), g = l.valueOf();
          return a.eq(y, g);
        }
        case i.booleanTag:
        case i.dateTag:
        case i.symbolTag:
          return Object.is(s.valueOf(), l.valueOf());
        case i.regexpTag:
          return s.source === l.source && s.flags === l.flags;
        case i.functionTag:
          return s === l;
      }
      f = f ?? /* @__PURE__ */ new Map();
      const p = f.get(s), m = f.get(l);
      if (p != null && m != null)
        return p === l;
      f.set(s, l), f.set(l, s);
      try {
        switch (v) {
          case i.mapTag: {
            if (s.size !== l.size)
              return !1;
            for (const [y, g] of s.entries())
              if (!l.has(y) || !u(g, l.get(y), y, s, l, f, d))
                return !1;
            return !0;
          }
          case i.setTag: {
            if (s.size !== l.size)
              return !1;
            const y = Array.from(s.values()), g = Array.from(l.values());
            for (let b = 0; b < y.length; b++) {
              const O = y[b], w = g.findIndex((P) => u(O, P, void 0, s, l, f, d));
              if (w === -1)
                return !1;
              g.splice(w, 1);
            }
            return !0;
          }
          case i.arrayTag:
          case i.uint8ArrayTag:
          case i.uint8ClampedArrayTag:
          case i.uint16ArrayTag:
          case i.uint32ArrayTag:
          case i.bigUint64ArrayTag:
          case i.int8ArrayTag:
          case i.int16ArrayTag:
          case i.int32ArrayTag:
          case i.bigInt64ArrayTag:
          case i.float32ArrayTag:
          case i.float64ArrayTag: {
            if (typeof Buffer < "u" && Buffer.isBuffer(s) !== Buffer.isBuffer(l) || s.length !== l.length)
              return !1;
            for (let y = 0; y < s.length; y++)
              if (!u(s[y], l[y], y, s, l, f, d))
                return !1;
            return !0;
          }
          case i.arrayBufferTag:
            return s.byteLength !== l.byteLength ? !1 : c(new Uint8Array(s), new Uint8Array(l), f, d);
          case i.dataViewTag:
            return s.byteLength !== l.byteLength || s.byteOffset !== l.byteOffset ? !1 : c(new Uint8Array(s), new Uint8Array(l), f, d);
          case i.errorTag:
            return s.name === l.name && s.message === l.message;
          case i.objectTag: {
            if (!(c(s.constructor, l.constructor, f, d) || t.isPlainObject(s) && t.isPlainObject(l)))
              return !1;
            const g = [...Object.keys(s), ...r.getSymbols(s)], b = [...Object.keys(l), ...r.getSymbols(l)];
            if (g.length !== b.length)
              return !1;
            for (let O = 0; O < g.length; O++) {
              const w = g[O], P = s[w];
              if (!Object.hasOwn(l, w))
                return !1;
              const A = l[w];
              if (!u(P, A, w, s, l, f, d))
                return !1;
            }
            return !0;
          }
          default:
            return !1;
        }
      } finally {
        f.delete(s), f.delete(l);
      }
    }
    e.isEqualWith = o;
  })(Zo)), Zo;
}
var Qo = {}, wd;
function Q1() {
  return wd || (wd = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t() {
    }
    e.noop = t;
  })(Qo)), Qo;
}
var xd;
function eP() {
  return xd || (xd = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ J1(), r = /* @__PURE__ */ Q1();
    function n(i, a) {
      return t.isEqualWith(i, a, r.noop);
    }
    e.isEqual = n;
  })(Xo)), Xo;
}
var eu, Od;
function tP() {
  return Od || (Od = 1, eu = eP().isEqual), eu;
}
var rP = /* @__PURE__ */ tP();
const nP = /* @__PURE__ */ It(rP);
var ki = 1e-4, sm = (e, t) => [0, 3 * e, 3 * t - 6 * e, 3 * e - 3 * t + 1], lm = (e, t) => e.map((r, n) => r * t ** n).reduce((r, n) => r + n), Pd = (e, t) => (r) => {
  var n = sm(e, t);
  return lm(n, r);
}, iP = (e, t) => (r) => {
  var n = sm(e, t), i = [...n.map((a, o) => a * o).slice(1), 0];
  return lm(i, r);
}, Ad = function() {
  for (var t, r, n, i, a = arguments.length, o = new Array(a), u = 0; u < a; u++)
    o[u] = arguments[u];
  if (o.length === 1)
    switch (o[0]) {
      case "linear":
        [t, n, r, i] = [0, 0, 1, 1];
        break;
      case "ease":
        [t, n, r, i] = [0.25, 0.1, 0.25, 1];
        break;
      case "ease-in":
        [t, n, r, i] = [0.42, 0, 1, 1];
        break;
      case "ease-out":
        [t, n, r, i] = [0.42, 0, 0.58, 1];
        break;
      case "ease-in-out":
        [t, n, r, i] = [0, 0, 0.58, 1];
        break;
      default: {
        var c = o[0].split("(");
        c[0] === "cubic-bezier" && c[1].split(")")[0].split(",").length === 4 && ([t, n, r, i] = c[1].split(")")[0].split(",").map((h) => parseFloat(h)));
      }
    }
  else o.length === 4 && ([t, n, r, i] = o);
  var s = Pd(t, r), l = Pd(n, i), f = iP(t, r), d = (h) => h > 1 ? 1 : h < 0 ? 0 : h, v = (h) => {
    for (var p = h > 1 ? 1 : h, m = p, y = 0; y < 8; ++y) {
      var g = s(m) - p, b = f(m);
      if (Math.abs(g - p) < ki || b < ki)
        return l(m);
      m = d(m - g / b);
    }
    return l(m);
  };
  return v.isStepper = !1, v;
}, aP = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, {
    stiff: r = 100,
    damping: n = 8,
    dt: i = 17
  } = t, a = (o, u, c) => {
    var s = -(o - u) * r, l = c * n, f = c + (s - l) * i / 1e3, d = c * i / 1e3 + o;
    return Math.abs(d - u) < ki && Math.abs(f) < ki ? [u, 0] : [d, f];
  };
  return a.isStepper = !0, a.dt = i, a;
}, fm = (e) => {
  if (typeof e == "string")
    switch (e) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return Ad(e);
      case "spring":
        return aP();
      default:
        if (e.split("(")[0] === "cubic-bezier")
          return Ad(e);
    }
  return typeof e == "function" ? e : null;
};
function Sd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ed(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sd(Object(r), !0).forEach(function(n) {
      oP(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function oP(e, t, r) {
  return (t = uP(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function uP(e) {
  var t = cP(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function cP(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var sP = (e) => e.replace(/([A-Z])/g, (t) => "-".concat(t.toLowerCase())), lP = (e, t, r) => e.map((n) => "".concat(sP(n), " ").concat(t, "ms ").concat(r)).join(","), fP = (e, t) => [Object.keys(e), Object.keys(t)].reduce((r, n) => r.filter((i) => n.includes(i))), En = (e, t) => Object.keys(t).reduce((r, n) => Ed(Ed({}, r), {}, {
  [n]: e(n, t[n])
}), {});
function _d(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Oe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _d(Object(r), !0).forEach(function(n) {
      dP(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _d(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function dP(e, t, r) {
  return (t = vP(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function vP(e) {
  var t = hP(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function hP(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ii = (e, t, r) => e + (t - e) * r, oc = (e) => {
  var {
    from: t,
    to: r
  } = e;
  return t !== r;
}, dm = (e, t, r) => {
  var n = En((i, a) => {
    if (oc(a)) {
      var [o, u] = e(a.from, a.to, a.velocity);
      return Oe(Oe({}, a), {}, {
        from: o,
        velocity: u
      });
    }
    return a;
  }, t);
  return r < 1 ? En((i, a) => oc(a) ? Oe(Oe({}, a), {}, {
    velocity: Ii(a.velocity, n[i].velocity, r),
    from: Ii(a.from, n[i].from, r)
  }) : a, t) : dm(e, n, r - 1);
};
function pP(e, t, r, n, i, a) {
  var o, u = n.reduce((d, v) => Oe(Oe({}, d), {}, {
    [v]: {
      from: e[v],
      velocity: 0,
      to: t[v]
    }
  }), {}), c = () => En((d, v) => v.from, u), s = () => !Object.values(u).filter(oc).length, l = null, f = (d) => {
    o || (o = d);
    var v = d - o, h = v / r.dt;
    u = dm(r, u, h), i(Oe(Oe(Oe({}, e), t), c())), o = d, s() || (l = a.setTimeout(f));
  };
  return () => (l = a.setTimeout(f), () => {
    l();
  });
}
function mP(e, t, r, n, i, a, o) {
  var u = null, c = i.reduce((f, d) => Oe(Oe({}, f), {}, {
    [d]: [e[d], t[d]]
  }), {}), s, l = (f) => {
    s || (s = f);
    var d = (f - s) / n, v = En((p, m) => Ii(...m, r(d)), c);
    if (a(Oe(Oe(Oe({}, e), t), v)), d < 1)
      u = o.setTimeout(l);
    else {
      var h = En((p, m) => Ii(...m, r(1)), c);
      a(Oe(Oe(Oe({}, e), t), h));
    }
  };
  return () => (u = o.setTimeout(l), () => {
    u();
  });
}
const vm = (e, t, r, n, i, a) => {
  var o = fP(e, t);
  return r.isStepper === !0 ? pP(e, t, r, o, i, a) : mP(e, t, r, n, o, i, a);
};
function yP(e) {
  var t, r = () => null, n = !1, i = null, a = (o) => {
    if (!n) {
      if (Array.isArray(o)) {
        if (!o.length)
          return;
        var u = o, [c, ...s] = u;
        if (typeof c == "number") {
          i = e.setTimeout(a.bind(null, s), c);
          return;
        }
        a(c), i = e.setTimeout(a.bind(null, s));
        return;
      }
      typeof o == "string" && (t = o, r(t)), typeof o == "object" && (t = o, r(t)), typeof o == "function" && o();
    }
  };
  return {
    stop: () => {
      n = !0;
    },
    start: (o) => {
      n = !1, i && (i(), i = null), a(o);
    },
    subscribe: (o) => (r = o, () => {
      r = () => null;
    }),
    getTimeoutController: () => e
  };
}
class gP {
  setTimeout(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = performance.now(), i = null, a = (o) => {
      o - n >= r ? t(o) : typeof requestAnimationFrame == "function" && (i = requestAnimationFrame(a));
    };
    return i = requestAnimationFrame(a), () => {
      cancelAnimationFrame(i);
    };
  }
}
function bP() {
  return yP(new gP());
}
var wP = /* @__PURE__ */ er(bP);
function hm(e, t) {
  var r = Gr(wP);
  return na(() => t ?? r(e), [e, t, r]);
}
var xP = ["children", "begin", "duration", "attributeName", "easing", "isActive", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart", "animationManager"];
function uc() {
  return uc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, uc.apply(null, arguments);
}
function OP(e, t) {
  if (e == null) return {};
  var r, n, i = PP(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function PP(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function jd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ft(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jd(Object(r), !0).forEach(function(n) {
      lr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : jd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function lr(e, t, r) {
  return (t = AP(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function AP(e) {
  var t = SP(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function SP(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class fs extends Yr {
  constructor(t, r) {
    super(t, r), lr(this, "mounted", !1), lr(this, "manager", void 0), lr(this, "stopJSAnimation", null), lr(this, "unSubscribe", null);
    var {
      isActive: n,
      attributeName: i,
      from: a,
      to: o,
      children: u,
      duration: c,
      animationManager: s
    } = this.props;
    if (this.manager = s, this.handleStyleChange = this.handleStyleChange.bind(this), this.changeStyle = this.changeStyle.bind(this), !n || c <= 0) {
      this.state = {
        style: {}
      }, typeof u == "function" && (this.state = {
        style: o
      });
      return;
    }
    if (a) {
      if (typeof u == "function") {
        this.state = {
          style: a
        };
        return;
      }
      this.state = {
        style: i ? {
          [i]: a
        } : a
      };
    } else
      this.state = {
        style: {}
      };
  }
  componentDidMount() {
    var {
      isActive: t,
      canBegin: r
    } = this.props;
    this.mounted = !0, !(!t || !r) && this.runAnimation(this.props);
  }
  componentDidUpdate(t) {
    var {
      isActive: r,
      canBegin: n,
      attributeName: i,
      shouldReAnimate: a,
      to: o,
      from: u
    } = this.props, {
      style: c
    } = this.state;
    if (n) {
      if (!r) {
        var s = {
          style: i ? {
            [i]: o
          } : o
        };
        this.state && c && (i && c[i] !== o || !i && c !== o) && this.setState(s);
        return;
      }
      if (!(nP(t.to, o) && t.canBegin && t.isActive)) {
        var l = !t.canBegin || !t.isActive;
        this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
        var f = l || a ? u : t.to;
        if (this.state && c) {
          var d = {
            style: i ? {
              [i]: f
            } : f
          };
          (i && c[i] !== f || !i && c !== f) && this.setState(d);
        }
        this.runAnimation(Ft(Ft({}, this.props), {}, {
          from: f,
          begin: 0
        }));
      }
    }
  }
  componentWillUnmount() {
    this.mounted = !1;
    var {
      onAnimationEnd: t
    } = this.props;
    this.unSubscribe && this.unSubscribe(), this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation(), t && t();
  }
  handleStyleChange(t) {
    this.changeStyle(t);
  }
  changeStyle(t) {
    this.mounted && this.setState({
      style: t
    });
  }
  runJSAnimation(t) {
    var {
      from: r,
      to: n,
      duration: i,
      easing: a,
      begin: o,
      onAnimationEnd: u,
      onAnimationStart: c
    } = t, s = vm(r, n, fm(a), i, this.changeStyle, this.manager.getTimeoutController()), l = () => {
      this.stopJSAnimation = s();
    };
    this.manager.start([c, o, l, i, u]);
  }
  runAnimation(t) {
    var {
      begin: r,
      duration: n,
      attributeName: i,
      to: a,
      easing: o,
      onAnimationStart: u,
      onAnimationEnd: c,
      children: s
    } = t;
    if (this.unSubscribe = this.manager.subscribe(this.handleStyleChange), typeof o == "function" || typeof s == "function" || o === "spring") {
      this.runJSAnimation(t);
      return;
    }
    var l = i ? {
      [i]: a
    } : a, f = lP(Object.keys(l), n, o);
    this.manager.start([u, r, Ft(Ft({}, l), {}, {
      transition: f
    }), n, c]);
  }
  render() {
    var t = this.props, {
      children: r,
      begin: n,
      duration: i,
      attributeName: a,
      easing: o,
      isActive: u,
      from: c,
      to: s,
      canBegin: l,
      onAnimationEnd: f,
      shouldReAnimate: d,
      onAnimationReStart: v,
      animationManager: h
    } = t, p = OP(t, xP), m = hi.count(r), y = this.state.style;
    if (typeof r == "function")
      return r(y);
    if (!u || m === 0 || i <= 0)
      return r;
    var g = (b) => {
      var {
        style: O = {},
        className: w
      } = b.props, P = /* @__PURE__ */ kt(b, Ft(Ft({}, p), {}, {
        style: Ft(Ft({}, O), y),
        className: w
      }));
      return P;
    };
    return m === 1 ? g(hi.only(r)) : /* @__PURE__ */ x.createElement("div", null, hi.map(r, (b) => g(b)));
  }
}
lr(fs, "displayName", "Animate");
lr(fs, "defaultProps", {
  begin: 0,
  duration: 1e3,
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  onAnimationEnd: () => {
  },
  onAnimationStart: () => {
  }
});
function Di(e) {
  var t, r = hm((t = e.attributeName) !== null && t !== void 0 ? t : Object.keys(e.to).join(","), e.animationManager);
  return /* @__PURE__ */ x.createElement(fs, uc({}, e, {
    animationManager: r
  }));
}
function Ni() {
  return Ni = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ni.apply(null, arguments);
}
var Td = (e, t, r, n, i) => {
  var a = Math.min(Math.abs(r) / 2, Math.abs(n) / 2), o = n >= 0 ? 1 : -1, u = r >= 0 ? 1 : -1, c = n >= 0 && r >= 0 || n < 0 && r < 0 ? 1 : 0, s;
  if (a > 0 && i instanceof Array) {
    for (var l = [0, 0, 0, 0], f = 0, d = 4; f < d; f++)
      l[f] = i[f] > a ? a : i[f];
    s = "M".concat(e, ",").concat(t + o * l[0]), l[0] > 0 && (s += "A ".concat(l[0], ",").concat(l[0], ",0,0,").concat(c, ",").concat(e + u * l[0], ",").concat(t)), s += "L ".concat(e + r - u * l[1], ",").concat(t), l[1] > 0 && (s += "A ".concat(l[1], ",").concat(l[1], ",0,0,").concat(c, `,
        `).concat(e + r, ",").concat(t + o * l[1])), s += "L ".concat(e + r, ",").concat(t + n - o * l[2]), l[2] > 0 && (s += "A ".concat(l[2], ",").concat(l[2], ",0,0,").concat(c, `,
        `).concat(e + r - u * l[2], ",").concat(t + n)), s += "L ".concat(e + u * l[3], ",").concat(t + n), l[3] > 0 && (s += "A ".concat(l[3], ",").concat(l[3], ",0,0,").concat(c, `,
        `).concat(e, ",").concat(t + n - o * l[3])), s += "Z";
  } else if (a > 0 && i === +i && i > 0) {
    var v = Math.min(a, i);
    s = "M ".concat(e, ",").concat(t + o * v, `
            A `).concat(v, ",").concat(v, ",0,0,").concat(c, ",").concat(e + u * v, ",").concat(t, `
            L `).concat(e + r - u * v, ",").concat(t, `
            A `).concat(v, ",").concat(v, ",0,0,").concat(c, ",").concat(e + r, ",").concat(t + o * v, `
            L `).concat(e + r, ",").concat(t + n - o * v, `
            A `).concat(v, ",").concat(v, ",0,0,").concat(c, ",").concat(e + r - u * v, ",").concat(t + n, `
            L `).concat(e + u * v, ",").concat(t + n, `
            A `).concat(v, ",").concat(v, ",0,0,").concat(c, ",").concat(e, ",").concat(t + n - o * v, " Z");
  } else
    s = "M ".concat(e, ",").concat(t, " h ").concat(r, " v ").concat(n, " h ").concat(-r, " Z");
  return s;
}, EP = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, pm = (e) => {
  var t = bt(e, EP), r = it(null), [n, i] = ct(-1);
  ae(() => {
    if (r.current && r.current.getTotalLength)
      try {
        var y = r.current.getTotalLength();
        y && i(y);
      } catch {
      }
  }, []);
  var {
    x: a,
    y: o,
    width: u,
    height: c,
    radius: s,
    className: l
  } = t, {
    animationEasing: f,
    animationDuration: d,
    animationBegin: v,
    isAnimationActive: h,
    isUpdateAnimationActive: p
  } = t;
  if (a !== +a || o !== +o || u !== +u || c !== +c || u === 0 || c === 0)
    return null;
  var m = G("recharts-rectangle", l);
  return p ? /* @__PURE__ */ x.createElement(Di, {
    canBegin: n > 0,
    from: {
      width: u,
      height: c,
      x: a,
      y: o
    },
    to: {
      width: u,
      height: c,
      x: a,
      y: o
    },
    duration: d,
    animationEasing: f,
    isActive: p
  }, (y) => {
    var {
      width: g,
      height: b,
      x: O,
      y: w
    } = y;
    return /* @__PURE__ */ x.createElement(Di, {
      canBegin: n > 0,
      from: "0px ".concat(n === -1 ? 1 : n, "px"),
      to: "".concat(n, "px 0px"),
      attributeName: "strokeDasharray",
      begin: v,
      duration: d,
      isActive: h,
      easing: f
    }, /* @__PURE__ */ x.createElement("path", Ni({}, ie(t, !0), {
      className: m,
      d: Td(O, w, g, b, s),
      ref: r
    })));
  }) : /* @__PURE__ */ x.createElement("path", Ni({}, ie(t, !0), {
    className: m,
    d: Td(a, o, u, c, s)
  }));
};
function mm(e) {
  var {
    cx: t,
    cy: r,
    radius: n,
    startAngle: i,
    endAngle: a
  } = e, o = Pe(t, r, n, i), u = Pe(t, r, n, a);
  return {
    points: [o, u],
    cx: t,
    cy: r,
    radius: n,
    startAngle: i,
    endAngle: a
  };
}
function cc() {
  return cc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cc.apply(null, arguments);
}
var _P = (e, t) => {
  var r = Re(t - e), n = Math.min(Math.abs(t - e), 359.999);
  return r * n;
}, oi = (e) => {
  var {
    cx: t,
    cy: r,
    radius: n,
    angle: i,
    sign: a,
    isExternal: o,
    cornerRadius: u,
    cornerIsExternal: c
  } = e, s = u * (o ? 1 : -1) + n, l = Math.asin(u / s) / _i, f = c ? i : i + a * l, d = Pe(t, r, s, f), v = Pe(t, r, n, f), h = c ? i - a * l : i, p = Pe(t, r, s * Math.cos(l * _i), h);
  return {
    center: d,
    circleTangency: v,
    lineTangency: p,
    theta: l
  };
}, ym = (e) => {
  var {
    cx: t,
    cy: r,
    innerRadius: n,
    outerRadius: i,
    startAngle: a,
    endAngle: o
  } = e, u = _P(a, o), c = a + u, s = Pe(t, r, i, a), l = Pe(t, r, i, c), f = "M ".concat(s.x, ",").concat(s.y, `
    A `).concat(i, ",").concat(i, `,0,
    `).concat(+(Math.abs(u) > 180), ",").concat(+(a > c), `,
    `).concat(l.x, ",").concat(l.y, `
  `);
  if (n > 0) {
    var d = Pe(t, r, n, a), v = Pe(t, r, n, c);
    f += "L ".concat(v.x, ",").concat(v.y, `
            A `).concat(n, ",").concat(n, `,0,
            `).concat(+(Math.abs(u) > 180), ",").concat(+(a <= c), `,
            `).concat(d.x, ",").concat(d.y, " Z");
  } else
    f += "L ".concat(t, ",").concat(r, " Z");
  return f;
}, jP = (e) => {
  var {
    cx: t,
    cy: r,
    innerRadius: n,
    outerRadius: i,
    cornerRadius: a,
    forceCornerRadius: o,
    cornerIsExternal: u,
    startAngle: c,
    endAngle: s
  } = e, l = Re(s - c), {
    circleTangency: f,
    lineTangency: d,
    theta: v
  } = oi({
    cx: t,
    cy: r,
    radius: i,
    angle: c,
    sign: l,
    cornerRadius: a,
    cornerIsExternal: u
  }), {
    circleTangency: h,
    lineTangency: p,
    theta: m
  } = oi({
    cx: t,
    cy: r,
    radius: i,
    angle: s,
    sign: -l,
    cornerRadius: a,
    cornerIsExternal: u
  }), y = u ? Math.abs(c - s) : Math.abs(c - s) - v - m;
  if (y < 0)
    return o ? "M ".concat(d.x, ",").concat(d.y, `
        a`).concat(a, ",").concat(a, ",0,0,1,").concat(a * 2, `,0
        a`).concat(a, ",").concat(a, ",0,0,1,").concat(-a * 2, `,0
      `) : ym({
      cx: t,
      cy: r,
      innerRadius: n,
      outerRadius: i,
      startAngle: c,
      endAngle: s
    });
  var g = "M ".concat(d.x, ",").concat(d.y, `
    A`).concat(a, ",").concat(a, ",0,0,").concat(+(l < 0), ",").concat(f.x, ",").concat(f.y, `
    A`).concat(i, ",").concat(i, ",0,").concat(+(y > 180), ",").concat(+(l < 0), ",").concat(h.x, ",").concat(h.y, `
    A`).concat(a, ",").concat(a, ",0,0,").concat(+(l < 0), ",").concat(p.x, ",").concat(p.y, `
  `);
  if (n > 0) {
    var {
      circleTangency: b,
      lineTangency: O,
      theta: w
    } = oi({
      cx: t,
      cy: r,
      radius: n,
      angle: c,
      sign: l,
      isExternal: !0,
      cornerRadius: a,
      cornerIsExternal: u
    }), {
      circleTangency: P,
      lineTangency: A,
      theta: _
    } = oi({
      cx: t,
      cy: r,
      radius: n,
      angle: s,
      sign: -l,
      isExternal: !0,
      cornerRadius: a,
      cornerIsExternal: u
    }), T = u ? Math.abs(c - s) : Math.abs(c - s) - w - _;
    if (T < 0 && a === 0)
      return "".concat(g, "L").concat(t, ",").concat(r, "Z");
    g += "L".concat(A.x, ",").concat(A.y, `
      A`).concat(a, ",").concat(a, ",0,0,").concat(+(l < 0), ",").concat(P.x, ",").concat(P.y, `
      A`).concat(n, ",").concat(n, ",0,").concat(+(T > 180), ",").concat(+(l > 0), ",").concat(b.x, ",").concat(b.y, `
      A`).concat(a, ",").concat(a, ",0,0,").concat(+(l < 0), ",").concat(O.x, ",").concat(O.y, "Z");
  } else
    g += "L".concat(t, ",").concat(r, "Z");
  return g;
}, TP = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, gm = (e) => {
  var t = bt(e, TP), {
    cx: r,
    cy: n,
    innerRadius: i,
    outerRadius: a,
    cornerRadius: o,
    forceCornerRadius: u,
    cornerIsExternal: c,
    startAngle: s,
    endAngle: l,
    className: f
  } = t;
  if (a < i || s === l)
    return null;
  var d = G("recharts-sector", f), v = a - i, h = st(o, v, 0, !0), p;
  return h > 0 && Math.abs(s - l) < 360 ? p = jP({
    cx: r,
    cy: n,
    innerRadius: i,
    outerRadius: a,
    cornerRadius: Math.min(h, v / 2),
    forceCornerRadius: u,
    cornerIsExternal: c,
    startAngle: s,
    endAngle: l
  }) : p = ym({
    cx: r,
    cy: n,
    innerRadius: i,
    outerRadius: a,
    startAngle: s,
    endAngle: l
  }), /* @__PURE__ */ x.createElement("path", cc({}, ie(t, !0), {
    className: d,
    d: p
  }));
};
function MP(e, t, r) {
  var n, i, a, o;
  if (e === "horizontal")
    n = t.x, a = n, i = r.top, o = r.top + r.height;
  else if (e === "vertical")
    i = t.y, o = i, n = r.left, a = r.left + r.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var {
        cx: u,
        cy: c,
        innerRadius: s,
        outerRadius: l,
        angle: f
      } = t, d = Pe(u, c, s, f), v = Pe(u, c, l, f);
      n = d.x, i = d.y, a = v.x, o = v.y;
    } else
      return mm(t);
  return [{
    x: n,
    y: i
  }, {
    x: a,
    y: o
  }];
}
var tu = {}, ru = {}, nu = {}, Md;
function CP() {
  return Md || (Md = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ bp();
    function r(n) {
      return t.isSymbol(n) ? NaN : Number(n);
    }
    e.toNumber = r;
  })(nu)), nu;
}
var Cd;
function kP() {
  return Cd || (Cd = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ CP();
    function r(n) {
      return n ? (n = t.toNumber(n), n === 1 / 0 || n === -1 / 0 ? (n < 0 ? -1 : 1) * Number.MAX_VALUE : n === n ? n : 0) : n === 0 ? n : 0;
    }
    e.toFinite = r;
  })(ru)), ru;
}
var kd;
function IP() {
  return kd || (kd = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ wp(), r = /* @__PURE__ */ kP();
    function n(i, a, o) {
      o && typeof o != "number" && t.isIterateeCall(i, a, o) && (a = o = void 0), i = r.toFinite(i), a === void 0 ? (a = i, i = 0) : a = r.toFinite(a), o = o === void 0 ? i < a ? 1 : -1 : r.toFinite(o);
      const u = Math.max(Math.ceil((a - i) / (o || 1)), 0), c = new Array(u);
      for (let s = 0; s < u; s++)
        c[s] = i, i += o;
      return c;
    }
    e.range = n;
  })(tu)), tu;
}
var iu, Id;
function DP() {
  return Id || (Id = 1, iu = IP().range), iu;
}
var NP = /* @__PURE__ */ DP();
const bm = /* @__PURE__ */ It(NP);
function Yt(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function $P(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function ds(e) {
  let t, r, n;
  e.length !== 2 ? (t = Yt, r = (u, c) => Yt(e(u), c), n = (u, c) => e(u) - c) : (t = e === Yt || e === $P ? e : RP, r = e, n = e);
  function i(u, c, s = 0, l = u.length) {
    if (s < l) {
      if (t(c, c) !== 0) return l;
      do {
        const f = s + l >>> 1;
        r(u[f], c) < 0 ? s = f + 1 : l = f;
      } while (s < l);
    }
    return s;
  }
  function a(u, c, s = 0, l = u.length) {
    if (s < l) {
      if (t(c, c) !== 0) return l;
      do {
        const f = s + l >>> 1;
        r(u[f], c) <= 0 ? s = f + 1 : l = f;
      } while (s < l);
    }
    return s;
  }
  function o(u, c, s = 0, l = u.length) {
    const f = i(u, c, s, l - 1);
    return f > s && n(u[f - 1], c) > -n(u[f], c) ? f - 1 : f;
  }
  return { left: i, center: o, right: a };
}
function RP() {
  return 0;
}
function wm(e) {
  return e === null ? NaN : +e;
}
function* LP(e, t) {
  for (let r of e)
    r != null && (r = +r) >= r && (yield r);
}
const BP = ds(Yt), zn = BP.right;
ds(wm).center;
class Dd extends Map {
  constructor(t, r = KP) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), t != null) for (const [n, i] of t) this.set(n, i);
  }
  get(t) {
    return super.get(Nd(this, t));
  }
  has(t) {
    return super.has(Nd(this, t));
  }
  set(t, r) {
    return super.set(zP(this, t), r);
  }
  delete(t) {
    return super.delete(qP(this, t));
  }
}
function Nd({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : r;
}
function zP({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : (e.set(n, r), r);
}
function qP({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) && (r = e.get(n), e.delete(n)), r;
}
function KP(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function FP(e = Yt) {
  if (e === Yt) return xm;
  if (typeof e != "function") throw new TypeError("compare is not a function");
  return (t, r) => {
    const n = e(t, r);
    return n || n === 0 ? n : (e(r, r) === 0) - (e(t, t) === 0);
  };
}
function xm(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const WP = Math.sqrt(50), UP = Math.sqrt(10), VP = Math.sqrt(2);
function $i(e, t, r) {
  const n = (t - e) / Math.max(0, r), i = Math.floor(Math.log10(n)), a = n / Math.pow(10, i), o = a >= WP ? 10 : a >= UP ? 5 : a >= VP ? 2 : 1;
  let u, c, s;
  return i < 0 ? (s = Math.pow(10, -i) / o, u = Math.round(e * s), c = Math.round(t * s), u / s < e && ++u, c / s > t && --c, s = -s) : (s = Math.pow(10, i) * o, u = Math.round(e / s), c = Math.round(t / s), u * s < e && ++u, c * s > t && --c), c < u && 0.5 <= r && r < 2 ? $i(e, t, r * 2) : [u, c, s];
}
function sc(e, t, r) {
  if (t = +t, e = +e, r = +r, !(r > 0)) return [];
  if (e === t) return [e];
  const n = t < e, [i, a, o] = n ? $i(t, e, r) : $i(e, t, r);
  if (!(a >= i)) return [];
  const u = a - i + 1, c = new Array(u);
  if (n)
    if (o < 0) for (let s = 0; s < u; ++s) c[s] = (a - s) / -o;
    else for (let s = 0; s < u; ++s) c[s] = (a - s) * o;
  else if (o < 0) for (let s = 0; s < u; ++s) c[s] = (i + s) / -o;
  else for (let s = 0; s < u; ++s) c[s] = (i + s) * o;
  return c;
}
function lc(e, t, r) {
  return t = +t, e = +e, r = +r, $i(e, t, r)[2];
}
function fc(e, t, r) {
  t = +t, e = +e, r = +r;
  const n = t < e, i = n ? lc(t, e, r) : lc(e, t, r);
  return (n ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function $d(e, t) {
  let r;
  for (const n of e)
    n != null && (r < n || r === void 0 && n >= n) && (r = n);
  return r;
}
function Rd(e, t) {
  let r;
  for (const n of e)
    n != null && (r > n || r === void 0 && n >= n) && (r = n);
  return r;
}
function Om(e, t, r = 0, n = 1 / 0, i) {
  if (t = Math.floor(t), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(e.length - 1, n)), !(r <= t && t <= n)) return e;
  for (i = i === void 0 ? xm : FP(i); n > r; ) {
    if (n - r > 600) {
      const c = n - r + 1, s = t - r + 1, l = Math.log(c), f = 0.5 * Math.exp(2 * l / 3), d = 0.5 * Math.sqrt(l * f * (c - f) / c) * (s - c / 2 < 0 ? -1 : 1), v = Math.max(r, Math.floor(t - s * f / c + d)), h = Math.min(n, Math.floor(t + (c - s) * f / c + d));
      Om(e, t, v, h, i);
    }
    const a = e[t];
    let o = r, u = n;
    for (fn(e, r, t), i(e[n], a) > 0 && fn(e, r, n); o < u; ) {
      for (fn(e, o, u), ++o, --u; i(e[o], a) < 0; ) ++o;
      for (; i(e[u], a) > 0; ) --u;
    }
    i(e[r], a) === 0 ? fn(e, r, u) : (++u, fn(e, u, n)), u <= t && (r = u + 1), t <= u && (n = u - 1);
  }
  return e;
}
function fn(e, t, r) {
  const n = e[t];
  e[t] = e[r], e[r] = n;
}
function HP(e, t, r) {
  if (e = Float64Array.from(LP(e)), !(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return Rd(e);
    if (t >= 1) return $d(e);
    var n, i = (n - 1) * t, a = Math.floor(i), o = $d(Om(e, a).subarray(0, a + 1)), u = Rd(e.subarray(a + 1));
    return o + (u - o) * (i - a);
  }
}
function GP(e, t, r = wm) {
  if (!(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return +r(e[0], 0, e);
    if (t >= 1) return +r(e[n - 1], n - 1, e);
    var n, i = (n - 1) * t, a = Math.floor(i), o = +r(e[a], a, e), u = +r(e[a + 1], a + 1, e);
    return o + (u - o) * (i - a);
  }
}
function YP(e, t, r) {
  e = +e, t = +t, r = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +r;
  for (var n = -1, i = Math.max(0, Math.ceil((t - e) / r)) | 0, a = new Array(i); ++n < i; )
    a[n] = e + n * r;
  return a;
}
function ot(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function Rt(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const dc = /* @__PURE__ */ Symbol("implicit");
function vs() {
  var e = new Dd(), t = [], r = [], n = dc;
  function i(a) {
    let o = e.get(a);
    if (o === void 0) {
      if (n !== dc) return n;
      e.set(a, o = t.push(a) - 1);
    }
    return r[o % r.length];
  }
  return i.domain = function(a) {
    if (!arguments.length) return t.slice();
    t = [], e = new Dd();
    for (const o of a)
      e.has(o) || e.set(o, t.push(o) - 1);
    return i;
  }, i.range = function(a) {
    return arguments.length ? (r = Array.from(a), i) : r.slice();
  }, i.unknown = function(a) {
    return arguments.length ? (n = a, i) : n;
  }, i.copy = function() {
    return vs(t, r).unknown(n);
  }, ot.apply(i, arguments), i;
}
function hs() {
  var e = vs().unknown(void 0), t = e.domain, r = e.range, n = 0, i = 1, a, o, u = !1, c = 0, s = 0, l = 0.5;
  delete e.unknown;
  function f() {
    var d = t().length, v = i < n, h = v ? i : n, p = v ? n : i;
    a = (p - h) / Math.max(1, d - c + s * 2), u && (a = Math.floor(a)), h += (p - h - a * (d - c)) * l, o = a * (1 - c), u && (h = Math.round(h), o = Math.round(o));
    var m = YP(d).map(function(y) {
      return h + a * y;
    });
    return r(v ? m.reverse() : m);
  }
  return e.domain = function(d) {
    return arguments.length ? (t(d), f()) : t();
  }, e.range = function(d) {
    return arguments.length ? ([n, i] = d, n = +n, i = +i, f()) : [n, i];
  }, e.rangeRound = function(d) {
    return [n, i] = d, n = +n, i = +i, u = !0, f();
  }, e.bandwidth = function() {
    return o;
  }, e.step = function() {
    return a;
  }, e.round = function(d) {
    return arguments.length ? (u = !!d, f()) : u;
  }, e.padding = function(d) {
    return arguments.length ? (c = Math.min(1, s = +d), f()) : c;
  }, e.paddingInner = function(d) {
    return arguments.length ? (c = Math.min(1, d), f()) : c;
  }, e.paddingOuter = function(d) {
    return arguments.length ? (s = +d, f()) : s;
  }, e.align = function(d) {
    return arguments.length ? (l = Math.max(0, Math.min(1, d)), f()) : l;
  }, e.copy = function() {
    return hs(t(), [n, i]).round(u).paddingInner(c).paddingOuter(s).align(l);
  }, ot.apply(f(), arguments);
}
function Pm(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return Pm(t());
  }, e;
}
function XP() {
  return Pm(hs.apply(null, arguments).paddingInner(1));
}
function ps(e, t, r) {
  e.prototype = t.prototype = r, r.constructor = e;
}
function Am(e, t) {
  var r = Object.create(e.prototype);
  for (var n in t) r[n] = t[n];
  return r;
}
function qn() {
}
var _n = 0.7, Ri = 1 / _n, Rr = "\\s*([+-]?\\d+)\\s*", jn = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", pt = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", ZP = /^#([0-9a-f]{3,8})$/, JP = new RegExp(`^rgb\\(${Rr},${Rr},${Rr}\\)$`), QP = new RegExp(`^rgb\\(${pt},${pt},${pt}\\)$`), eA = new RegExp(`^rgba\\(${Rr},${Rr},${Rr},${jn}\\)$`), tA = new RegExp(`^rgba\\(${pt},${pt},${pt},${jn}\\)$`), rA = new RegExp(`^hsl\\(${jn},${pt},${pt}\\)$`), nA = new RegExp(`^hsla\\(${jn},${pt},${pt},${jn}\\)$`), Ld = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
ps(qn, Tn, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Bd,
  // Deprecated! Use color.formatHex.
  formatHex: Bd,
  formatHex8: iA,
  formatHsl: aA,
  formatRgb: zd,
  toString: zd
});
function Bd() {
  return this.rgb().formatHex();
}
function iA() {
  return this.rgb().formatHex8();
}
function aA() {
  return Sm(this).formatHsl();
}
function zd() {
  return this.rgb().formatRgb();
}
function Tn(e) {
  var t, r;
  return e = (e + "").trim().toLowerCase(), (t = ZP.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? qd(t) : r === 3 ? new Le(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? ui(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? ui(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = JP.exec(e)) ? new Le(t[1], t[2], t[3], 1) : (t = QP.exec(e)) ? new Le(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = eA.exec(e)) ? ui(t[1], t[2], t[3], t[4]) : (t = tA.exec(e)) ? ui(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = rA.exec(e)) ? Wd(t[1], t[2] / 100, t[3] / 100, 1) : (t = nA.exec(e)) ? Wd(t[1], t[2] / 100, t[3] / 100, t[4]) : Ld.hasOwnProperty(e) ? qd(Ld[e]) : e === "transparent" ? new Le(NaN, NaN, NaN, 0) : null;
}
function qd(e) {
  return new Le(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function ui(e, t, r, n) {
  return n <= 0 && (e = t = r = NaN), new Le(e, t, r, n);
}
function oA(e) {
  return e instanceof qn || (e = Tn(e)), e ? (e = e.rgb(), new Le(e.r, e.g, e.b, e.opacity)) : new Le();
}
function vc(e, t, r, n) {
  return arguments.length === 1 ? oA(e) : new Le(e, t, r, n ?? 1);
}
function Le(e, t, r, n) {
  this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
}
ps(Le, vc, Am(qn, {
  brighter(e) {
    return e = e == null ? Ri : Math.pow(Ri, e), new Le(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? _n : Math.pow(_n, e), new Le(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Le(mr(this.r), mr(this.g), mr(this.b), Li(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Kd,
  // Deprecated! Use color.formatHex.
  formatHex: Kd,
  formatHex8: uA,
  formatRgb: Fd,
  toString: Fd
}));
function Kd() {
  return `#${fr(this.r)}${fr(this.g)}${fr(this.b)}`;
}
function uA() {
  return `#${fr(this.r)}${fr(this.g)}${fr(this.b)}${fr((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Fd() {
  const e = Li(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${mr(this.r)}, ${mr(this.g)}, ${mr(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function Li(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function mr(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function fr(e) {
  return e = mr(e), (e < 16 ? "0" : "") + e.toString(16);
}
function Wd(e, t, r, n) {
  return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new ut(e, t, r, n);
}
function Sm(e) {
  if (e instanceof ut) return new ut(e.h, e.s, e.l, e.opacity);
  if (e instanceof qn || (e = Tn(e)), !e) return new ut();
  if (e instanceof ut) return e;
  e = e.rgb();
  var t = e.r / 255, r = e.g / 255, n = e.b / 255, i = Math.min(t, r, n), a = Math.max(t, r, n), o = NaN, u = a - i, c = (a + i) / 2;
  return u ? (t === a ? o = (r - n) / u + (r < n) * 6 : r === a ? o = (n - t) / u + 2 : o = (t - r) / u + 4, u /= c < 0.5 ? a + i : 2 - a - i, o *= 60) : u = c > 0 && c < 1 ? 0 : o, new ut(o, u, c, e.opacity);
}
function cA(e, t, r, n) {
  return arguments.length === 1 ? Sm(e) : new ut(e, t, r, n ?? 1);
}
function ut(e, t, r, n) {
  this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
}
ps(ut, cA, Am(qn, {
  brighter(e) {
    return e = e == null ? Ri : Math.pow(Ri, e), new ut(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? _n : Math.pow(_n, e), new ut(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * t, i = 2 * r - n;
    return new Le(
      au(e >= 240 ? e - 240 : e + 120, i, n),
      au(e, i, n),
      au(e < 120 ? e + 240 : e - 120, i, n),
      this.opacity
    );
  },
  clamp() {
    return new ut(Ud(this.h), ci(this.s), ci(this.l), Li(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = Li(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${Ud(this.h)}, ${ci(this.s) * 100}%, ${ci(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function Ud(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function ci(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function au(e, t, r) {
  return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
}
const ms = (e) => () => e;
function sA(e, t) {
  return function(r) {
    return e + r * t;
  };
}
function lA(e, t, r) {
  return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
    return Math.pow(e + n * t, r);
  };
}
function fA(e) {
  return (e = +e) == 1 ? Em : function(t, r) {
    return r - t ? lA(t, r, e) : ms(isNaN(t) ? r : t);
  };
}
function Em(e, t) {
  var r = t - e;
  return r ? sA(e, r) : ms(isNaN(e) ? t : e);
}
const Vd = (function e(t) {
  var r = fA(t);
  function n(i, a) {
    var o = r((i = vc(i)).r, (a = vc(a)).r), u = r(i.g, a.g), c = r(i.b, a.b), s = Em(i.opacity, a.opacity);
    return function(l) {
      return i.r = o(l), i.g = u(l), i.b = c(l), i.opacity = s(l), i + "";
    };
  }
  return n.gamma = e, n;
})(1);
function dA(e, t) {
  t || (t = []);
  var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), i;
  return function(a) {
    for (i = 0; i < r; ++i) n[i] = e[i] * (1 - a) + t[i] * a;
    return n;
  };
}
function vA(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function hA(e, t) {
  var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, i = new Array(n), a = new Array(r), o;
  for (o = 0; o < n; ++o) i[o] = Jr(e[o], t[o]);
  for (; o < r; ++o) a[o] = t[o];
  return function(u) {
    for (o = 0; o < n; ++o) a[o] = i[o](u);
    return a;
  };
}
function pA(e, t) {
  var r = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(n) {
    return r.setTime(e * (1 - n) + t * n), r;
  };
}
function Bi(e, t) {
  return e = +e, t = +t, function(r) {
    return e * (1 - r) + t * r;
  };
}
function mA(e, t) {
  var r = {}, n = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? r[i] = Jr(e[i], t[i]) : n[i] = t[i];
  return function(a) {
    for (i in r) n[i] = r[i](a);
    return n;
  };
}
var hc = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, ou = new RegExp(hc.source, "g");
function yA(e) {
  return function() {
    return e;
  };
}
function gA(e) {
  return function(t) {
    return e(t) + "";
  };
}
function bA(e, t) {
  var r = hc.lastIndex = ou.lastIndex = 0, n, i, a, o = -1, u = [], c = [];
  for (e = e + "", t = t + ""; (n = hc.exec(e)) && (i = ou.exec(t)); )
    (a = i.index) > r && (a = t.slice(r, a), u[o] ? u[o] += a : u[++o] = a), (n = n[0]) === (i = i[0]) ? u[o] ? u[o] += i : u[++o] = i : (u[++o] = null, c.push({ i: o, x: Bi(n, i) })), r = ou.lastIndex;
  return r < t.length && (a = t.slice(r), u[o] ? u[o] += a : u[++o] = a), u.length < 2 ? c[0] ? gA(c[0].x) : yA(t) : (t = c.length, function(s) {
    for (var l = 0, f; l < t; ++l) u[(f = c[l]).i] = f.x(s);
    return u.join("");
  });
}
function Jr(e, t) {
  var r = typeof t, n;
  return t == null || r === "boolean" ? ms(t) : (r === "number" ? Bi : r === "string" ? (n = Tn(t)) ? (t = n, Vd) : bA : t instanceof Tn ? Vd : t instanceof Date ? pA : vA(t) ? dA : Array.isArray(t) ? hA : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? mA : Bi)(e, t);
}
function ys(e, t) {
  return e = +e, t = +t, function(r) {
    return Math.round(e * (1 - r) + t * r);
  };
}
function wA(e, t) {
  t === void 0 && (t = e, e = Jr);
  for (var r = 0, n = t.length - 1, i = t[0], a = new Array(n < 0 ? 0 : n); r < n; ) a[r] = e(i, i = t[++r]);
  return function(o) {
    var u = Math.max(0, Math.min(n - 1, Math.floor(o *= n)));
    return a[u](o - u);
  };
}
function xA(e) {
  return function() {
    return e;
  };
}
function zi(e) {
  return +e;
}
var Hd = [0, 1];
function ke(e) {
  return e;
}
function pc(e, t) {
  return (t -= e = +e) ? function(r) {
    return (r - e) / t;
  } : xA(isNaN(t) ? NaN : 0.5);
}
function OA(e, t) {
  var r;
  return e > t && (r = e, e = t, t = r), function(n) {
    return Math.max(e, Math.min(t, n));
  };
}
function PA(e, t, r) {
  var n = e[0], i = e[1], a = t[0], o = t[1];
  return i < n ? (n = pc(i, n), a = r(o, a)) : (n = pc(n, i), a = r(a, o)), function(u) {
    return a(n(u));
  };
}
function AA(e, t, r) {
  var n = Math.min(e.length, t.length) - 1, i = new Array(n), a = new Array(n), o = -1;
  for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < n; )
    i[o] = pc(e[o], e[o + 1]), a[o] = r(t[o], t[o + 1]);
  return function(u) {
    var c = zn(e, u, 1, n) - 1;
    return a[c](i[c](u));
  };
}
function Kn(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function wa() {
  var e = Hd, t = Hd, r = Jr, n, i, a, o = ke, u, c, s;
  function l() {
    var d = Math.min(e.length, t.length);
    return o !== ke && (o = OA(e[0], e[d - 1])), u = d > 2 ? AA : PA, c = s = null, f;
  }
  function f(d) {
    return d == null || isNaN(d = +d) ? a : (c || (c = u(e.map(n), t, r)))(n(o(d)));
  }
  return f.invert = function(d) {
    return o(i((s || (s = u(t, e.map(n), Bi)))(d)));
  }, f.domain = function(d) {
    return arguments.length ? (e = Array.from(d, zi), l()) : e.slice();
  }, f.range = function(d) {
    return arguments.length ? (t = Array.from(d), l()) : t.slice();
  }, f.rangeRound = function(d) {
    return t = Array.from(d), r = ys, l();
  }, f.clamp = function(d) {
    return arguments.length ? (o = d ? !0 : ke, l()) : o !== ke;
  }, f.interpolate = function(d) {
    return arguments.length ? (r = d, l()) : r;
  }, f.unknown = function(d) {
    return arguments.length ? (a = d, f) : a;
  }, function(d, v) {
    return n = d, i = v, l();
  };
}
function gs() {
  return wa()(ke, ke);
}
function SA(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function qi(e, t) {
  if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var r, n = e.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +e.slice(r + 1)
  ];
}
function Fr(e) {
  return e = qi(Math.abs(e)), e ? e[1] : NaN;
}
function EA(e, t) {
  return function(r, n) {
    for (var i = r.length, a = [], o = 0, u = e[0], c = 0; i > 0 && u > 0 && (c + u + 1 > n && (u = Math.max(1, n - c)), a.push(r.substring(i -= u, i + u)), !((c += u + 1) > n)); )
      u = e[o = (o + 1) % e.length];
    return a.reverse().join(t);
  };
}
function _A(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(r) {
      return e[+r];
    });
  };
}
var jA = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Mn(e) {
  if (!(t = jA.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new bs({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Mn.prototype = bs.prototype;
function bs(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
bs.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function TA(e) {
  e: for (var t = e.length, r = 1, n = -1, i; r < t; ++r)
    switch (e[r]) {
      case ".":
        n = i = r;
        break;
      case "0":
        n === 0 && (n = r), i = r;
        break;
      default:
        if (!+e[r]) break e;
        n > 0 && (n = 0);
        break;
    }
  return n > 0 ? e.slice(0, n) + e.slice(i + 1) : e;
}
var _m;
function MA(e, t) {
  var r = qi(e, t);
  if (!r) return e + "";
  var n = r[0], i = r[1], a = i - (_m = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = n.length;
  return a === o ? n : a > o ? n + new Array(a - o + 1).join("0") : a > 0 ? n.slice(0, a) + "." + n.slice(a) : "0." + new Array(1 - a).join("0") + qi(e, Math.max(0, t + a - 1))[0];
}
function Gd(e, t) {
  var r = qi(e, t);
  if (!r) return e + "";
  var n = r[0], i = r[1];
  return i < 0 ? "0." + new Array(-i).join("0") + n : n.length > i + 1 ? n.slice(0, i + 1) + "." + n.slice(i + 1) : n + new Array(i - n.length + 2).join("0");
}
const Yd = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: SA,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => Gd(e * 100, t),
  r: Gd,
  s: MA,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function Xd(e) {
  return e;
}
var Zd = Array.prototype.map, Jd = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function CA(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? Xd : EA(Zd.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", a = e.numerals === void 0 ? Xd : _A(Zd.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", u = e.minus === void 0 ? "−" : e.minus + "", c = e.nan === void 0 ? "NaN" : e.nan + "";
  function s(f) {
    f = Mn(f);
    var d = f.fill, v = f.align, h = f.sign, p = f.symbol, m = f.zero, y = f.width, g = f.comma, b = f.precision, O = f.trim, w = f.type;
    w === "n" ? (g = !0, w = "g") : Yd[w] || (b === void 0 && (b = 12), O = !0, w = "g"), (m || d === "0" && v === "=") && (m = !0, d = "0", v = "=");
    var P = p === "$" ? r : p === "#" && /[boxX]/.test(w) ? "0" + w.toLowerCase() : "", A = p === "$" ? n : /[%p]/.test(w) ? o : "", _ = Yd[w], T = /[defgprs%]/.test(w);
    b = b === void 0 ? 6 : /[gprs]/.test(w) ? Math.max(1, Math.min(21, b)) : Math.max(0, Math.min(20, b));
    function N(j) {
      var C = P, z = A, K, J, se;
      if (w === "c")
        z = _(j) + z, j = "";
      else {
        j = +j;
        var ne = j < 0 || 1 / j < 0;
        if (j = isNaN(j) ? c : _(Math.abs(j), b), O && (j = TA(j)), ne && +j == 0 && h !== "+" && (ne = !1), C = (ne ? h === "(" ? h : u : h === "-" || h === "(" ? "" : h) + C, z = (w === "s" ? Jd[8 + _m / 3] : "") + z + (ne && h === "(" ? ")" : ""), T) {
          for (K = -1, J = j.length; ++K < J; )
            if (se = j.charCodeAt(K), 48 > se || se > 57) {
              z = (se === 46 ? i + j.slice(K + 1) : j.slice(K)) + z, j = j.slice(0, K);
              break;
            }
        }
      }
      g && !m && (j = t(j, 1 / 0));
      var Ce = C.length + j.length + z.length, he = Ce < y ? new Array(y - Ce + 1).join(d) : "";
      switch (g && m && (j = t(he + j, he.length ? y - z.length : 1 / 0), he = ""), v) {
        case "<":
          j = C + j + z + he;
          break;
        case "=":
          j = C + he + j + z;
          break;
        case "^":
          j = he.slice(0, Ce = he.length >> 1) + C + j + z + he.slice(Ce);
          break;
        default:
          j = he + C + j + z;
          break;
      }
      return a(j);
    }
    return N.toString = function() {
      return f + "";
    }, N;
  }
  function l(f, d) {
    var v = s((f = Mn(f), f.type = "f", f)), h = Math.max(-8, Math.min(8, Math.floor(Fr(d) / 3))) * 3, p = Math.pow(10, -h), m = Jd[8 + h / 3];
    return function(y) {
      return v(p * y) + m;
    };
  }
  return {
    format: s,
    formatPrefix: l
  };
}
var si, ws, jm;
kA({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function kA(e) {
  return si = CA(e), ws = si.format, jm = si.formatPrefix, si;
}
function IA(e) {
  return Math.max(0, -Fr(Math.abs(e)));
}
function DA(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Fr(t) / 3))) * 3 - Fr(Math.abs(e)));
}
function NA(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, Fr(t) - Fr(e)) + 1;
}
function Tm(e, t, r, n) {
  var i = fc(e, t, r), a;
  switch (n = Mn(n ?? ",f"), n.type) {
    case "s": {
      var o = Math.max(Math.abs(e), Math.abs(t));
      return n.precision == null && !isNaN(a = DA(i, o)) && (n.precision = a), jm(n, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(a = NA(i, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = a - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(a = IA(i)) && (n.precision = a - (n.type === "%") * 2);
      break;
    }
  }
  return ws(n);
}
function rr(e) {
  var t = e.domain;
  return e.ticks = function(r) {
    var n = t();
    return sc(n[0], n[n.length - 1], r ?? 10);
  }, e.tickFormat = function(r, n) {
    var i = t();
    return Tm(i[0], i[i.length - 1], r ?? 10, n);
  }, e.nice = function(r) {
    r == null && (r = 10);
    var n = t(), i = 0, a = n.length - 1, o = n[i], u = n[a], c, s, l = 10;
    for (u < o && (s = o, o = u, u = s, s = i, i = a, a = s); l-- > 0; ) {
      if (s = lc(o, u, r), s === c)
        return n[i] = o, n[a] = u, t(n);
      if (s > 0)
        o = Math.floor(o / s) * s, u = Math.ceil(u / s) * s;
      else if (s < 0)
        o = Math.ceil(o * s) / s, u = Math.floor(u * s) / s;
      else
        break;
      c = s;
    }
    return e;
  }, e;
}
function Mm() {
  var e = gs();
  return e.copy = function() {
    return Kn(e, Mm());
  }, ot.apply(e, arguments), rr(e);
}
function Cm(e) {
  var t;
  function r(n) {
    return n == null || isNaN(n = +n) ? t : n;
  }
  return r.invert = r, r.domain = r.range = function(n) {
    return arguments.length ? (e = Array.from(n, zi), r) : e.slice();
  }, r.unknown = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.copy = function() {
    return Cm(e).unknown(t);
  }, e = arguments.length ? Array.from(e, zi) : [0, 1], rr(r);
}
function km(e, t) {
  e = e.slice();
  var r = 0, n = e.length - 1, i = e[r], a = e[n], o;
  return a < i && (o = r, r = n, n = o, o = i, i = a, a = o), e[r] = t.floor(i), e[n] = t.ceil(a), e;
}
function Qd(e) {
  return Math.log(e);
}
function ev(e) {
  return Math.exp(e);
}
function $A(e) {
  return -Math.log(-e);
}
function RA(e) {
  return -Math.exp(-e);
}
function LA(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function BA(e) {
  return e === 10 ? LA : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function zA(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function tv(e) {
  return (t, r) => -e(-t, r);
}
function xs(e) {
  const t = e(Qd, ev), r = t.domain;
  let n = 10, i, a;
  function o() {
    return i = zA(n), a = BA(n), r()[0] < 0 ? (i = tv(i), a = tv(a), e($A, RA)) : e(Qd, ev), t;
  }
  return t.base = function(u) {
    return arguments.length ? (n = +u, o()) : n;
  }, t.domain = function(u) {
    return arguments.length ? (r(u), o()) : r();
  }, t.ticks = (u) => {
    const c = r();
    let s = c[0], l = c[c.length - 1];
    const f = l < s;
    f && ([s, l] = [l, s]);
    let d = i(s), v = i(l), h, p;
    const m = u == null ? 10 : +u;
    let y = [];
    if (!(n % 1) && v - d < m) {
      if (d = Math.floor(d), v = Math.ceil(v), s > 0) {
        for (; d <= v; ++d)
          for (h = 1; h < n; ++h)
            if (p = d < 0 ? h / a(-d) : h * a(d), !(p < s)) {
              if (p > l) break;
              y.push(p);
            }
      } else for (; d <= v; ++d)
        for (h = n - 1; h >= 1; --h)
          if (p = d > 0 ? h / a(-d) : h * a(d), !(p < s)) {
            if (p > l) break;
            y.push(p);
          }
      y.length * 2 < m && (y = sc(s, l, m));
    } else
      y = sc(d, v, Math.min(v - d, m)).map(a);
    return f ? y.reverse() : y;
  }, t.tickFormat = (u, c) => {
    if (u == null && (u = 10), c == null && (c = n === 10 ? "s" : ","), typeof c != "function" && (!(n % 1) && (c = Mn(c)).precision == null && (c.trim = !0), c = ws(c)), u === 1 / 0) return c;
    const s = Math.max(1, n * u / t.ticks().length);
    return (l) => {
      let f = l / a(Math.round(i(l)));
      return f * n < n - 0.5 && (f *= n), f <= s ? c(l) : "";
    };
  }, t.nice = () => r(km(r(), {
    floor: (u) => a(Math.floor(i(u))),
    ceil: (u) => a(Math.ceil(i(u)))
  })), t;
}
function Im() {
  const e = xs(wa()).domain([1, 10]);
  return e.copy = () => Kn(e, Im()).base(e.base()), ot.apply(e, arguments), e;
}
function rv(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function nv(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function Os(e) {
  var t = 1, r = e(rv(t), nv(t));
  return r.constant = function(n) {
    return arguments.length ? e(rv(t = +n), nv(t)) : t;
  }, rr(r);
}
function Dm() {
  var e = Os(wa());
  return e.copy = function() {
    return Kn(e, Dm()).constant(e.constant());
  }, ot.apply(e, arguments);
}
function iv(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function qA(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function KA(e) {
  return e < 0 ? -e * e : e * e;
}
function Ps(e) {
  var t = e(ke, ke), r = 1;
  function n() {
    return r === 1 ? e(ke, ke) : r === 0.5 ? e(qA, KA) : e(iv(r), iv(1 / r));
  }
  return t.exponent = function(i) {
    return arguments.length ? (r = +i, n()) : r;
  }, rr(t);
}
function As() {
  var e = Ps(wa());
  return e.copy = function() {
    return Kn(e, As()).exponent(e.exponent());
  }, ot.apply(e, arguments), e;
}
function FA() {
  return As.apply(null, arguments).exponent(0.5);
}
function av(e) {
  return Math.sign(e) * e * e;
}
function WA(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function Nm() {
  var e = gs(), t = [0, 1], r = !1, n;
  function i(a) {
    var o = WA(e(a));
    return isNaN(o) ? n : r ? Math.round(o) : o;
  }
  return i.invert = function(a) {
    return e.invert(av(a));
  }, i.domain = function(a) {
    return arguments.length ? (e.domain(a), i) : e.domain();
  }, i.range = function(a) {
    return arguments.length ? (e.range((t = Array.from(a, zi)).map(av)), i) : t.slice();
  }, i.rangeRound = function(a) {
    return i.range(a).round(!0);
  }, i.round = function(a) {
    return arguments.length ? (r = !!a, i) : r;
  }, i.clamp = function(a) {
    return arguments.length ? (e.clamp(a), i) : e.clamp();
  }, i.unknown = function(a) {
    return arguments.length ? (n = a, i) : n;
  }, i.copy = function() {
    return Nm(e.domain(), t).round(r).clamp(e.clamp()).unknown(n);
  }, ot.apply(i, arguments), rr(i);
}
function $m() {
  var e = [], t = [], r = [], n;
  function i() {
    var o = 0, u = Math.max(1, t.length);
    for (r = new Array(u - 1); ++o < u; ) r[o - 1] = GP(e, o / u);
    return a;
  }
  function a(o) {
    return o == null || isNaN(o = +o) ? n : t[zn(r, o)];
  }
  return a.invertExtent = function(o) {
    var u = t.indexOf(o);
    return u < 0 ? [NaN, NaN] : [
      u > 0 ? r[u - 1] : e[0],
      u < r.length ? r[u] : e[e.length - 1]
    ];
  }, a.domain = function(o) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let u of o) u != null && !isNaN(u = +u) && e.push(u);
    return e.sort(Yt), i();
  }, a.range = function(o) {
    return arguments.length ? (t = Array.from(o), i()) : t.slice();
  }, a.unknown = function(o) {
    return arguments.length ? (n = o, a) : n;
  }, a.quantiles = function() {
    return r.slice();
  }, a.copy = function() {
    return $m().domain(e).range(t).unknown(n);
  }, ot.apply(a, arguments);
}
function Rm() {
  var e = 0, t = 1, r = 1, n = [0.5], i = [0, 1], a;
  function o(c) {
    return c != null && c <= c ? i[zn(n, c, 0, r)] : a;
  }
  function u() {
    var c = -1;
    for (n = new Array(r); ++c < r; ) n[c] = ((c + 1) * t - (c - r) * e) / (r + 1);
    return o;
  }
  return o.domain = function(c) {
    return arguments.length ? ([e, t] = c, e = +e, t = +t, u()) : [e, t];
  }, o.range = function(c) {
    return arguments.length ? (r = (i = Array.from(c)).length - 1, u()) : i.slice();
  }, o.invertExtent = function(c) {
    var s = i.indexOf(c);
    return s < 0 ? [NaN, NaN] : s < 1 ? [e, n[0]] : s >= r ? [n[r - 1], t] : [n[s - 1], n[s]];
  }, o.unknown = function(c) {
    return arguments.length && (a = c), o;
  }, o.thresholds = function() {
    return n.slice();
  }, o.copy = function() {
    return Rm().domain([e, t]).range(i).unknown(a);
  }, ot.apply(rr(o), arguments);
}
function Lm() {
  var e = [0.5], t = [0, 1], r, n = 1;
  function i(a) {
    return a != null && a <= a ? t[zn(e, a, 0, n)] : r;
  }
  return i.domain = function(a) {
    return arguments.length ? (e = Array.from(a), n = Math.min(e.length, t.length - 1), i) : e.slice();
  }, i.range = function(a) {
    return arguments.length ? (t = Array.from(a), n = Math.min(e.length, t.length - 1), i) : t.slice();
  }, i.invertExtent = function(a) {
    var o = t.indexOf(a);
    return [e[o - 1], e[o]];
  }, i.unknown = function(a) {
    return arguments.length ? (r = a, i) : r;
  }, i.copy = function() {
    return Lm().domain(e).range(t).unknown(r);
  }, ot.apply(i, arguments);
}
const uu = /* @__PURE__ */ new Date(), cu = /* @__PURE__ */ new Date();
function fe(e, t, r, n) {
  function i(a) {
    return e(a = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+a)), a;
  }
  return i.floor = (a) => (e(a = /* @__PURE__ */ new Date(+a)), a), i.ceil = (a) => (e(a = new Date(a - 1)), t(a, 1), e(a), a), i.round = (a) => {
    const o = i(a), u = i.ceil(a);
    return a - o < u - a ? o : u;
  }, i.offset = (a, o) => (t(a = /* @__PURE__ */ new Date(+a), o == null ? 1 : Math.floor(o)), a), i.range = (a, o, u) => {
    const c = [];
    if (a = i.ceil(a), u = u == null ? 1 : Math.floor(u), !(a < o) || !(u > 0)) return c;
    let s;
    do
      c.push(s = /* @__PURE__ */ new Date(+a)), t(a, u), e(a);
    while (s < a && a < o);
    return c;
  }, i.filter = (a) => fe((o) => {
    if (o >= o) for (; e(o), !a(o); ) o.setTime(o - 1);
  }, (o, u) => {
    if (o >= o)
      if (u < 0) for (; ++u <= 0; )
        for (; t(o, -1), !a(o); )
          ;
      else for (; --u >= 0; )
        for (; t(o, 1), !a(o); )
          ;
  }), r && (i.count = (a, o) => (uu.setTime(+a), cu.setTime(+o), e(uu), e(cu), Math.floor(r(uu, cu))), i.every = (a) => (a = Math.floor(a), !isFinite(a) || !(a > 0) ? null : a > 1 ? i.filter(n ? (o) => n(o) % a === 0 : (o) => i.count(0, o) % a === 0) : i)), i;
}
const Ki = fe(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
Ki.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? fe((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, r) => {
  t.setTime(+t + r * e);
}, (t, r) => (r - t) / e) : Ki);
Ki.range;
const Pt = 1e3, nt = Pt * 60, At = nt * 60, Tt = At * 24, Ss = Tt * 7, ov = Tt * 30, su = Tt * 365, dr = fe((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * Pt);
}, (e, t) => (t - e) / Pt, (e) => e.getUTCSeconds());
dr.range;
const Es = fe((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Pt);
}, (e, t) => {
  e.setTime(+e + t * nt);
}, (e, t) => (t - e) / nt, (e) => e.getMinutes());
Es.range;
const _s = fe((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * nt);
}, (e, t) => (t - e) / nt, (e) => e.getUTCMinutes());
_s.range;
const js = fe((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Pt - e.getMinutes() * nt);
}, (e, t) => {
  e.setTime(+e + t * At);
}, (e, t) => (t - e) / At, (e) => e.getHours());
js.range;
const Ts = fe((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * At);
}, (e, t) => (t - e) / At, (e) => e.getUTCHours());
Ts.range;
const Fn = fe(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * nt) / Tt,
  (e) => e.getDate() - 1
);
Fn.range;
const xa = fe((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Tt, (e) => e.getUTCDate() - 1);
xa.range;
const Bm = fe((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Tt, (e) => Math.floor(e / Tt));
Bm.range;
function Sr(e) {
  return fe((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setDate(t.getDate() + r * 7);
  }, (t, r) => (r - t - (r.getTimezoneOffset() - t.getTimezoneOffset()) * nt) / Ss);
}
const Oa = Sr(0), Fi = Sr(1), UA = Sr(2), VA = Sr(3), Wr = Sr(4), HA = Sr(5), GA = Sr(6);
Oa.range;
Fi.range;
UA.range;
VA.range;
Wr.range;
HA.range;
GA.range;
function Er(e) {
  return fe((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setUTCDate(t.getUTCDate() + r * 7);
  }, (t, r) => (r - t) / Ss);
}
const Pa = Er(0), Wi = Er(1), YA = Er(2), XA = Er(3), Ur = Er(4), ZA = Er(5), JA = Er(6);
Pa.range;
Wi.range;
YA.range;
XA.range;
Ur.range;
ZA.range;
JA.range;
const Ms = fe((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
Ms.range;
const Cs = fe((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
Cs.range;
const Mt = fe((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Mt.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : fe((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, r) => {
  t.setFullYear(t.getFullYear() + r * e);
});
Mt.range;
const Ct = fe((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
Ct.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : fe((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, r) => {
  t.setUTCFullYear(t.getUTCFullYear() + r * e);
});
Ct.range;
function zm(e, t, r, n, i, a) {
  const o = [
    [dr, 1, Pt],
    [dr, 5, 5 * Pt],
    [dr, 15, 15 * Pt],
    [dr, 30, 30 * Pt],
    [a, 1, nt],
    [a, 5, 5 * nt],
    [a, 15, 15 * nt],
    [a, 30, 30 * nt],
    [i, 1, At],
    [i, 3, 3 * At],
    [i, 6, 6 * At],
    [i, 12, 12 * At],
    [n, 1, Tt],
    [n, 2, 2 * Tt],
    [r, 1, Ss],
    [t, 1, ov],
    [t, 3, 3 * ov],
    [e, 1, su]
  ];
  function u(s, l, f) {
    const d = l < s;
    d && ([s, l] = [l, s]);
    const v = f && typeof f.range == "function" ? f : c(s, l, f), h = v ? v.range(s, +l + 1) : [];
    return d ? h.reverse() : h;
  }
  function c(s, l, f) {
    const d = Math.abs(l - s) / f, v = ds(([, , m]) => m).right(o, d);
    if (v === o.length) return e.every(fc(s / su, l / su, f));
    if (v === 0) return Ki.every(Math.max(fc(s, l, f), 1));
    const [h, p] = o[d / o[v - 1][2] < o[v][2] / d ? v - 1 : v];
    return h.every(p);
  }
  return [u, c];
}
const [QA, eS] = zm(Ct, Cs, Pa, Bm, Ts, _s), [tS, rS] = zm(Mt, Ms, Oa, Fn, js, Es);
function lu(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function fu(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function dn(e, t, r) {
  return { y: e, m: t, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function nS(e) {
  var t = e.dateTime, r = e.date, n = e.time, i = e.periods, a = e.days, o = e.shortDays, u = e.months, c = e.shortMonths, s = vn(i), l = hn(i), f = vn(a), d = hn(a), v = vn(o), h = hn(o), p = vn(u), m = hn(u), y = vn(c), g = hn(c), b = {
    a: ne,
    A: Ce,
    b: he,
    B: zt,
    c: null,
    d: dv,
    e: dv,
    f: ES,
    g: $S,
    G: LS,
    H: PS,
    I: AS,
    j: SS,
    L: qm,
    m: _S,
    M: jS,
    p: qt,
    q: L,
    Q: pv,
    s: mv,
    S: TS,
    u: MS,
    U: CS,
    V: kS,
    w: IS,
    W: DS,
    x: null,
    X: null,
    y: NS,
    Y: RS,
    Z: BS,
    "%": hv
  }, O = {
    a: on,
    A: un,
    b: De,
    B: qa,
    c: null,
    d: vv,
    e: vv,
    f: FS,
    g: QS,
    G: tE,
    H: zS,
    I: qS,
    j: KS,
    L: Fm,
    m: WS,
    M: US,
    p: Ka,
    q: Fa,
    Q: pv,
    s: mv,
    S: VS,
    u: HS,
    U: GS,
    V: YS,
    w: XS,
    W: ZS,
    x: null,
    X: null,
    y: JS,
    Y: eE,
    Z: rE,
    "%": hv
  }, w = {
    a: N,
    A: j,
    b: C,
    B: z,
    c: K,
    d: lv,
    e: lv,
    f: bS,
    g: sv,
    G: cv,
    H: fv,
    I: fv,
    j: pS,
    L: gS,
    m: hS,
    M: mS,
    p: T,
    q: vS,
    Q: xS,
    s: OS,
    S: yS,
    u: cS,
    U: sS,
    V: lS,
    w: uS,
    W: fS,
    x: J,
    X: se,
    y: sv,
    Y: cv,
    Z: dS,
    "%": wS
  };
  b.x = P(r, b), b.X = P(n, b), b.c = P(t, b), O.x = P(r, O), O.X = P(n, O), O.c = P(t, O);
  function P(D, B) {
    return function(q) {
      var E = [], Ee = -1, M = 0, xe = D.length, pe, ft, ml;
      for (q instanceof Date || (q = /* @__PURE__ */ new Date(+q)); ++Ee < xe; )
        D.charCodeAt(Ee) === 37 && (E.push(D.slice(M, Ee)), (ft = uv[pe = D.charAt(++Ee)]) != null ? pe = D.charAt(++Ee) : ft = pe === "e" ? " " : "0", (ml = B[pe]) && (pe = ml(q, ft)), E.push(pe), M = Ee + 1);
      return E.push(D.slice(M, Ee)), E.join("");
    };
  }
  function A(D, B) {
    return function(q) {
      var E = dn(1900, void 0, 1), Ee = _(E, D, q += "", 0), M, xe;
      if (Ee != q.length) return null;
      if ("Q" in E) return new Date(E.Q);
      if ("s" in E) return new Date(E.s * 1e3 + ("L" in E ? E.L : 0));
      if (B && !("Z" in E) && (E.Z = 0), "p" in E && (E.H = E.H % 12 + E.p * 12), E.m === void 0 && (E.m = "q" in E ? E.q : 0), "V" in E) {
        if (E.V < 1 || E.V > 53) return null;
        "w" in E || (E.w = 1), "Z" in E ? (M = fu(dn(E.y, 0, 1)), xe = M.getUTCDay(), M = xe > 4 || xe === 0 ? Wi.ceil(M) : Wi(M), M = xa.offset(M, (E.V - 1) * 7), E.y = M.getUTCFullYear(), E.m = M.getUTCMonth(), E.d = M.getUTCDate() + (E.w + 6) % 7) : (M = lu(dn(E.y, 0, 1)), xe = M.getDay(), M = xe > 4 || xe === 0 ? Fi.ceil(M) : Fi(M), M = Fn.offset(M, (E.V - 1) * 7), E.y = M.getFullYear(), E.m = M.getMonth(), E.d = M.getDate() + (E.w + 6) % 7);
      } else ("W" in E || "U" in E) && ("w" in E || (E.w = "u" in E ? E.u % 7 : "W" in E ? 1 : 0), xe = "Z" in E ? fu(dn(E.y, 0, 1)).getUTCDay() : lu(dn(E.y, 0, 1)).getDay(), E.m = 0, E.d = "W" in E ? (E.w + 6) % 7 + E.W * 7 - (xe + 5) % 7 : E.w + E.U * 7 - (xe + 6) % 7);
      return "Z" in E ? (E.H += E.Z / 100 | 0, E.M += E.Z % 100, fu(E)) : lu(E);
    };
  }
  function _(D, B, q, E) {
    for (var Ee = 0, M = B.length, xe = q.length, pe, ft; Ee < M; ) {
      if (E >= xe) return -1;
      if (pe = B.charCodeAt(Ee++), pe === 37) {
        if (pe = B.charAt(Ee++), ft = w[pe in uv ? B.charAt(Ee++) : pe], !ft || (E = ft(D, q, E)) < 0) return -1;
      } else if (pe != q.charCodeAt(E++))
        return -1;
    }
    return E;
  }
  function T(D, B, q) {
    var E = s.exec(B.slice(q));
    return E ? (D.p = l.get(E[0].toLowerCase()), q + E[0].length) : -1;
  }
  function N(D, B, q) {
    var E = v.exec(B.slice(q));
    return E ? (D.w = h.get(E[0].toLowerCase()), q + E[0].length) : -1;
  }
  function j(D, B, q) {
    var E = f.exec(B.slice(q));
    return E ? (D.w = d.get(E[0].toLowerCase()), q + E[0].length) : -1;
  }
  function C(D, B, q) {
    var E = y.exec(B.slice(q));
    return E ? (D.m = g.get(E[0].toLowerCase()), q + E[0].length) : -1;
  }
  function z(D, B, q) {
    var E = p.exec(B.slice(q));
    return E ? (D.m = m.get(E[0].toLowerCase()), q + E[0].length) : -1;
  }
  function K(D, B, q) {
    return _(D, t, B, q);
  }
  function J(D, B, q) {
    return _(D, r, B, q);
  }
  function se(D, B, q) {
    return _(D, n, B, q);
  }
  function ne(D) {
    return o[D.getDay()];
  }
  function Ce(D) {
    return a[D.getDay()];
  }
  function he(D) {
    return c[D.getMonth()];
  }
  function zt(D) {
    return u[D.getMonth()];
  }
  function qt(D) {
    return i[+(D.getHours() >= 12)];
  }
  function L(D) {
    return 1 + ~~(D.getMonth() / 3);
  }
  function on(D) {
    return o[D.getUTCDay()];
  }
  function un(D) {
    return a[D.getUTCDay()];
  }
  function De(D) {
    return c[D.getUTCMonth()];
  }
  function qa(D) {
    return u[D.getUTCMonth()];
  }
  function Ka(D) {
    return i[+(D.getUTCHours() >= 12)];
  }
  function Fa(D) {
    return 1 + ~~(D.getUTCMonth() / 3);
  }
  return {
    format: function(D) {
      var B = P(D += "", b);
      return B.toString = function() {
        return D;
      }, B;
    },
    parse: function(D) {
      var B = A(D += "", !1);
      return B.toString = function() {
        return D;
      }, B;
    },
    utcFormat: function(D) {
      var B = P(D += "", O);
      return B.toString = function() {
        return D;
      }, B;
    },
    utcParse: function(D) {
      var B = A(D += "", !0);
      return B.toString = function() {
        return D;
      }, B;
    }
  };
}
var uv = { "-": "", _: " ", 0: "0" }, we = /^\s*\d+/, iS = /^%/, aS = /[\\^$*+?|[\]().{}]/g;
function F(e, t, r) {
  var n = e < 0 ? "-" : "", i = (n ? -e : e) + "", a = i.length;
  return n + (a < r ? new Array(r - a + 1).join(t) + i : i);
}
function oS(e) {
  return e.replace(aS, "\\$&");
}
function vn(e) {
  return new RegExp("^(?:" + e.map(oS).join("|") + ")", "i");
}
function hn(e) {
  return new Map(e.map((t, r) => [t.toLowerCase(), r]));
}
function uS(e, t, r) {
  var n = we.exec(t.slice(r, r + 1));
  return n ? (e.w = +n[0], r + n[0].length) : -1;
}
function cS(e, t, r) {
  var n = we.exec(t.slice(r, r + 1));
  return n ? (e.u = +n[0], r + n[0].length) : -1;
}
function sS(e, t, r) {
  var n = we.exec(t.slice(r, r + 2));
  return n ? (e.U = +n[0], r + n[0].length) : -1;
}
function lS(e, t, r) {
  var n = we.exec(t.slice(r, r + 2));
  return n ? (e.V = +n[0], r + n[0].length) : -1;
}
function fS(e, t, r) {
  var n = we.exec(t.slice(r, r + 2));
  return n ? (e.W = +n[0], r + n[0].length) : -1;
}
function cv(e, t, r) {
  var n = we.exec(t.slice(r, r + 4));
  return n ? (e.y = +n[0], r + n[0].length) : -1;
}
function sv(e, t, r) {
  var n = we.exec(t.slice(r, r + 2));
  return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
}
function dS(e, t, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
  return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}
function vS(e, t, r) {
  var n = we.exec(t.slice(r, r + 1));
  return n ? (e.q = n[0] * 3 - 3, r + n[0].length) : -1;
}
function hS(e, t, r) {
  var n = we.exec(t.slice(r, r + 2));
  return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
}
function lv(e, t, r) {
  var n = we.exec(t.slice(r, r + 2));
  return n ? (e.d = +n[0], r + n[0].length) : -1;
}
function pS(e, t, r) {
  var n = we.exec(t.slice(r, r + 3));
  return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
}
function fv(e, t, r) {
  var n = we.exec(t.slice(r, r + 2));
  return n ? (e.H = +n[0], r + n[0].length) : -1;
}
function mS(e, t, r) {
  var n = we.exec(t.slice(r, r + 2));
  return n ? (e.M = +n[0], r + n[0].length) : -1;
}
function yS(e, t, r) {
  var n = we.exec(t.slice(r, r + 2));
  return n ? (e.S = +n[0], r + n[0].length) : -1;
}
function gS(e, t, r) {
  var n = we.exec(t.slice(r, r + 3));
  return n ? (e.L = +n[0], r + n[0].length) : -1;
}
function bS(e, t, r) {
  var n = we.exec(t.slice(r, r + 6));
  return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}
function wS(e, t, r) {
  var n = iS.exec(t.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}
function xS(e, t, r) {
  var n = we.exec(t.slice(r));
  return n ? (e.Q = +n[0], r + n[0].length) : -1;
}
function OS(e, t, r) {
  var n = we.exec(t.slice(r));
  return n ? (e.s = +n[0], r + n[0].length) : -1;
}
function dv(e, t) {
  return F(e.getDate(), t, 2);
}
function PS(e, t) {
  return F(e.getHours(), t, 2);
}
function AS(e, t) {
  return F(e.getHours() % 12 || 12, t, 2);
}
function SS(e, t) {
  return F(1 + Fn.count(Mt(e), e), t, 3);
}
function qm(e, t) {
  return F(e.getMilliseconds(), t, 3);
}
function ES(e, t) {
  return qm(e, t) + "000";
}
function _S(e, t) {
  return F(e.getMonth() + 1, t, 2);
}
function jS(e, t) {
  return F(e.getMinutes(), t, 2);
}
function TS(e, t) {
  return F(e.getSeconds(), t, 2);
}
function MS(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function CS(e, t) {
  return F(Oa.count(Mt(e) - 1, e), t, 2);
}
function Km(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? Wr(e) : Wr.ceil(e);
}
function kS(e, t) {
  return e = Km(e), F(Wr.count(Mt(e), e) + (Mt(e).getDay() === 4), t, 2);
}
function IS(e) {
  return e.getDay();
}
function DS(e, t) {
  return F(Fi.count(Mt(e) - 1, e), t, 2);
}
function NS(e, t) {
  return F(e.getFullYear() % 100, t, 2);
}
function $S(e, t) {
  return e = Km(e), F(e.getFullYear() % 100, t, 2);
}
function RS(e, t) {
  return F(e.getFullYear() % 1e4, t, 4);
}
function LS(e, t) {
  var r = e.getDay();
  return e = r >= 4 || r === 0 ? Wr(e) : Wr.ceil(e), F(e.getFullYear() % 1e4, t, 4);
}
function BS(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + F(t / 60 | 0, "0", 2) + F(t % 60, "0", 2);
}
function vv(e, t) {
  return F(e.getUTCDate(), t, 2);
}
function zS(e, t) {
  return F(e.getUTCHours(), t, 2);
}
function qS(e, t) {
  return F(e.getUTCHours() % 12 || 12, t, 2);
}
function KS(e, t) {
  return F(1 + xa.count(Ct(e), e), t, 3);
}
function Fm(e, t) {
  return F(e.getUTCMilliseconds(), t, 3);
}
function FS(e, t) {
  return Fm(e, t) + "000";
}
function WS(e, t) {
  return F(e.getUTCMonth() + 1, t, 2);
}
function US(e, t) {
  return F(e.getUTCMinutes(), t, 2);
}
function VS(e, t) {
  return F(e.getUTCSeconds(), t, 2);
}
function HS(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function GS(e, t) {
  return F(Pa.count(Ct(e) - 1, e), t, 2);
}
function Wm(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? Ur(e) : Ur.ceil(e);
}
function YS(e, t) {
  return e = Wm(e), F(Ur.count(Ct(e), e) + (Ct(e).getUTCDay() === 4), t, 2);
}
function XS(e) {
  return e.getUTCDay();
}
function ZS(e, t) {
  return F(Wi.count(Ct(e) - 1, e), t, 2);
}
function JS(e, t) {
  return F(e.getUTCFullYear() % 100, t, 2);
}
function QS(e, t) {
  return e = Wm(e), F(e.getUTCFullYear() % 100, t, 2);
}
function eE(e, t) {
  return F(e.getUTCFullYear() % 1e4, t, 4);
}
function tE(e, t) {
  var r = e.getUTCDay();
  return e = r >= 4 || r === 0 ? Ur(e) : Ur.ceil(e), F(e.getUTCFullYear() % 1e4, t, 4);
}
function rE() {
  return "+0000";
}
function hv() {
  return "%";
}
function pv(e) {
  return +e;
}
function mv(e) {
  return Math.floor(+e / 1e3);
}
var Mr, Um, Vm;
nE({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function nE(e) {
  return Mr = nS(e), Um = Mr.format, Mr.parse, Vm = Mr.utcFormat, Mr.utcParse, Mr;
}
function iE(e) {
  return new Date(e);
}
function aE(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function ks(e, t, r, n, i, a, o, u, c, s) {
  var l = gs(), f = l.invert, d = l.domain, v = s(".%L"), h = s(":%S"), p = s("%I:%M"), m = s("%I %p"), y = s("%a %d"), g = s("%b %d"), b = s("%B"), O = s("%Y");
  function w(P) {
    return (c(P) < P ? v : u(P) < P ? h : o(P) < P ? p : a(P) < P ? m : n(P) < P ? i(P) < P ? y : g : r(P) < P ? b : O)(P);
  }
  return l.invert = function(P) {
    return new Date(f(P));
  }, l.domain = function(P) {
    return arguments.length ? d(Array.from(P, aE)) : d().map(iE);
  }, l.ticks = function(P) {
    var A = d();
    return e(A[0], A[A.length - 1], P ?? 10);
  }, l.tickFormat = function(P, A) {
    return A == null ? w : s(A);
  }, l.nice = function(P) {
    var A = d();
    return (!P || typeof P.range != "function") && (P = t(A[0], A[A.length - 1], P ?? 10)), P ? d(km(A, P)) : l;
  }, l.copy = function() {
    return Kn(l, ks(e, t, r, n, i, a, o, u, c, s));
  }, l;
}
function oE() {
  return ot.apply(ks(tS, rS, Mt, Ms, Oa, Fn, js, Es, dr, Um).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function uE() {
  return ot.apply(ks(QA, eS, Ct, Cs, Pa, xa, Ts, _s, dr, Vm).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function Aa() {
  var e = 0, t = 1, r, n, i, a, o = ke, u = !1, c;
  function s(f) {
    return f == null || isNaN(f = +f) ? c : o(i === 0 ? 0.5 : (f = (a(f) - r) * i, u ? Math.max(0, Math.min(1, f)) : f));
  }
  s.domain = function(f) {
    return arguments.length ? ([e, t] = f, r = a(e = +e), n = a(t = +t), i = r === n ? 0 : 1 / (n - r), s) : [e, t];
  }, s.clamp = function(f) {
    return arguments.length ? (u = !!f, s) : u;
  }, s.interpolator = function(f) {
    return arguments.length ? (o = f, s) : o;
  };
  function l(f) {
    return function(d) {
      var v, h;
      return arguments.length ? ([v, h] = d, o = f(v, h), s) : [o(0), o(1)];
    };
  }
  return s.range = l(Jr), s.rangeRound = l(ys), s.unknown = function(f) {
    return arguments.length ? (c = f, s) : c;
  }, function(f) {
    return a = f, r = f(e), n = f(t), i = r === n ? 0 : 1 / (n - r), s;
  };
}
function nr(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function Hm() {
  var e = rr(Aa()(ke));
  return e.copy = function() {
    return nr(e, Hm());
  }, Rt.apply(e, arguments);
}
function Gm() {
  var e = xs(Aa()).domain([1, 10]);
  return e.copy = function() {
    return nr(e, Gm()).base(e.base());
  }, Rt.apply(e, arguments);
}
function Ym() {
  var e = Os(Aa());
  return e.copy = function() {
    return nr(e, Ym()).constant(e.constant());
  }, Rt.apply(e, arguments);
}
function Is() {
  var e = Ps(Aa());
  return e.copy = function() {
    return nr(e, Is()).exponent(e.exponent());
  }, Rt.apply(e, arguments);
}
function cE() {
  return Is.apply(null, arguments).exponent(0.5);
}
function Xm() {
  var e = [], t = ke;
  function r(n) {
    if (n != null && !isNaN(n = +n)) return t((zn(e, n, 1) - 1) / (e.length - 1));
  }
  return r.domain = function(n) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let i of n) i != null && !isNaN(i = +i) && e.push(i);
    return e.sort(Yt), r;
  }, r.interpolator = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.range = function() {
    return e.map((n, i) => t(i / (e.length - 1)));
  }, r.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (i, a) => HP(e, a / n));
  }, r.copy = function() {
    return Xm(t).domain(e);
  }, Rt.apply(r, arguments);
}
function Sa() {
  var e = 0, t = 0.5, r = 1, n = 1, i, a, o, u, c, s = ke, l, f = !1, d;
  function v(p) {
    return isNaN(p = +p) ? d : (p = 0.5 + ((p = +l(p)) - a) * (n * p < n * a ? u : c), s(f ? Math.max(0, Math.min(1, p)) : p));
  }
  v.domain = function(p) {
    return arguments.length ? ([e, t, r] = p, i = l(e = +e), a = l(t = +t), o = l(r = +r), u = i === a ? 0 : 0.5 / (a - i), c = a === o ? 0 : 0.5 / (o - a), n = a < i ? -1 : 1, v) : [e, t, r];
  }, v.clamp = function(p) {
    return arguments.length ? (f = !!p, v) : f;
  }, v.interpolator = function(p) {
    return arguments.length ? (s = p, v) : s;
  };
  function h(p) {
    return function(m) {
      var y, g, b;
      return arguments.length ? ([y, g, b] = m, s = wA(p, [y, g, b]), v) : [s(0), s(0.5), s(1)];
    };
  }
  return v.range = h(Jr), v.rangeRound = h(ys), v.unknown = function(p) {
    return arguments.length ? (d = p, v) : d;
  }, function(p) {
    return l = p, i = p(e), a = p(t), o = p(r), u = i === a ? 0 : 0.5 / (a - i), c = a === o ? 0 : 0.5 / (o - a), n = a < i ? -1 : 1, v;
  };
}
function Zm() {
  var e = rr(Sa()(ke));
  return e.copy = function() {
    return nr(e, Zm());
  }, Rt.apply(e, arguments);
}
function Jm() {
  var e = xs(Sa()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return nr(e, Jm()).base(e.base());
  }, Rt.apply(e, arguments);
}
function Qm() {
  var e = Os(Sa());
  return e.copy = function() {
    return nr(e, Qm()).constant(e.constant());
  }, Rt.apply(e, arguments);
}
function Ds() {
  var e = Ps(Sa());
  return e.copy = function() {
    return nr(e, Ds()).exponent(e.exponent());
  }, Rt.apply(e, arguments);
}
function sE() {
  return Ds.apply(null, arguments).exponent(0.5);
}
const yn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: hs,
  scaleDiverging: Zm,
  scaleDivergingLog: Jm,
  scaleDivergingPow: Ds,
  scaleDivergingSqrt: sE,
  scaleDivergingSymlog: Qm,
  scaleIdentity: Cm,
  scaleImplicit: dc,
  scaleLinear: Mm,
  scaleLog: Im,
  scaleOrdinal: vs,
  scalePoint: XP,
  scalePow: As,
  scaleQuantile: $m,
  scaleQuantize: Rm,
  scaleRadial: Nm,
  scaleSequential: Hm,
  scaleSequentialLog: Gm,
  scaleSequentialPow: Is,
  scaleSequentialQuantile: Xm,
  scaleSequentialSqrt: cE,
  scaleSequentialSymlog: Ym,
  scaleSqrt: FA,
  scaleSymlog: Dm,
  scaleThreshold: Lm,
  scaleTime: oE,
  scaleUtc: uE,
  tickFormat: Tm
}, Symbol.toStringTag, { value: "Module" }));
var ir = (e) => e.chartData, lE = S([ir], (e) => {
  var t = e.chartData != null ? e.chartData.length - 1 : 0;
  return {
    chartData: e.chartData,
    computedData: e.computedData,
    dataEndIndex: t,
    dataStartIndex: 0
  };
}), Ea = (e, t, r, n) => n ? lE(e) : ir(e);
function Vr(e) {
  if (Array.isArray(e) && e.length === 2) {
    var [t, r] = e;
    if (Ae(t) && Ae(r))
      return !0;
  }
  return !1;
}
function yv(e, t, r) {
  return r ? e : [Math.min(e[0], t[0]), Math.max(e[1], t[1])];
}
function fE(e, t) {
  if (t && typeof e != "function" && Array.isArray(e) && e.length === 2) {
    var [r, n] = e, i, a;
    if (Ae(r))
      i = r;
    else if (typeof r == "function")
      return;
    if (Ae(n))
      a = n;
    else if (typeof n == "function")
      return;
    var o = [i, a];
    if (Vr(o))
      return o;
  }
}
function dE(e, t, r) {
  if (!(!r && t == null)) {
    if (typeof e == "function" && t != null)
      try {
        var n = e(t, r);
        if (Vr(n))
          return yv(n, t, r);
      } catch {
      }
    if (Array.isArray(e) && e.length === 2) {
      var [i, a] = e, o, u;
      if (i === "auto")
        t != null && (o = Math.min(...t));
      else if (k(i))
        o = i;
      else if (typeof i == "function")
        try {
          t != null && (o = i(t?.[0]));
        } catch {
        }
      else if (typeof i == "string" && Qf.test(i)) {
        var c = Qf.exec(i);
        if (c == null || t == null)
          o = void 0;
        else {
          var s = +c[1];
          o = t[0] - s;
        }
      } else
        o = t?.[0];
      if (a === "auto")
        t != null && (u = Math.max(...t));
      else if (k(a))
        u = a;
      else if (typeof a == "function")
        try {
          t != null && (u = a(t?.[1]));
        } catch {
        }
      else if (typeof a == "string" && ed.test(a)) {
        var l = ed.exec(a);
        if (l == null || t == null)
          u = void 0;
        else {
          var f = +l[1];
          u = t[1] + f;
        }
      } else
        u = t?.[1];
      var d = [o, u];
      if (Vr(d))
        return t == null ? d : yv(d, t, r);
    }
  }
}
var Qr = 1e9, vE = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, $s, ee = !0, at = "[DecimalError] ", yr = at + "Invalid argument: ", Ns = at + "Exponent out of range: ", en = Math.floor, cr = Math.pow, hE = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Ue, me = 1e7, Z = 7, ey = 9007199254740991, Ui = en(ey / Z), I = {};
I.absoluteValue = I.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
I.comparedTo = I.cmp = function(e) {
  var t, r, n, i, a = this;
  if (e = new a.constructor(e), a.s !== e.s) return a.s || -e.s;
  if (a.e !== e.e) return a.e > e.e ^ a.s < 0 ? 1 : -1;
  for (n = a.d.length, i = e.d.length, t = 0, r = n < i ? n : i; t < r; ++t)
    if (a.d[t] !== e.d[t]) return a.d[t] > e.d[t] ^ a.s < 0 ? 1 : -1;
  return n === i ? 0 : n > i ^ a.s < 0 ? 1 : -1;
};
I.decimalPlaces = I.dp = function() {
  var e = this, t = e.d.length - 1, r = (t - e.e) * Z;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) r--;
  return r < 0 ? 0 : r;
};
I.dividedBy = I.div = function(e) {
  return Et(this, new this.constructor(e));
};
I.dividedToIntegerBy = I.idiv = function(e) {
  var t = this, r = t.constructor;
  return Y(Et(t, new r(e), 0, 1), r.precision);
};
I.equals = I.eq = function(e) {
  return !this.cmp(e);
};
I.exponent = function() {
  return ue(this);
};
I.greaterThan = I.gt = function(e) {
  return this.cmp(e) > 0;
};
I.greaterThanOrEqualTo = I.gte = function(e) {
  return this.cmp(e) >= 0;
};
I.isInteger = I.isint = function() {
  return this.e > this.d.length - 2;
};
I.isNegative = I.isneg = function() {
  return this.s < 0;
};
I.isPositive = I.ispos = function() {
  return this.s > 0;
};
I.isZero = function() {
  return this.s === 0;
};
I.lessThan = I.lt = function(e) {
  return this.cmp(e) < 0;
};
I.lessThanOrEqualTo = I.lte = function(e) {
  return this.cmp(e) < 1;
};
I.logarithm = I.log = function(e) {
  var t, r = this, n = r.constructor, i = n.precision, a = i + 5;
  if (e === void 0)
    e = new n(10);
  else if (e = new n(e), e.s < 1 || e.eq(Ue)) throw Error(at + "NaN");
  if (r.s < 1) throw Error(at + (r.s ? "NaN" : "-Infinity"));
  return r.eq(Ue) ? new n(0) : (ee = !1, t = Et(Cn(r, a), Cn(e, a), a), ee = !0, Y(t, i));
};
I.minus = I.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? ny(t, e) : ty(t, (e.s = -e.s, e));
};
I.modulo = I.mod = function(e) {
  var t, r = this, n = r.constructor, i = n.precision;
  if (e = new n(e), !e.s) throw Error(at + "NaN");
  return r.s ? (ee = !1, t = Et(r, e, 0, 1).times(e), ee = !0, r.minus(t)) : Y(new n(r), i);
};
I.naturalExponential = I.exp = function() {
  return ry(this);
};
I.naturalLogarithm = I.ln = function() {
  return Cn(this);
};
I.negated = I.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
I.plus = I.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? ty(t, e) : ny(t, (e.s = -e.s, e));
};
I.precision = I.sd = function(e) {
  var t, r, n, i = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(yr + e);
  if (t = ue(i) + 1, n = i.d.length - 1, r = n * Z + 1, n = i.d[n], n) {
    for (; n % 10 == 0; n /= 10) r--;
    for (n = i.d[0]; n >= 10; n /= 10) r++;
  }
  return e && t > r ? t : r;
};
I.squareRoot = I.sqrt = function() {
  var e, t, r, n, i, a, o, u = this, c = u.constructor;
  if (u.s < 1) {
    if (!u.s) return new c(0);
    throw Error(at + "NaN");
  }
  for (e = ue(u), ee = !1, i = Math.sqrt(+u), i == 0 || i == 1 / 0 ? (t = dt(u.d), (t.length + e) % 2 == 0 && (t += "0"), i = Math.sqrt(t), e = en((e + 1) / 2) - (e < 0 || e % 2), i == 1 / 0 ? t = "5e" + e : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new c(t)) : n = new c(i.toString()), r = c.precision, i = o = r + 3; ; )
    if (a = n, n = a.plus(Et(u, a, o + 2)).times(0.5), dt(a.d).slice(0, o) === (t = dt(n.d)).slice(0, o)) {
      if (t = t.slice(o - 3, o + 1), i == o && t == "4999") {
        if (Y(a, r + 1, 0), a.times(a).eq(u)) {
          n = a;
          break;
        }
      } else if (t != "9999")
        break;
      o += 4;
    }
  return ee = !0, Y(n, r);
};
I.times = I.mul = function(e) {
  var t, r, n, i, a, o, u, c, s, l = this, f = l.constructor, d = l.d, v = (e = new f(e)).d;
  if (!l.s || !e.s) return new f(0);
  for (e.s *= l.s, r = l.e + e.e, c = d.length, s = v.length, c < s && (a = d, d = v, v = a, o = c, c = s, s = o), a = [], o = c + s, n = o; n--; ) a.push(0);
  for (n = s; --n >= 0; ) {
    for (t = 0, i = c + n; i > n; )
      u = a[i] + v[n] * d[i - n - 1] + t, a[i--] = u % me | 0, t = u / me | 0;
    a[i] = (a[i] + t) % me | 0;
  }
  for (; !a[--o]; ) a.pop();
  return t ? ++r : a.shift(), e.d = a, e.e = r, ee ? Y(e, f.precision) : e;
};
I.toDecimalPlaces = I.todp = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (yt(e, 0, Qr), t === void 0 ? t = n.rounding : yt(t, 0, 8), Y(r, e + ue(r) + 1, t));
};
I.toExponential = function(e, t) {
  var r, n = this, i = n.constructor;
  return e === void 0 ? r = Pr(n, !0) : (yt(e, 0, Qr), t === void 0 ? t = i.rounding : yt(t, 0, 8), n = Y(new i(n), e + 1, t), r = Pr(n, !0, e + 1)), r;
};
I.toFixed = function(e, t) {
  var r, n, i = this, a = i.constructor;
  return e === void 0 ? Pr(i) : (yt(e, 0, Qr), t === void 0 ? t = a.rounding : yt(t, 0, 8), n = Y(new a(i), e + ue(i) + 1, t), r = Pr(n.abs(), !1, e + ue(n) + 1), i.isneg() && !i.isZero() ? "-" + r : r);
};
I.toInteger = I.toint = function() {
  var e = this, t = e.constructor;
  return Y(new t(e), ue(e) + 1, t.rounding);
};
I.toNumber = function() {
  return +this;
};
I.toPower = I.pow = function(e) {
  var t, r, n, i, a, o, u = this, c = u.constructor, s = 12, l = +(e = new c(e));
  if (!e.s) return new c(Ue);
  if (u = new c(u), !u.s) {
    if (e.s < 1) throw Error(at + "Infinity");
    return u;
  }
  if (u.eq(Ue)) return u;
  if (n = c.precision, e.eq(Ue)) return Y(u, n);
  if (t = e.e, r = e.d.length - 1, o = t >= r, a = u.s, o) {
    if ((r = l < 0 ? -l : l) <= ey) {
      for (i = new c(Ue), t = Math.ceil(n / Z + 4), ee = !1; r % 2 && (i = i.times(u), bv(i.d, t)), r = en(r / 2), r !== 0; )
        u = u.times(u), bv(u.d, t);
      return ee = !0, e.s < 0 ? new c(Ue).div(i) : Y(i, n);
    }
  } else if (a < 0) throw Error(at + "NaN");
  return a = a < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, u.s = 1, ee = !1, i = e.times(Cn(u, n + s)), ee = !0, i = ry(i), i.s = a, i;
};
I.toPrecision = function(e, t) {
  var r, n, i = this, a = i.constructor;
  return e === void 0 ? (r = ue(i), n = Pr(i, r <= a.toExpNeg || r >= a.toExpPos)) : (yt(e, 1, Qr), t === void 0 ? t = a.rounding : yt(t, 0, 8), i = Y(new a(i), e, t), r = ue(i), n = Pr(i, e <= r || r <= a.toExpNeg, e)), n;
};
I.toSignificantDigits = I.tosd = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (yt(e, 1, Qr), t === void 0 ? t = n.rounding : yt(t, 0, 8)), Y(new n(r), e, t);
};
I.toString = I.valueOf = I.val = I.toJSON = I[/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = ue(e), r = e.constructor;
  return Pr(e, t <= r.toExpNeg || t >= r.toExpPos);
};
function ty(e, t) {
  var r, n, i, a, o, u, c, s, l = e.constructor, f = l.precision;
  if (!e.s || !t.s)
    return t.s || (t = new l(e)), ee ? Y(t, f) : t;
  if (c = e.d, s = t.d, o = e.e, i = t.e, c = c.slice(), a = o - i, a) {
    for (a < 0 ? (n = c, a = -a, u = s.length) : (n = s, i = o, u = c.length), o = Math.ceil(f / Z), u = o > u ? o + 1 : u + 1, a > u && (a = u, n.length = 1), n.reverse(); a--; ) n.push(0);
    n.reverse();
  }
  for (u = c.length, a = s.length, u - a < 0 && (a = u, n = s, s = c, c = n), r = 0; a; )
    r = (c[--a] = c[a] + s[a] + r) / me | 0, c[a] %= me;
  for (r && (c.unshift(r), ++i), u = c.length; c[--u] == 0; ) c.pop();
  return t.d = c, t.e = i, ee ? Y(t, f) : t;
}
function yt(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(yr + e);
}
function dt(e) {
  var t, r, n, i = e.length - 1, a = "", o = e[0];
  if (i > 0) {
    for (a += o, t = 1; t < i; t++)
      n = e[t] + "", r = Z - n.length, r && (a += Ut(r)), a += n;
    o = e[t], n = o + "", r = Z - n.length, r && (a += Ut(r));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; ) o /= 10;
  return a + o;
}
var Et = /* @__PURE__ */ (function() {
  function e(n, i) {
    var a, o = 0, u = n.length;
    for (n = n.slice(); u--; )
      a = n[u] * i + o, n[u] = a % me | 0, o = a / me | 0;
    return o && n.unshift(o), n;
  }
  function t(n, i, a, o) {
    var u, c;
    if (a != o)
      c = a > o ? 1 : -1;
    else
      for (u = c = 0; u < a; u++)
        if (n[u] != i[u]) {
          c = n[u] > i[u] ? 1 : -1;
          break;
        }
    return c;
  }
  function r(n, i, a) {
    for (var o = 0; a--; )
      n[a] -= o, o = n[a] < i[a] ? 1 : 0, n[a] = o * me + n[a] - i[a];
    for (; !n[0] && n.length > 1; ) n.shift();
  }
  return function(n, i, a, o) {
    var u, c, s, l, f, d, v, h, p, m, y, g, b, O, w, P, A, _, T = n.constructor, N = n.s == i.s ? 1 : -1, j = n.d, C = i.d;
    if (!n.s) return new T(n);
    if (!i.s) throw Error(at + "Division by zero");
    for (c = n.e - i.e, A = C.length, w = j.length, v = new T(N), h = v.d = [], s = 0; C[s] == (j[s] || 0); ) ++s;
    if (C[s] > (j[s] || 0) && --c, a == null ? g = a = T.precision : o ? g = a + (ue(n) - ue(i)) + 1 : g = a, g < 0) return new T(0);
    if (g = g / Z + 2 | 0, s = 0, A == 1)
      for (l = 0, C = C[0], g++; (s < w || l) && g--; s++)
        b = l * me + (j[s] || 0), h[s] = b / C | 0, l = b % C | 0;
    else {
      for (l = me / (C[0] + 1) | 0, l > 1 && (C = e(C, l), j = e(j, l), A = C.length, w = j.length), O = A, p = j.slice(0, A), m = p.length; m < A; ) p[m++] = 0;
      _ = C.slice(), _.unshift(0), P = C[0], C[1] >= me / 2 && ++P;
      do
        l = 0, u = t(C, p, A, m), u < 0 ? (y = p[0], A != m && (y = y * me + (p[1] || 0)), l = y / P | 0, l > 1 ? (l >= me && (l = me - 1), f = e(C, l), d = f.length, m = p.length, u = t(f, p, d, m), u == 1 && (l--, r(f, A < d ? _ : C, d))) : (l == 0 && (u = l = 1), f = C.slice()), d = f.length, d < m && f.unshift(0), r(p, f, m), u == -1 && (m = p.length, u = t(C, p, A, m), u < 1 && (l++, r(p, A < m ? _ : C, m))), m = p.length) : u === 0 && (l++, p = [0]), h[s++] = l, u && p[0] ? p[m++] = j[O] || 0 : (p = [j[O]], m = 1);
      while ((O++ < w || p[0] !== void 0) && g--);
    }
    return h[0] || h.shift(), v.e = c, Y(v, o ? a + ue(v) + 1 : a);
  };
})();
function ry(e, t) {
  var r, n, i, a, o, u, c = 0, s = 0, l = e.constructor, f = l.precision;
  if (ue(e) > 16) throw Error(Ns + ue(e));
  if (!e.s) return new l(Ue);
  for (ee = !1, u = f, o = new l(0.03125); e.abs().gte(0.1); )
    e = e.times(o), s += 5;
  for (n = Math.log(cr(2, s)) / Math.LN10 * 2 + 5 | 0, u += n, r = i = a = new l(Ue), l.precision = u; ; ) {
    if (i = Y(i.times(e), u), r = r.times(++c), o = a.plus(Et(i, r, u)), dt(o.d).slice(0, u) === dt(a.d).slice(0, u)) {
      for (; s--; ) a = Y(a.times(a), u);
      return l.precision = f, t == null ? (ee = !0, Y(a, f)) : a;
    }
    a = o;
  }
}
function ue(e) {
  for (var t = e.e * Z, r = e.d[0]; r >= 10; r /= 10) t++;
  return t;
}
function du(e, t, r) {
  if (t > e.LN10.sd())
    throw ee = !0, r && (e.precision = r), Error(at + "LN10 precision limit exceeded");
  return Y(new e(e.LN10), t);
}
function Ut(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function Cn(e, t) {
  var r, n, i, a, o, u, c, s, l, f = 1, d = 10, v = e, h = v.d, p = v.constructor, m = p.precision;
  if (v.s < 1) throw Error(at + (v.s ? "NaN" : "-Infinity"));
  if (v.eq(Ue)) return new p(0);
  if (t == null ? (ee = !1, s = m) : s = t, v.eq(10))
    return t == null && (ee = !0), du(p, s);
  if (s += d, p.precision = s, r = dt(h), n = r.charAt(0), a = ue(v), Math.abs(a) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      v = v.times(e), r = dt(v.d), n = r.charAt(0), f++;
    a = ue(v), n > 1 ? (v = new p("0." + r), a++) : v = new p(n + "." + r.slice(1));
  } else
    return c = du(p, s + 2, m).times(a + ""), v = Cn(new p(n + "." + r.slice(1)), s - d).plus(c), p.precision = m, t == null ? (ee = !0, Y(v, m)) : v;
  for (u = o = v = Et(v.minus(Ue), v.plus(Ue), s), l = Y(v.times(v), s), i = 3; ; ) {
    if (o = Y(o.times(l), s), c = u.plus(Et(o, new p(i), s)), dt(c.d).slice(0, s) === dt(u.d).slice(0, s))
      return u = u.times(2), a !== 0 && (u = u.plus(du(p, s + 2, m).times(a + ""))), u = Et(u, new p(f), s), p.precision = m, t == null ? (ee = !0, Y(u, m)) : u;
    u = c, i += 2;
  }
}
function gv(e, t) {
  var r, n, i;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; ) ++n;
  for (i = t.length; t.charCodeAt(i - 1) === 48; ) --i;
  if (t = t.slice(n, i), t) {
    if (i -= n, r = r - n - 1, e.e = en(r / Z), e.d = [], n = (r + 1) % Z, r < 0 && (n += Z), n < i) {
      for (n && e.d.push(+t.slice(0, n)), i -= Z; n < i; ) e.d.push(+t.slice(n, n += Z));
      t = t.slice(n), n = Z - t.length;
    } else
      n -= i;
    for (; n--; ) t += "0";
    if (e.d.push(+t), ee && (e.e > Ui || e.e < -Ui)) throw Error(Ns + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function Y(e, t, r) {
  var n, i, a, o, u, c, s, l, f = e.d;
  for (o = 1, a = f[0]; a >= 10; a /= 10) o++;
  if (n = t - o, n < 0)
    n += Z, i = t, s = f[l = 0];
  else {
    if (l = Math.ceil((n + 1) / Z), a = f.length, l >= a) return e;
    for (s = a = f[l], o = 1; a >= 10; a /= 10) o++;
    n %= Z, i = n - Z + o;
  }
  if (r !== void 0 && (a = cr(10, o - i - 1), u = s / a % 10 | 0, c = t < 0 || f[l + 1] !== void 0 || s % a, c = r < 4 ? (u || c) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : u > 5 || u == 5 && (r == 4 || c || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? i > 0 ? s / cr(10, o - i) : 0 : f[l - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !f[0])
    return c ? (a = ue(e), f.length = 1, t = t - a - 1, f[0] = cr(10, (Z - t % Z) % Z), e.e = en(-t / Z) || 0) : (f.length = 1, f[0] = e.e = e.s = 0), e;
  if (n == 0 ? (f.length = l, a = 1, l--) : (f.length = l + 1, a = cr(10, Z - n), f[l] = i > 0 ? (s / cr(10, o - i) % cr(10, i) | 0) * a : 0), c)
    for (; ; )
      if (l == 0) {
        (f[0] += a) == me && (f[0] = 1, ++e.e);
        break;
      } else {
        if (f[l] += a, f[l] != me) break;
        f[l--] = 0, a = 1;
      }
  for (n = f.length; f[--n] === 0; ) f.pop();
  if (ee && (e.e > Ui || e.e < -Ui))
    throw Error(Ns + ue(e));
  return e;
}
function ny(e, t) {
  var r, n, i, a, o, u, c, s, l, f, d = e.constructor, v = d.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new d(e), ee ? Y(t, v) : t;
  if (c = e.d, f = t.d, n = t.e, s = e.e, c = c.slice(), o = s - n, o) {
    for (l = o < 0, l ? (r = c, o = -o, u = f.length) : (r = f, n = s, u = c.length), i = Math.max(Math.ceil(v / Z), u) + 2, o > i && (o = i, r.length = 1), r.reverse(), i = o; i--; ) r.push(0);
    r.reverse();
  } else {
    for (i = c.length, u = f.length, l = i < u, l && (u = i), i = 0; i < u; i++)
      if (c[i] != f[i]) {
        l = c[i] < f[i];
        break;
      }
    o = 0;
  }
  for (l && (r = c, c = f, f = r, t.s = -t.s), u = c.length, i = f.length - u; i > 0; --i) c[u++] = 0;
  for (i = f.length; i > o; ) {
    if (c[--i] < f[i]) {
      for (a = i; a && c[--a] === 0; ) c[a] = me - 1;
      --c[a], c[i] += me;
    }
    c[i] -= f[i];
  }
  for (; c[--u] === 0; ) c.pop();
  for (; c[0] === 0; c.shift()) --n;
  return c[0] ? (t.d = c, t.e = n, ee ? Y(t, v) : t) : new d(0);
}
function Pr(e, t, r) {
  var n, i = ue(e), a = dt(e.d), o = a.length;
  return t ? (r && (n = r - o) > 0 ? a = a.charAt(0) + "." + a.slice(1) + Ut(n) : o > 1 && (a = a.charAt(0) + "." + a.slice(1)), a = a + (i < 0 ? "e" : "e+") + i) : i < 0 ? (a = "0." + Ut(-i - 1) + a, r && (n = r - o) > 0 && (a += Ut(n))) : i >= o ? (a += Ut(i + 1 - o), r && (n = r - i - 1) > 0 && (a = a + "." + Ut(n))) : ((n = i + 1) < o && (a = a.slice(0, n) + "." + a.slice(n)), r && (n = r - o) > 0 && (i + 1 === o && (a += "."), a += Ut(n))), e.s < 0 ? "-" + a : a;
}
function bv(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function iy(e) {
  var t, r, n;
  function i(a) {
    var o = this;
    if (!(o instanceof i)) return new i(a);
    if (o.constructor = i, a instanceof i) {
      o.s = a.s, o.e = a.e, o.d = (a = a.d) ? a.slice() : a;
      return;
    }
    if (typeof a == "number") {
      if (a * 0 !== 0)
        throw Error(yr + a);
      if (a > 0)
        o.s = 1;
      else if (a < 0)
        a = -a, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (a === ~~a && a < 1e7) {
        o.e = 0, o.d = [a];
        return;
      }
      return gv(o, a.toString());
    } else if (typeof a != "string")
      throw Error(yr + a);
    if (a.charCodeAt(0) === 45 ? (a = a.slice(1), o.s = -1) : o.s = 1, hE.test(a)) gv(o, a);
    else throw Error(yr + a);
  }
  if (i.prototype = I, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = iy, i.config = i.set = pE, e === void 0 && (e = {}), e)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; ) e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return i.config(e), i;
}
function pE(e) {
  if (!e || typeof e != "object")
    throw Error(at + "Object expected");
  var t, r, n, i = [
    "precision",
    1,
    Qr,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < i.length; t += 3)
    if ((n = e[r = i[t]]) !== void 0)
      if (en(n) === n && n >= i[t + 1] && n <= i[t + 2]) this[r] = n;
      else throw Error(yr + r + ": " + n);
  if ((n = e[r = "LN10"]) !== void 0)
    if (n == Math.LN10) this[r] = new this(n);
    else throw Error(yr + r + ": " + n);
  return this;
}
var $s = iy(vE);
Ue = new $s(1);
const H = $s;
var mE = (e) => e, ay = {}, oy = (e) => e === ay, wv = (e) => function t() {
  return arguments.length === 0 || arguments.length === 1 && oy(arguments.length <= 0 ? void 0 : arguments[0]) ? t : e(...arguments);
}, uy = (e, t) => e === 1 ? t : wv(function() {
  for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++)
    n[i] = arguments[i];
  var a = n.filter((o) => o !== ay).length;
  return a >= e ? t(...n) : uy(e - a, wv(function() {
    for (var o = arguments.length, u = new Array(o), c = 0; c < o; c++)
      u[c] = arguments[c];
    var s = n.map((l) => oy(l) ? u.shift() : l);
    return t(...s, ...u);
  }));
}), _a = (e) => uy(e.length, e), mc = (e, t) => {
  for (var r = [], n = e; n < t; ++n)
    r[n - e] = n;
  return r;
}, yE = _a((e, t) => Array.isArray(t) ? t.map(e) : Object.keys(t).map((r) => t[r]).map(e)), gE = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  if (!r.length)
    return mE;
  var i = r.reverse(), a = i[0], o = i.slice(1);
  return function() {
    return o.reduce((u, c) => c(u), a(...arguments));
  };
}, yc = (e) => Array.isArray(e) ? e.reverse() : e.split("").reverse().join(""), cy = (e) => {
  var t = null, r = null;
  return function() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return t && i.every((o, u) => {
      var c;
      return o === ((c = t) === null || c === void 0 ? void 0 : c[u]);
    }) || (t = i, r = e(...i)), r;
  };
};
function sy(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new H(e).abs().log(10).toNumber()) + 1, t;
}
function ly(e, t, r) {
  for (var n = new H(e), i = 0, a = []; n.lt(t) && i < 1e5; )
    a.push(n.toNumber()), n = n.add(r), i++;
  return a;
}
_a((e, t, r) => {
  var n = +e, i = +t;
  return n + r * (i - n);
});
_a((e, t, r) => {
  var n = t - +e;
  return n = n || 1 / 0, (r - e) / n;
});
_a((e, t, r) => {
  var n = t - +e;
  return n = n || 1 / 0, Math.max(0, Math.min(1, (r - e) / n));
});
var fy = (e) => {
  var [t, r] = e, [n, i] = [t, r];
  return t > r && ([n, i] = [r, t]), [n, i];
}, dy = (e, t, r) => {
  if (e.lte(0))
    return new H(0);
  var n = sy(e.toNumber()), i = new H(10).pow(n), a = e.div(i), o = n !== 1 ? 0.05 : 0.1, u = new H(Math.ceil(a.div(o).toNumber())).add(r).mul(o), c = u.mul(i);
  return t ? new H(c.toNumber()) : new H(Math.ceil(c.toNumber()));
}, bE = (e, t, r) => {
  var n = new H(1), i = new H(e);
  if (!i.isint() && r) {
    var a = Math.abs(e);
    a < 1 ? (n = new H(10).pow(sy(e) - 1), i = new H(Math.floor(i.div(n).toNumber())).mul(n)) : a > 1 && (i = new H(Math.floor(e)));
  } else e === 0 ? i = new H(Math.floor((t - 1) / 2)) : r || (i = new H(Math.floor(e)));
  var o = Math.floor((t - 1) / 2), u = gE(yE((c) => i.add(new H(c - o).mul(n)).toNumber()), mc);
  return u(0, t);
}, vy = function(t, r, n, i) {
  var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((r - t) / (n - 1)))
    return {
      step: new H(0),
      tickMin: new H(0),
      tickMax: new H(0)
    };
  var o = dy(new H(r).sub(t).div(n - 1), i, a), u;
  t <= 0 && r >= 0 ? u = new H(0) : (u = new H(t).add(r).div(2), u = u.sub(new H(u).mod(o)));
  var c = Math.ceil(u.sub(t).div(o).toNumber()), s = Math.ceil(new H(r).sub(u).div(o).toNumber()), l = c + s + 1;
  return l > n ? vy(t, r, n, i, a + 1) : (l < n && (s = r > 0 ? s + (n - l) : s, c = r > 0 ? c : c + (n - l)), {
    step: o,
    tickMin: u.sub(new H(c).mul(o)),
    tickMax: u.add(new H(s).mul(o))
  });
};
function wE(e) {
  var [t, r] = e, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, a = Math.max(n, 2), [o, u] = fy([t, r]);
  if (o === -1 / 0 || u === 1 / 0) {
    var c = u === 1 / 0 ? [o, ...mc(0, n - 1).map(() => 1 / 0)] : [...mc(0, n - 1).map(() => -1 / 0), u];
    return t > r ? yc(c) : c;
  }
  if (o === u)
    return bE(o, n, i);
  var {
    step: s,
    tickMin: l,
    tickMax: f
  } = vy(o, u, a, i, 0), d = ly(l, f.add(new H(0.1).mul(s)), s);
  return t > r ? yc(d) : d;
}
function xE(e, t) {
  var [r, n] = e, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, [a, o] = fy([r, n]);
  if (a === -1 / 0 || o === 1 / 0)
    return [r, n];
  if (a === o)
    return [a];
  var u = Math.max(t, 2), c = dy(new H(o).sub(a).div(u - 1), i, 0), s = [...ly(new H(a), new H(o), c), o];
  return i === !1 && (s = s.map((l) => Math.round(l))), r > n ? yc(s) : s;
}
var OE = cy(wE), PE = cy(xE), hy = (e) => e.rootProps.maxBarSize, AE = (e) => e.rootProps.barGap, py = (e) => e.rootProps.barCategoryGap, SE = (e) => e.rootProps.barSize, ja = (e) => e.rootProps.stackOffset, Rs = (e) => e.options.chartName, Ls = (e) => e.rootProps.syncId, my = (e) => e.rootProps.syncMethod, Bs = (e) => e.options.eventEmitter, xt = {
  allowDuplicatedCategory: !0,
  // if I set this to false then Tooltip synchronisation stops working in Radar, wtf
  angleAxisId: 0,
  reversed: !1,
  scale: "auto",
  tick: !0,
  type: "category"
}, Fe = {
  allowDataOverflow: !1,
  allowDuplicatedCategory: !0,
  radiusAxisId: 0,
  scale: "auto",
  tick: !0,
  tickCount: 5,
  type: "number"
}, Ta = (e, t) => {
  if (!(!e || !t))
    return e != null && e.reversed ? [t[1], t[0]] : t;
}, EE = {
  allowDataOverflow: !1,
  allowDecimals: !1,
  allowDuplicatedCategory: !1,
  // defaultPolarAngleAxisProps.allowDuplicatedCategory has it set to true but the actual axis rendering ignores the prop because reasons,
  dataKey: void 0,
  domain: void 0,
  id: xt.angleAxisId,
  includeHidden: !1,
  name: void 0,
  reversed: xt.reversed,
  scale: xt.scale,
  tick: xt.tick,
  tickCount: void 0,
  ticks: void 0,
  type: xt.type,
  unit: void 0
}, _E = {
  allowDataOverflow: Fe.allowDataOverflow,
  allowDecimals: !1,
  allowDuplicatedCategory: Fe.allowDuplicatedCategory,
  dataKey: void 0,
  domain: void 0,
  id: Fe.radiusAxisId,
  includeHidden: !1,
  name: void 0,
  reversed: !1,
  scale: Fe.scale,
  tick: Fe.tick,
  tickCount: Fe.tickCount,
  ticks: void 0,
  type: Fe.type,
  unit: void 0
}, jE = {
  allowDataOverflow: !1,
  allowDecimals: !1,
  allowDuplicatedCategory: xt.allowDuplicatedCategory,
  dataKey: void 0,
  domain: void 0,
  id: xt.angleAxisId,
  includeHidden: !1,
  name: void 0,
  reversed: !1,
  scale: xt.scale,
  tick: xt.tick,
  tickCount: void 0,
  ticks: void 0,
  type: "number",
  unit: void 0
}, TE = {
  allowDataOverflow: Fe.allowDataOverflow,
  allowDecimals: !1,
  allowDuplicatedCategory: Fe.allowDuplicatedCategory,
  dataKey: void 0,
  domain: void 0,
  id: Fe.radiusAxisId,
  includeHidden: !1,
  name: void 0,
  reversed: !1,
  scale: Fe.scale,
  tick: Fe.tick,
  tickCount: Fe.tickCount,
  ticks: void 0,
  type: "category",
  unit: void 0
}, zs = (e, t) => e.polarAxis.angleAxis[t] != null ? e.polarAxis.angleAxis[t] : e.layout.layoutType === "radial" ? jE : EE, qs = (e, t) => e.polarAxis.radiusAxis[t] != null ? e.polarAxis.radiusAxis[t] : e.layout.layoutType === "radial" ? TE : _E, Ma = (e) => e.polarOptions, Ks = S([Nt, $t, Se], sO), yy = S([Ma, Ks], (e, t) => {
  if (e != null)
    return st(e.innerRadius, t, 0);
}), gy = S([Ma, Ks], (e, t) => {
  if (e != null)
    return st(e.outerRadius, t, t * 0.8);
}), ME = (e) => {
  if (e == null)
    return [0, 0];
  var {
    startAngle: t,
    endAngle: r
  } = e;
  return [t, r];
}, by = S([Ma], ME);
S([zs, by], Ta);
var wy = S([Ks, yy, gy], (e, t, r) => {
  if (!(e == null || t == null || r == null))
    return [t, r];
});
S([qs, wy], Ta);
var xy = S([W, Ma, yy, gy, Nt, $t], (e, t, r, n, i, a) => {
  if (!(e !== "centric" && e !== "radial" || t == null || r == null || n == null)) {
    var {
      cx: o,
      cy: u,
      startAngle: c,
      endAngle: s
    } = t;
    return {
      cx: st(o, i, i / 2),
      cy: st(u, a, a / 2),
      innerRadius: r,
      outerRadius: n,
      startAngle: c,
      endAngle: s,
      clockWise: !1
    };
  }
}), ce = (e, t) => t, Ca = (e, t, r) => r;
function ka(e) {
  return e?.id;
}
var de = (e) => {
  var t = W(e);
  return t === "horizontal" ? "xAxis" : t === "vertical" ? "yAxis" : t === "centric" ? "angleAxis" : "radiusAxis";
}, tn = (e) => e.tooltip.settings.axisId, ve = (e) => {
  var t = de(e), r = tn(e);
  return Wn(e, t, r);
};
function Oy(e, t, r) {
  var {
    chartData: n = []
  } = t, i = r?.dataKey, a = /* @__PURE__ */ new Map();
  return e.forEach((o) => {
    var u, c = (u = o.data) !== null && u !== void 0 ? u : n;
    if (!(c == null || c.length === 0)) {
      var s = ka(o);
      c.forEach((l, f) => {
        var d = i == null ? f : String(ge(l, i, null)), v = ge(l, o.dataKey, 0), h;
        a.has(d) ? h = a.get(d) : h = {}, Object.assign(h, {
          [s]: v
        }), a.set(d, h);
      });
    }
  }), Array.from(a.values());
}
function Ia(e) {
  return e.stackId != null && e.dataKey != null;
}
function xv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Vi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xv(Object(r), !0).forEach(function(n) {
      CE(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function CE(e, t, r) {
  return (t = kE(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kE(e) {
  var t = IE(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function IE(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var gc = [0, "auto"], Ke = {
  allowDataOverflow: !1,
  allowDecimals: !0,
  allowDuplicatedCategory: !0,
  angle: 0,
  dataKey: void 0,
  domain: void 0,
  height: 30,
  hide: !0,
  id: 0,
  includeHidden: !1,
  interval: "preserveEnd",
  minTickGap: 5,
  mirror: !1,
  name: void 0,
  orientation: "bottom",
  padding: {
    left: 0,
    right: 0
  },
  reversed: !1,
  scale: "auto",
  tick: !0,
  tickCount: 5,
  tickFormatter: void 0,
  ticks: void 0,
  type: "category",
  unit: void 0
}, Lt = (e, t) => {
  var r = e.cartesianAxis.xAxis[t];
  return r ?? Ke;
}, Py = {
  allowDataOverflow: !1,
  allowDecimals: !0,
  allowDuplicatedCategory: !0,
  angle: 0,
  dataKey: void 0,
  domain: gc,
  hide: !0,
  id: 0,
  includeHidden: !1,
  interval: "preserveEnd",
  minTickGap: 5,
  mirror: !1,
  name: void 0,
  orientation: "left",
  padding: {
    top: 0,
    bottom: 0
  },
  reversed: !1,
  scale: "auto",
  tick: !0,
  tickCount: 5,
  tickFormatter: void 0,
  ticks: void 0,
  type: "number",
  unit: void 0,
  width: fa
}, _r = (e, t) => {
  var r = e.cartesianAxis.yAxis[t];
  return r ?? Py;
}, DE = {
  domain: [0, "auto"],
  includeHidden: !1,
  reversed: !1,
  allowDataOverflow: !1,
  allowDuplicatedCategory: !1,
  dataKey: void 0,
  id: 0,
  name: "",
  range: [64, 64],
  scale: "auto",
  type: "number",
  unit: ""
}, Fs = (e, t) => {
  var r = e.cartesianAxis.zAxis[t];
  return r ?? DE;
}, qe = (e, t, r) => {
  switch (t) {
    case "xAxis":
      return Lt(e, r);
    case "yAxis":
      return _r(e, r);
    case "zAxis":
      return Fs(e, r);
    case "angleAxis":
      return zs(e, r);
    case "radiusAxis":
      return qs(e, r);
    default:
      throw new Error("Unexpected axis type: ".concat(t));
  }
}, NE = (e, t, r) => {
  switch (t) {
    case "xAxis":
      return Lt(e, r);
    case "yAxis":
      return _r(e, r);
    default:
      throw new Error("Unexpected axis type: ".concat(t));
  }
}, Wn = (e, t, r) => {
  switch (t) {
    case "xAxis":
      return Lt(e, r);
    case "yAxis":
      return _r(e, r);
    case "angleAxis":
      return zs(e, r);
    case "radiusAxis":
      return qs(e, r);
    default:
      throw new Error("Unexpected axis type: ".concat(t));
  }
}, Ay = (e) => e.graphicalItems.cartesianItems.some((t) => t.type === "bar") || e.graphicalItems.polarItems.some((t) => t.type === "radialBar");
function Sy(e, t) {
  return (r) => {
    switch (e) {
      case "xAxis":
        return "xAxisId" in r && r.xAxisId === t;
      case "yAxis":
        return "yAxisId" in r && r.yAxisId === t;
      case "zAxis":
        return "zAxisId" in r && r.zAxisId === t;
      case "angleAxis":
        return "angleAxisId" in r && r.angleAxisId === t;
      case "radiusAxis":
        return "radiusAxisId" in r && r.radiusAxisId === t;
      default:
        return !1;
    }
  };
}
var Da = (e) => e.graphicalItems.cartesianItems, $E = S([ce, Ca], Sy), Ey = (e, t, r) => e.filter(r).filter((n) => t?.includeHidden === !0 ? !0 : !n.hide), Un = S([Da, qe, $E], Ey), _y = S([Un], (e) => e.filter((t) => t.type === "area" || t.type === "bar").filter(Ia)), jy = (e) => e.filter((t) => !("stackId" in t) || t.stackId === void 0), Ty = S([Un], jy), My = (e) => e.map((t) => t.data).filter(Boolean).flat(1), RE = S([Un], My), Cy = (e, t) => {
  var {
    chartData: r = [],
    dataStartIndex: n,
    dataEndIndex: i
  } = t;
  return e.length > 0 ? e : r.slice(n, i + 1);
}, Ws = S([RE, Ea], Cy), ky = (e, t, r) => t?.dataKey != null ? e.map((n) => ({
  value: ge(n, t.dataKey)
})) : r.length > 0 ? r.map((n) => n.dataKey).flatMap((n) => e.map((i) => ({
  value: ge(i, n)
}))) : e.map((n) => ({
  value: n
})), Na = S([Ws, qe, Un], ky);
function Iy(e, t) {
  switch (e) {
    case "xAxis":
      return t.direction === "x";
    case "yAxis":
      return t.direction === "y";
    default:
      return !1;
  }
}
function jr(e) {
  return e.filter((t) => mt(t) || t instanceof Date).map(Number).filter((t) => Be(t) === !1);
}
function LE(e, t, r) {
  return !r || typeof t != "number" || Be(t) ? [] : r.length ? jr(r.flatMap((n) => {
    var i = ge(e, n.dataKey), a, o;
    if (Array.isArray(i) ? [a, o] = i : a = o = i, !(!Ae(a) || !Ae(o)))
      return [t - a, t + o];
  })) : [];
}
var BE = S([_y, Ea, ve], Oy), Dy = (e, t, r) => {
  var n = {}, i = t.reduce((a, o) => (o.stackId == null || (a[o.stackId] == null && (a[o.stackId] = []), a[o.stackId].push(o)), a), n);
  return Object.fromEntries(Object.entries(i).map((a) => {
    var [o, u] = a, c = u.map(ka);
    return [o, {
      // @ts-expect-error getStackedData requires that the input is array of objects, Recharts does not test for that
      stackedData: SO(e, c, r),
      graphicalItems: u
    }];
  }));
}, kn = S([BE, _y, ja], Dy), Ny = (e, t, r) => {
  var {
    dataStartIndex: n,
    dataEndIndex: i
  } = t;
  if (r !== "zAxis") {
    var a = TO(e, n, i);
    if (!(a != null && a[0] === 0 && a[1] === 0))
      return a;
  }
}, zE = S([kn, ir, ce], Ny), $y = (e, t, r, n, i) => r.length > 0 ? e.flatMap((a) => r.flatMap((o) => {
  var u, c, s = (u = n[o.id]) === null || u === void 0 ? void 0 : u.filter((f) => Iy(i, f)), l = ge(a, (c = t.dataKey) !== null && c !== void 0 ? c : o.dataKey);
  return {
    value: l,
    errorDomain: LE(a, l, s)
  };
})).filter(Boolean) : t?.dataKey != null ? e.map((a) => ({
  value: ge(a, t.dataKey),
  errorDomain: []
})) : e.map((a) => ({
  value: a,
  errorDomain: []
})), $a = (e) => e.errorBars, Ry = (e, t, r) => e.flatMap((n) => t[n.id]).filter(Boolean).filter((n) => Iy(r, n));
S([Ty, $a, ce], Ry);
var qE = S([Ws, qe, Ty, $a, ce], $y);
function KE(e) {
  var {
    value: t
  } = e;
  if (mt(t) || t instanceof Date)
    return t;
}
var Ov = (e) => {
  var t = e.flatMap((n) => [n.value, n.errorDomain]).flat(1), r = jr(t);
  if (r.length !== 0)
    return [Math.min(...r), Math.max(...r)];
}, FE = (e, t, r) => {
  var n = e.map(KE).filter((i) => i != null);
  return r && (t.dataKey == null || t.allowDuplicatedCategory && Kh(n)) ? bm(0, e.length) : t.allowDuplicatedCategory ? n : Array.from(new Set(n));
}, Us = (e) => {
  var t;
  if (e == null || !("domain" in e))
    return gc;
  if (e.domain != null)
    return e.domain;
  if (e.ticks != null) {
    if (e.type === "number") {
      var r = jr(e.ticks);
      return [Math.min(...r), Math.max(...r)];
    }
    if (e.type === "category")
      return e.ticks.map(String);
  }
  return (t = e?.domain) !== null && t !== void 0 ? t : gc;
}, Hi = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = r.filter(Boolean);
  if (i.length !== 0) {
    var a = i.flat(), o = Math.min(...a), u = Math.max(...a);
    return [o, u];
  }
}, Ly = (e) => e.referenceElements.dots, rn = (e, t, r) => e.filter((n) => n.ifOverflow === "extendDomain").filter((n) => t === "xAxis" ? n.xAxisId === r : n.yAxisId === r), WE = S([Ly, ce, Ca], rn), By = (e) => e.referenceElements.areas, UE = S([By, ce, Ca], rn), zy = (e) => e.referenceElements.lines, VE = S([zy, ce, Ca], rn), qy = (e, t) => {
  var r = jr(e.map((n) => t === "xAxis" ? n.x : n.y));
  if (r.length !== 0)
    return [Math.min(...r), Math.max(...r)];
}, HE = S(WE, ce, qy), Ky = (e, t) => {
  var r = jr(e.flatMap((n) => [t === "xAxis" ? n.x1 : n.y1, t === "xAxis" ? n.x2 : n.y2]));
  if (r.length !== 0)
    return [Math.min(...r), Math.max(...r)];
}, GE = S([UE, ce], Ky), Fy = (e, t) => {
  var r = jr(e.map((n) => t === "xAxis" ? n.x : n.y));
  if (r.length !== 0)
    return [Math.min(...r), Math.max(...r)];
}, YE = S(VE, ce, Fy), XE = S(HE, YE, GE, (e, t, r) => Hi(e, r, t)), ZE = S([qe], Us), Wy = (e, t, r, n, i, a, o) => {
  var u = fE(t, e.allowDataOverflow);
  if (u != null)
    return u;
  var c = a === "vertical" && o === "xAxis" || a === "horizontal" && o === "yAxis", s = c ? Hi(r, i, Ov(n)) : Hi(i, Ov(n));
  return dE(t, s, e.allowDataOverflow);
}, JE = S([qe, ZE, zE, qE, XE, W, ce], Wy), QE = [0, 1], Uy = (e, t, r, n, i, a, o) => {
  if (!((e == null || r == null || r.length === 0) && o === void 0)) {
    var {
      dataKey: u,
      type: c
    } = e, s = Dt(t, a);
    return s && u == null ? bm(0, r.length) : c === "category" ? FE(n, e, s) : i === "expand" ? QE : o;
  }
}, Vs = S([qe, W, Ws, Na, ja, ce, JE], Uy), Vy = (e, t, r, n, i) => {
  if (e != null) {
    var {
      scale: a,
      type: o
    } = e;
    if (a === "auto")
      return t === "radial" && i === "radiusAxis" ? "band" : t === "radial" && i === "angleAxis" ? "linear" : o === "category" && n && (n.indexOf("LineChart") >= 0 || n.indexOf("AreaChart") >= 0 || n.indexOf("ComposedChart") >= 0 && !r) ? "point" : o === "category" ? "band" : "linear";
    if (typeof a == "string") {
      var u = "scale".concat(Nn(a));
      return u in yn ? u : "point";
    }
  }
}, Vn = S([qe, W, Ay, Rs, ce], Vy);
function e_(e) {
  if (e != null) {
    if (e in yn)
      return yn[e]();
    var t = "scale".concat(Nn(e));
    if (t in yn)
      return yn[t]();
  }
}
function Hs(e, t, r, n) {
  if (!(r == null || n == null)) {
    if (typeof e.scale == "function")
      return e.scale.copy().domain(r).range(n);
    var i = e_(t);
    if (i != null) {
      var a = i.domain(r).range(n);
      return wO(a), a;
    }
  }
}
var Hy = (e, t, r) => {
  var n = Us(t);
  if (!(r !== "auto" && r !== "linear")) {
    if (t != null && t.tickCount && Array.isArray(n) && (n[0] === "auto" || n[1] === "auto") && Vr(e))
      return OE(e, t.tickCount, t.allowDecimals);
    if (t != null && t.tickCount && t.type === "number" && Vr(e))
      return PE(e, t.tickCount, t.allowDecimals);
  }
}, Gs = S([Vs, Wn, Vn], Hy), Gy = (e, t, r, n) => {
  if (
    /*
     * Angle axis for some reason uses nice ticks when rendering axis tick labels,
     * but doesn't use nice ticks for extending domain like all the other axes do.
     * Not really sure why? Is there a good reason,
     * or is it just because someone added support for nice ticks to the other axes and forgot this one?
     */
    n !== "angleAxis" && e?.type === "number" && Vr(t) && Array.isArray(r) && r.length > 0
  ) {
    var i = t[0], a = r[0], o = t[1], u = r[r.length - 1];
    return [Math.min(i, a), Math.max(o, u)];
  }
  return t;
}, t_ = S([qe, Vs, Gs, ce], Gy), r_ = S(Na, qe, (e, t) => {
  if (!(!t || t.type !== "number")) {
    var r = 1 / 0, n = Array.from(jr(e.map((u) => u.value))).sort((u, c) => u - c);
    if (n.length < 2)
      return 1 / 0;
    var i = n[n.length - 1] - n[0];
    if (i === 0)
      return 1 / 0;
    for (var a = 0; a < n.length - 1; a++) {
      var o = n[a + 1] - n[a];
      r = Math.min(r, o);
    }
    return r / i;
  }
}), Yy = S(r_, W, py, Se, (e, t, r, n) => n, (e, t, r, n, i) => {
  if (!Ae(e))
    return 0;
  var a = t === "vertical" ? n.height : n.width;
  if (i === "gap")
    return e * a / 2;
  if (i === "no-gap") {
    var o = st(r, e * a), u = e * a / 2;
    return u - o - (u - o) / a * o;
  }
  return 0;
}), n_ = (e, t) => {
  var r = Lt(e, t);
  return r == null || typeof r.padding != "string" ? 0 : Yy(e, "xAxis", t, r.padding);
}, i_ = (e, t) => {
  var r = _r(e, t);
  return r == null || typeof r.padding != "string" ? 0 : Yy(e, "yAxis", t, r.padding);
}, a_ = S(Lt, n_, (e, t) => {
  var r, n;
  if (e == null)
    return {
      left: 0,
      right: 0
    };
  var {
    padding: i
  } = e;
  return typeof i == "string" ? {
    left: t,
    right: t
  } : {
    left: ((r = i.left) !== null && r !== void 0 ? r : 0) + t,
    right: ((n = i.right) !== null && n !== void 0 ? n : 0) + t
  };
}), o_ = S(_r, i_, (e, t) => {
  var r, n;
  if (e == null)
    return {
      top: 0,
      bottom: 0
    };
  var {
    padding: i
  } = e;
  return typeof i == "string" ? {
    top: t,
    bottom: t
  } : {
    top: ((r = i.top) !== null && r !== void 0 ? r : 0) + t,
    bottom: ((n = i.bottom) !== null && n !== void 0 ? n : 0) + t
  };
}), u_ = S([Se, a_, va, da, (e, t, r) => r], (e, t, r, n, i) => {
  var {
    padding: a
  } = n;
  return i ? [a.left, r.width - a.right] : [e.left + t.left, e.left + e.width - t.right];
}), c_ = S([Se, W, o_, va, da, (e, t, r) => r], (e, t, r, n, i, a) => {
  var {
    padding: o
  } = i;
  return a ? [n.height - o.bottom, o.top] : t === "horizontal" ? [e.top + e.height - r.bottom, e.top + r.top] : [e.top + r.top, e.top + e.height - r.bottom];
}), Hn = (e, t, r, n) => {
  var i;
  switch (t) {
    case "xAxis":
      return u_(e, r, n);
    case "yAxis":
      return c_(e, r, n);
    case "zAxis":
      return (i = Fs(e, r)) === null || i === void 0 ? void 0 : i.range;
    case "angleAxis":
      return by(e);
    case "radiusAxis":
      return wy(e, r);
    default:
      return;
  }
}, Xy = S([qe, Hn], Ta), Gn = S([qe, Vn, t_, Xy], Hs);
S([Un, $a, ce], Ry);
function Zy(e, t) {
  return e.id < t.id ? -1 : e.id > t.id ? 1 : 0;
}
var Ra = (e, t) => t, La = (e, t, r) => r, s_ = S(ns, Ra, La, (e, t, r) => e.filter((n) => n.orientation === t).filter((n) => n.mirror === r).sort(Zy)), l_ = S(is, Ra, La, (e, t, r) => e.filter((n) => n.orientation === t).filter((n) => n.mirror === r).sort(Zy)), Jy = (e, t) => ({
  width: e.width,
  height: t.height
}), f_ = (e, t) => {
  var r = typeof t.width == "number" ? t.width : fa;
  return {
    width: r,
    height: e.height
  };
}, Qy = S(Se, Lt, Jy), d_ = (e, t, r) => {
  switch (t) {
    case "top":
      return e.top;
    case "bottom":
      return r - e.bottom;
    default:
      return 0;
  }
}, v_ = (e, t, r) => {
  switch (t) {
    case "left":
      return e.left;
    case "right":
      return r - e.right;
    default:
      return 0;
  }
}, h_ = S($t, Se, s_, Ra, La, (e, t, r, n, i) => {
  var a = {}, o;
  return r.forEach((u) => {
    var c = Jy(t, u);
    o == null && (o = d_(t, n, e));
    var s = n === "top" && !i || n === "bottom" && i;
    a[u.id] = o - Number(s) * c.height, o += (s ? -1 : 1) * c.height;
  }), a;
});
S(Nt, Se, l_, Ra, La, (e, t, r, n, i) => {
  var a = {}, o;
  return r.forEach((u) => {
    var c = f_(t, u);
    o == null && (o = v_(t, n, e));
    var s = n === "left" && !i || n === "right" && i;
    a[u.id] = o - Number(s) * c.width, o += (s ? -1 : 1) * c.width;
  }), a;
});
var p_ = (e, t) => {
  var r = Se(e), n = Lt(e, t);
  if (n != null) {
    var i = h_(e, n.orientation, n.mirror), a = i[t];
    return a == null ? {
      x: r.left,
      y: 0
    } : {
      x: r.left,
      y: a
    };
  }
}, m_ = S(Se, _r, (e, t) => {
  var r = typeof t.width == "number" ? t.width : fa;
  return {
    width: r,
    height: e.height
  };
}), Pv = (e, t, r) => {
  switch (t) {
    case "xAxis":
      return Qy(e, r).width;
    case "yAxis":
      return m_(e, r).height;
    default:
      return;
  }
}, eg = (e, t, r, n) => {
  if (r != null) {
    var {
      allowDuplicatedCategory: i,
      type: a,
      dataKey: o
    } = r, u = Dt(e, n), c = t.map((s) => s.value);
    if (o && u && a === "category" && i && Kh(c))
      return c;
  }
}, Ys = S([W, Na, qe, ce], eg), tg = (e, t, r, n) => {
  if (!(r == null || r.dataKey == null)) {
    var {
      type: i,
      scale: a
    } = r, o = Dt(e, n);
    if (o && (i === "number" || a !== "auto"))
      return t.map((u) => u.value);
  }
}, Xs = S([W, Na, Wn, ce], tg), Av = S([W, NE, Vn, Gn, Ys, Xs, Hn, Gs, ce], (e, t, r, n, i, a, o, u, c) => {
  if (t == null)
    return null;
  var s = Dt(e, c);
  return {
    angle: t.angle,
    interval: t.interval,
    minTickGap: t.minTickGap,
    orientation: t.orientation,
    tick: t.tick,
    tickCount: t.tickCount,
    tickFormatter: t.tickFormatter,
    ticks: t.ticks,
    type: t.type,
    unit: t.unit,
    axisType: c,
    categoricalDomain: a,
    duplicateDomain: i,
    isCategorical: s,
    niceTicks: u,
    range: o,
    realScaleType: r,
    scale: n
  };
}), y_ = (e, t, r, n, i, a, o, u, c) => {
  if (!(t == null || n == null)) {
    var s = Dt(e, c), {
      type: l,
      ticks: f,
      tickCount: d
    } = t, v = r === "scaleBand" && typeof n.bandwidth == "function" ? n.bandwidth() / 2 : 2, h = l === "category" && n.bandwidth ? n.bandwidth() / v : 0;
    h = c === "angleAxis" && a != null && a.length >= 2 ? Re(a[0] - a[1]) * 2 * h : h;
    var p = f || i;
    if (p) {
      var m = p.map((y, g) => {
        var b = o ? o.indexOf(y) : y;
        return {
          index: g,
          // If the scaleContent is not a number, the coordinate will be NaN.
          // That could be the case for example with a PointScale and a string as domain.
          coordinate: n(b) + h,
          value: y,
          offset: h
        };
      });
      return m.filter((y) => !Be(y.coordinate));
    }
    return s && u ? u.map((y, g) => ({
      coordinate: n(y) + h,
      value: y,
      index: g,
      offset: h
    })) : n.ticks ? n.ticks(d).map((y) => ({
      coordinate: n(y) + h,
      value: y,
      offset: h
    })) : n.domain().map((y, g) => ({
      coordinate: n(y) + h,
      value: o ? o[y] : y,
      index: g,
      offset: h
    }));
  }
}, g_ = S([W, Wn, Vn, Gn, Gs, Hn, Ys, Xs, ce], y_), b_ = (e, t, r, n, i, a, o) => {
  if (!(t == null || r == null || n == null || n[0] === n[1])) {
    var u = Dt(e, o), {
      tickCount: c
    } = t, s = 0;
    return s = o === "angleAxis" && n?.length >= 2 ? Re(n[0] - n[1]) * 2 * s : s, u && a ? a.map((l, f) => ({
      coordinate: r(l) + s,
      value: l,
      index: f,
      offset: s
    })) : r.ticks ? r.ticks(c).map((l) => ({
      coordinate: r(l) + s,
      value: l,
      offset: s
    })) : r.domain().map((l, f) => ({
      coordinate: r(l) + s,
      value: i ? i[l] : l,
      index: f,
      offset: s
    }));
  }
}, Jt = S([W, Wn, Gn, Hn, Ys, Xs, ce], b_), Qt = S(qe, Gn, (e, t) => {
  if (!(e == null || t == null))
    return Vi(Vi({}, e), {}, {
      scale: t
    });
}), w_ = S([qe, Vn, Vs, Xy], Hs);
S((e, t, r) => Fs(e, r), w_, (e, t) => {
  if (!(e == null || t == null))
    return Vi(Vi({}, e), {}, {
      scale: t
    });
});
var x_ = S([W, ns, is], (e, t, r) => {
  switch (e) {
    case "horizontal":
      return t.some((n) => n.reversed) ? "right-to-left" : "left-to-right";
    case "vertical":
      return r.some((n) => n.reversed) ? "bottom-to-top" : "top-to-bottom";
    // TODO: make this better. For now, right arrow triggers "forward", left arrow "back"
    // however, the tooltip moves an unintuitive direction because of how the indices are rendered
    case "centric":
    case "radial":
      return "left-to-right";
    default:
      return;
  }
}), rg = (e) => e.options.defaultTooltipEventType, ng = (e) => e.options.validateTooltipEventTypes;
function ig(e, t, r) {
  if (e == null)
    return t;
  var n = e ? "axis" : "item";
  return r == null ? t : r.includes(n) ? n : t;
}
function Zs(e, t) {
  var r = rg(e), n = ng(e);
  return ig(t, r, n);
}
function O_(e) {
  return $((t) => Zs(t, e));
}
var ag = (e, t) => {
  var r, n = Number(t);
  if (!(Be(n) || t == null))
    return n >= 0 ? e == null || (r = e[n]) === null || r === void 0 ? void 0 : r.value : void 0;
}, P_ = (e) => e.tooltip.settings, Ht = {
  active: !1,
  index: null,
  dataKey: void 0,
  coordinate: void 0
}, A_ = {
  itemInteraction: {
    click: Ht,
    hover: Ht
  },
  axisInteraction: {
    click: Ht,
    hover: Ht
  },
  keyboardInteraction: Ht,
  syncInteraction: {
    active: !1,
    index: null,
    dataKey: void 0,
    label: void 0,
    coordinate: void 0
  },
  tooltipItemPayloads: [],
  settings: {
    shared: void 0,
    trigger: "hover",
    axisId: 0,
    active: !1,
    defaultIndex: void 0
  }
}, og = Ye({
  name: "tooltip",
  initialState: A_,
  reducers: {
    addTooltipEntrySettings(e, t) {
      e.tooltipItemPayloads.push(t.payload);
    },
    removeTooltipEntrySettings(e, t) {
      var r = St(e).tooltipItemPayloads.indexOf(t.payload);
      r > -1 && e.tooltipItemPayloads.splice(r, 1);
    },
    setTooltipSettingsState(e, t) {
      e.settings = t.payload;
    },
    setActiveMouseOverItemIndex(e, t) {
      e.syncInteraction.active = !1, e.keyboardInteraction.active = !1, e.itemInteraction.hover.active = !0, e.itemInteraction.hover.index = t.payload.activeIndex, e.itemInteraction.hover.dataKey = t.payload.activeDataKey, e.itemInteraction.hover.coordinate = t.payload.activeCoordinate;
    },
    mouseLeaveChart(e) {
      e.itemInteraction.hover.active = !1, e.axisInteraction.hover.active = !1;
    },
    mouseLeaveItem(e) {
      e.itemInteraction.hover.active = !1;
    },
    setActiveClickItemIndex(e, t) {
      e.syncInteraction.active = !1, e.itemInteraction.click.active = !0, e.keyboardInteraction.active = !1, e.itemInteraction.click.index = t.payload.activeIndex, e.itemInteraction.click.dataKey = t.payload.activeDataKey, e.itemInteraction.click.coordinate = t.payload.activeCoordinate;
    },
    setMouseOverAxisIndex(e, t) {
      e.syncInteraction.active = !1, e.axisInteraction.hover.active = !0, e.keyboardInteraction.active = !1, e.axisInteraction.hover.index = t.payload.activeIndex, e.axisInteraction.hover.dataKey = t.payload.activeDataKey, e.axisInteraction.hover.coordinate = t.payload.activeCoordinate;
    },
    setMouseClickAxisIndex(e, t) {
      e.syncInteraction.active = !1, e.keyboardInteraction.active = !1, e.axisInteraction.click.active = !0, e.axisInteraction.click.index = t.payload.activeIndex, e.axisInteraction.click.dataKey = t.payload.activeDataKey, e.axisInteraction.click.coordinate = t.payload.activeCoordinate;
    },
    setSyncInteraction(e, t) {
      e.syncInteraction = t.payload;
    },
    setKeyboardInteraction(e, t) {
      e.keyboardInteraction.active = t.payload.active, e.keyboardInteraction.index = t.payload.activeIndex, e.keyboardInteraction.coordinate = t.payload.activeCoordinate, e.keyboardInteraction.dataKey = t.payload.activeDataKey;
    }
  }
}), {
  addTooltipEntrySettings: S_,
  removeTooltipEntrySettings: E_,
  setTooltipSettingsState: __,
  setActiveMouseOverItemIndex: ug,
  mouseLeaveItem: j_,
  mouseLeaveChart: cg,
  setActiveClickItemIndex: T_,
  setMouseOverAxisIndex: sg,
  setMouseClickAxisIndex: M_,
  setSyncInteraction: bc,
  setKeyboardInteraction: wc
} = og.actions, C_ = og.reducer;
function Sv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function li(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sv(Object(r), !0).forEach(function(n) {
      k_(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function k_(e, t, r) {
  return (t = I_(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function I_(e) {
  var t = D_(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function D_(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function N_(e, t, r) {
  return t === "axis" ? r === "click" ? e.axisInteraction.click : e.axisInteraction.hover : r === "click" ? e.itemInteraction.click : e.itemInteraction.hover;
}
function $_(e) {
  return e.index != null;
}
var lg = (e, t, r, n) => {
  if (t == null)
    return Ht;
  var i = N_(e, t, r);
  if (i == null)
    return Ht;
  if (i.active)
    return i;
  if (e.keyboardInteraction.active)
    return e.keyboardInteraction;
  if (e.syncInteraction.active && e.syncInteraction.index != null)
    return e.syncInteraction;
  var a = e.settings.active === !0;
  if ($_(i)) {
    if (a)
      return li(li({}, i), {}, {
        active: !0
      });
  } else if (n != null)
    return {
      active: !0,
      coordinate: void 0,
      dataKey: void 0,
      index: n
    };
  return li(li({}, Ht), {}, {
    coordinate: i.coordinate
  });
}, Js = (e, t) => {
  var r = e?.index;
  if (r == null)
    return null;
  var n = Number(r);
  if (!Ae(n))
    return r;
  var i = 0, a = 1 / 0;
  return t.length > 0 && (a = t.length - 1), String(Math.max(i, Math.min(n, a)));
}, fg = (e, t, r, n, i, a, o, u) => {
  if (!(a == null || u == null)) {
    var c = o[0], s = c == null ? void 0 : u(c.positions, a);
    if (s != null)
      return s;
    var l = i?.[Number(a)];
    if (l)
      return r === "horizontal" ? {
        x: l.coordinate,
        y: (n.top + t) / 2
      } : {
        x: (n.left + e) / 2,
        y: l.coordinate
      };
  }
}, dg = (e, t, r, n) => {
  if (t === "axis")
    return e.tooltipItemPayloads;
  if (e.tooltipItemPayloads.length === 0)
    return [];
  var i;
  return r === "hover" ? i = e.itemInteraction.hover.dataKey : i = e.itemInteraction.click.dataKey, i == null && n != null ? [e.tooltipItemPayloads[0]] : e.tooltipItemPayloads.filter((a) => {
    var o;
    return ((o = a.settings) === null || o === void 0 ? void 0 : o.dataKey) === i;
  });
}, Yn = (e) => e.options.tooltipPayloadSearcher, nn = (e) => e.tooltip;
function Ev(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _v(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ev(Object(r), !0).forEach(function(n) {
      R_(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ev(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function R_(e, t, r) {
  return (t = L_(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function L_(e) {
  var t = B_(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function B_(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function z_(e, t) {
  return e ?? t;
}
var vg = (e, t, r, n, i, a, o) => {
  if (!(t == null || a == null)) {
    var {
      chartData: u,
      computedData: c,
      dataStartIndex: s,
      dataEndIndex: l
    } = r, f = [];
    return e.reduce((d, v) => {
      var h, {
        dataDefinedOnItem: p,
        settings: m
      } = v, y = z_(p, u), g = Array.isArray(y) ? Yp(y, s, l) : y, b = (h = m?.dataKey) !== null && h !== void 0 ? h : n?.dataKey, O = m?.nameKey, w;
      if (n != null && n.dataKey && Array.isArray(g) && /*
       * findEntryInArray won't work for Scatter because Scatter provides an array of arrays
       * as tooltip payloads and findEntryInArray is not prepared to handle that.
       * Sad but also ScatterChart only allows 'item' tooltipEventType
       * and also this is only a problem if there are multiple Scatters and each has its own data array
       * so let's fix that some other time.
       */
      !Array.isArray(g[0]) && /*
       * If the tooltipEventType is 'axis', we should search for the dataKey in the sliced data
       * because thanks to allowDuplicatedCategory=false, the order of elements in the array
       * no longer matches the order of elements in the original data
       * and so we need to search by the active dataKey + label rather than by index.
       *
       * The same happens if multiple graphical items are present in the chart
       * and each of them has its own data array. Those arrays get concatenated
       * and again the tooltip index no longer matches the original data.
       *
       * On the other hand the tooltipEventType 'item' should always search by index
       * because we get the index from interacting over the individual elements
       * which is always accurate, irrespective of the allowDuplicatedCategory setting.
       */
      o === "axis" ? w = Fh(g, n.dataKey, i) : w = a(g, t, c, O), Array.isArray(w))
        w.forEach((A) => {
          var _ = _v(_v({}, m), {}, {
            name: A.name,
            unit: A.unit,
            // color and fill are erased to keep 100% the identical behaviour to recharts 2.x - but there's nothing stopping us from returning them here. It's technically a breaking change.
            color: void 0,
            // color and fill are erased to keep 100% the identical behaviour to recharts 2.x - but there's nothing stopping us from returning them here. It's technically a breaking change.
            fill: void 0
          });
          d.push(td({
            tooltipEntrySettings: _,
            dataKey: A.dataKey,
            payload: A.payload,
            // @ts-expect-error getValueByDataKey does not validate the output type
            value: ge(A.payload, A.dataKey),
            name: A.name
          }));
        });
      else {
        var P;
        d.push(td({
          tooltipEntrySettings: m,
          dataKey: b,
          payload: w,
          // @ts-expect-error getValueByDataKey does not validate the output type
          value: ge(w, b),
          // @ts-expect-error getValueByDataKey does not validate the output type
          name: (P = ge(w, O)) !== null && P !== void 0 ? P : m?.name
        }));
      }
      return d;
    }, f);
  }
}, Qs = S([ve, W, Ay, Rs, de], Vy), q_ = S([(e) => e.graphicalItems.cartesianItems, (e) => e.graphicalItems.polarItems], (e, t) => [...e, ...t]), K_ = S([de, tn], Sy), Xn = S([q_, ve, K_], Ey), F_ = S([Xn], (e) => e.filter(Ia)), W_ = S([Xn], My), an = S([W_, ir], Cy), U_ = S([F_, ir, ve], Oy), el = S([an, ve, Xn], ky), V_ = S([ve], Us), H_ = S([Xn], (e) => e.filter(Ia)), G_ = S([U_, H_, ja], Dy), Y_ = S([G_, ir, de], Ny), X_ = S([Xn], jy), Z_ = S([an, ve, X_, $a, de], $y), J_ = S([Ly, de, tn], rn), Q_ = S([J_, de], qy), ej = S([By, de, tn], rn), tj = S([ej, de], Ky), rj = S([zy, de, tn], rn), nj = S([rj, de], Fy), ij = S([Q_, nj, tj], Hi), aj = S([ve, V_, Y_, Z_, ij, W, de], Wy), hg = S([ve, W, an, el, ja, de, aj], Uy), oj = S([hg, ve, Qs], Hy), uj = S([ve, hg, oj, de], Gy), pg = (e) => {
  var t = de(e), r = tn(e), n = !1;
  return Hn(e, t, r, n);
}, mg = S([ve, pg], Ta), yg = S([ve, Qs, uj, mg], Hs), cj = S([W, el, ve, de], eg), sj = S([W, el, ve, de], tg), lj = (e, t, r, n, i, a, o, u) => {
  if (t) {
    var {
      type: c
    } = t, s = Dt(e, u);
    if (n) {
      var l = r === "scaleBand" && n.bandwidth ? n.bandwidth() / 2 : 2, f = c === "category" && n.bandwidth ? n.bandwidth() / l : 0;
      return f = u === "angleAxis" && i != null && i?.length >= 2 ? Re(i[0] - i[1]) * 2 * f : f, s && o ? o.map((d, v) => ({
        coordinate: n(d) + f,
        value: d,
        index: v,
        offset: f
      })) : n.domain().map((d, v) => ({
        coordinate: n(d) + f,
        value: a ? a[d] : d,
        index: v,
        offset: f
      }));
    }
  }
}, Bt = S([W, ve, Qs, yg, pg, cj, sj, de], lj), tl = S([rg, ng, P_], (e, t, r) => ig(r.shared, e, t)), gg = (e) => e.tooltip.settings.trigger, rl = (e) => e.tooltip.settings.defaultIndex, Ba = S([nn, tl, gg, rl], lg), Ar = S([Ba, an], Js), bg = S([Bt, Ar], ag), wg = S([Ba], (e) => {
  if (e)
    return e.dataKey;
}), xg = S([nn, tl, gg, rl], dg), fj = S([Nt, $t, W, Se, Bt, rl, xg, Yn], fg), dj = S([Ba, fj], (e, t) => e != null && e.coordinate ? e.coordinate : t), vj = S([Ba], (e) => e.active), hj = S([xg, Ar, ir, ve, bg, Yn, tl], vg), pj = S([hj], (e) => {
  if (e != null) {
    var t = e.map((r) => r.payload).filter((r) => r != null);
    return Array.from(new Set(t));
  }
});
function jv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Tv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jv(Object(r), !0).forEach(function(n) {
      mj(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : jv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function mj(e, t, r) {
  return (t = yj(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function yj(e) {
  var t = gj(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function gj(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var bj = () => $(ve), wj = () => {
  var e = bj(), t = $(Bt), r = $(yg);
  return Pn(Tv(Tv({}, e), {}, {
    scale: r
  }), t);
}, Og = () => $(Rs), nl = (e, t) => t, Pg = (e, t, r) => r, il = (e, t, r, n) => n, xj = S(Bt, (e) => ca(e, (t) => t.coordinate)), al = S([nn, nl, Pg, il], lg), Ag = S([al, an], Js), Oj = (e, t, r) => {
  if (t != null) {
    var n = nn(e);
    return t === "axis" ? r === "hover" ? n.axisInteraction.hover.dataKey : n.axisInteraction.click.dataKey : r === "hover" ? n.itemInteraction.hover.dataKey : n.itemInteraction.click.dataKey;
  }
}, Sg = S([nn, nl, Pg, il], dg), Gi = S([Nt, $t, W, Se, Bt, il, Sg, Yn], fg), Pj = S([al, Gi], (e, t) => {
  var r;
  return (r = e.coordinate) !== null && r !== void 0 ? r : t;
}), Eg = S(Bt, Ag, ag), Aj = S([Sg, Ag, ir, ve, Eg, Yn, nl], vg), Sj = S([al], (e) => ({
  isActive: e.active,
  activeIndex: e.index
})), Ej = (e, t, r, n, i, a, o, u) => {
  if (!(!e || !t || !n || !i || !a)) {
    var c = MO(e.chartX, e.chartY, t, r, u);
    if (c) {
      var s = kO(c, t), l = gO(s, o, a, n, i), f = CO(t, a, l, c);
      return {
        activeIndex: String(l),
        activeCoordinate: f
      };
    }
  }
};
function xc() {
  return xc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xc.apply(null, arguments);
}
function Mv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function fi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mv(Object(r), !0).forEach(function(n) {
      _j(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Mv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function _j(e, t, r) {
  return (t = jj(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function jj(e) {
  var t = Tj(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Tj(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Mj(e) {
  var {
    coordinate: t,
    payload: r,
    index: n,
    offset: i,
    tooltipAxisBandSize: a,
    layout: o,
    cursor: u,
    tooltipEventType: c,
    chartName: s
  } = e, l = t, f = r, d = n;
  if (!u || !l || s !== "ScatterChart" && c !== "axis")
    return null;
  var v, h;
  if (s === "ScatterChart")
    v = l, h = U1;
  else if (s === "BarChart")
    v = V1(o, l, i, a), h = pm;
  else if (o === "radial") {
    var {
      cx: p,
      cy: m,
      radius: y,
      startAngle: g,
      endAngle: b
    } = mm(l);
    v = {
      cx: p,
      cy: m,
      startAngle: g,
      endAngle: b,
      innerRadius: y,
      outerRadius: y
    }, h = gm;
  } else
    v = {
      points: MP(o, l, i)
    }, h = mi;
  var O = typeof u == "object" && "className" in u ? u.className : void 0, w = fi(fi(fi(fi({
    stroke: "#ccc",
    pointerEvents: "none"
  }, i), v), ie(u, !1)), {}, {
    payload: f,
    payloadIndex: d,
    className: G("recharts-tooltip-cursor", O)
  });
  return /* @__PURE__ */ vt(u) ? /* @__PURE__ */ kt(u, w) : /* @__PURE__ */ $h(h, w);
}
function Cj(e) {
  var t = wj(), r = em(), n = ha(), i = Og();
  return /* @__PURE__ */ x.createElement(Mj, xc({}, e, {
    coordinate: e.coordinate,
    index: e.index,
    payload: e.payload,
    offset: r,
    layout: n,
    tooltipAxisBandSize: t,
    chartName: i
  }));
}
var _g = /* @__PURE__ */ er(null), kj = () => Gr(_g), vu = { exports: {} }, Cv;
function Ij() {
  return Cv || (Cv = 1, (function(e) {
    var t = Object.prototype.hasOwnProperty, r = "~";
    function n() {
    }
    Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
    function i(c, s, l) {
      this.fn = c, this.context = s, this.once = l || !1;
    }
    function a(c, s, l, f, d) {
      if (typeof l != "function")
        throw new TypeError("The listener must be a function");
      var v = new i(l, f || c, d), h = r ? r + s : s;
      return c._events[h] ? c._events[h].fn ? c._events[h] = [c._events[h], v] : c._events[h].push(v) : (c._events[h] = v, c._eventsCount++), c;
    }
    function o(c, s) {
      --c._eventsCount === 0 ? c._events = new n() : delete c._events[s];
    }
    function u() {
      this._events = new n(), this._eventsCount = 0;
    }
    u.prototype.eventNames = function() {
      var s = [], l, f;
      if (this._eventsCount === 0) return s;
      for (f in l = this._events)
        t.call(l, f) && s.push(r ? f.slice(1) : f);
      return Object.getOwnPropertySymbols ? s.concat(Object.getOwnPropertySymbols(l)) : s;
    }, u.prototype.listeners = function(s) {
      var l = r ? r + s : s, f = this._events[l];
      if (!f) return [];
      if (f.fn) return [f.fn];
      for (var d = 0, v = f.length, h = new Array(v); d < v; d++)
        h[d] = f[d].fn;
      return h;
    }, u.prototype.listenerCount = function(s) {
      var l = r ? r + s : s, f = this._events[l];
      return f ? f.fn ? 1 : f.length : 0;
    }, u.prototype.emit = function(s, l, f, d, v, h) {
      var p = r ? r + s : s;
      if (!this._events[p]) return !1;
      var m = this._events[p], y = arguments.length, g, b;
      if (m.fn) {
        switch (m.once && this.removeListener(s, m.fn, void 0, !0), y) {
          case 1:
            return m.fn.call(m.context), !0;
          case 2:
            return m.fn.call(m.context, l), !0;
          case 3:
            return m.fn.call(m.context, l, f), !0;
          case 4:
            return m.fn.call(m.context, l, f, d), !0;
          case 5:
            return m.fn.call(m.context, l, f, d, v), !0;
          case 6:
            return m.fn.call(m.context, l, f, d, v, h), !0;
        }
        for (b = 1, g = new Array(y - 1); b < y; b++)
          g[b - 1] = arguments[b];
        m.fn.apply(m.context, g);
      } else {
        var O = m.length, w;
        for (b = 0; b < O; b++)
          switch (m[b].once && this.removeListener(s, m[b].fn, void 0, !0), y) {
            case 1:
              m[b].fn.call(m[b].context);
              break;
            case 2:
              m[b].fn.call(m[b].context, l);
              break;
            case 3:
              m[b].fn.call(m[b].context, l, f);
              break;
            case 4:
              m[b].fn.call(m[b].context, l, f, d);
              break;
            default:
              if (!g) for (w = 1, g = new Array(y - 1); w < y; w++)
                g[w - 1] = arguments[w];
              m[b].fn.apply(m[b].context, g);
          }
      }
      return !0;
    }, u.prototype.on = function(s, l, f) {
      return a(this, s, l, f, !1);
    }, u.prototype.once = function(s, l, f) {
      return a(this, s, l, f, !0);
    }, u.prototype.removeListener = function(s, l, f, d) {
      var v = r ? r + s : s;
      if (!this._events[v]) return this;
      if (!l)
        return o(this, v), this;
      var h = this._events[v];
      if (h.fn)
        h.fn === l && (!d || h.once) && (!f || h.context === f) && o(this, v);
      else {
        for (var p = 0, m = [], y = h.length; p < y; p++)
          (h[p].fn !== l || d && !h[p].once || f && h[p].context !== f) && m.push(h[p]);
        m.length ? this._events[v] = m.length === 1 ? m[0] : m : o(this, v);
      }
      return this;
    }, u.prototype.removeAllListeners = function(s) {
      var l;
      return s ? (l = r ? r + s : s, this._events[l] && o(this, l)) : (this._events = new n(), this._eventsCount = 0), this;
    }, u.prototype.off = u.prototype.removeListener, u.prototype.addListener = u.prototype.on, u.prefixed = r, u.EventEmitter = u, e.exports = u;
  })(vu)), vu.exports;
}
var Dj = Ij();
const Nj = /* @__PURE__ */ It(Dj);
var In = new Nj(), Oc = "recharts.syncEvent.tooltip", kv = "recharts.syncEvent.brush";
function jg(e, t) {
  if (t) {
    var r = Number.parseInt(t, 10);
    if (!Be(r))
      return e?.[r];
  }
}
var $j = {
  chartName: "",
  tooltipPayloadSearcher: void 0,
  eventEmitter: void 0,
  defaultTooltipEventType: "axis"
}, Tg = Ye({
  name: "options",
  initialState: $j,
  reducers: {
    createEventEmitter: (e) => {
      e.eventEmitter == null && (e.eventEmitter = /* @__PURE__ */ Symbol("rechartsEventEmitter"));
    }
  }
}), Rj = Tg.reducer, {
  createEventEmitter: Lj
} = Tg.actions;
function Bj(e) {
  return e.tooltip.syncInteraction;
}
var zj = {
  chartData: void 0,
  computedData: void 0,
  dataStartIndex: 0,
  dataEndIndex: 0
}, Mg = Ye({
  name: "chartData",
  initialState: zj,
  reducers: {
    setChartData(e, t) {
      if (e.chartData = t.payload, t.payload == null) {
        e.dataStartIndex = 0, e.dataEndIndex = 0;
        return;
      }
      t.payload.length > 0 && e.dataEndIndex !== t.payload.length - 1 && (e.dataEndIndex = t.payload.length - 1);
    },
    setComputedData(e, t) {
      e.computedData = t.payload;
    },
    setDataStartEndIndexes(e, t) {
      var {
        startIndex: r,
        endIndex: n
      } = t.payload;
      r != null && (e.dataStartIndex = r), n != null && (e.dataEndIndex = n);
    }
  }
}), {
  setChartData: Iv,
  setDataStartEndIndexes: qj
} = Mg.actions, Kj = Mg.reducer, Cg = () => {
};
function Fj() {
  var e = $(Ls), t = $(Bs), r = be(), n = $(my), i = $(Bt), a = ha(), o = as(), u = $((c) => c.rootProps.className);
  ae(() => {
    if (e == null)
      return Cg;
    var c = (s, l, f) => {
      if (t !== f && e === s) {
        if (n === "index") {
          r(l);
          return;
        }
        if (i != null) {
          var d;
          if (typeof n == "function") {
            var v = {
              activeTooltipIndex: l.payload.index == null ? void 0 : Number(l.payload.index),
              isTooltipActive: l.payload.active,
              activeIndex: l.payload.index == null ? void 0 : Number(l.payload.index),
              activeLabel: l.payload.label,
              activeDataKey: l.payload.dataKey,
              activeCoordinate: l.payload.coordinate
            }, h = n(i, v);
            d = i[h];
          } else n === "value" && (d = i.find((P) => String(P.value) === l.payload.label));
          var {
            coordinate: p
          } = l.payload;
          if (d == null || l.payload.active === !1 || p == null || o == null) {
            r(bc({
              active: !1,
              coordinate: void 0,
              dataKey: void 0,
              index: null,
              label: void 0
            }));
            return;
          }
          var {
            x: m,
            y
          } = p, g = Math.min(m, o.x + o.width), b = Math.min(y, o.y + o.height), O = {
            x: a === "horizontal" ? d.coordinate : g,
            y: a === "horizontal" ? b : d.coordinate
          }, w = bc({
            active: l.payload.active,
            coordinate: O,
            dataKey: l.payload.dataKey,
            index: String(d.index),
            label: l.payload.label
          });
          r(w);
        }
      }
    };
    return In.on(Oc, c), () => {
      In.off(Oc, c);
    };
  }, [u, r, t, e, n, i, a, o]);
}
function Wj() {
  var e = $(Ls), t = $(Bs), r = be();
  ae(() => {
    if (e == null)
      return Cg;
    var n = (i, a, o) => {
      t !== o && e === i && r(qj(a));
    };
    return In.on(kv, n), () => {
      In.off(kv, n);
    };
  }, [r, t, e]);
}
function Uj() {
  var e = be();
  ae(() => {
    e(Lj());
  }, [e]), Fj(), Wj();
}
function Vj(e, t, r, n, i, a) {
  var o = $((d) => Oj(d, e, t)), u = $(Bs), c = $(Ls), s = $(my), l = $(Bj), f = l?.active;
  ae(() => {
    if (!f && c != null && u != null) {
      var d = bc({
        active: a,
        coordinate: r,
        dataKey: o,
        index: i,
        label: typeof n == "number" ? String(n) : n
      });
      In.emit(Oc, c, d, u);
    }
  }, [f, r, o, i, n, u, c, s, a]);
}
function Dv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Nv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Dv(Object(r), !0).forEach(function(n) {
      Hj(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Dv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Hj(e, t, r) {
  return (t = Gj(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Gj(e) {
  var t = Yj(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Yj(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Xj(e) {
  return e.dataKey;
}
function Zj(e, t) {
  return /* @__PURE__ */ x.isValidElement(e) ? /* @__PURE__ */ x.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ x.createElement(e, t) : /* @__PURE__ */ x.createElement(P1, t);
}
var $v = [], Jj = {
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  axisId: 0,
  contentStyle: {},
  cursor: !0,
  filterNull: !0,
  isAnimationActive: !Zr.isSsr,
  itemSorter: "name",
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  wrapperStyle: {}
};
function Qj(e) {
  var t = bt(e, Jj), {
    active: r,
    allowEscapeViewBox: n,
    animationDuration: i,
    animationEasing: a,
    content: o,
    filterNull: u,
    isAnimationActive: c,
    offset: s,
    payloadUniqBy: l,
    position: f,
    reverseDirection: d,
    useTranslate3d: v,
    wrapperStyle: h,
    cursor: p,
    shared: m,
    trigger: y,
    defaultIndex: g,
    portal: b,
    axisId: O
  } = t, w = be(), P = typeof g == "number" ? String(g) : g;
  ae(() => {
    w(__({
      shared: m,
      trigger: y,
      axisId: O,
      active: r,
      defaultIndex: P
    }));
  }, [w, m, y, O, r, P]);
  var A = as(), _ = cm(), T = O_(m), {
    activeIndex: N,
    isActive: j
  } = $((De) => Sj(De, T, y, P)), C = $((De) => Aj(De, T, y, P)), z = $((De) => Eg(De, T, y, P)), K = $((De) => Pj(De, T, y, P)), J = C, se = kj(), ne = r ?? j, [Ce, he] = Op([J, ne]), zt = T === "axis" ? z : void 0;
  Vj(T, y, K, zt, N, ne);
  var qt = b ?? se;
  if (qt == null)
    return null;
  var L = J ?? $v;
  ne || (L = $v), u && L.length && (L = yp(J.filter((De) => De.value != null && (De.hide !== !0 || t.includeHidden)), l, Xj));
  var on = L.length > 0, un = /* @__PURE__ */ x.createElement(M1, {
    allowEscapeViewBox: n,
    animationDuration: i,
    animationEasing: a,
    isAnimationActive: c,
    active: ne,
    coordinate: K,
    hasPayload: on,
    offset: s,
    position: f,
    reverseDirection: d,
    useTranslate3d: v,
    viewBox: A,
    wrapperStyle: h,
    lastBoundingBox: Ce,
    innerRef: he,
    hasPortalFromProps: !!b
  }, Zj(o, Nv(Nv({}, t), {}, {
    // @ts-expect-error renderContent method expects the payload to be mutable, TODO make it immutable
    payload: L,
    label: zt,
    active: ne,
    coordinate: K,
    accessibilityLayer: _
  })));
  return /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ Lh(un, qt), ne && /* @__PURE__ */ x.createElement(Cj, {
    cursor: p,
    tooltipEventType: T,
    coordinate: K,
    payload: J,
    index: N
  }));
}
var hu = {}, pu = {}, mu = {}, Rv;
function eT() {
  return Rv || (Rv = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r, n, { signal: i, edges: a } = {}) {
      let o, u = null;
      const c = a != null && a.includes("leading"), s = a == null || a.includes("trailing"), l = () => {
        u !== null && (r.apply(o, u), o = void 0, u = null);
      }, f = () => {
        s && l(), p();
      };
      let d = null;
      const v = () => {
        d != null && clearTimeout(d), d = setTimeout(() => {
          d = null, f();
        }, n);
      }, h = () => {
        d !== null && (clearTimeout(d), d = null);
      }, p = () => {
        h(), o = void 0, u = null;
      }, m = () => {
        l();
      }, y = function(...g) {
        if (i?.aborted)
          return;
        o = this, u = g;
        const b = d == null;
        v(), c && b && l();
      };
      return y.schedule = v, y.cancel = p, y.flush = m, i?.addEventListener("abort", p, { once: !0 }), y;
    }
    e.debounce = t;
  })(mu)), mu;
}
var Lv;
function tT() {
  return Lv || (Lv = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ eT();
    function r(n, i = 0, a = {}) {
      typeof a != "object" && (a = {});
      const { leading: o = !1, trailing: u = !0, maxWait: c } = a, s = Array(2);
      o && (s[0] = "leading"), u && (s[1] = "trailing");
      let l, f = null;
      const d = t.debounce(function(...p) {
        l = n.apply(this, p), f = null;
      }, i, { edges: s }), v = function(...p) {
        return c != null && (f === null && (f = Date.now()), Date.now() - f >= c) ? (l = n.apply(this, p), f = Date.now(), d.cancel(), d.schedule(), l) : (d.apply(this, p), l);
      }, h = () => (d.flush(), l);
      return v.cancel = d.cancel, v.flush = h, v;
    }
    e.debounce = r;
  })(pu)), pu;
}
var Bv;
function rT() {
  return Bv || (Bv = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ tT();
    function r(n, i = 0, a = {}) {
      const { leading: o = !0, trailing: u = !0 } = a;
      return t.debounce(n, i, {
        leading: o,
        maxWait: i,
        trailing: u
      });
    }
    e.throttle = r;
  })(hu)), hu;
}
var yu, zv;
function nT() {
  return zv || (zv = 1, yu = rT().throttle), yu;
}
var iT = /* @__PURE__ */ nT();
const aT = /* @__PURE__ */ It(iT);
var oT = process.env.NODE_ENV !== "production", gn = function(t, r) {
  for (var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++)
    i[a - 2] = arguments[a];
  if (oT && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var o = 0;
      console.warn(r.replace(/%s/g, () => i[o++]));
    }
};
function qv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function gu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qv(Object(r), !0).forEach(function(n) {
      uT(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : qv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function uT(e, t, r) {
  return (t = cT(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function cT(e) {
  var t = sT(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function sT(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var lT = /* @__PURE__ */ gt((e, t) => {
  var {
    aspect: r,
    initialDimension: n = {
      width: -1,
      height: -1
    },
    width: i = "100%",
    height: a = "100%",
    /*
     * default min-width to 0 if not specified - 'auto' causes issues with flexbox
     * https://github.com/recharts/recharts/issues/172
     */
    minWidth: o = 0,
    minHeight: u,
    maxHeight: c,
    children: s,
    debounce: l = 0,
    id: f,
    className: d,
    onResize: v,
    style: h = {}
  } = e, p = it(null), m = it();
  m.current = v, Db(t, () => p.current);
  var [y, g] = ct({
    containerWidth: n.width,
    containerHeight: n.height
  }), b = oe((w, P) => {
    g((A) => {
      var _ = Math.round(w), T = Math.round(P);
      return A.containerWidth === _ && A.containerHeight === T ? A : {
        containerWidth: _,
        containerHeight: T
      };
    });
  }, []);
  ae(() => {
    var w = (T) => {
      var N, {
        width: j,
        height: C
      } = T[0].contentRect;
      b(j, C), (N = m.current) === null || N === void 0 || N.call(m, j, C);
    };
    l > 0 && (w = aT(w, l, {
      trailing: !0,
      leading: !1
    }));
    var P = new ResizeObserver(w), {
      width: A,
      height: _
    } = p.current.getBoundingClientRect();
    return b(A, _), P.observe(p.current), () => {
      P.disconnect();
    };
  }, [b, l]);
  var O = na(() => {
    var {
      containerWidth: w,
      containerHeight: P
    } = y;
    if (w < 0 || P < 0)
      return null;
    gn(sr(i) || sr(a), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, i, a), gn(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
    var A = sr(i) ? w : i, _ = sr(a) ? P : a;
    return r && r > 0 && (A ? _ = A / r : _ && (A = _ * r), c && _ > c && (_ = c)), gn(A > 0 || _ > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, A, _, i, a, o, u, r), x.Children.map(s, (T) => /* @__PURE__ */ kt(T, {
      width: A,
      height: _,
      // calculate the actual size and override it.
      style: gu({
        width: A,
        height: _
      }, T.props.style)
    }));
  }, [r, s, a, c, u, o, y, i]);
  return /* @__PURE__ */ x.createElement("div", {
    id: f ? "".concat(f) : void 0,
    className: G("recharts-responsive-container", d),
    style: gu(gu({}, h), {}, {
      width: i,
      height: a,
      minWidth: o,
      minHeight: u,
      maxHeight: c
    }),
    ref: p
  }, /* @__PURE__ */ x.createElement("div", {
    style: {
      width: 0,
      height: 0,
      overflow: "visible"
    }
  }, O));
}), kg = (e) => null;
kg.displayName = "Cell";
function fT(e, t, r) {
  return (t = dT(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function dT(e) {
  var t = vT(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function vT(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class hT {
  constructor(t) {
    fT(this, "cache", /* @__PURE__ */ new Map()), this.maxSize = t;
  }
  get(t) {
    var r = this.cache.get(t);
    return r !== void 0 && (this.cache.delete(t), this.cache.set(t, r)), r;
  }
  set(t, r) {
    if (this.cache.has(t))
      this.cache.delete(t);
    else if (this.cache.size >= this.maxSize) {
      var n = this.cache.keys().next().value;
      this.cache.delete(n);
    }
    this.cache.set(t, r);
  }
  clear() {
    this.cache.clear();
  }
  size() {
    return this.cache.size;
  }
}
function Kv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pT(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Kv(Object(r), !0).forEach(function(n) {
      mT(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Kv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function mT(e, t, r) {
  return (t = yT(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function yT(e) {
  var t = gT(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function gT(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var bT = {
  cacheSize: 2e3,
  enableCache: !0
}, Ig = pT({}, bT), Fv = new hT(Ig.cacheSize), wT = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, Wv = "recharts_measurement_span";
function xT(e, t) {
  var r = t.fontSize || "", n = t.fontFamily || "", i = t.fontWeight || "", a = t.fontStyle || "", o = t.letterSpacing || "", u = t.textTransform || "";
  return "".concat(e, "|").concat(r, "|").concat(n, "|").concat(i, "|").concat(a, "|").concat(o, "|").concat(u);
}
var Uv = (e, t) => {
  try {
    var r = document.getElementById(Wv);
    r || (r = document.createElement("span"), r.setAttribute("id", Wv), r.setAttribute("aria-hidden", "true"), document.body.appendChild(r)), Object.assign(r.style, wT, t), r.textContent = "".concat(e);
    var n = r.getBoundingClientRect();
    return {
      width: n.width,
      height: n.height
    };
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, bn = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || Zr.isSsr)
    return {
      width: 0,
      height: 0
    };
  if (!Ig.enableCache)
    return Uv(t, r);
  var n = xT(t, r), i = Fv.get(n);
  if (i)
    return i;
  var a = Uv(t, r);
  return Fv.set(n, a), a;
}, Vv = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, Hv = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, OT = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, PT = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, Dg = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, AT = Object.keys(Dg), Cr = "NaN";
function ST(e, t) {
  return e * Dg[t];
}
class Ne {
  static parse(t) {
    var r, [, n, i] = (r = PT.exec(t)) !== null && r !== void 0 ? r : [];
    return new Ne(parseFloat(n), i ?? "");
  }
  constructor(t, r) {
    this.num = t, this.unit = r, this.num = t, this.unit = r, Be(t) && (this.unit = ""), r !== "" && !OT.test(r) && (this.num = NaN, this.unit = ""), AT.includes(r) && (this.num = ST(t, r), this.unit = "px");
  }
  add(t) {
    return this.unit !== t.unit ? new Ne(NaN, "") : new Ne(this.num + t.num, this.unit);
  }
  subtract(t) {
    return this.unit !== t.unit ? new Ne(NaN, "") : new Ne(this.num - t.num, this.unit);
  }
  multiply(t) {
    return this.unit !== "" && t.unit !== "" && this.unit !== t.unit ? new Ne(NaN, "") : new Ne(this.num * t.num, this.unit || t.unit);
  }
  divide(t) {
    return this.unit !== "" && t.unit !== "" && this.unit !== t.unit ? new Ne(NaN, "") : new Ne(this.num / t.num, this.unit || t.unit);
  }
  toString() {
    return "".concat(this.num).concat(this.unit);
  }
  isNaN() {
    return Be(this.num);
  }
}
function Ng(e) {
  if (e.includes(Cr))
    return Cr;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var r, [, n, i, a] = (r = Vv.exec(t)) !== null && r !== void 0 ? r : [], o = Ne.parse(n ?? ""), u = Ne.parse(a ?? ""), c = i === "*" ? o.multiply(u) : o.divide(u);
    if (c.isNaN())
      return Cr;
    t = t.replace(Vv, c.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var s, [, l, f, d] = (s = Hv.exec(t)) !== null && s !== void 0 ? s : [], v = Ne.parse(l ?? ""), h = Ne.parse(d ?? ""), p = f === "+" ? v.add(h) : v.subtract(h);
    if (p.isNaN())
      return Cr;
    t = t.replace(Hv, p.toString());
  }
  return t;
}
var Gv = /\(([^()]*)\)/;
function ET(e) {
  for (var t = e, r; (r = Gv.exec(t)) != null; ) {
    var [, n] = r;
    t = t.replace(Gv, Ng(n));
  }
  return t;
}
function _T(e) {
  var t = e.replace(/\s+/g, "");
  return t = ET(t), t = Ng(t), t;
}
function jT(e) {
  try {
    return _T(e);
  } catch {
    return Cr;
  }
}
function bu(e) {
  var t = jT(e.slice(5, -1));
  return t === Cr ? "" : t;
}
var TT = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], MT = ["dx", "dy", "angle", "className", "breakAll"];
function Pc() {
  return Pc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pc.apply(null, arguments);
}
function Yv(e, t) {
  if (e == null) return {};
  var r, n, i = CT(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function CT(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var $g = /[ \f\n\r\t\v\u2028\u2029]+/, Rg = (e) => {
  var {
    children: t,
    breakAll: r,
    style: n
  } = e;
  try {
    var i = [];
    te(t) || (r ? i = t.toString().split("") : i = t.toString().split($g));
    var a = i.map((u) => ({
      word: u,
      width: bn(u, n).width
    })), o = r ? 0 : bn(" ", n).width;
    return {
      wordsWithComputedWidth: a,
      spaceWidth: o
    };
  } catch {
    return null;
  }
}, kT = (e, t, r, n, i) => {
  var {
    maxLines: a,
    children: o,
    style: u,
    breakAll: c
  } = e, s = k(a), l = o, f = function() {
    var j = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return j.reduce((C, z) => {
      var {
        word: K,
        width: J
      } = z, se = C[C.length - 1];
      if (se && (n == null || i || se.width + J + r < Number(n)))
        se.words.push(K), se.width += J + r;
      else {
        var ne = {
          words: [K],
          width: J
        };
        C.push(ne);
      }
      return C;
    }, []);
  }, d = f(t), v = (N) => N.reduce((j, C) => j.width > C.width ? j : C);
  if (!s || i)
    return d;
  var h = d.length > a || v(d).width > Number(n);
  if (!h)
    return d;
  for (var p = "…", m = (N) => {
    var j = l.slice(0, N), C = Rg({
      breakAll: c,
      style: u,
      children: j + p
    }).wordsWithComputedWidth, z = f(C), K = z.length > a || v(z).width > Number(n);
    return [K, z];
  }, y = 0, g = l.length - 1, b = 0, O; y <= g && b <= l.length - 1; ) {
    var w = Math.floor((y + g) / 2), P = w - 1, [A, _] = m(P), [T] = m(w);
    if (!A && !T && (y = w + 1), A && T && (g = w - 1), !A && T) {
      O = _;
      break;
    }
    b++;
  }
  return O || d;
}, Xv = (e) => {
  var t = te(e) ? [] : e.toString().split($g);
  return [{
    words: t
  }];
}, IT = (e) => {
  var {
    width: t,
    scaleToFit: r,
    children: n,
    style: i,
    breakAll: a,
    maxLines: o
  } = e;
  if ((t || r) && !Zr.isSsr) {
    var u, c, s = Rg({
      breakAll: a,
      children: n,
      style: i
    });
    if (s) {
      var {
        wordsWithComputedWidth: l,
        spaceWidth: f
      } = s;
      u = l, c = f;
    } else
      return Xv(n);
    return kT({
      breakAll: a,
      children: n,
      maxLines: o,
      style: i
    }, u, c, t, r);
  }
  return Xv(n);
}, Zv = "#808080", ol = /* @__PURE__ */ gt((e, t) => {
  var {
    x: r = 0,
    y: n = 0,
    lineHeight: i = "1em",
    // Magic number from d3
    capHeight: a = "0.71em",
    scaleToFit: o = !1,
    textAnchor: u = "start",
    // Maintain compat with existing charts / default SVG behavior
    verticalAnchor: c = "end",
    fill: s = Zv
  } = e, l = Yv(e, TT), f = na(() => IT({
    breakAll: l.breakAll,
    children: l.children,
    maxLines: l.maxLines,
    scaleToFit: o,
    style: l.style,
    width: l.width
  }), [l.breakAll, l.children, l.maxLines, o, l.style, l.width]), {
    dx: d,
    dy: v,
    angle: h,
    className: p,
    breakAll: m
  } = l, y = Yv(l, MT);
  if (!mt(r) || !mt(n))
    return null;
  var g = r + (k(d) ? d : 0), b = n + (k(v) ? v : 0), O;
  switch (c) {
    case "start":
      O = bu("calc(".concat(a, ")"));
      break;
    case "middle":
      O = bu("calc(".concat((f.length - 1) / 2, " * -").concat(i, " + (").concat(a, " / 2))"));
      break;
    default:
      O = bu("calc(".concat(f.length - 1, " * -").concat(i, ")"));
      break;
  }
  var w = [];
  if (o) {
    var P = f[0].width, {
      width: A
    } = l;
    w.push("scale(".concat(k(A) ? A / P : 1, ")"));
  }
  return h && w.push("rotate(".concat(h, ", ").concat(g, ", ").concat(b, ")")), w.length && (y.transform = w.join(" ")), /* @__PURE__ */ x.createElement("text", Pc({}, ie(y, !0), {
    ref: t,
    x: g,
    y: b,
    className: G("recharts-text", p),
    textAnchor: u,
    fill: s.includes("url") ? Zv : s
  }), f.map((_, T) => {
    var N = _.words.join(m ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ x.createElement("tspan", {
        x: g,
        dy: T === 0 ? O : i,
        key: "".concat(N, "-").concat(T)
      }, N)
    );
  }));
});
ol.displayName = "Text";
var DT = ["offset"], NT = ["labelRef"];
function Jv(e, t) {
  if (e == null) return {};
  var r, n, i = $T(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function $T(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function Qv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function re(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Qv(Object(r), !0).forEach(function(n) {
      RT(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Qv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function RT(e, t, r) {
  return (t = LT(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function LT(e) {
  var t = BT(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function BT(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ot() {
  return Ot = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ot.apply(null, arguments);
}
var zT = (e) => {
  var {
    value: t,
    formatter: r
  } = e, n = te(e.children) ? t : e.children;
  return typeof r == "function" ? r(n) : n;
}, Lg = (e) => e != null && typeof e == "function", qT = (e, t) => {
  var r = Re(t - e), n = Math.min(Math.abs(t - e), 360);
  return r * n;
}, KT = (e, t, r, n) => {
  var {
    position: i,
    offset: a,
    className: o
  } = e, {
    cx: u,
    cy: c,
    innerRadius: s,
    outerRadius: l,
    startAngle: f,
    endAngle: d,
    clockWise: v
  } = n, h = (s + l) / 2, p = qT(f, d), m = p >= 0 ? 1 : -1, y, g;
  i === "insideStart" ? (y = f + m * a, g = v) : i === "insideEnd" ? (y = d - m * a, g = !v) : i === "end" && (y = d + m * a, g = v), g = p <= 0 ? g : !g;
  var b = Pe(u, c, h, y), O = Pe(u, c, h, y + (g ? 1 : -1) * 359), w = "M".concat(b.x, ",").concat(b.y, `
    A`).concat(h, ",").concat(h, ",0,1,").concat(g ? 0 : 1, `,
    `).concat(O.x, ",").concat(O.y), P = te(e.id) ? wn("recharts-radial-line-") : e.id;
  return /* @__PURE__ */ x.createElement("text", Ot({}, r, {
    dominantBaseline: "central",
    className: G("recharts-radial-bar-label", o)
  }), /* @__PURE__ */ x.createElement("defs", null, /* @__PURE__ */ x.createElement("path", {
    id: P,
    d: w
  })), /* @__PURE__ */ x.createElement("textPath", {
    xlinkHref: "#".concat(P)
  }, t));
}, FT = (e, t, r) => {
  var {
    cx: n,
    cy: i,
    innerRadius: a,
    outerRadius: o,
    startAngle: u,
    endAngle: c
  } = e, s = (u + c) / 2;
  if (r === "outside") {
    var {
      x: l,
      y: f
    } = Pe(n, i, o + t, s);
    return {
      x: l,
      y: f,
      textAnchor: l >= n ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (r === "center")
    return {
      x: n,
      y: i,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (r === "centerTop")
    return {
      x: n,
      y: i,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (r === "centerBottom")
    return {
      x: n,
      y: i,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var d = (a + o) / 2, {
    x: v,
    y: h
  } = Pe(n, i, d, s);
  return {
    x: v,
    y: h,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, WT = (e, t) => {
  var {
    parentViewBox: r,
    offset: n,
    position: i
  } = e, {
    x: a,
    y: o,
    width: u,
    height: c
  } = t, s = c >= 0 ? 1 : -1, l = s * n, f = s > 0 ? "end" : "start", d = s > 0 ? "start" : "end", v = u >= 0 ? 1 : -1, h = v * n, p = v > 0 ? "end" : "start", m = v > 0 ? "start" : "end";
  if (i === "top") {
    var y = {
      x: a + u / 2,
      y: o - s * n,
      textAnchor: "middle",
      verticalAnchor: f
    };
    return re(re({}, y), r ? {
      height: Math.max(o - r.y, 0),
      width: u
    } : {});
  }
  if (i === "bottom") {
    var g = {
      x: a + u / 2,
      y: o + c + l,
      textAnchor: "middle",
      verticalAnchor: d
    };
    return re(re({}, g), r ? {
      height: Math.max(r.y + r.height - (o + c), 0),
      width: u
    } : {});
  }
  if (i === "left") {
    var b = {
      x: a - h,
      y: o + c / 2,
      textAnchor: p,
      verticalAnchor: "middle"
    };
    return re(re({}, b), r ? {
      width: Math.max(b.x - r.x, 0),
      height: c
    } : {});
  }
  if (i === "right") {
    var O = {
      x: a + u + h,
      y: o + c / 2,
      textAnchor: m,
      verticalAnchor: "middle"
    };
    return re(re({}, O), r ? {
      width: Math.max(r.x + r.width - O.x, 0),
      height: c
    } : {});
  }
  var w = r ? {
    width: u,
    height: c
  } : {};
  return i === "insideLeft" ? re({
    x: a + h,
    y: o + c / 2,
    textAnchor: m,
    verticalAnchor: "middle"
  }, w) : i === "insideRight" ? re({
    x: a + u - h,
    y: o + c / 2,
    textAnchor: p,
    verticalAnchor: "middle"
  }, w) : i === "insideTop" ? re({
    x: a + u / 2,
    y: o + l,
    textAnchor: "middle",
    verticalAnchor: d
  }, w) : i === "insideBottom" ? re({
    x: a + u / 2,
    y: o + c - l,
    textAnchor: "middle",
    verticalAnchor: f
  }, w) : i === "insideTopLeft" ? re({
    x: a + h,
    y: o + l,
    textAnchor: m,
    verticalAnchor: d
  }, w) : i === "insideTopRight" ? re({
    x: a + u - h,
    y: o + l,
    textAnchor: p,
    verticalAnchor: d
  }, w) : i === "insideBottomLeft" ? re({
    x: a + h,
    y: o + c - l,
    textAnchor: m,
    verticalAnchor: f
  }, w) : i === "insideBottomRight" ? re({
    x: a + u - h,
    y: o + c - l,
    textAnchor: p,
    verticalAnchor: f
  }, w) : i && typeof i == "object" && (k(i.x) || sr(i.x)) && (k(i.y) || sr(i.y)) ? re({
    x: a + st(i.x, u),
    y: o + st(i.y, c),
    textAnchor: "end",
    verticalAnchor: "end"
  }, w) : re({
    x: a + u / 2,
    y: o + c / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, w);
}, UT = (e) => "cx" in e && k(e.cx);
function We(e) {
  var {
    offset: t = 5
  } = e, r = Jv(e, DT), n = re({
    offset: t
  }, r), {
    viewBox: i,
    position: a,
    value: o,
    children: u,
    content: c,
    className: s = "",
    textBreakAll: l,
    labelRef: f
  } = n, d = $(xy), v = as(), h = a === "center" ? v : d ?? v, p = i || h;
  if (!p || te(o) && te(u) && !/* @__PURE__ */ vt(c) && typeof c != "function")
    return null;
  var m = re(re({}, n), {}, {
    viewBox: p
  });
  if (/* @__PURE__ */ vt(c)) {
    var {
      labelRef: y
    } = m, g = Jv(m, NT);
    return /* @__PURE__ */ kt(c, g);
  }
  var b;
  if (typeof c == "function") {
    if (b = /* @__PURE__ */ $h(c, m), /* @__PURE__ */ vt(b))
      return b;
  } else
    b = zT(n);
  var O = UT(p), w = ie(n, !0);
  if (O && (a === "insideStart" || a === "insideEnd" || a === "end"))
    return KT(n, b, w, p);
  var P = O ? FT(p, n.offset, n.position) : WT(n, p);
  return /* @__PURE__ */ x.createElement(ol, Ot({
    ref: f,
    className: G("recharts-label", s)
  }, w, P, {
    breakAll: l
  }), b);
}
We.displayName = "Label";
var Bg = (e) => {
  var {
    cx: t,
    cy: r,
    angle: n,
    startAngle: i,
    endAngle: a,
    r: o,
    radius: u,
    innerRadius: c,
    outerRadius: s,
    x: l,
    y: f,
    top: d,
    left: v,
    width: h,
    height: p,
    clockWise: m,
    labelViewBox: y
  } = e;
  if (y)
    return y;
  if (k(h) && k(p)) {
    if (k(l) && k(f))
      return {
        x: l,
        y: f,
        width: h,
        height: p
      };
    if (k(d) && k(v))
      return {
        x: d,
        y: v,
        width: h,
        height: p
      };
  }
  if (k(l) && k(f))
    return {
      x: l,
      y: f,
      width: 0,
      height: 0
    };
  if (k(t) && k(r))
    return {
      cx: t,
      cy: r,
      startAngle: i || n || 0,
      endAngle: a || n || 0,
      innerRadius: c || 0,
      outerRadius: s || u || o || 0,
      clockWise: m
    };
  if (e.viewBox)
    return e.viewBox;
}, VT = (e, t, r) => {
  if (!e)
    return null;
  var n = {
    viewBox: t,
    labelRef: r
  };
  return e === !0 ? /* @__PURE__ */ x.createElement(We, Ot({
    key: "label-implicit"
  }, n)) : mt(e) ? /* @__PURE__ */ x.createElement(We, Ot({
    key: "label-implicit",
    value: e
  }, n)) : /* @__PURE__ */ vt(e) ? e.type === We ? /* @__PURE__ */ kt(e, re({
    key: "label-implicit"
  }, n)) : /* @__PURE__ */ x.createElement(We, Ot({
    key: "label-implicit",
    content: e
  }, n)) : Lg(e) ? /* @__PURE__ */ x.createElement(We, Ot({
    key: "label-implicit",
    content: e
  }, n)) : e && typeof e == "object" ? /* @__PURE__ */ x.createElement(We, Ot({}, e, {
    key: "label-implicit"
  }, n)) : null;
}, HT = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && n && !t.label)
    return null;
  var {
    children: i,
    labelRef: a
  } = t, o = Bg(t), u = Dc(i, We).map((s, l) => /* @__PURE__ */ kt(s, {
    viewBox: r || o,
    // eslint-disable-next-line react/no-array-index-key
    key: "label-".concat(l)
  }));
  if (!n)
    return u;
  var c = VT(t.label, r || o, a);
  return [c, ...u];
};
We.parseViewBox = Bg;
We.renderCallByParent = HT;
var wu = {}, xu = {}, eh;
function GT() {
  return eh || (eh = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      return r[r.length - 1];
    }
    e.last = t;
  })(xu)), xu;
}
var Ou = {}, th;
function YT() {
  return th || (th = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      return Array.isArray(r) ? r : Array.from(r);
    }
    e.toArray = t;
  })(Ou)), Ou;
}
var rh;
function XT() {
  return rh || (rh = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    const t = /* @__PURE__ */ GT(), r = /* @__PURE__ */ YT(), n = /* @__PURE__ */ Kc();
    function i(a) {
      if (n.isArrayLike(a))
        return t.last(r.toArray(a));
    }
    e.last = i;
  })(wu)), wu;
}
var Pu, nh;
function ZT() {
  return nh || (nh = 1, Pu = XT().last), Pu;
}
var JT = /* @__PURE__ */ ZT();
const QT = /* @__PURE__ */ It(JT);
var eM = ["valueAccessor"], tM = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function Yi() {
  return Yi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Yi.apply(null, arguments);
}
function ih(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ah(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ih(Object(r), !0).forEach(function(n) {
      rM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ih(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function rM(e, t, r) {
  return (t = nM(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function nM(e) {
  var t = iM(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function iM(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function oh(e, t) {
  if (e == null) return {};
  var r, n, i = aM(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function aM(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var oM = (e) => Array.isArray(e.value) ? QT(e.value) : e.value;
function Xt(e) {
  var {
    valueAccessor: t = oM
  } = e, r = oh(e, eM), {
    data: n,
    dataKey: i,
    clockWise: a,
    id: o,
    textBreakAll: u
  } = r, c = oh(r, tM);
  return !n || !n.length ? null : /* @__PURE__ */ x.createElement(ze, {
    className: "recharts-label-list"
  }, n.map((s, l) => {
    var f = te(i) ? t(s, l) : ge(s && s.payload, i), d = te(o) ? {} : {
      id: "".concat(o, "-").concat(l)
    };
    return /* @__PURE__ */ x.createElement(We, Yi({}, ie(s, !0), c, d, {
      parentViewBox: s.parentViewBox,
      value: f,
      textBreakAll: u,
      viewBox: We.parseViewBox(te(a) ? s : ah(ah({}, s), {}, {
        clockWise: a
      })),
      key: "label-".concat(l),
      index: l
    }));
  }));
}
Xt.displayName = "LabelList";
function uM(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ x.createElement(Xt, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ x.isValidElement(e) || Lg(e) ? /* @__PURE__ */ x.createElement(Xt, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : typeof e == "object" ? /* @__PURE__ */ x.createElement(Xt, Yi({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function cM(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && r && !e.label)
    return null;
  var {
    children: n
  } = e, i = Dc(n, Xt).map((o, u) => /* @__PURE__ */ kt(o, {
    data: t,
    // eslint-disable-next-line react/no-array-index-key
    key: "labelList-".concat(u)
  }));
  if (!r)
    return i;
  var a = uM(e.label, t);
  return [a, ...i];
}
Xt.renderCallByParent = cM;
function Ac() {
  return Ac = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ac.apply(null, arguments);
}
var zg = (e) => {
  var {
    cx: t,
    cy: r,
    r: n,
    className: i
  } = e, a = G("recharts-dot", i);
  return t === +t && r === +r && n === +n ? /* @__PURE__ */ x.createElement("circle", Ac({}, tr(e), Ic(e), {
    className: a,
    cx: t,
    cy: r,
    r: n
  })) : null;
}, sM = {
  radiusAxis: {},
  angleAxis: {}
}, lM = Ye({
  name: "polarAxis",
  initialState: sM,
  reducers: {
    addRadiusAxis(e, t) {
      e.radiusAxis[t.payload.id] = t.payload;
    },
    removeRadiusAxis(e, t) {
      delete e.radiusAxis[t.payload.id];
    },
    addAngleAxis(e, t) {
      e.angleAxis[t.payload.id] = t.payload;
    },
    removeAngleAxis(e, t) {
      delete e.angleAxis[t.payload.id];
    }
  }
}), fM = lM.reducer, Au = {}, uh;
function dM() {
  return uh || (uh = 1, (function(e) {
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
    function t(r) {
      if (typeof r != "object" || r == null)
        return !1;
      if (Object.getPrototypeOf(r) === null)
        return !0;
      if (Object.prototype.toString.call(r) !== "[object Object]") {
        const i = r[Symbol.toStringTag];
        return i == null || !Object.getOwnPropertyDescriptor(r, Symbol.toStringTag)?.writable ? !1 : r.toString() === `[object ${i}]`;
      }
      let n = r;
      for (; Object.getPrototypeOf(n) !== null; )
        n = Object.getPrototypeOf(n);
      return Object.getPrototypeOf(r) === n;
    }
    e.isPlainObject = t;
  })(Au)), Au;
}
var Su, ch;
function vM() {
  return ch || (ch = 1, Su = dM().isPlainObject), Su;
}
var hM = /* @__PURE__ */ vM();
const pM = /* @__PURE__ */ It(hM);
function Xi() {
  return Xi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xi.apply(null, arguments);
}
var sh = (e, t, r, n, i) => {
  var a = r - n, o;
  return o = "M ".concat(e, ",").concat(t), o += "L ".concat(e + r, ",").concat(t), o += "L ".concat(e + r - a / 2, ",").concat(t + i), o += "L ".concat(e + r - a / 2 - n, ",").concat(t + i), o += "L ".concat(e, ",").concat(t, " Z"), o;
}, mM = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, yM = (e) => {
  var t = bt(e, mM), r = it(), [n, i] = ct(-1);
  ae(() => {
    if (r.current && r.current.getTotalLength)
      try {
        var m = r.current.getTotalLength();
        m && i(m);
      } catch {
      }
  }, []);
  var {
    x: a,
    y: o,
    upperWidth: u,
    lowerWidth: c,
    height: s,
    className: l
  } = t, {
    animationEasing: f,
    animationDuration: d,
    animationBegin: v,
    isUpdateAnimationActive: h
  } = t;
  if (a !== +a || o !== +o || u !== +u || c !== +c || s !== +s || u === 0 && c === 0 || s === 0)
    return null;
  var p = G("recharts-trapezoid", l);
  return h ? /* @__PURE__ */ x.createElement(Di, {
    canBegin: n > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: s,
      x: a,
      y: o
    },
    to: {
      upperWidth: u,
      lowerWidth: c,
      height: s,
      x: a,
      y: o
    },
    duration: d,
    animationEasing: f,
    isActive: h
  }, (m) => {
    var {
      upperWidth: y,
      lowerWidth: g,
      height: b,
      x: O,
      y: w
    } = m;
    return /* @__PURE__ */ x.createElement(Di, {
      canBegin: n > 0,
      from: "0px ".concat(n === -1 ? 1 : n, "px"),
      to: "".concat(n, "px 0px"),
      attributeName: "strokeDasharray",
      begin: v,
      duration: d,
      easing: f
    }, /* @__PURE__ */ x.createElement("path", Xi({}, ie(t, !0), {
      className: p,
      d: sh(O, w, y, g, b),
      ref: r
    })));
  }) : /* @__PURE__ */ x.createElement("g", null, /* @__PURE__ */ x.createElement("path", Xi({}, ie(t, !0), {
    className: p,
    d: sh(a, o, u, c, s)
  })));
}, gM = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function bM(e, t) {
  if (e == null) return {};
  var r, n, i = wM(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function wM(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function lh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Zi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? lh(Object(r), !0).forEach(function(n) {
      xM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : lh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function xM(e, t, r) {
  return (t = OM(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function OM(e) {
  var t = PM(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function PM(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function AM(e, t) {
  return Zi(Zi({}, t), e);
}
function SM(e, t) {
  return e === "symbols";
}
function fh(e) {
  var {
    shapeType: t,
    elementProps: r
  } = e;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ x.createElement(pm, r);
    case "trapezoid":
      return /* @__PURE__ */ x.createElement(yM, r);
    case "sector":
      return /* @__PURE__ */ x.createElement(gm, r);
    case "symbols":
      if (SM(t))
        return /* @__PURE__ */ x.createElement(Bc, r);
      break;
    default:
      return null;
  }
}
function EM(e) {
  return /* @__PURE__ */ vt(e) ? e.props : e;
}
function _M(e) {
  var {
    option: t,
    shapeType: r,
    propTransformer: n = AM,
    activeClassName: i = "recharts-active-shape",
    isActive: a
  } = e, o = bM(e, gM), u;
  if (/* @__PURE__ */ vt(t))
    u = /* @__PURE__ */ kt(t, Zi(Zi({}, o), EM(t)));
  else if (typeof t == "function")
    u = t(o);
  else if (pM(t) && typeof t != "boolean") {
    var c = n(t, o);
    u = /* @__PURE__ */ x.createElement(fh, {
      shapeType: r,
      elementProps: c
    });
  } else {
    var s = o;
    u = /* @__PURE__ */ x.createElement(fh, {
      shapeType: r,
      elementProps: s
    });
  }
  return a ? /* @__PURE__ */ x.createElement(ze, {
    className: i
  }, u) : u;
}
var qg = (e, t) => {
  var r = be();
  return (n, i) => (a) => {
    e?.(n, i, a), r(ug({
      activeIndex: String(i),
      activeDataKey: t,
      activeCoordinate: n.tooltipPosition
    }));
  };
}, Kg = (e) => {
  var t = be();
  return (r, n) => (i) => {
    e?.(r, n, i), t(j_());
  };
}, Fg = (e, t) => {
  var r = be();
  return (n, i) => (a) => {
    e?.(n, i, a), r(T_({
      activeIndex: String(i),
      activeDataKey: t,
      activeCoordinate: n.tooltipPosition
    }));
  };
};
function Wg(e) {
  var {
    fn: t,
    args: r
  } = e, n = be(), i = Xe();
  return ae(() => {
    if (!i) {
      var a = t(r);
      return n(S_(a)), () => {
        n(E_(a));
      };
    }
  }, [t, r, n, i]), null;
}
var jM = () => {
};
function Ug(e) {
  var {
    legendPayload: t
  } = e, r = be(), n = Xe();
  return ae(() => n ? jM : (r(a1(t)), () => {
    r(o1(t));
  }), [r, n, t]), null;
}
function Vg(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "animation-", r = it(wn(t)), n = it(e);
  return n.current !== e && (r.current = wn(t), n.current = e), r.current;
}
var Eu, TM = () => {
  var [e] = x.useState(() => wn("uid-"));
  return e;
}, MM = (Eu = x.useId) !== null && Eu !== void 0 ? Eu : TM;
function CM(e, t) {
  var r = MM();
  return t || (e ? "".concat(e, "-").concat(r) : r);
}
var kM = /* @__PURE__ */ er(void 0), Hg = (e) => {
  var {
    id: t,
    type: r,
    children: n
  } = e, i = CM("recharts-".concat(r), t);
  return /* @__PURE__ */ x.createElement(kM.Provider, {
    value: i
  }, n(i));
}, IM = {
  cartesianItems: [],
  polarItems: []
}, Gg = Ye({
  name: "graphicalItems",
  initialState: IM,
  reducers: {
    addCartesianGraphicalItem(e, t) {
      e.cartesianItems.push(t.payload);
    },
    replaceCartesianGraphicalItem(e, t) {
      var {
        prev: r,
        next: n
      } = t.payload, i = St(e).cartesianItems.indexOf(r);
      i > -1 && (e.cartesianItems[i] = n);
    },
    removeCartesianGraphicalItem(e, t) {
      var r = St(e).cartesianItems.indexOf(t.payload);
      r > -1 && e.cartesianItems.splice(r, 1);
    },
    addPolarGraphicalItem(e, t) {
      e.polarItems.push(t.payload);
    },
    removePolarGraphicalItem(e, t) {
      var r = St(e).polarItems.indexOf(t.payload);
      r > -1 && e.polarItems.splice(r, 1);
    }
  }
}), {
  addCartesianGraphicalItem: DM,
  replaceCartesianGraphicalItem: NM,
  removeCartesianGraphicalItem: $M
} = Gg.actions, RM = Gg.reducer;
function Yg(e) {
  var t = be(), r = it(null);
  return ae(() => {
    r.current === null ? t(DM(e)) : r.current !== e && t(NM({
      prev: r.current,
      next: e
    })), r.current = e;
  }, [t, e]), ae(() => () => {
    r.current && (t($M(r.current)), r.current = null);
  }, [t]), null;
}
function LM() {
}
var BM = {
  begin: 0,
  duration: 1e3,
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  onAnimationEnd: () => {
  },
  onAnimationStart: () => {
  }
}, dh = {
  t: 0
}, _u = {
  t: 1
};
function Xg(e) {
  var t = bt(e, BM), {
    isActive: r,
    canBegin: n,
    duration: i,
    easing: a,
    begin: o,
    onAnimationEnd: u,
    onAnimationStart: c,
    children: s
  } = t, l = hm("JavascriptAnimate", t.animationManager), [f, d] = ct(r ? dh : _u), v = it(null);
  return ae(() => {
    r || d(_u);
  }, [r]), ae(() => {
    if (!r || !n)
      return LM;
    var h = vm(dh, _u, fm(a), i, d, l.getTimeoutController()), p = () => {
      v.current = h();
    };
    return l.start([c, o, p, i, u]), () => {
      l.stop(), v.current && v.current(), u();
    };
  }, [r, n, i, a, o, c, u, l]), s(f.t);
}
var zM = S([Se], (e) => {
  if (e)
    return {
      top: e.top,
      bottom: e.bottom,
      left: e.left,
      right: e.right
    };
}), qM = S([zM, Nt, $t], (e, t, r) => {
  if (!(!e || t == null || r == null))
    return {
      x: e.left,
      y: e.top,
      width: Math.max(0, t - e.left - e.right),
      height: Math.max(0, r - e.top - e.bottom)
    };
}), ul = () => $(qM), KM = () => $(pj);
function vh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vh(Object(r), !0).forEach(function(n) {
      FM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function FM(e, t, r) {
  return (t = WM(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function WM(e) {
  var t = UM(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function UM(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var VM = (e) => {
  var {
    point: t,
    childIndex: r,
    mainColor: n,
    activeDot: i,
    dataKey: a
  } = e;
  if (i === !1 || t.x == null || t.y == null)
    return null;
  var o = hh(hh({
    index: r,
    dataKey: a,
    cx: t.x,
    cy: t.y,
    r: 4,
    fill: n ?? "none",
    strokeWidth: 2,
    stroke: "#fff",
    payload: t.payload,
    value: t.value
  }, ie(i, !1)), Ic(i)), u;
  return /* @__PURE__ */ vt(i) ? u = /* @__PURE__ */ kt(i, o) : typeof i == "function" ? u = i(o) : u = /* @__PURE__ */ x.createElement(zg, o), /* @__PURE__ */ x.createElement(ze, {
    className: "recharts-active-dot"
  }, u);
};
function ph(e) {
  var {
    points: t,
    mainColor: r,
    activeDot: n,
    itemDataKey: i
  } = e, a = $(Ar), o = KM();
  if (t == null || o == null)
    return null;
  var u = t.find((c) => o.includes(c.payload));
  return te(u) ? null : VM({
    point: u,
    childIndex: Number(a),
    mainColor: r,
    dataKey: i,
    activeDot: n
  });
}
var HM = process.env.NODE_ENV === "production", ju = "Invariant failed";
function mh(e, t) {
  if (HM)
    throw new Error(ju);
  var r = typeof t == "function" ? t() : t, n = r ? "".concat(ju, ": ").concat(r) : ju;
  throw new Error(n);
}
var GM = ["x", "y"];
function Sc() {
  return Sc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Sc.apply(null, arguments);
}
function yh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yh(Object(r), !0).forEach(function(n) {
      YM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function YM(e, t, r) {
  return (t = XM(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function XM(e) {
  var t = ZM(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function ZM(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function JM(e, t) {
  if (e == null) return {};
  var r, n, i = QM(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function QM(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function eC(e, t) {
  var {
    x: r,
    y: n
  } = e, i = JM(e, GM), a = "".concat(r), o = parseInt(a, 10), u = "".concat(n), c = parseInt(u, 10), s = "".concat(t.height || i.height), l = parseInt(s, 10), f = "".concat(t.width || i.width), d = parseInt(f, 10);
  return pn(pn(pn(pn(pn({}, t), i), o ? {
    x: o
  } : {}), c ? {
    y: c
  } : {}), {}, {
    height: l,
    width: d,
    name: t.name,
    radius: t.radius
  });
}
function Zg(e) {
  return /* @__PURE__ */ x.createElement(_M, Sc({
    shapeType: "rectangle",
    propTransformer: eC,
    activeClassName: "recharts-active-bar"
  }, e));
}
var tC = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return (n, i) => {
    if (k(t)) return t;
    var a = k(n) || te(n);
    return a ? t(n, i) : (a || (process.env.NODE_ENV !== "production" ? mh(!1, "minPointSize callback function received a value with type of ".concat(typeof n, ". Currently only numbers or null/undefined are supported.")) : mh()), r);
  };
}, rC = {}, nC = Ye({
  name: "errorBars",
  initialState: rC,
  reducers: {
    addErrorBar: (e, t) => {
      var {
        itemId: r,
        errorBar: n
      } = t.payload;
      e[r] || (e[r] = []), e[r].push(n);
    },
    removeErrorBar: (e, t) => {
      var {
        itemId: r,
        errorBar: n
      } = t.payload;
      e[r] && (e[r] = e[r].filter((i) => i.dataKey !== n.dataKey || i.direction !== n.direction));
    }
  }
}), iC = nC.reducer, aC = ["children"];
function oC(e, t) {
  if (e == null) return {};
  var r, n, i = uC(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function uC(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var cC = {
  data: [],
  xAxisId: "xAxis-0",
  yAxisId: "yAxis-0",
  dataPointFormatter: () => ({
    x: 0,
    y: 0,
    value: 0
  }),
  errorBarOffset: 0
}, sC = /* @__PURE__ */ er(cC);
function lC(e) {
  var {
    children: t
  } = e, r = oC(e, aC);
  return /* @__PURE__ */ x.createElement(sC.Provider, {
    value: r
  }, t);
}
function cl(e, t) {
  var r, n, i = $((s) => Lt(s, e)), a = $((s) => _r(s, t)), o = (r = i?.allowDataOverflow) !== null && r !== void 0 ? r : Ke.allowDataOverflow, u = (n = a?.allowDataOverflow) !== null && n !== void 0 ? n : Py.allowDataOverflow, c = o || u;
  return {
    needClip: c,
    needClipX: o,
    needClipY: u
  };
}
function Jg(e) {
  var {
    xAxisId: t,
    yAxisId: r,
    clipPathId: n
  } = e, i = ul(), {
    needClipX: a,
    needClipY: o,
    needClip: u
  } = cl(t, r);
  if (!u)
    return null;
  var {
    x: c,
    y: s,
    width: l,
    height: f
  } = i;
  return /* @__PURE__ */ x.createElement("clipPath", {
    id: "clipPath-".concat(n)
  }, /* @__PURE__ */ x.createElement("rect", {
    x: a ? c : c - l / 2,
    y: o ? s : s - f / 2,
    width: a ? l : l * 2,
    height: o ? f : f * 2
  }));
}
var fC = ["onMouseEnter", "onMouseLeave", "onClick"], dC = ["value", "background", "tooltipPosition"], vC = ["id"], hC = ["onMouseEnter", "onClick", "onMouseLeave"];
function Hr() {
  return Hr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hr.apply(null, arguments);
}
function gh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Te(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gh(Object(r), !0).forEach(function(n) {
      pC(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function pC(e, t, r) {
  return (t = mC(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function mC(e) {
  var t = yC(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function yC(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ji(e, t) {
  if (e == null) return {};
  var r, n, i = gC(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function gC(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var bC = (e) => {
  var {
    dataKey: t,
    name: r,
    fill: n,
    legendType: i,
    hide: a
  } = e;
  return [{
    inactive: a,
    dataKey: t,
    type: i,
    color: n,
    value: la(r, t),
    payload: e
  }];
};
function wC(e) {
  var {
    dataKey: t,
    stroke: r,
    strokeWidth: n,
    fill: i,
    name: a,
    hide: o,
    unit: u
  } = e;
  return {
    dataDefinedOnItem: void 0,
    positions: void 0,
    settings: {
      stroke: r,
      strokeWidth: n,
      fill: i,
      dataKey: t,
      nameKey: void 0,
      name: la(a, t),
      hide: o,
      type: e.tooltipType,
      color: e.fill,
      unit: u
    }
  };
}
function xC(e) {
  var t = $(Ar), {
    data: r,
    dataKey: n,
    background: i,
    allOtherBarProps: a
  } = e, {
    onMouseEnter: o,
    onMouseLeave: u,
    onClick: c
  } = a, s = Ji(a, fC), l = qg(o, n), f = Kg(u), d = Fg(c, n);
  if (!i || r == null)
    return null;
  var v = ie(i, !1);
  return /* @__PURE__ */ x.createElement(x.Fragment, null, r.map((h, p) => {
    var {
      value: m,
      background: y,
      tooltipPosition: g
    } = h, b = Ji(h, dC);
    if (!y)
      return null;
    var O = l(h, p), w = f(h, p), P = d(h, p), A = Te(Te(Te(Te(Te({
      option: i,
      isActive: String(p) === t
    }, b), {}, {
      // @ts-expect-error BarRectangle props do not accept `fill` property.
      fill: "#eee"
    }, y), v), ia(s, h, p)), {}, {
      onMouseEnter: O,
      onMouseLeave: w,
      onClick: P,
      dataKey: n,
      index: p,
      className: "recharts-bar-background-rectangle"
    });
    return /* @__PURE__ */ x.createElement(Zg, Hr({
      key: "background-bar-".concat(p)
    }, A));
  }));
}
function Qg(e) {
  var {
    data: t,
    props: r,
    showLabels: n
  } = e, i = tr(r), {
    id: a
  } = i, o = Ji(i, vC), {
    shape: u,
    dataKey: c,
    activeBar: s
  } = r, l = $(Ar), f = $(wg), {
    onMouseEnter: d,
    onClick: v,
    onMouseLeave: h
  } = r, p = Ji(r, hC), m = qg(d, c), y = Kg(h), g = Fg(v, c);
  return t ? /* @__PURE__ */ x.createElement(x.Fragment, null, t.map((b, O) => {
    var w = s && String(O) === l && (f == null || c === f), P = w ? s : u, A = Te(Te(Te({}, o), b), {}, {
      isActive: w,
      option: P,
      index: O,
      dataKey: c
    });
    return /* @__PURE__ */ x.createElement(ze, Hr({
      className: "recharts-bar-rectangle"
    }, ia(p, b, O), {
      // @ts-expect-error BarRectangleItem type definition says it's missing properties, but I can see them present in debugger!
      onMouseEnter: m(b, O),
      onMouseLeave: y(b, O),
      onClick: g(b, O),
      key: "rectangle-".concat(b?.x, "-").concat(b?.y, "-").concat(b?.value, "-").concat(O)
    }), /* @__PURE__ */ x.createElement(Zg, A));
  }), n && Xt.renderCallByParent(r, t)) : null;
}
function OC(e) {
  var {
    props: t,
    previousRectanglesRef: r
  } = e, {
    data: n,
    layout: i,
    isAnimationActive: a,
    animationBegin: o,
    animationDuration: u,
    animationEasing: c,
    onAnimationEnd: s,
    onAnimationStart: l
  } = t, f = r.current, d = Vg(t, "recharts-bar-"), [v, h] = ct(!1), p = oe(() => {
    typeof s == "function" && s(), h(!1);
  }, [s]), m = oe(() => {
    typeof l == "function" && l(), h(!0);
  }, [l]);
  return /* @__PURE__ */ x.createElement(Xg, {
    begin: o,
    duration: u,
    isActive: a,
    easing: c,
    onAnimationEnd: p,
    onAnimationStart: m,
    key: d
  }, (y) => {
    var g = y === 1 ? n : n?.map((b, O) => {
      var w = f && f[O];
      if (w)
        return Te(Te({}, b), {}, {
          x: tt(w.x, b.x, y),
          y: tt(w.y, b.y, y),
          width: tt(w.width, b.width, y),
          height: tt(w.height, b.height, y)
        });
      if (i === "horizontal") {
        var P = tt(0, b.height, y);
        return Te(Te({}, b), {}, {
          y: b.y + b.height - P,
          height: P
        });
      }
      var A = tt(0, b.width, y);
      return Te(Te({}, b), {}, {
        width: A
      });
    });
    return y > 0 && (r.current = g ?? null), g == null ? null : /* @__PURE__ */ x.createElement(ze, null, /* @__PURE__ */ x.createElement(Qg, {
      props: t,
      data: g,
      showLabels: !v
    }));
  });
}
function PC(e) {
  var {
    data: t,
    isAnimationActive: r
  } = e, n = it(null);
  return r && t && t.length && (n.current == null || n.current !== t) ? /* @__PURE__ */ x.createElement(OC, {
    previousRectanglesRef: n,
    props: e
  }) : /* @__PURE__ */ x.createElement(Qg, {
    props: e,
    data: t,
    showLabels: !0
  });
}
var eb = 0, AC = (e, t) => {
  var r = Array.isArray(e.value) ? e.value[1] : e.value;
  return {
    x: e.x,
    y: e.y,
    value: r,
    // @ts-expect-error getValueByDataKey does not validate the output type
    errorVal: ge(e, t)
  };
};
class SC extends Yr {
  render() {
    var {
      hide: t,
      data: r,
      dataKey: n,
      className: i,
      xAxisId: a,
      yAxisId: o,
      needClip: u,
      background: c,
      id: s
    } = this.props;
    if (t)
      return null;
    var l = G("recharts-bar", i), f = s;
    return /* @__PURE__ */ x.createElement(ze, {
      className: l,
      id: s
    }, u && /* @__PURE__ */ x.createElement("defs", null, /* @__PURE__ */ x.createElement(Jg, {
      clipPathId: f,
      xAxisId: a,
      yAxisId: o
    })), /* @__PURE__ */ x.createElement(ze, {
      className: "recharts-bar-rectangles",
      clipPath: u ? "url(#clipPath-".concat(f, ")") : void 0
    }, /* @__PURE__ */ x.createElement(xC, {
      data: r,
      dataKey: n,
      background: c,
      allOtherBarProps: this.props
    }), /* @__PURE__ */ x.createElement(PC, this.props)), this.props.children);
  }
}
var EC = {
  activeBar: !1,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease",
  hide: !1,
  isAnimationActive: !Zr.isSsr,
  legendType: "rect",
  minPointSize: eb,
  xAxisId: 0,
  yAxisId: 0
};
function _C(e) {
  var {
    xAxisId: t,
    yAxisId: r,
    hide: n,
    legendType: i,
    minPointSize: a,
    activeBar: o,
    animationBegin: u,
    animationDuration: c,
    animationEasing: s,
    isAnimationActive: l
  } = e, {
    needClip: f
  } = cl(t, r), d = ha(), v = Xe(), h = Dc(e.children, kg), p = $((g) => ek(g, t, r, v, e.id, h));
  if (d !== "vertical" && d !== "horizontal")
    return null;
  var m, y = p?.[0];
  return y == null || y.height == null || y.width == null ? m = 0 : m = d === "vertical" ? y.height / 2 : y.width / 2, /* @__PURE__ */ x.createElement(lC, {
    xAxisId: t,
    yAxisId: r,
    data: p,
    dataPointFormatter: AC,
    errorBarOffset: m
  }, /* @__PURE__ */ x.createElement(SC, Hr({}, e, {
    layout: d,
    needClip: f,
    data: p,
    xAxisId: t,
    yAxisId: r,
    hide: n,
    legendType: i,
    minPointSize: a,
    activeBar: o,
    animationBegin: u,
    animationDuration: c,
    animationEasing: s,
    isAnimationActive: l
  })));
}
function jC(e) {
  var {
    layout: t,
    barSettings: {
      dataKey: r,
      minPointSize: n
    },
    pos: i,
    bandSize: a,
    xAxis: o,
    yAxis: u,
    xAxisTicks: c,
    yAxisTicks: s,
    stackedData: l,
    displayedData: f,
    offset: d,
    cells: v
  } = e, h = t === "horizontal" ? u : o, p = l ? h.scale.domain() : null, m = EO({
    numericAxis: h
  });
  return f.map((y, g) => {
    var b, O, w, P, A, _;
    l ? b = xO(l[g], p) : (b = ge(y, r), Array.isArray(b) || (b = [m, b]));
    var T = tC(n, eb)(b[1], g);
    if (t === "horizontal") {
      var N, [j, C] = [u.scale(b[0]), u.scale(b[1])];
      O = Jf({
        axis: o,
        ticks: c,
        bandSize: a,
        offset: i.offset,
        entry: y,
        index: g
      }), w = (N = C ?? j) !== null && N !== void 0 ? N : void 0, P = i.size;
      var z = j - C;
      if (A = Be(z) ? 0 : z, _ = {
        x: O,
        y: d.top,
        width: P,
        height: d.height
      }, Math.abs(T) > 0 && Math.abs(A) < Math.abs(T)) {
        var K = Re(A || T) * (Math.abs(T) - Math.abs(A));
        w -= K, A += K;
      }
    } else {
      var [J, se] = [o.scale(b[0]), o.scale(b[1])];
      if (O = J, w = Jf({
        axis: u,
        ticks: s,
        bandSize: a,
        offset: i.offset,
        entry: y,
        index: g
      }), P = se - J, A = i.size, _ = {
        x: d.left,
        y: w,
        width: d.width,
        height: A
      }, Math.abs(T) > 0 && Math.abs(P) < Math.abs(T)) {
        var ne = Re(P || T) * (Math.abs(T) - Math.abs(P));
        P += ne;
      }
    }
    if (O == null || w == null || P == null || A == null)
      return null;
    var Ce = Te(Te({}, y), {}, {
      x: O,
      y: w,
      width: P,
      height: A,
      value: l ? b : b[1],
      payload: y,
      background: _,
      tooltipPosition: {
        x: O + P / 2,
        y: w + A / 2
      }
    }, v && v[g] && v[g].props);
    return Ce;
  }).filter(Boolean);
}
function tb(e) {
  var t = bt(e, EC), r = Xe();
  return /* @__PURE__ */ x.createElement(Hg, {
    id: t.id,
    type: "bar"
  }, (n) => /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(Ug, {
    legendPayload: bC(t)
  }), /* @__PURE__ */ x.createElement(Wg, {
    fn: wC,
    args: t
  }), /* @__PURE__ */ x.createElement(Yg, {
    type: "bar",
    id: n,
    data: void 0,
    xAxisId: t.xAxisId,
    yAxisId: t.yAxisId,
    zAxisId: 0,
    dataKey: t.dataKey,
    stackId: Jp(t.stackId),
    hide: t.hide,
    barSize: t.barSize,
    minPointSize: t.minPointSize,
    maxBarSize: t.maxBarSize,
    isPanorama: r
  }), /* @__PURE__ */ x.createElement(_C, Hr({}, t, {
    id: n
  }))));
}
tb.displayName = "Bar";
function bh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function di(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bh(Object(r), !0).forEach(function(n) {
      TC(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function TC(e, t, r) {
  return (t = MC(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function MC(e) {
  var t = CC(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function CC(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var kC = (e, t) => t, IC = (e, t, r) => r, DC = (e, t, r, n) => n, NC = (e, t, r, n, i) => i, Zn = S([Da, NC], (e, t) => e.filter((r) => r.type === "bar").find((r) => r.id === t)), $C = S([Zn], (e) => e?.maxBarSize), RC = (e, t, r, n, i, a) => a, wh = (e, t, r) => {
  var n = r ?? e;
  if (!te(n))
    return st(n, t, 0);
}, LC = S([W, Da, kC, IC, DC], (e, t, r, n, i) => t.filter((a) => e === "horizontal" ? a.xAxisId === r : a.yAxisId === n).filter((a) => a.isPanorama === i).filter((a) => a.hide === !1).filter((a) => a.type === "bar")), BC = (e, t, r, n) => {
  var i = W(e);
  return i === "horizontal" ? kn(e, "yAxis", r, n) : kn(e, "xAxis", t, n);
}, zC = (e, t, r) => {
  var n = W(e);
  return n === "horizontal" ? Pv(e, "xAxis", t) : Pv(e, "yAxis", r);
}, qC = (e, t, r) => {
  var n = {}, i = e.filter(Ia), a = e.filter((s) => s.stackId == null), o = i.reduce((s, l) => (s[l.stackId] || (s[l.stackId] = []), s[l.stackId].push(l), s), n), u = Object.entries(o).map((s) => {
    var [l, f] = s, d = f.map((h) => h.dataKey), v = wh(t, r, f[0].barSize);
    return {
      stackId: l,
      dataKeys: d,
      barSize: v
    };
  }), c = a.map((s) => {
    var l = [s.dataKey].filter((d) => d != null), f = wh(t, r, s.barSize);
    return {
      stackId: void 0,
      dataKeys: l,
      barSize: f
    };
  });
  return [...u, ...c];
}, KC = S([LC, SE, zC], qC), FC = (e, t, r, n, i) => {
  var a, o, u = Zn(e, t, r, n, i);
  if (u != null) {
    var c = W(e), s = hy(e), {
      maxBarSize: l
    } = u, f = te(l) ? s : l, d, v;
    return c === "horizontal" ? (d = Qt(e, "xAxis", t, n), v = Jt(e, "xAxis", t, n)) : (d = Qt(e, "yAxis", r, n), v = Jt(e, "yAxis", r, n)), (a = (o = Pn(d, v, !0)) !== null && o !== void 0 ? o : f) !== null && a !== void 0 ? a : 0;
  }
}, rb = (e, t, r, n) => {
  var i = W(e), a, o;
  return i === "horizontal" ? (a = Qt(e, "xAxis", t, n), o = Jt(e, "xAxis", t, n)) : (a = Qt(e, "yAxis", r, n), o = Jt(e, "yAxis", r, n)), Pn(a, o);
};
function WC(e, t, r, n, i) {
  var a = n.length;
  if (!(a < 1)) {
    var o = st(e, r, 0, !0), u, c = [];
    if (Ae(n[0].barSize)) {
      var s = !1, l = r / a, f = n.reduce((y, g) => y + (g.barSize || 0), 0);
      f += (a - 1) * o, f >= r && (f -= (a - 1) * o, o = 0), f >= r && l > 0 && (s = !0, l *= 0.9, f = a * l);
      var d = (r - f) / 2 >> 0, v = {
        offset: d - o,
        size: 0
      };
      u = n.reduce((y, g) => {
        var b, O = {
          stackId: g.stackId,
          dataKeys: g.dataKeys,
          position: {
            offset: v.offset + v.size + o,
            size: s ? l : (b = g.barSize) !== null && b !== void 0 ? b : 0
          }
        }, w = [...y, O];
        return v = w[w.length - 1].position, w;
      }, c);
    } else {
      var h = st(t, r, 0, !0);
      r - 2 * h - (a - 1) * o <= 0 && (o = 0);
      var p = (r - 2 * h - (a - 1) * o) / a;
      p > 1 && (p >>= 0);
      var m = Ae(i) ? Math.min(p, i) : p;
      u = n.reduce((y, g, b) => [...y, {
        stackId: g.stackId,
        dataKeys: g.dataKeys,
        position: {
          offset: h + (p + o) * b + (p - m) / 2,
          size: m
        }
      }], c);
    }
    return u;
  }
}
var UC = (e, t, r, n, i, a, o) => {
  var u = te(o) ? t : o, c = WC(r, n, i !== a ? i : a, e, u);
  return i !== a && c != null && (c = c.map((s) => di(di({}, s), {}, {
    position: di(di({}, s.position), {}, {
      offset: s.position.offset - i / 2
    })
  }))), c;
}, VC = S([KC, hy, AE, py, FC, rb, $C], UC), HC = (e, t, r, n) => Qt(e, "xAxis", t, n), GC = (e, t, r, n) => Qt(e, "yAxis", r, n), YC = (e, t, r, n) => Jt(e, "xAxis", t, n), XC = (e, t, r, n) => Jt(e, "yAxis", r, n), ZC = S([VC, Zn], (e, t) => {
  if (!(e == null || t == null)) {
    var r = e.find((n) => n.stackId === t.stackId && t.dataKey != null && n.dataKeys.includes(t.dataKey));
    if (r != null)
      return r.position;
  }
}), JC = (e, t) => {
  var r = ka(t);
  if (!(!e || r == null || t == null)) {
    var {
      stackId: n
    } = t;
    if (n != null) {
      var i = e[n];
      if (i) {
        var {
          stackedData: a
        } = i;
        if (a)
          return a.find((o) => o.key === r);
      }
    }
  }
}, QC = S([BC, Zn], JC), ek = S([Se, HC, GC, YC, XC, ZC, W, Ea, rb, QC, Zn, RC], (e, t, r, n, i, a, o, u, c, s, l, f) => {
  var {
    chartData: d,
    dataStartIndex: v,
    dataEndIndex: h
  } = u;
  if (!(l == null || a == null || o !== "horizontal" && o !== "vertical" || t == null || r == null || n == null || i == null || c == null)) {
    var {
      data: p
    } = l, m;
    if (p != null && p.length > 0 ? m = p : m = d?.slice(v, h + 1), m != null)
      return jC({
        layout: o,
        barSettings: l,
        pos: a,
        bandSize: c,
        xAxis: t,
        yAxis: r,
        xAxisTicks: n,
        yAxisTicks: i,
        stackedData: s,
        displayedData: m,
        offset: e,
        cells: f
      });
  }
}), tk = (e) => {
  var {
    chartData: t
  } = e, r = be(), n = Xe();
  return ae(() => n ? () => {
  } : (r(Iv(t)), () => {
    r(Iv(void 0));
  }), [t, r, n]), null;
}, xh = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
}, rk = Ye({
  name: "brush",
  initialState: xh,
  reducers: {
    setBrushSettings(e, t) {
      return t.payload == null ? xh : t.payload;
    }
  }
}), nk = rk.reducer;
function ik(e, t, r) {
  return (t = ak(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ak(e) {
  var t = ok(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function ok(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class sl {
  static create(t) {
    return new sl(t);
  }
  constructor(t) {
    this.scale = t;
  }
  get domain() {
    return this.scale.domain;
  }
  get range() {
    return this.scale.range;
  }
  get rangeMin() {
    return this.range()[0];
  }
  get rangeMax() {
    return this.range()[1];
  }
  get bandwidth() {
    return this.scale.bandwidth;
  }
  apply(t) {
    var {
      bandAware: r,
      position: n
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (t !== void 0) {
      if (n)
        switch (n) {
          case "start":
            return this.scale(t);
          case "middle": {
            var i = this.bandwidth ? this.bandwidth() / 2 : 0;
            return this.scale(t) + i;
          }
          case "end": {
            var a = this.bandwidth ? this.bandwidth() : 0;
            return this.scale(t) + a;
          }
          default:
            return this.scale(t);
        }
      if (r) {
        var o = this.bandwidth ? this.bandwidth() / 2 : 0;
        return this.scale(t) + o;
      }
      return this.scale(t);
    }
  }
  isInRange(t) {
    var r = this.range(), n = r[0], i = r[r.length - 1];
    return n <= i ? t >= n && t <= i : t >= i && t <= n;
  }
}
ik(sl, "EPS", 1e-4);
function uk(e) {
  return (e % 180 + 180) % 180;
}
var ck = function(t) {
  var {
    width: r,
    height: n
  } = t, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a = uk(i), o = a * Math.PI / 180, u = Math.atan(n / r), c = o > u && o < Math.PI - u ? n / Math.sin(o) : r / Math.cos(o);
  return Math.abs(c);
}, sk = {
  dots: [],
  areas: [],
  lines: []
}, lk = Ye({
  name: "referenceElements",
  initialState: sk,
  reducers: {
    addDot: (e, t) => {
      e.dots.push(t.payload);
    },
    removeDot: (e, t) => {
      var r = St(e).dots.findIndex((n) => n === t.payload);
      r !== -1 && e.dots.splice(r, 1);
    },
    addArea: (e, t) => {
      e.areas.push(t.payload);
    },
    removeArea: (e, t) => {
      var r = St(e).areas.findIndex((n) => n === t.payload);
      r !== -1 && e.areas.splice(r, 1);
    },
    addLine: (e, t) => {
      e.lines.push(t.payload);
    },
    removeLine: (e, t) => {
      var r = St(e).lines.findIndex((n) => n === t.payload);
      r !== -1 && e.lines.splice(r, 1);
    }
  }
}), fk = lk.reducer, dk = /* @__PURE__ */ er(void 0), vk = (e) => {
  var {
    children: t
  } = e, [r] = ct("".concat(wn("recharts"), "-clip")), n = ul();
  if (n == null)
    return null;
  var {
    x: i,
    y: a,
    width: o,
    height: u
  } = n;
  return /* @__PURE__ */ x.createElement(dk.Provider, {
    value: r
  }, /* @__PURE__ */ x.createElement("defs", null, /* @__PURE__ */ x.createElement("clipPath", {
    id: r
  }, /* @__PURE__ */ x.createElement("rect", {
    x: i,
    y: a,
    height: u,
    width: o
  }))), t);
};
function Tu(e, t) {
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r) && (!{}.hasOwnProperty.call(t, r) || e[r] !== t[r]))
      return !1;
  for (var n in t)
    if ({}.hasOwnProperty.call(t, n) && !{}.hasOwnProperty.call(e, n))
      return !1;
  return !0;
}
function nb(e, t, r) {
  if (t < 1)
    return [];
  if (t === 1 && r === void 0)
    return e;
  for (var n = [], i = 0; i < e.length; i += t)
    n.push(e[i]);
  return n;
}
function hk(e, t, r) {
  var n = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return ck(n, r);
}
function pk(e, t, r) {
  var n = r === "width", {
    x: i,
    y: a,
    width: o,
    height: u
  } = e;
  return t === 1 ? {
    start: n ? i : a,
    end: n ? i + o : a + u
  } : {
    start: n ? i + o : a + u,
    end: n ? i : a
  };
}
function Qi(e, t, r, n, i) {
  if (e * t < e * n || e * t > e * i)
    return !1;
  var a = r();
  return e * (t - e * a / 2 - n) >= 0 && e * (t + e * a / 2 - i) <= 0;
}
function mk(e, t) {
  return nb(e, t + 1);
}
function yk(e, t, r, n, i) {
  for (var a = (n || []).slice(), {
    start: o,
    end: u
  } = t, c = 0, s = 1, l = o, f = function() {
    var h = n?.[c];
    if (h === void 0)
      return {
        v: nb(n, s)
      };
    var p = c, m, y = () => (m === void 0 && (m = r(h, p)), m), g = h.coordinate, b = c === 0 || Qi(e, g, y, l, u);
    b || (c = 0, l = o, s += 1), b && (l = g + e * (y() / 2 + i), c += s);
  }, d; s <= a.length; )
    if (d = f(), d) return d.v;
  return [];
}
function Oh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function je(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Oh(Object(r), !0).forEach(function(n) {
      gk(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Oh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function gk(e, t, r) {
  return (t = bk(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function bk(e) {
  var t = wk(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function wk(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function xk(e, t, r, n, i) {
  for (var a = (n || []).slice(), o = a.length, {
    start: u
  } = t, {
    end: c
  } = t, s = function(d) {
    var v = a[d], h, p = () => (h === void 0 && (h = r(v, d)), h);
    if (d === o - 1) {
      var m = e * (v.coordinate + e * p() / 2 - c);
      a[d] = v = je(je({}, v), {}, {
        tickCoord: m > 0 ? v.coordinate - m * e : v.coordinate
      });
    } else
      a[d] = v = je(je({}, v), {}, {
        tickCoord: v.coordinate
      });
    var y = Qi(e, v.tickCoord, p, u, c);
    y && (c = v.tickCoord - e * (p() / 2 + i), a[d] = je(je({}, v), {}, {
      isShow: !0
    }));
  }, l = o - 1; l >= 0; l--)
    s(l);
  return a;
}
function Ok(e, t, r, n, i, a) {
  var o = (n || []).slice(), u = o.length, {
    start: c,
    end: s
  } = t;
  if (a) {
    var l = n[u - 1], f = r(l, u - 1), d = e * (l.coordinate + e * f / 2 - s);
    o[u - 1] = l = je(je({}, l), {}, {
      tickCoord: d > 0 ? l.coordinate - d * e : l.coordinate
    });
    var v = Qi(e, l.tickCoord, () => f, c, s);
    v && (s = l.tickCoord - e * (f / 2 + i), o[u - 1] = je(je({}, l), {}, {
      isShow: !0
    }));
  }
  for (var h = a ? u - 1 : u, p = function(g) {
    var b = o[g], O, w = () => (O === void 0 && (O = r(b, g)), O);
    if (g === 0) {
      var P = e * (b.coordinate - e * w() / 2 - c);
      o[g] = b = je(je({}, b), {}, {
        tickCoord: P < 0 ? b.coordinate - P * e : b.coordinate
      });
    } else
      o[g] = b = je(je({}, b), {}, {
        tickCoord: b.coordinate
      });
    var A = Qi(e, b.tickCoord, w, c, s);
    A && (c = b.tickCoord + e * (w() / 2 + i), o[g] = je(je({}, b), {}, {
      isShow: !0
    }));
  }, m = 0; m < h; m++)
    p(m);
  return o;
}
function ll(e, t, r) {
  var {
    tick: n,
    ticks: i,
    viewBox: a,
    minTickGap: o,
    orientation: u,
    interval: c,
    tickFormatter: s,
    unit: l,
    angle: f
  } = e;
  if (!i || !i.length || !n)
    return [];
  if (k(c) || Zr.isSsr) {
    var d;
    return (d = mk(i, k(c) ? c : 0)) !== null && d !== void 0 ? d : [];
  }
  var v = [], h = u === "top" || u === "bottom" ? "width" : "height", p = l && h === "width" ? bn(l, {
    fontSize: t,
    letterSpacing: r
  }) : {
    width: 0,
    height: 0
  }, m = (b, O) => {
    var w = typeof s == "function" ? s(b.value, O) : b.value;
    return h === "width" ? hk(bn(w, {
      fontSize: t,
      letterSpacing: r
    }), p, f) : bn(w, {
      fontSize: t,
      letterSpacing: r
    })[h];
  }, y = i.length >= 2 ? Re(i[1].coordinate - i[0].coordinate) : 1, g = pk(a, y, h);
  return c === "equidistantPreserveStart" ? yk(y, g, m, i, o) : (c === "preserveStart" || c === "preserveStartEnd" ? v = Ok(y, g, m, i, o, c === "preserveStartEnd") : v = xk(y, g, m, i, o), v.filter((b) => b.isShow));
}
var Pk = ["viewBox"], Ak = ["viewBox"];
function kr() {
  return kr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kr.apply(null, arguments);
}
function Ph(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function le(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ph(Object(r), !0).forEach(function(n) {
      fl(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ph(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ah(e, t) {
  if (e == null) return {};
  var r, n, i = Sk(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function Sk(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function fl(e, t, r) {
  return (t = Ek(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ek(e) {
  var t = _k(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function _k(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class Tr extends Rh {
  constructor(t) {
    super(t), this.tickRefs = /* @__PURE__ */ x.createRef(), this.tickRefs.current = [], this.state = {
      fontSize: "",
      letterSpacing: ""
    };
  }
  shouldComponentUpdate(t, r) {
    var {
      viewBox: n
    } = t, i = Ah(t, Pk), a = this.props, {
      viewBox: o
    } = a, u = Ah(a, Ak);
    return !Tu(n, o) || !Tu(i, u) || !Tu(r, this.state);
  }
  /**
   * Calculate the coordinates of endpoints in ticks
   * @param  data The data of a simple tick
   * @return (x1, y1): The coordinate of endpoint close to tick text
   *  (x2, y2): The coordinate of endpoint close to axis
   */
  getTickLineCoord(t) {
    var {
      x: r,
      y: n,
      width: i,
      height: a,
      orientation: o,
      tickSize: u,
      mirror: c,
      tickMargin: s
    } = this.props, l, f, d, v, h, p, m = c ? -1 : 1, y = t.tickSize || u, g = k(t.tickCoord) ? t.tickCoord : t.coordinate;
    switch (o) {
      case "top":
        l = f = t.coordinate, v = n + +!c * a, d = v - m * y, p = d - m * s, h = g;
        break;
      case "left":
        d = v = t.coordinate, f = r + +!c * i, l = f - m * y, h = l - m * s, p = g;
        break;
      case "right":
        d = v = t.coordinate, f = r + +c * i, l = f + m * y, h = l + m * s, p = g;
        break;
      default:
        l = f = t.coordinate, v = n + +c * a, d = v + m * y, p = d + m * s, h = g;
        break;
    }
    return {
      line: {
        x1: l,
        y1: d,
        x2: f,
        y2: v
      },
      tick: {
        x: h,
        y: p
      }
    };
  }
  getTickTextAnchor() {
    var {
      orientation: t,
      mirror: r
    } = this.props, n;
    switch (t) {
      case "left":
        n = r ? "start" : "end";
        break;
      case "right":
        n = r ? "end" : "start";
        break;
      default:
        n = "middle";
        break;
    }
    return n;
  }
  getTickVerticalAnchor() {
    var {
      orientation: t,
      mirror: r
    } = this.props;
    switch (t) {
      case "left":
      case "right":
        return "middle";
      case "top":
        return r ? "start" : "end";
      default:
        return r ? "end" : "start";
    }
  }
  renderAxisLine() {
    var {
      x: t,
      y: r,
      width: n,
      height: i,
      orientation: a,
      mirror: o,
      axisLine: u
    } = this.props, c = le(le(le({}, ie(this.props, !1)), ie(u, !1)), {}, {
      fill: "none"
    });
    if (a === "top" || a === "bottom") {
      var s = +(a === "top" && !o || a === "bottom" && o);
      c = le(le({}, c), {}, {
        x1: t,
        y1: r + s * i,
        x2: t + n,
        y2: r + s * i
      });
    } else {
      var l = +(a === "left" && !o || a === "right" && o);
      c = le(le({}, c), {}, {
        x1: t + l * n,
        y1: r,
        x2: t + l * n,
        y2: r + i
      });
    }
    return /* @__PURE__ */ x.createElement("line", kr({}, c, {
      className: G("recharts-cartesian-axis-line", gr(u, "className"))
    }));
  }
  static renderTickItem(t, r, n) {
    var i, a = G(r.className, "recharts-cartesian-axis-tick-value");
    if (/* @__PURE__ */ x.isValidElement(t))
      i = /* @__PURE__ */ x.cloneElement(t, le(le({}, r), {}, {
        className: a
      }));
    else if (typeof t == "function")
      i = t(le(le({}, r), {}, {
        className: a
      }));
    else {
      var o = "recharts-cartesian-axis-tick-value";
      typeof t != "boolean" && (o = G(o, t.className)), i = /* @__PURE__ */ x.createElement(ol, kr({}, r, {
        className: o
      }), n);
    }
    return i;
  }
  /**
   * render the ticks
   * @param {string} fontSize Fontsize to consider for tick spacing
   * @param {string} letterSpacing Letter spacing to consider for tick spacing
   * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
   * @return {ReactElement | null} renderedTicks
   */
  renderTicks(t, r) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], {
      tickLine: i,
      stroke: a,
      tick: o,
      tickFormatter: u,
      unit: c,
      padding: s
    } = this.props, l = ll(le(le({}, this.props), {}, {
      ticks: n
    }), t, r), f = this.getTickTextAnchor(), d = this.getTickVerticalAnchor(), v = tr(this.props), h = ie(o, !1), p = le(le({}, v), {}, {
      fill: "none"
    }, ie(i, !1)), m = l.map((y, g) => {
      var {
        line: b,
        tick: O
      } = this.getTickLineCoord(y), w = le(le(le(le({
        textAnchor: f,
        verticalAnchor: d
      }, v), {}, {
        stroke: "none",
        fill: a
      }, h), O), {}, {
        index: g,
        payload: y,
        visibleTicksCount: l.length,
        tickFormatter: u,
        padding: s
      });
      return /* @__PURE__ */ x.createElement(ze, kr({
        className: "recharts-cartesian-axis-tick",
        key: "tick-".concat(y.value, "-").concat(y.coordinate, "-").concat(y.tickCoord)
      }, ia(this.props, y, g)), i && // @ts-expect-error recharts scale is not compatible with SVG scale
      /* @__PURE__ */ x.createElement("line", kr({}, p, b, {
        className: G("recharts-cartesian-axis-tick-line", gr(i, "className"))
      })), o && Tr.renderTickItem(o, w, "".concat(typeof u == "function" ? u(y.value, g) : y.value).concat(c || "")));
    });
    return m.length > 0 ? /* @__PURE__ */ x.createElement("g", {
      className: "recharts-cartesian-axis-ticks"
    }, m) : null;
  }
  render() {
    var {
      axisLine: t,
      width: r,
      height: n,
      className: i,
      hide: a
    } = this.props;
    if (a)
      return null;
    var {
      ticks: o
    } = this.props;
    return r != null && r <= 0 || n != null && n <= 0 ? null : /* @__PURE__ */ x.createElement(ze, {
      className: G("recharts-cartesian-axis", i),
      ref: (u) => {
        if (u) {
          var c = u.getElementsByClassName("recharts-cartesian-axis-tick-value");
          this.tickRefs.current = Array.from(c);
          var s = c[0];
          if (s) {
            var l = window.getComputedStyle(s).fontSize, f = window.getComputedStyle(s).letterSpacing;
            (l !== this.state.fontSize || f !== this.state.letterSpacing) && this.setState({
              fontSize: window.getComputedStyle(s).fontSize,
              letterSpacing: window.getComputedStyle(s).letterSpacing
            });
          }
        }
      }
    }, t && this.renderAxisLine(), this.renderTicks(this.state.fontSize, this.state.letterSpacing, o), We.renderCallByParent(this.props));
  }
}
fl(Tr, "displayName", "CartesianAxis");
fl(Tr, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var jk = ["x1", "y1", "x2", "y2", "key"], Tk = ["offset"], Mk = ["xAxisId", "yAxisId"], Ck = ["xAxisId", "yAxisId"];
function Sh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Me(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sh(Object(r), !0).forEach(function(n) {
      kk(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function kk(e, t, r) {
  return (t = Ik(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ik(e) {
  var t = Dk(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Dk(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function vr() {
  return vr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vr.apply(null, arguments);
}
function ea(e, t) {
  if (e == null) return {};
  var r, n, i = Nk(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function Nk(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var $k = (e) => {
  var {
    fill: t
  } = e;
  if (!t || t === "none")
    return null;
  var {
    fillOpacity: r,
    x: n,
    y: i,
    width: a,
    height: o,
    ry: u
  } = e;
  return /* @__PURE__ */ x.createElement("rect", {
    x: n,
    y: i,
    ry: u,
    width: a,
    height: o,
    stroke: "none",
    fill: t,
    fillOpacity: r,
    className: "recharts-cartesian-grid-bg"
  });
};
function ib(e, t) {
  var r;
  if (/* @__PURE__ */ x.isValidElement(e))
    r = /* @__PURE__ */ x.cloneElement(e, t);
  else if (typeof e == "function")
    r = e(t);
  else {
    var {
      x1: n,
      y1: i,
      x2: a,
      y2: o,
      key: u
    } = t, c = ea(t, jk), s = tr(c), {
      offset: l
    } = s, f = ea(s, Tk);
    r = /* @__PURE__ */ x.createElement("line", vr({}, f, {
      x1: n,
      y1: i,
      x2: a,
      y2: o,
      fill: "none",
      key: u
    }));
  }
  return r;
}
function Rk(e) {
  var {
    x: t,
    width: r,
    horizontal: n = !0,
    horizontalPoints: i
  } = e;
  if (!n || !i || !i.length)
    return null;
  var {
    xAxisId: a,
    yAxisId: o
  } = e, u = ea(e, Mk), c = i.map((s, l) => {
    var f = Me(Me({}, u), {}, {
      x1: t,
      y1: s,
      x2: t + r,
      y2: s,
      key: "line-".concat(l),
      index: l
    });
    return ib(n, f);
  });
  return /* @__PURE__ */ x.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, c);
}
function Lk(e) {
  var {
    y: t,
    height: r,
    vertical: n = !0,
    verticalPoints: i
  } = e;
  if (!n || !i || !i.length)
    return null;
  var {
    xAxisId: a,
    yAxisId: o
  } = e, u = ea(e, Ck), c = i.map((s, l) => {
    var f = Me(Me({}, u), {}, {
      x1: s,
      y1: t,
      x2: s,
      y2: t + r,
      key: "line-".concat(l),
      index: l
    });
    return ib(n, f);
  });
  return /* @__PURE__ */ x.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, c);
}
function Bk(e) {
  var {
    horizontalFill: t,
    fillOpacity: r,
    x: n,
    y: i,
    width: a,
    height: o,
    horizontalPoints: u,
    horizontal: c = !0
  } = e;
  if (!c || !t || !t.length)
    return null;
  var s = u.map((f) => Math.round(f + i - i)).sort((f, d) => f - d);
  i !== s[0] && s.unshift(0);
  var l = s.map((f, d) => {
    var v = !s[d + 1], h = v ? i + o - f : s[d + 1] - f;
    if (h <= 0)
      return null;
    var p = d % t.length;
    return /* @__PURE__ */ x.createElement("rect", {
      key: "react-".concat(d),
      y: f,
      x: n,
      height: h,
      width: a,
      stroke: "none",
      fill: t[p],
      fillOpacity: r,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ x.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, l);
}
function zk(e) {
  var {
    vertical: t = !0,
    verticalFill: r,
    fillOpacity: n,
    x: i,
    y: a,
    width: o,
    height: u,
    verticalPoints: c
  } = e;
  if (!t || !r || !r.length)
    return null;
  var s = c.map((f) => Math.round(f + i - i)).sort((f, d) => f - d);
  i !== s[0] && s.unshift(0);
  var l = s.map((f, d) => {
    var v = !s[d + 1], h = v ? i + o - f : s[d + 1] - f;
    if (h <= 0)
      return null;
    var p = d % r.length;
    return /* @__PURE__ */ x.createElement("rect", {
      key: "react-".concat(d),
      x: f,
      y: a,
      width: h,
      height: u,
      stroke: "none",
      fill: r[p],
      fillOpacity: n,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ x.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, l);
}
var qk = (e, t) => {
  var {
    xAxis: r,
    width: n,
    height: i,
    offset: a
  } = e;
  return Xp(ll(Me(Me(Me({}, Tr.defaultProps), r), {}, {
    ticks: Zp(r),
    viewBox: {
      x: 0,
      y: 0,
      width: n,
      height: i
    }
  })), a.left, a.left + a.width, t);
}, Kk = (e, t) => {
  var {
    yAxis: r,
    width: n,
    height: i,
    offset: a
  } = e;
  return Xp(ll(Me(Me(Me({}, Tr.defaultProps), r), {}, {
    ticks: Zp(r),
    viewBox: {
      x: 0,
      y: 0,
      width: n,
      height: i
    }
  })), a.top, a.top + a.height, t);
}, Fk = {
  horizontal: !0,
  vertical: !0,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: [],
  xAxisId: 0,
  yAxisId: 0
};
function dl(e) {
  var t = os(), r = us(), n = em(), i = Me(Me({}, bt(e, Fk)), {}, {
    x: k(e.x) ? e.x : n.left,
    y: k(e.y) ? e.y : n.top,
    width: k(e.width) ? e.width : n.width,
    height: k(e.height) ? e.height : n.height
  }), {
    xAxisId: a,
    yAxisId: o,
    x: u,
    y: c,
    width: s,
    height: l,
    syncWithTicks: f,
    horizontalValues: d,
    verticalValues: v
  } = i, h = Xe(), p = $((T) => Av(T, "xAxis", a, h)), m = $((T) => Av(T, "yAxis", o, h));
  if (!k(s) || s <= 0 || !k(l) || l <= 0 || !k(u) || u !== +u || !k(c) || c !== +c)
    return null;
  var y = i.verticalCoordinatesGenerator || qk, g = i.horizontalCoordinatesGenerator || Kk, {
    horizontalPoints: b,
    verticalPoints: O
  } = i;
  if ((!b || !b.length) && typeof g == "function") {
    var w = d && d.length, P = g({
      yAxis: m ? Me(Me({}, m), {}, {
        ticks: w ? d : m.ticks
      }) : void 0,
      width: t,
      height: r,
      offset: n
    }, w ? !0 : f);
    gn(Array.isArray(P), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(typeof P, "]")), Array.isArray(P) && (b = P);
  }
  if ((!O || !O.length) && typeof y == "function") {
    var A = v && v.length, _ = y({
      xAxis: p ? Me(Me({}, p), {}, {
        ticks: A ? v : p.ticks
      }) : void 0,
      width: t,
      height: r,
      offset: n
    }, A ? !0 : f);
    gn(Array.isArray(_), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(typeof _, "]")), Array.isArray(_) && (O = _);
  }
  return /* @__PURE__ */ x.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ x.createElement($k, {
    fill: i.fill,
    fillOpacity: i.fillOpacity,
    x: i.x,
    y: i.y,
    width: i.width,
    height: i.height,
    ry: i.ry
  }), /* @__PURE__ */ x.createElement(Bk, vr({}, i, {
    horizontalPoints: b
  })), /* @__PURE__ */ x.createElement(zk, vr({}, i, {
    verticalPoints: O
  })), /* @__PURE__ */ x.createElement(Rk, vr({}, i, {
    offset: n,
    horizontalPoints: b,
    xAxis: p,
    yAxis: m
  })), /* @__PURE__ */ x.createElement(Lk, vr({}, i, {
    offset: n,
    verticalPoints: O,
    xAxis: p,
    yAxis: m
  })));
}
dl.displayName = "CartesianGrid";
var ab = (e, t, r, n) => Qt(e, "xAxis", t, n), ob = (e, t, r, n) => Jt(e, "xAxis", t, n), ub = (e, t, r, n) => Qt(e, "yAxis", r, n), cb = (e, t, r, n) => Jt(e, "yAxis", r, n), Wk = S([W, ab, ub, ob, cb], (e, t, r, n, i) => Dt(e, "xAxis") ? Pn(t, n, !1) : Pn(r, i, !1)), Uk = (e, t, r, n, i) => i, sb = S([Da, Uk], (e, t) => e.filter((r) => r.type === "area").find((r) => r.id === t)), Vk = (e, t, r, n, i) => {
  var a, o = sb(e, t, r, n, i);
  if (o != null) {
    var u = W(e), c = Dt(u, "xAxis"), s;
    if (c ? s = kn(e, "yAxis", r, n) : s = kn(e, "xAxis", t, n), s != null) {
      var {
        stackId: l
      } = o, f = ka(o);
      if (!(l == null || f == null)) {
        var d = (a = s[l]) === null || a === void 0 ? void 0 : a.stackedData;
        return d?.find((v) => v.key === f);
      }
    }
  }
}, Hk = S([W, ab, ub, ob, cb, Vk, Ea, Wk, sb], (e, t, r, n, i, a, o, u, c) => {
  var {
    chartData: s,
    dataStartIndex: l,
    dataEndIndex: f
  } = o;
  if (!(c == null || e !== "horizontal" && e !== "vertical" || t == null || r == null || n == null || i == null || n.length === 0 || i.length === 0 || u == null)) {
    var {
      data: d
    } = c, v;
    if (d && d.length > 0 ? v = d : v = s?.slice(l, f + 1), v != null) {
      var h = void 0;
      return vI({
        layout: e,
        xAxis: t,
        yAxis: r,
        xAxisTicks: n,
        yAxisTicks: i,
        dataStartIndex: l,
        areaSettings: c,
        stackedData: a,
        displayedData: v,
        chartBaseValue: h,
        bandSize: u
      });
    }
  }
}), Gk = ["id"], Yk = ["activeDot", "animationBegin", "animationDuration", "animationEasing", "connectNulls", "dot", "fill", "fillOpacity", "hide", "isAnimationActive", "legendType", "stroke", "xAxisId", "yAxisId"];
function lb(e, t) {
  if (e == null) return {};
  var r, n, i = Xk(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function Xk(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function Eh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Eh(Object(r), !0).forEach(function(n) {
      Zk(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Eh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Zk(e, t, r) {
  return (t = Jk(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Jk(e) {
  var t = Qk(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Qk(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _t() {
  return _t = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _t.apply(null, arguments);
}
function ta(e, t) {
  return e && e !== "none" ? e : t;
}
var eI = (e) => {
  var {
    dataKey: t,
    name: r,
    stroke: n,
    fill: i,
    legendType: a,
    hide: o
  } = e;
  return [{
    inactive: o,
    dataKey: t,
    type: a,
    color: ta(n, i),
    value: la(r, t),
    payload: e
  }];
};
function tI(e) {
  var {
    dataKey: t,
    data: r,
    stroke: n,
    strokeWidth: i,
    fill: a,
    name: o,
    hide: u,
    unit: c
  } = e;
  return {
    dataDefinedOnItem: r,
    positions: void 0,
    settings: {
      stroke: n,
      strokeWidth: i,
      fill: a,
      dataKey: t,
      nameKey: void 0,
      name: la(o, t),
      hide: u,
      type: e.tooltipType,
      color: ta(n, a),
      unit: c
    }
  };
}
var rI = (e, t) => {
  var r;
  if (/* @__PURE__ */ x.isValidElement(e))
    r = /* @__PURE__ */ x.cloneElement(e, t);
  else if (typeof e == "function")
    r = e(t);
  else {
    var n = G("recharts-area-dot", typeof e != "boolean" ? e.className : "");
    r = /* @__PURE__ */ x.createElement(zg, _t({}, t, {
      className: n
    }));
  }
  return r;
};
function nI(e, t) {
  return e == null ? !1 : t ? !0 : e.length === 1;
}
function iI(e) {
  var {
    clipPathId: t,
    points: r,
    props: n
  } = e, {
    needClip: i,
    dot: a,
    dataKey: o
  } = n;
  if (!nI(r, a))
    return null;
  var u = Vh(a), c = tr(n), s = ie(a, !0), l = r.map((d, v) => {
    var h = hr(hr(hr({
      key: "dot-".concat(v),
      r: 3
    }, c), s), {}, {
      index: v,
      cx: d.x,
      cy: d.y,
      dataKey: o,
      value: d.value,
      payload: d.payload,
      points: r
    });
    return rI(a, h);
  }), f = {
    clipPath: i ? "url(#clipPath-".concat(u ? "" : "dots-").concat(t, ")") : void 0
  };
  return /* @__PURE__ */ x.createElement(ze, _t({
    className: "recharts-area-dots"
  }, f), l);
}
function Ec(e) {
  var {
    points: t,
    baseLine: r,
    needClip: n,
    clipPathId: i,
    props: a,
    showLabels: o
  } = e, {
    layout: u,
    type: c,
    stroke: s,
    connectNulls: l,
    isRange: f
  } = a, {
    id: d
  } = a, v = lb(a, Gk), h = tr(v);
  return /* @__PURE__ */ x.createElement(x.Fragment, null, t?.length > 1 && /* @__PURE__ */ x.createElement(ze, {
    clipPath: n ? "url(#clipPath-".concat(i, ")") : void 0
  }, /* @__PURE__ */ x.createElement(mi, _t({}, h, {
    id: d,
    points: t,
    connectNulls: l,
    type: c,
    baseLine: r,
    layout: u,
    stroke: "none",
    className: "recharts-area-area"
  })), s !== "none" && /* @__PURE__ */ x.createElement(mi, _t({}, h, {
    className: "recharts-area-curve",
    layout: u,
    type: c,
    connectNulls: l,
    fill: "none",
    points: t
  })), s !== "none" && f && /* @__PURE__ */ x.createElement(mi, _t({}, h, {
    className: "recharts-area-curve",
    layout: u,
    type: c,
    connectNulls: l,
    fill: "none",
    points: r
  }))), /* @__PURE__ */ x.createElement(iI, {
    points: t,
    props: v,
    clipPathId: i
  }), o && Xt.renderCallByParent(v, t));
}
function aI(e) {
  var {
    alpha: t,
    baseLine: r,
    points: n,
    strokeWidth: i
  } = e, a = n[0].y, o = n[n.length - 1].y;
  if (!Ae(a) || !Ae(o))
    return null;
  var u = t * Math.abs(a - o), c = Math.max(...n.map((s) => s.x || 0));
  return k(r) ? c = Math.max(r, c) : r && Array.isArray(r) && r.length && (c = Math.max(...r.map((s) => s.x || 0), c)), k(c) ? /* @__PURE__ */ x.createElement("rect", {
    x: 0,
    y: a < o ? a : a - u,
    width: c + (i ? parseInt("".concat(i), 10) : 1),
    height: Math.floor(u)
  }) : null;
}
function oI(e) {
  var {
    alpha: t,
    baseLine: r,
    points: n,
    strokeWidth: i
  } = e, a = n[0].x, o = n[n.length - 1].x;
  if (!Ae(a) || !Ae(o))
    return null;
  var u = t * Math.abs(a - o), c = Math.max(...n.map((s) => s.y || 0));
  return k(r) ? c = Math.max(r, c) : r && Array.isArray(r) && r.length && (c = Math.max(...r.map((s) => s.y || 0), c)), k(c) ? /* @__PURE__ */ x.createElement("rect", {
    x: a < o ? a : a - u,
    y: 0,
    width: u,
    height: Math.floor(c + (i ? parseInt("".concat(i), 10) : 1))
  }) : null;
}
function uI(e) {
  var {
    alpha: t,
    layout: r,
    points: n,
    baseLine: i,
    strokeWidth: a
  } = e;
  return r === "vertical" ? /* @__PURE__ */ x.createElement(aI, {
    alpha: t,
    points: n,
    baseLine: i,
    strokeWidth: a
  }) : /* @__PURE__ */ x.createElement(oI, {
    alpha: t,
    points: n,
    baseLine: i,
    strokeWidth: a
  });
}
function cI(e) {
  var {
    needClip: t,
    clipPathId: r,
    props: n,
    previousPointsRef: i,
    previousBaselineRef: a
  } = e, {
    points: o,
    baseLine: u,
    isAnimationActive: c,
    animationBegin: s,
    animationDuration: l,
    animationEasing: f,
    onAnimationStart: d,
    onAnimationEnd: v
  } = n, h = Vg(n, "recharts-area-"), [p, m] = ct(!0), y = oe(() => {
    typeof v == "function" && v(), m(!1);
  }, [v]), g = oe(() => {
    typeof d == "function" && d(), m(!0);
  }, [d]), b = i.current, O = a.current;
  return /* @__PURE__ */ x.createElement(Xg, {
    begin: s,
    duration: l,
    isActive: c,
    easing: f,
    onAnimationEnd: y,
    onAnimationStart: g,
    key: h
  }, (w) => {
    if (b) {
      var P = b.length / o.length, A = (
        /*
         * Here it is important that at the very end of the animation, on the last frame,
         * we render the original points without any interpolation.
         * This is needed because the code above is checking for reference equality to decide if the animation should run
         * and if we create a new array instance (even if the numbers were the same)
         * then we would break animations.
         */
        w === 1 ? o : o.map((T, N) => {
          var j = Math.floor(N * P);
          if (b[j]) {
            var C = b[j];
            return hr(hr({}, T), {}, {
              x: tt(C.x, T.x, w),
              y: tt(C.y, T.y, w)
            });
          }
          return T;
        })
      ), _;
      return k(u) ? _ = tt(O, u, w) : te(u) || Be(u) ? _ = tt(O, 0, w) : _ = u.map((T, N) => {
        var j = Math.floor(N * P);
        if (Array.isArray(O) && O[j]) {
          var C = O[j];
          return hr(hr({}, T), {}, {
            x: tt(C.x, T.x, w),
            y: tt(C.y, T.y, w)
          });
        }
        return T;
      }), w > 0 && (i.current = A, a.current = _), /* @__PURE__ */ x.createElement(Ec, {
        points: A,
        baseLine: _,
        needClip: t,
        clipPathId: r,
        props: n,
        showLabels: !p
      });
    }
    return w > 0 && (i.current = o, a.current = u), /* @__PURE__ */ x.createElement(ze, null, /* @__PURE__ */ x.createElement("defs", null, /* @__PURE__ */ x.createElement("clipPath", {
      id: "animationClipPath-".concat(r)
    }, /* @__PURE__ */ x.createElement(uI, {
      alpha: w,
      points: o,
      baseLine: u,
      layout: n.layout,
      strokeWidth: n.strokeWidth
    }))), /* @__PURE__ */ x.createElement(ze, {
      clipPath: "url(#animationClipPath-".concat(r, ")")
    }, /* @__PURE__ */ x.createElement(Ec, {
      points: o,
      baseLine: u,
      needClip: t,
      clipPathId: r,
      props: n,
      showLabels: !0
    })));
  });
}
function sI(e) {
  var {
    needClip: t,
    clipPathId: r,
    props: n
  } = e, {
    points: i,
    baseLine: a,
    isAnimationActive: o
  } = n, u = it(null), c = it(), s = u.current, l = c.current;
  return o && /*
   * Here it's important that we unmount of AreaWithAnimation in case points are undefined
   * - this will make sure to interrupt the animation if it's running.
   * We still get to keep the last shape of the animation in the refs above.
   */
  i && i.length && (s !== i || l !== a) ? /* @__PURE__ */ x.createElement(cI, {
    needClip: t,
    clipPathId: r,
    props: n,
    previousPointsRef: u,
    previousBaselineRef: c
  }) : /* @__PURE__ */ x.createElement(Ec, {
    points: i,
    baseLine: a,
    needClip: t,
    clipPathId: r,
    props: n,
    showLabels: !0
  });
}
class lI extends Yr {
  render() {
    var t, {
      hide: r,
      dot: n,
      points: i,
      className: a,
      top: o,
      left: u,
      needClip: c,
      xAxisId: s,
      yAxisId: l,
      width: f,
      height: d,
      id: v,
      baseLine: h
    } = this.props;
    if (r)
      return null;
    var p = G("recharts-area", a), m = v, {
      r: y = 3,
      strokeWidth: g = 2
    } = (t = ie(n, !1)) !== null && t !== void 0 ? t : {
      r: 3,
      strokeWidth: 2
    }, b = Vh(n), O = y * 2 + g;
    return /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(ze, {
      className: p
    }, c && /* @__PURE__ */ x.createElement("defs", null, /* @__PURE__ */ x.createElement(Jg, {
      clipPathId: m,
      xAxisId: s,
      yAxisId: l
    }), !b && /* @__PURE__ */ x.createElement("clipPath", {
      id: "clipPath-dots-".concat(m)
    }, /* @__PURE__ */ x.createElement("rect", {
      x: u - O / 2,
      y: o - O / 2,
      width: f + O,
      height: d + O
    }))), /* @__PURE__ */ x.createElement(sI, {
      needClip: c,
      clipPathId: m,
      props: this.props
    })), /* @__PURE__ */ x.createElement(ph, {
      points: i,
      mainColor: ta(this.props.stroke, this.props.fill),
      itemDataKey: this.props.dataKey,
      activeDot: this.props.activeDot
    }), this.props.isRange && Array.isArray(h) && /* @__PURE__ */ x.createElement(ph, {
      points: h,
      mainColor: ta(this.props.stroke, this.props.fill),
      itemDataKey: this.props.dataKey,
      activeDot: this.props.activeDot
    }));
  }
}
var fb = {
  activeDot: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  connectNulls: !1,
  dot: !1,
  fill: "#3182bd",
  fillOpacity: 0.6,
  hide: !1,
  isAnimationActive: !Zr.isSsr,
  legendType: "line",
  stroke: "#3182bd",
  xAxisId: 0,
  yAxisId: 0
};
function fI(e) {
  var t, r = bt(e, fb), {
    activeDot: n,
    animationBegin: i,
    animationDuration: a,
    animationEasing: o,
    connectNulls: u,
    dot: c,
    fill: s,
    fillOpacity: l,
    hide: f,
    isAnimationActive: d,
    legendType: v,
    stroke: h,
    xAxisId: p,
    yAxisId: m
  } = r, y = lb(r, Yk), g = ha(), b = Og(), {
    needClip: O
  } = cl(p, m), w = Xe(), {
    points: P,
    isRange: A,
    baseLine: _
  } = (t = $((K) => Hk(K, p, m, w, e.id))) !== null && t !== void 0 ? t : {}, T = ul();
  if (g !== "horizontal" && g !== "vertical" || T == null || b !== "AreaChart" && b !== "ComposedChart")
    return null;
  var {
    height: N,
    width: j,
    x: C,
    y: z
  } = T;
  return !P || !P.length ? null : /* @__PURE__ */ x.createElement(lI, _t({}, y, {
    activeDot: n,
    animationBegin: i,
    animationDuration: a,
    animationEasing: o,
    baseLine: _,
    connectNulls: u,
    dot: c,
    fill: s,
    fillOpacity: l,
    height: N,
    hide: f,
    layout: g,
    isAnimationActive: d,
    isRange: A,
    legendType: v,
    needClip: O,
    points: P,
    stroke: h,
    width: j,
    left: C,
    top: z,
    xAxisId: p,
    yAxisId: m
  }));
}
var dI = (e, t, r, n, i) => {
  var a = r ?? t;
  if (k(a))
    return a;
  var o = e === "horizontal" ? i : n, u = o.scale.domain();
  if (o.type === "number") {
    var c = Math.max(u[0], u[1]), s = Math.min(u[0], u[1]);
    return a === "dataMin" ? s : a === "dataMax" || c < 0 ? c : Math.max(Math.min(u[0], u[1]), 0);
  }
  return a === "dataMin" ? u[0] : a === "dataMax" ? u[1] : u[0];
};
function vI(e) {
  var {
    areaSettings: {
      connectNulls: t,
      baseValue: r,
      dataKey: n
    },
    stackedData: i,
    layout: a,
    chartBaseValue: o,
    xAxis: u,
    yAxis: c,
    displayedData: s,
    dataStartIndex: l,
    xAxisTicks: f,
    yAxisTicks: d,
    bandSize: v
  } = e, h = i && i.length, p = dI(a, o, r, u, c), m = a === "horizontal", y = !1, g = s.map((O, w) => {
    var P;
    h ? P = i[l + w] : (P = ge(O, n), Array.isArray(P) ? y = !0 : P = [p, P]);
    var A = P[1] == null || h && !t && ge(O, n) == null;
    return m ? {
      // @ts-expect-error getCateCoordinateOfLine expects chart data to be an object, we allow unknown
      x: Zf({
        axis: u,
        ticks: f,
        bandSize: v,
        entry: O,
        index: w
      }),
      y: A ? null : c.scale(P[1]),
      value: P,
      payload: O
    } : {
      x: A ? null : u.scale(P[1]),
      // @ts-expect-error getCateCoordinateOfLine expects chart data to be an object, we allow unknown
      y: Zf({
        axis: c,
        ticks: d,
        bandSize: v,
        entry: O,
        index: w
      }),
      value: P,
      payload: O
    };
  }), b;
  return h || y ? b = g.map((O) => {
    var w = Array.isArray(O.value) ? O.value[0] : null;
    return m ? {
      x: O.x,
      y: w != null && O.y != null ? c.scale(w) : null,
      payload: O.payload
    } : {
      x: w != null ? u.scale(w) : null,
      y: O.y,
      payload: O.payload
    };
  }) : b = m ? c.scale(p) : u.scale(p), {
    points: g,
    baseLine: b,
    isRange: y
  };
}
function db(e) {
  var t = bt(e, fb), r = Xe();
  return /* @__PURE__ */ x.createElement(Hg, {
    id: t.id,
    type: "area"
  }, (n) => /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(Ug, {
    legendPayload: eI(t)
  }), /* @__PURE__ */ x.createElement(Wg, {
    fn: tI,
    args: t
  }), /* @__PURE__ */ x.createElement(Yg, {
    type: "area",
    id: n,
    data: t.data,
    dataKey: t.dataKey,
    xAxisId: t.xAxisId,
    yAxisId: t.yAxisId,
    zAxisId: 0,
    stackId: Jp(t.stackId),
    hide: t.hide,
    barSize: void 0,
    baseValue: t.baseValue,
    isPanorama: r,
    connectNulls: t.connectNulls
  }), /* @__PURE__ */ x.createElement(fI, _t({}, t, {
    id: n
  }))));
}
db.displayName = "Area";
function _h(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function jh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _h(Object(r), !0).forEach(function(n) {
      hI(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _h(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function hI(e, t, r) {
  return (t = pI(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function pI(e) {
  var t = mI(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function mI(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var yI = {
  xAxis: {},
  yAxis: {},
  zAxis: {}
}, vb = Ye({
  name: "cartesianAxis",
  initialState: yI,
  reducers: {
    addXAxis(e, t) {
      e.xAxis[t.payload.id] = t.payload;
    },
    removeXAxis(e, t) {
      delete e.xAxis[t.payload.id];
    },
    addYAxis(e, t) {
      e.yAxis[t.payload.id] = t.payload;
    },
    removeYAxis(e, t) {
      delete e.yAxis[t.payload.id];
    },
    addZAxis(e, t) {
      e.zAxis[t.payload.id] = t.payload;
    },
    removeZAxis(e, t) {
      delete e.zAxis[t.payload.id];
    },
    updateYAxisWidth(e, t) {
      var {
        id: r,
        width: n
      } = t.payload;
      e.yAxis[r] && (e.yAxis[r] = jh(jh({}, e.yAxis[r]), {}, {
        width: n
      }));
    }
  }
}), {
  addXAxis: gI,
  removeXAxis: bI
} = vb.actions, wI = vb.reducer, xI = ["children"], OI = ["dangerouslySetInnerHTML", "ticks"];
function hb(e, t, r) {
  return (t = PI(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function PI(e) {
  var t = AI(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function AI(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _c() {
  return _c = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _c.apply(null, arguments);
}
function pb(e, t) {
  if (e == null) return {};
  var r, n, i = SI(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function SI(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function EI(e) {
  var t = be(), r = na(() => {
    var {
      children: a
    } = e, o = pb(e, xI);
    return o;
  }, [e]), n = $((a) => Lt(a, r.id)), i = r === n;
  return ae(() => (t(gI(r)), () => {
    t(bI(r));
  }), [r, t]), i ? e.children : null;
}
var _I = (e) => {
  var {
    xAxisId: t,
    className: r
  } = e, n = $(qO), i = Xe(), a = "xAxis", o = $((v) => Gn(v, a, t, i)), u = $((v) => g_(v, a, t, i)), c = $((v) => Qy(v, t)), s = $((v) => p_(v, t));
  if (c == null || s == null)
    return null;
  var {
    dangerouslySetInnerHTML: l,
    ticks: f
  } = e, d = pb(e, OI);
  return /* @__PURE__ */ x.createElement(Tr, _c({}, d, {
    scale: o,
    x: s.x,
    y: s.y,
    width: c.width,
    height: c.height,
    className: G("recharts-".concat(a, " ").concat(a), r),
    viewBox: n,
    ticks: u
  }));
}, jI = (e) => {
  var t, r, n, i, a;
  return /* @__PURE__ */ x.createElement(EI, {
    interval: (t = e.interval) !== null && t !== void 0 ? t : "preserveEnd",
    id: e.xAxisId,
    scale: e.scale,
    type: e.type,
    padding: e.padding,
    allowDataOverflow: e.allowDataOverflow,
    domain: e.domain,
    dataKey: e.dataKey,
    allowDuplicatedCategory: e.allowDuplicatedCategory,
    allowDecimals: e.allowDecimals,
    tickCount: e.tickCount,
    includeHidden: (r = e.includeHidden) !== null && r !== void 0 ? r : !1,
    reversed: e.reversed,
    ticks: e.ticks,
    height: e.height,
    orientation: e.orientation,
    mirror: e.mirror,
    hide: e.hide,
    unit: e.unit,
    name: e.name,
    angle: (n = e.angle) !== null && n !== void 0 ? n : 0,
    minTickGap: (i = e.minTickGap) !== null && i !== void 0 ? i : 5,
    tick: (a = e.tick) !== null && a !== void 0 ? a : !0,
    tickFormatter: e.tickFormatter
  }, /* @__PURE__ */ x.createElement(_I, e));
};
class za extends Rh {
  render() {
    return /* @__PURE__ */ x.createElement(jI, this.props);
  }
}
hb(za, "displayName", "XAxis");
hb(za, "defaultProps", {
  allowDataOverflow: Ke.allowDataOverflow,
  allowDecimals: Ke.allowDecimals,
  allowDuplicatedCategory: Ke.allowDuplicatedCategory,
  height: Ke.height,
  hide: !1,
  mirror: Ke.mirror,
  orientation: Ke.orientation,
  padding: Ke.padding,
  reversed: Ke.reversed,
  scale: Ke.scale,
  tickCount: Ke.tickCount,
  type: Ke.type,
  xAxisId: 0
});
var vi = { exports: {} }, Mu = {};
var Th;
function TI() {
  if (Th) return Mu;
  Th = 1;
  var e = Dn;
  function t(c, s) {
    return c === s && (c !== 0 || 1 / c === 1 / s) || c !== c && s !== s;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useSyncExternalStore, i = e.useRef, a = e.useEffect, o = e.useMemo, u = e.useDebugValue;
  return Mu.useSyncExternalStoreWithSelector = function(c, s, l, f, d) {
    var v = i(null);
    if (v.current === null) {
      var h = { hasValue: !1, value: null };
      v.current = h;
    } else h = v.current;
    v = o(
      function() {
        function m(w) {
          if (!y) {
            if (y = !0, g = w, w = f(w), d !== void 0 && h.hasValue) {
              var P = h.value;
              if (d(P, w))
                return b = P;
            }
            return b = w;
          }
          if (P = b, r(g, w)) return P;
          var A = f(w);
          return d !== void 0 && d(P, A) ? (g = w, P) : (g = w, b = A);
        }
        var y = !1, g, b, O = l === void 0 ? null : l;
        return [
          function() {
            return m(s());
          },
          O === null ? void 0 : function() {
            return m(O());
          }
        ];
      },
      [s, l, f, d]
    );
    var p = n(c, v[0], v[1]);
    return a(
      function() {
        h.hasValue = !0, h.value = p;
      },
      [p]
    ), u(p), p;
  }, Mu;
}
var Cu = {};
var Mh;
function MI() {
  return Mh || (Mh = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(c, s) {
      return c === s && (c !== 0 || 1 / c === 1 / s) || c !== c && s !== s;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = Dn, r = typeof Object.is == "function" ? Object.is : e, n = t.useSyncExternalStore, i = t.useRef, a = t.useEffect, o = t.useMemo, u = t.useDebugValue;
    Cu.useSyncExternalStoreWithSelector = function(c, s, l, f, d) {
      var v = i(null);
      if (v.current === null) {
        var h = { hasValue: !1, value: null };
        v.current = h;
      } else h = v.current;
      v = o(
        function() {
          function m(w) {
            if (!y) {
              if (y = !0, g = w, w = f(w), d !== void 0 && h.hasValue) {
                var P = h.value;
                if (d(P, w))
                  return b = P;
              }
              return b = w;
            }
            if (P = b, r(g, w))
              return P;
            var A = f(w);
            return d !== void 0 && d(P, A) ? (g = w, P) : (g = w, b = A);
          }
          var y = !1, g, b, O = l === void 0 ? null : l;
          return [
            function() {
              return m(s());
            },
            O === null ? void 0 : function() {
              return m(O());
            }
          ];
        },
        [s, l, f, d]
      );
      var p = n(c, v[0], v[1]);
      return a(
        function() {
          h.hasValue = !0, h.value = p;
        },
        [p]
      ), u(p), p;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), Cu;
}
var Ch;
function CI() {
  return Ch || (Ch = 1, process.env.NODE_ENV === "production" ? vi.exports = TI() : vi.exports = MI()), vi.exports;
}
CI();
function kI(e) {
  e();
}
function II() {
  let e = null, t = null;
  return {
    clear() {
      e = null, t = null;
    },
    notify() {
      kI(() => {
        let r = e;
        for (; r; )
          r.callback(), r = r.next;
      });
    },
    get() {
      const r = [];
      let n = e;
      for (; n; )
        r.push(n), n = n.next;
      return r;
    },
    subscribe(r) {
      let n = !0;
      const i = t = {
        callback: r,
        next: null,
        prev: t
      };
      return i.prev ? i.prev.next = i : e = i, function() {
        !n || e === null || (n = !1, i.next ? i.next.prev = i.prev : t = i.prev, i.prev ? i.prev.next = i.next : e = i.next);
      };
    }
  };
}
var kh = {
  notify() {
  },
  get: () => []
};
function DI(e, t) {
  let r, n = kh, i = 0, a = !1;
  function o(p) {
    l();
    const m = n.subscribe(p);
    let y = !1;
    return () => {
      y || (y = !0, m(), f());
    };
  }
  function u() {
    n.notify();
  }
  function c() {
    h.onStateChange && h.onStateChange();
  }
  function s() {
    return a;
  }
  function l() {
    i++, r || (r = e.subscribe(c), n = II());
  }
  function f() {
    i--, r && i === 0 && (r(), r = void 0, n.clear(), n = kh);
  }
  function d() {
    a || (a = !0, l());
  }
  function v() {
    a && (a = !1, f());
  }
  const h = {
    addNestedSub: o,
    notifyNestedSubs: u,
    handleChangeWrapper: c,
    isSubscribed: s,
    trySubscribe: d,
    tryUnsubscribe: v,
    getListeners: () => n
  };
  return h;
}
var NI = () => typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", $I = /* @__PURE__ */ NI(), RI = () => typeof navigator < "u" && navigator.product === "ReactNative", LI = /* @__PURE__ */ RI(), BI = () => $I || LI ? x.useLayoutEffect : x.useEffect, zI = /* @__PURE__ */ BI(), qI = /* @__PURE__ */ Symbol.for("react-redux-context"), KI = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function FI() {
  if (!x.createContext) return {};
  const e = KI[qI] ??= /* @__PURE__ */ new Map();
  let t = e.get(x.createContext);
  return t || (t = x.createContext(
    null
  ), process.env.NODE_ENV !== "production" && (t.displayName = "ReactRedux"), e.set(x.createContext, t)), t;
}
var WI = /* @__PURE__ */ FI();
function UI(e) {
  const { children: t, context: r, serverState: n, store: i } = e, a = x.useMemo(() => {
    const c = DI(i), s = {
      store: i,
      subscription: c,
      getServerState: n ? () => n : void 0
    };
    if (process.env.NODE_ENV === "production")
      return s;
    {
      const { identityFunctionCheck: l = "once", stabilityCheck: f = "once" } = e;
      return /* @__PURE__ */ Object.assign(s, {
        stabilityCheck: f,
        identityFunctionCheck: l
      });
    }
  }, [i, n]), o = x.useMemo(() => i.getState(), [i]);
  zI(() => {
    const { subscription: c } = a;
    return c.onStateChange = c.notifyNestedSubs, c.trySubscribe(), o !== i.getState() && c.notifyNestedSubs(), () => {
      c.tryUnsubscribe(), c.onStateChange = void 0;
    };
  }, [a, o]);
  const u = r || WI;
  return /* @__PURE__ */ x.createElement(u.Provider, { value: a }, t);
}
var VI = UI, HI = (e, t) => t, vl = S([HI, W, xy, de, mg, Bt, xj, Se], Ej), hl = (e) => {
  var t = e.currentTarget.getBoundingClientRect(), r = t.width / e.currentTarget.offsetWidth, n = t.height / e.currentTarget.offsetHeight;
  return {
    /*
     * Here it's important to use:
     * - event.clientX and event.clientY to get the mouse position relative to the viewport, including scroll.
     * - pageX and pageY are not used because they are relative to the whole document, and ignore scroll.
     * - rect.left and rect.top are used to get the position of the chart relative to the viewport.
     * - offsetX and offsetY are not used because they are relative to the offset parent
     *  which may or may not be the same as the clientX and clientY, depending on the position of the chart in the DOM
     *  and surrounding element styles. CSS position: relative, absolute, fixed, will change the offset parent.
     * - scaleX and scaleY are necessary for when the chart element is scaled using CSS `transform: scale(N)`.
     */
    chartX: Math.round((e.clientX - t.left) / r),
    chartY: Math.round((e.clientY - t.top) / n)
  };
}, mb = Ie("mouseClick"), yb = Bn();
yb.startListening({
  actionCreator: mb,
  effect: (e, t) => {
    var r = e.payload, n = vl(t.getState(), hl(r));
    n?.activeIndex != null && t.dispatch(M_({
      activeIndex: n.activeIndex,
      activeDataKey: void 0,
      activeCoordinate: n.activeCoordinate
    }));
  }
});
var jc = Ie("mouseMove"), gb = Bn();
gb.startListening({
  actionCreator: jc,
  effect: (e, t) => {
    var r = e.payload, n = t.getState(), i = Zs(n, n.tooltip.settings.shared), a = vl(n, hl(r));
    i === "axis" && (a?.activeIndex != null ? t.dispatch(sg({
      activeIndex: a.activeIndex,
      activeDataKey: void 0,
      activeCoordinate: a.activeCoordinate
    })) : t.dispatch(cg()));
  }
});
function GI(e, t) {
  return t instanceof HTMLElement ? "HTMLElement <".concat(t.tagName, ' class="').concat(t.className, '">') : t === window ? "global.window" : t;
}
var Ih = {
  accessibilityLayer: !0,
  barCategoryGap: "10%",
  barGap: 4,
  barSize: void 0,
  className: void 0,
  maxBarSize: void 0,
  stackOffset: "none",
  syncId: void 0,
  syncMethod: "index"
}, bb = Ye({
  name: "rootProps",
  initialState: Ih,
  reducers: {
    updateOptions: (e, t) => {
      var r;
      e.accessibilityLayer = t.payload.accessibilityLayer, e.barCategoryGap = t.payload.barCategoryGap, e.barGap = (r = t.payload.barGap) !== null && r !== void 0 ? r : Ih.barGap, e.barSize = t.payload.barSize, e.maxBarSize = t.payload.maxBarSize, e.stackOffset = t.payload.stackOffset, e.syncId = t.payload.syncId, e.syncMethod = t.payload.syncMethod, e.className = t.payload.className;
    }
  }
}), YI = bb.reducer, {
  updateOptions: XI
} = bb.actions, ZI = Ye({
  name: "polarOptions",
  initialState: null,
  reducers: {
    updatePolarOptions: (e, t) => t.payload
  }
}), JI = ZI.reducer, wb = Ie("keyDown"), xb = Ie("focus"), pl = Bn();
pl.startListening({
  actionCreator: wb,
  effect: (e, t) => {
    var r = t.getState(), n = r.rootProps.accessibilityLayer !== !1;
    if (n) {
      var {
        keyboardInteraction: i
      } = r.tooltip, a = e.payload;
      if (!(a !== "ArrowRight" && a !== "ArrowLeft" && a !== "Enter")) {
        var o = Number(Js(i, an(r))), u = Bt(r);
        if (a === "Enter") {
          var c = Gi(r, "axis", "hover", String(i.index));
          t.dispatch(wc({
            active: !i.active,
            activeIndex: i.index,
            activeDataKey: i.dataKey,
            activeCoordinate: c
          }));
          return;
        }
        var s = x_(r), l = s === "left-to-right" ? 1 : -1, f = a === "ArrowRight" ? 1 : -1, d = o + f * l;
        if (!(u == null || d >= u.length || d < 0)) {
          var v = Gi(r, "axis", "hover", String(d));
          t.dispatch(wc({
            active: !0,
            activeIndex: d.toString(),
            activeDataKey: void 0,
            activeCoordinate: v
          }));
        }
      }
    }
  }
});
pl.startListening({
  actionCreator: xb,
  effect: (e, t) => {
    var r = t.getState(), n = r.rootProps.accessibilityLayer !== !1;
    if (n) {
      var {
        keyboardInteraction: i
      } = r.tooltip;
      if (!i.active && i.index == null) {
        var a = "0", o = Gi(r, "axis", "hover", String(a));
        t.dispatch(wc({
          activeDataKey: void 0,
          active: !0,
          activeIndex: a,
          activeCoordinate: o
        }));
      }
    }
  }
});
var et = Ie("externalEvent"), Ob = Bn();
Ob.startListening({
  actionCreator: et,
  effect: (e, t) => {
    if (e.payload.handler != null) {
      var r = t.getState(), n = {
        activeCoordinate: dj(r),
        activeDataKey: wg(r),
        activeIndex: Ar(r),
        activeLabel: bg(r),
        activeTooltipIndex: Ar(r),
        isTooltipActive: vj(r)
      };
      e.payload.handler(n, e.payload.reactEvent);
    }
  }
});
var QI = S([nn], (e) => e.tooltipItemPayloads), eD = S([QI, Yn, (e, t, r) => t, (e, t, r) => r], (e, t, r, n) => {
  var i = e.find((u) => u.settings.dataKey === n);
  if (i != null) {
    var {
      positions: a
    } = i;
    if (a != null) {
      var o = t(a, r);
      return o;
    }
  }
}), Pb = Ie("touchMove"), Ab = Bn();
Ab.startListening({
  actionCreator: Pb,
  effect: (e, t) => {
    var r = e.payload, n = t.getState(), i = Zs(n, n.tooltip.settings.shared);
    if (i === "axis") {
      var a = vl(n, hl({
        clientX: r.touches[0].clientX,
        clientY: r.touches[0].clientY,
        currentTarget: r.currentTarget
      }));
      a?.activeIndex != null && t.dispatch(sg({
        activeIndex: a.activeIndex,
        activeDataKey: void 0,
        activeCoordinate: a.activeCoordinate
      }));
    } else if (i === "item") {
      var o, u = r.touches[0], c = document.elementFromPoint(u.clientX, u.clientY);
      if (!c || !c.getAttribute)
        return;
      var s = c.getAttribute(DO), l = (o = c.getAttribute(NO)) !== null && o !== void 0 ? o : void 0, f = eD(t.getState(), s, l);
      t.dispatch(ug({
        activeDataKey: l,
        activeIndex: s,
        activeCoordinate: f
      }));
    }
  }
});
var tD = Mp({
  brush: nk,
  cartesianAxis: wI,
  chartData: Kj,
  errorBars: iC,
  graphicalItems: RM,
  layout: iO,
  legend: u1,
  options: Rj,
  polarAxis: fM,
  polarOptions: JI,
  referenceElements: fk,
  rootProps: YI,
  tooltip: C_
}), rD = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Chart";
  return Mx({
    reducer: tD,
    // redux-toolkit v1 types are unhappy with the preloadedState type. Remove the `as any` when bumping to v2
    preloadedState: t,
    // @ts-expect-error redux-toolkit v1 types are unhappy with the middleware array. Remove this comment when bumping to v2
    middleware: (n) => n({
      serializableCheck: !1
    }).concat([yb.middleware, gb.middleware, pl.middleware, Ob.middleware, Ab.middleware]),
    devTools: {
      serialize: {
        replacer: GI
      },
      name: "recharts-".concat(r)
    }
  });
};
function nD(e) {
  var {
    preloadedState: t,
    children: r,
    reduxStoreName: n
  } = e, i = Xe(), a = it(null);
  if (i)
    return r;
  a.current == null && (a.current = rD(t, n));
  var o = Hc;
  return /* @__PURE__ */ x.createElement(VI, {
    context: o,
    store: a.current
  }, r);
}
function iD(e) {
  var {
    layout: t,
    width: r,
    height: n,
    margin: i
  } = e, a = be(), o = Xe();
  return ae(() => {
    o || (a(tO(t)), a(rO({
      width: r,
      height: n
    })), a(eO(i)));
  }, [a, o, t, r, n, i]), null;
}
function aD(e) {
  var t = be();
  return ae(() => {
    t(XI(e));
  }, [t, e]), null;
}
var oD = ["children"];
function uD(e, t) {
  if (e == null) return {};
  var r, n, i = cD(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function cD(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function ra() {
  return ra = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ra.apply(null, arguments);
}
var sD = {
  width: "100%",
  height: "100%"
}, lD = /* @__PURE__ */ gt((e, t) => {
  var r = os(), n = us(), i = cm();
  if (!Ci(r) || !Ci(n))
    return null;
  var {
    children: a,
    otherAttributes: o,
    title: u,
    desc: c
  } = e, s, l;
  return typeof o.tabIndex == "number" ? s = o.tabIndex : s = i ? 0 : void 0, typeof o.role == "string" ? l = o.role : l = i ? "application" : void 0, /* @__PURE__ */ x.createElement(Nc, ra({}, o, {
    title: u,
    desc: c,
    role: l,
    tabIndex: s,
    width: r,
    height: n,
    style: sD,
    ref: t
  }), a);
}), fD = (e) => {
  var {
    children: t
  } = e, r = $(va);
  if (!r)
    return null;
  var {
    width: n,
    height: i,
    y: a,
    x: o
  } = r;
  return /* @__PURE__ */ x.createElement(Nc, {
    width: n,
    height: i,
    x: o,
    y: a
  }, t);
}, Dh = /* @__PURE__ */ gt((e, t) => {
  var {
    children: r
  } = e, n = uD(e, oD), i = Xe();
  return i ? /* @__PURE__ */ x.createElement(fD, null, r) : /* @__PURE__ */ x.createElement(lD, ra({
    ref: t
  }, n), r);
});
function dD() {
  var e = be(), [t, r] = ct(null), n = $(IO);
  return ae(() => {
    if (t != null) {
      var i = t.getBoundingClientRect(), a = i.width / t.offsetWidth;
      Ae(a) && a !== n && e(nO(a));
    }
  }, [t, e, n]), r;
}
function Nh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vD(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Nh(Object(r), !0).forEach(function(n) {
      hD(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Nh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function hD(e, t, r) {
  return (t = pD(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function pD(e) {
  var t = mD(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function mD(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var yD = /* @__PURE__ */ gt((e, t) => {
  var {
    children: r,
    className: n,
    height: i,
    onClick: a,
    onContextMenu: o,
    onDoubleClick: u,
    onMouseDown: c,
    onMouseEnter: s,
    onMouseLeave: l,
    onMouseMove: f,
    onMouseUp: d,
    onTouchEnd: v,
    onTouchMove: h,
    onTouchStart: p,
    style: m,
    width: y
  } = e, g = be(), [b, O] = ct(null), [w, P] = ct(null);
  Uj();
  var A = dD(), _ = oe((L) => {
    A(L), typeof t == "function" && t(L), O(L), P(L);
  }, [A, t, O, P]), T = oe((L) => {
    g(mb(L)), g(et({
      handler: a,
      reactEvent: L
    }));
  }, [g, a]), N = oe((L) => {
    g(jc(L)), g(et({
      handler: s,
      reactEvent: L
    }));
  }, [g, s]), j = oe((L) => {
    g(cg()), g(et({
      handler: l,
      reactEvent: L
    }));
  }, [g, l]), C = oe((L) => {
    g(jc(L)), g(et({
      handler: f,
      reactEvent: L
    }));
  }, [g, f]), z = oe(() => {
    g(xb());
  }, [g]), K = oe((L) => {
    g(wb(L.key));
  }, [g]), J = oe((L) => {
    g(et({
      handler: o,
      reactEvent: L
    }));
  }, [g, o]), se = oe((L) => {
    g(et({
      handler: u,
      reactEvent: L
    }));
  }, [g, u]), ne = oe((L) => {
    g(et({
      handler: c,
      reactEvent: L
    }));
  }, [g, c]), Ce = oe((L) => {
    g(et({
      handler: d,
      reactEvent: L
    }));
  }, [g, d]), he = oe((L) => {
    g(et({
      handler: p,
      reactEvent: L
    }));
  }, [g, p]), zt = oe((L) => {
    g(Pb(L)), g(et({
      handler: h,
      reactEvent: L
    }));
  }, [g, h]), qt = oe((L) => {
    g(et({
      handler: v,
      reactEvent: L
    }));
  }, [g, v]);
  return /* @__PURE__ */ x.createElement(_g.Provider, {
    value: b
  }, /* @__PURE__ */ x.createElement(Hh.Provider, {
    value: w
  }, /* @__PURE__ */ x.createElement("div", {
    className: G("recharts-wrapper", n),
    style: vD({
      position: "relative",
      cursor: "default",
      width: y,
      height: i
    }, m),
    onClick: T,
    onContextMenu: J,
    onDoubleClick: se,
    onFocus: z,
    onKeyDown: K,
    onMouseDown: ne,
    onMouseEnter: N,
    onMouseLeave: j,
    onMouseMove: C,
    onMouseUp: Ce,
    onTouchEnd: qt,
    onTouchMove: zt,
    onTouchStart: he,
    ref: _
  }, r)));
}), gD = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function bD(e, t) {
  if (e == null) return {};
  var r, n, i = wD(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function wD(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var xD = /* @__PURE__ */ gt((e, t) => {
  var {
    children: r,
    className: n,
    width: i,
    height: a,
    style: o,
    compact: u,
    title: c,
    desc: s
  } = e, l = bD(e, gD), f = tr(l);
  return u ? /* @__PURE__ */ x.createElement(Dh, {
    otherAttributes: f,
    title: c,
    desc: s
  }, r) : /* @__PURE__ */ x.createElement(yD, {
    className: n,
    style: o,
    width: i,
    height: a,
    onClick: e.onClick,
    onMouseLeave: e.onMouseLeave,
    onMouseEnter: e.onMouseEnter,
    onMouseMove: e.onMouseMove,
    onMouseDown: e.onMouseDown,
    onMouseUp: e.onMouseUp,
    onContextMenu: e.onContextMenu,
    onDoubleClick: e.onDoubleClick,
    onTouchStart: e.onTouchStart,
    onTouchMove: e.onTouchMove,
    onTouchEnd: e.onTouchEnd
  }, /* @__PURE__ */ x.createElement(Dh, {
    otherAttributes: f,
    title: c,
    desc: s,
    ref: t
  }, /* @__PURE__ */ x.createElement(vk, null, r)));
}), OD = ["width", "height"];
function Tc() {
  return Tc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Tc.apply(null, arguments);
}
function PD(e, t) {
  if (e == null) return {};
  var r, n, i = AD(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function AD(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var SD = {
  top: 5,
  right: 5,
  bottom: 5,
  left: 5
}, ED = {
  accessibilityLayer: !0,
  layout: "horizontal",
  stackOffset: "none",
  barCategoryGap: "10%",
  barGap: 4,
  margin: SD,
  reverseStackOrder: !1,
  syncMethod: "index"
}, Sb = /* @__PURE__ */ gt(function(t, r) {
  var n, i = bt(t.categoricalChartProps, ED), {
    width: a,
    height: o
  } = i, u = PD(i, OD);
  if (!Ci(a) || !Ci(o))
    return null;
  var {
    chartName: c,
    defaultTooltipEventType: s,
    validateTooltipEventTypes: l,
    tooltipPayloadSearcher: f,
    categoricalChartProps: d
  } = t, v = {
    chartName: c,
    defaultTooltipEventType: s,
    validateTooltipEventTypes: l,
    tooltipPayloadSearcher: f,
    eventEmitter: void 0
  };
  return /* @__PURE__ */ x.createElement(nD, {
    preloadedState: {
      options: v
    },
    reduxStoreName: (n = d.id) !== null && n !== void 0 ? n : c
  }, /* @__PURE__ */ x.createElement(tk, {
    chartData: d.data
  }), /* @__PURE__ */ x.createElement(iD, {
    width: a,
    height: o,
    layout: i.layout,
    margin: i.margin
  }), /* @__PURE__ */ x.createElement(aD, {
    accessibilityLayer: i.accessibilityLayer,
    barCategoryGap: i.barCategoryGap,
    maxBarSize: i.maxBarSize,
    stackOffset: i.stackOffset,
    barGap: i.barGap,
    barSize: i.barSize,
    syncId: i.syncId,
    syncMethod: i.syncMethod,
    className: i.className
  }), /* @__PURE__ */ x.createElement(xD, Tc({}, u, {
    width: a,
    height: o,
    ref: r
  })));
}), _D = ["axis", "item"], jD = /* @__PURE__ */ gt((e, t) => /* @__PURE__ */ x.createElement(Sb, {
  chartName: "BarChart",
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: _D,
  tooltipPayloadSearcher: jg,
  categoricalChartProps: e,
  ref: t
})), TD = ["axis"], MD = /* @__PURE__ */ gt((e, t) => /* @__PURE__ */ x.createElement(Sb, {
  chartName: "AreaChart",
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: TD,
  tooltipPayloadSearcher: jg,
  categoricalChartProps: e,
  ref: t
}));
const CD = { light: "", dark: ".dark" }, Eb = x.createContext(null);
function _b() {
  const e = x.useContext(Eb);
  if (!e)
    throw new Error("useChart must be used within a <ChartContainer />");
  return e;
}
const kD = ({
  id: e,
  config: t
}) => {
  const r = Object.entries(t).filter(([, n]) => n.theme || n.color);
  return r.length ? /* @__PURE__ */ R.jsx(
    "style",
    {
      dangerouslySetInnerHTML: {
        __html: Object.entries(CD).map(
          ([n, i]) => `
${i} [data-chart=${e}] {
${r.map(([a, o]) => {
            const u = o.theme?.[n] || o.color;
            return u ? `  --color-${a}: ${u};` : null;
          }).join(`
`)}
}
`
        ).join(`
`)
      }
    }
  ) : null;
};
function jb({
  id: e,
  className: t,
  children: r,
  config: n,
  ...i
}) {
  const a = x.useId(), o = `chart-${e || a.replace(/:/g, "")}`;
  return /* @__PURE__ */ R.jsx(Eb.Provider, { value: { config: n }, children: /* @__PURE__ */ R.jsxs(
    "div",
    {
      "data-slot": "chart",
      "data-chart": o,
      className: wt(
        "[&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border flex aspect-video justify-center text-xs [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-hidden [&_.recharts-sector]:outline-hidden [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-surface]:outline-hidden",
        t
      ),
      ...i,
      children: [
        /* @__PURE__ */ R.jsx(kD, { id: o, config: n }),
        /* @__PURE__ */ R.jsx(lT, { children: r })
      ]
    }
  ) });
}
const Tb = Qj;
function Mb({
  active: e,
  payload: t,
  className: r,
  indicator: n = "dot",
  hideLabel: i = !1,
  hideIndicator: a = !1,
  label: o,
  labelFormatter: u,
  labelClassName: c,
  formatter: s,
  color: l,
  nameKey: f,
  labelKey: d,
  locale: v
}) {
  const { config: h } = _b(), p = x.useMemo(() => {
    if (i || !t?.length)
      return null;
    const [y] = t, g = `${d || y?.dataKey || y?.name || "value"}`, b = h[g], O = !d && typeof o == "string" ? h[o]?.label || o : b?.label;
    return u ? /* @__PURE__ */ R.jsx("div", { className: wt("font-medium", c), children: u(O, t) }) : O ? /* @__PURE__ */ R.jsx("div", { className: wt("font-medium", c), children: O }) : null;
  }, [o, u, t, i, c, h, d]);
  if (!e || !t?.length)
    return null;
  const m = t.length === 1 && n !== "dot";
  return /* @__PURE__ */ R.jsxs(
    "div",
    {
      className: wt(
        "border-border/50 bg-background grid min-w-[8rem] items-start gap-3 rounded-lg border p-3 text-xs shadow-xl",
        r
      ),
      children: [
        m ? null : p,
        /* @__PURE__ */ R.jsx("div", { className: "grid gap-3", children: t.map((y, g) => {
          const b = `${f || y.name || y.dataKey || "value"}`, O = h[b], w = l || y.payload.fill || y.color;
          return /* @__PURE__ */ R.jsx(
            "div",
            {
              className: wt(
                "[&>svg]:text-muted-foreground flex w-full flex-wrap items-stretch gap-3 [&>svg]:h-4 [&>svg]:w-4",
                n === "dot" && "items-center"
              ),
              children: s && y?.value !== void 0 && y.name ? s(y.value, y.name, y, g, y.payload) : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
                O?.icon ? /* @__PURE__ */ R.jsx(O.icon, {}) : !a && /* @__PURE__ */ R.jsx(
                  "div",
                  {
                    className: wt(
                      "shrink-0 rounded-[2px] border-[var(--color-border)] bg-[var(--color-bg)]",
                      {
                        "h-4 w-4": n === "dot",
                        "w-2": n === "line",
                        "w-0 border-[2px] border-dashed bg-transparent": n === "dashed",
                        "my-1": m && n === "dashed"
                      }
                    ),
                    style: {
                      "--color-bg": w,
                      "--color-border": w
                    }
                  }
                ),
                /* @__PURE__ */ R.jsxs(
                  "div",
                  {
                    className: wt(
                      "flex flex-1 justify-between leading-none",
                      m ? "items-end" : "items-center"
                    ),
                    children: [
                      /* @__PURE__ */ R.jsxs("div", { className: "grid gap-3", children: [
                        m ? p : null,
                        /* @__PURE__ */ R.jsx("span", { className: "text-muted-foreground mr-3", children: O?.label || y.name })
                      ] }),
                      y.value && /* @__PURE__ */ R.jsx("span", { className: "text-foreground font-mono font-medium tabular-nums", children: typeof y.value == "number" ? new Intl.NumberFormat(v).format(y.value) : y.value.toLocaleString() })
                    ]
                  }
                )
              ] })
            },
            typeof y.dataKey == "function" ? `item-${g}` : y.dataKey
          );
        }) })
      ]
    }
  );
}
const Cb = ba;
function kb({
  className: e,
  hideIcon: t = !1,
  payload: r,
  verticalAlign: n = "bottom",
  nameKey: i
}) {
  const { config: a } = _b();
  return r?.length ? /* @__PURE__ */ R.jsx(
    "div",
    {
      className: wt(
        "flex items-center justify-center gap-5",
        n === "top" ? "pb-3" : "pt-3",
        e
      ),
      children: r.map((o) => {
        const u = `${i || o.dataKey || "value"}`, c = a[u];
        return /* @__PURE__ */ R.jsxs(
          "div",
          {
            className: wt(
              "[&>svg]:text-muted-foreground flex items-center gap-3 [&>svg]:h-4 [&>svg]:w-4"
            ),
            children: [
              c?.icon && !t ? /* @__PURE__ */ R.jsx(c.icon, {}) : /* @__PURE__ */ R.jsx(
                "div",
                {
                  className: "h-4 w-4 shrink-0 rounded-[2px]",
                  style: {
                    backgroundColor: o.color
                  }
                }
              ),
              c?.label
            ]
          },
          o.value
        );
      })
    }
  ) : null;
}
const qD = ({
  bars: e,
  chartData: t,
  chartConfig: r,
  xAxisConfig: n,
  tooltipContentConfig: i,
  ...a
}) => /* @__PURE__ */ R.jsx(jb, { config: r, className: "min-h-[200px] w-full", children: /* @__PURE__ */ R.jsxs(jD, { data: t, ...a, children: [
  /* @__PURE__ */ R.jsx(dl, { vertical: !1 }),
  n && /* @__PURE__ */ R.jsx(za, { ...n }),
  /* @__PURE__ */ R.jsx(Cb, { content: /* @__PURE__ */ R.jsx(kb, { verticalAlign: "bottom" }) }),
  i && /* @__PURE__ */ R.jsx(
    Tb,
    {
      cursor: !1,
      content: /* @__PURE__ */ R.jsx(Mb, { ...i })
    }
  ),
  e && e.map((o, u) => /* @__PURE__ */ R.jsx(tb, { ...o }, `${o.dataKey}-${u}`))
] }) }), Ib = (e, t) => `gradient-${e}-${t}`, ID = (e) => `var(--color-${e})`, DD = (e, t, r) => {
  const n = [];
  return t.forEach((i) => {
    const a = i.dataKey, o = e[a];
    if (o?.gradient) {
      const u = Ib(r, a), c = ID(a), { gradient: s } = o, l = s.direction || { x1: "0", y1: "0", x2: "0", y2: "1" };
      n.push(
        /* @__PURE__ */ R.jsx("linearGradient", { id: u, ...l, children: s.stops.map((f, d) => /* @__PURE__ */ R.jsx("stop", { ...f, stopColor: f.stopColor || c }, d)) }, u)
      );
    }
  }), n;
}, ND = (e, t, r) => e.map((n) => {
  const i = n.dataKey;
  if (t[i]?.gradient) {
    const o = Ib(r, i);
    return {
      ...n,
      fill: `url(#${o})`,
      fillOpacity: n.fillOpacity || 0.8
      // Default fillOpacity if not specified
    };
  }
  return n;
}), KD = ({
  areas: e,
  chartData: t,
  chartConfig: r,
  xAxisConfig: n,
  tooltipContentConfig: i,
  children: a,
  ...o
}) => {
  const u = Dn.useId().replace(/:/g, ""), c = ND(e, r, u), s = DD(r, e, u), l = r;
  return /* @__PURE__ */ R.jsx(jb, { config: l, className: "min-h-[200px] w-full", children: /* @__PURE__ */ R.jsxs(MD, { data: t, ...o, children: [
    /* @__PURE__ */ R.jsx(dl, { vertical: !1 }),
    n && /* @__PURE__ */ R.jsx(za, { ...n }),
    /* @__PURE__ */ R.jsx(Cb, { content: /* @__PURE__ */ R.jsx(kb, { verticalAlign: "bottom" }) }),
    i && /* @__PURE__ */ R.jsx(
      Tb,
      {
        cursor: !1,
        content: /* @__PURE__ */ R.jsx(Mb, { indicator: "dot", ...i })
      }
    ),
    s.length > 0 && /* @__PURE__ */ R.jsx("defs", { children: s }),
    a,
    c && c.map((f, d) => /* @__PURE__ */ R.jsx(db, { type: "natural", ...f }, `${f.dataKey}-${d}`))
  ] }) });
};
export {
  KD as AreaChart,
  qD as BarChart
};
